/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function bindProductImageHoverScrollPause() {
  var state = window.__dsrcvProductImageHoverScrollState;
  if (state && state.bound) return;

  state = {
    bound: true,
    isScrolling: false,
    timer: null,
    listeners: [],
    subscribe: function(listener) {
      this.listeners.push(listener);
      var currentState = this;
      return function() {
        currentState.listeners = currentState.listeners.filter(function(current) {
          return current !== listener;
        });
      };
    },
    notify: function() {
      var currentState = this;
      this.listeners.slice().forEach(function(listener) {
        listener(currentState.isScrolling);
      });
    }
  };

  window.__dsrcvProductImageHoverScrollState = state;
  window.addEventListener('scroll', function() {
    if (!state.isScrolling) {
      state.isScrolling = true;
      state.notify();
    }

    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function() {
      state.isScrolling = false;
      state.notify();
    }, 180);
  }, { passive: true });
})();

(function attachSidebarNavClickFallback() {
  function collapseSidebarNavigation() {
    document.querySelectorAll('#sidebar-menu .Collapsible__Button[aria-expanded="true"]').forEach(function(button) {
      var inner = button.nextElementSibling;

      button.setAttribute('aria-expanded', 'false');

      if (inner && inner.classList && inner.classList.contains('Collapsible__Inner')) {
        inner.setAttribute('aria-hidden', 'true');
        inner.style.height = '0px';
        inner.style.overflow = 'hidden';
        inner.style.visibility = '';
      }
    });
  }

  function isNavigableHref(href) {
    return href && href !== '#' && href.indexOf('javascript:') !== 0;
  }

  document.addEventListener('click', function(event) {
    var target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    if (target.closest('#sidebar-menu .Search__Input, #sidebar-menu .Search__Form, #sidebar-menu .Search__SearchBar')) {
      collapseSidebarNavigation();
      return;
    }

    if (target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')) {
      document.body.classList.remove('sidebar-search-active');
      return;
    }

    var sidebarNavLink = target.closest('#sidebar-menu .SidebarMenu__Nav a[href]');
    if (!sidebarNavLink || !isNavigableHref(sidebarNavLink.getAttribute('href'))) {
      return;
    }

    document.body.classList.remove('sidebar-search-active');

    if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = sidebarNavLink.href;
    }
  }, true);
})();

(function manageSidebarKeyboardFocus() {
  var sidebar = document.getElementById('sidebar-menu');
  var opener = null;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  if (!sidebar) return;

  function isOpen() {
    return sidebar.getAttribute('aria-hidden') === 'false';
  }

  function getFocusableElements() {
    return Array.prototype.slice.call(sidebar.querySelectorAll(focusableSelector)).filter(function(element) {
      var style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
    });
  }

  function focusFirstControl() {
    if (!isOpen()) return;
    // Opening queues focus work. A quick tap may already have selected the
    // search input before that frame runs; keep that deliberate focus.
    var focusableElements = getFocusableElements();
    if (focusableElements.indexOf(document.activeElement) !== -1) return;

    var closeButton = sidebar.querySelector('.Drawer__Close');
    var target = closeButton && focusableElements.indexOf(closeButton) !== -1 ? closeButton : focusableElements[0];

    if (target) target.focus({ preventScroll: true });
  }

  function restoreOpenerFocus() {
    var target = opener;
    opener = null;

    if (target && target.isConnected && target.getClientRects().length > 0) {
      target.focus({ preventScroll: true });
    }
  }

  function rememberOpener(event) {
    var target = event.target;
    var trigger = target && typeof target.closest === 'function'
      ? target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')
      : null;

    if (!trigger) return;

    opener = trigger;
  }

  window.addEventListener('pointerdown', rememberOpener, true);

  document.addEventListener('click', function(event) {
    rememberOpener(event);

    if (!opener || !event.target || typeof event.target.closest !== 'function' || !event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')) return;

    window.requestAnimationFrame(focusFirstControl);
  }, true);

  document.addEventListener('keydown', function(event) {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      var closeButton = sidebar.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-menu"]');
      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeButton.click();
      }
      return;
    }

    if (event.key !== 'Tab') return;

    var focusableElements = getFocusableElements();
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    var first = focusableElements[0];
    var last = focusableElements[focusableElements.length - 1];
    var active = document.activeElement;
    var activeIndex = focusableElements.indexOf(active);

    if (!sidebar.contains(active) || activeIndex === -1) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function(event) {
    if (isOpen() && !sidebar.contains(event.target)) {
      // Let the theme's generic drawer trap settle before selecting a visible control.
      window.requestAnimationFrame(focusFirstControl);
    }
  });

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName !== 'aria-hidden') return;

      if (isOpen()) {
        window.requestAnimationFrame(focusFirstControl);
      } else {
        window.requestAnimationFrame(restoreOpenerFocus);
      }
    });
  }).observe(sidebar, { attributes: true, attributeFilter: ['aria-hidden'] });
})();



(function() {
  var STORAGE_KEY = 'pdp-debug';
  var win = window;
  var doc = win.document;
  var explicitValue = null;

  try {
    var params = win.location && typeof win.location.search === 'string' ? new URLSearchParams(win.location.search) : null;
    if (params && params.has('pdp-debug')) {
      explicitValue = params.get('pdp-debug');
    }
  } catch (error) {
    explicitValue = null;
  }

  var explicit = null;
  if (explicitValue !== null) {
    var normalized = String(explicitValue).toLowerCase();
    if (normalized === '1' || normalized === 'true' || normalized === 'on') {
      explicit = true;
    } else if (normalized === '0' || normalized === 'false' || normalized === 'off') {
      explicit = false;
    } else if (normalized === 'toggle') {
      try {
        var stored = win.localStorage && win.localStorage.getItem(STORAGE_KEY);
        explicit = stored !== '1';
      } catch (error) {
        explicit = true;
      }
    }
  }

  var enabled = false;
  if (explicit !== null) {
    enabled = explicit;
  } else {
    try {
      enabled = win.localStorage && win.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      enabled = false;
    }
  }

  if (explicit !== null) {
    try {
      if (win.localStorage) {
        if (enabled) {
          win.localStorage.setItem(STORAGE_KEY, '1');
        } else {
          win.localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch (error) {
      // ignore storage issues
    }
  }

  win.__PDP_DEBUG__ = !!enabled;
  win.PDPDebug = win.PDPDebug || {};
  win.PDPDebug.enabled = win.__PDP_DEBUG__;

  win.PDPDebug.setEnabled = function(next) {
    var value = !!next;
    win.__PDP_DEBUG__ = value;
    win.PDPDebug.enabled = value;
    try {
      if (win.localStorage) {
        if (value) {
          win.localStorage.setItem(STORAGE_KEY, '1');
        } else {
          win.localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch (error) {
      // ignore storage issues
    }
    if (doc && doc.documentElement) {
      doc.documentElement.setAttribute('data-pdp-debug', value ? 'true' : 'false');
    }
    return value;
  };

  win.PDPDebug.toggle = function() {
    return win.PDPDebug.setEnabled(!win.__PDP_DEBUG__);
  };

  win.PDPDebug.log = function() {
    if (!win.__PDP_DEBUG__) {
      return;
    }
    if (typeof console === 'undefined' || typeof console.log !== 'function') {
      return;
    }
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[PDP Debug]');
    console.log.apply(console, args);
  };

  win.PDPDebug.annotate = function(label, payload) {
    if (!win.__PDP_DEBUG__) {
      return;
    }
    win.PDPDebug.log(label, payload);
  };

  if (doc && doc.documentElement) {
    doc.documentElement.setAttribute('data-pdp-debug', win.__PDP_DEBUG__ ? 'true' : 'false');
  }
})();

(function () {
  var SELECTOR = '.ProductRecommendations [data-buy-it-with-carousel], .buy-it-with-wrapper [data-buy-it-with-carousel], [data-section-type="recently-viewed-products"] [data-buy-it-with-carousel]';
  var WRAPPER_SELECTOR = '.ProductItem__ImageCarouselWrapper';
  var HINT_CLASS = 'ProductItem__ImageCarouselWrapper--nudgeActive';

  function getWrapper(carousel) {
    return carousel && carousel.closest ? carousel.closest(WRAPPER_SELECTOR) : null;
  }

  function getInstance(carousel) {
    var instance = carousel && carousel.buyItWithCarousel;

    if (instance && typeof instance.getFlickityInstance === 'function') {
      instance = instance.getFlickityInstance();
    }

    if (instance && instance.flickityInstance) {
      instance = instance.flickityInstance;
    }

    if (instance && typeof instance.on === 'function') {
      return instance;
    }

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      try {
        instance = window.Flickity.data(carousel);
      } catch (error) {
        instance = null;
      }
    }

    return instance && typeof instance.on === 'function' ? instance : null;
  }

  function getSlideCount(carousel, instance) {
    if (instance && instance.slides && typeof instance.slides.length === 'number') {
      return instance.slides.length;
    }

    if (instance && instance.cells && typeof instance.cells.length === 'number') {
      return instance.cells.length;
    }

    return carousel ? carousel.querySelectorAll('.Carousel__Cell').length : 0;
  }

  function getSelectedIndex(carousel, instance) {
    if (instance && typeof instance.selectedIndex === 'number') {
      return instance.selectedIndex;
    }

    var slides = carousel ? Array.prototype.slice.call(carousel.querySelectorAll('.Carousel__Cell')) : [];
    var selectedSlide = carousel ? carousel.querySelector('.Carousel__Cell.is-selected') : null;
    var selectedIndex = selectedSlide ? slides.indexOf(selectedSlide) : -1;

    return selectedIndex >= 0 ? selectedIndex : 0;
  }

  function updateProgress(carousel, instance) {
    var wrapper = getWrapper(carousel);
    var progress = wrapper && wrapper.querySelector('[data-buy-it-with-progress], [data-buy-it-with-carousel-progress]');

    if (!wrapper || !progress) {
      return;
    }

    var slideCount = getSlideCount(carousel, instance);
    var selectedIndex = getSelectedIndex(carousel, instance);

    progress.hidden = slideCount < 2;
    progress.style.setProperty('--product-card-progress-count', Math.max(slideCount, 1));
    progress.style.setProperty('--product-card-progress-index', Math.min(Math.max(selectedIndex, 0), Math.max(slideCount - 1, 0)));
    progress.setAttribute('data-product-card-progress-count', String(slideCount));
    progress.setAttribute('data-product-card-progress-index', String(selectedIndex));
  }

  function getSlides(carousel) {
    return carousel ? Array.prototype.slice.call(carousel.querySelectorAll('[data-buy-it-with-slide], .Carousel__Cell')) : [];
  }

  function unveilImage(img) {
    if (window.DsrcvCardPhotos) {
      window.DsrcvCardPhotos.request(img);
      return;
    }
    if (!img || img.dataset.buyItWithLoadedOnce === 'true') {
      return;
    }

    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      window.lazySizes.loader.unveil(img);
    } else if (img.dataset.src) {
      img.src = img.dataset.src.replace('{width}', '600');
    }

    img.dataset.buyItWithLoadedOnce = 'true';
  }

  function warmImageAtIndex(carousel, index) {
    var slides = getSlides(carousel);
    if (!slides.length) {
      return;
    }

    var boundedIndex = index;
    if (boundedIndex < 0) {
      boundedIndex = slides.length - 1;
    }
    if (boundedIndex >= slides.length) {
      boundedIndex = 0;
    }

    var img = slides[boundedIndex].querySelector('img.lazyload, img[data-src]');
    unveilImage(img);
  }

  function warmNearbyImages(carousel, instance) {
    var selectedIndex = getSelectedIndex(carousel, instance);
    var slides = getSlides(carousel);
    if (window.DsrcvCardPhotos) {
      window.DsrcvCardPhotos.prepare(carousel, slides, selectedIndex, true, true);
      return;
    }

    slides.forEach(function(slide, index) {
      if (Math.abs(index - selectedIndex) > 1) {
        return;
      }

      unveilImage(slide.querySelector('img.lazyload, img[data-src]'));
    });
  }

  function selectDomIndex(carousel, index) {
    var slides = getSlides(carousel);
    var slider = carousel && (carousel.querySelector('.flickity-slider') || carousel);
    if (!slides.length || !slider) {
      return;
    }

    var boundedIndex = index;
    if (boundedIndex < 0) {
      boundedIndex = slides.length - 1;
    }
    if (boundedIndex >= slides.length) {
      boundedIndex = 0;
    }

    var selectedSlide = slides[boundedIndex];
    var slideOffset = selectedSlide.style.left || (boundedIndex * 100) + '%';

    slides.forEach(function(slide, slideIndex) {
      slide.classList.toggle('is-selected', slideIndex === boundedIndex);
    });

    slider.style.transition = 'transform 520ms cubic-bezier(0.22, 0.61, 0.36, 1)';
    slider.style.transform = 'translateX(-' + slideOffset + ')';
    carousel.dataset.buyItWithDomSelectedIndex = String(boundedIndex);
  }

  function moveCarousel(carousel, direction) {
    if (carousel.dataset.mobileMediaBound === 'true') return;
    var instance = getInstance(carousel);
    var selectedIndex = getSelectedIndex(carousel, instance);
    var targetIndex = direction === 'next' ? selectedIndex + 1 : selectedIndex - 1;

    warmImageAtIndex(carousel, targetIndex);

    if (instance) {
      if (instance.options) {
        instance.options.selectedAttraction = 0.025;
        instance.options.friction = 0.28;
        if (typeof instance.updatePhysics === 'function') {
          instance.updatePhysics();
        }
      }

      if (direction === 'next' && typeof instance.next === 'function') {
        instance.next(true);
      } else if (direction !== 'next' && typeof instance.previous === 'function') {
        instance.previous(true);
      } else {
        selectDomIndex(carousel, targetIndex);
      }
    } else {
      selectDomIndex(carousel, targetIndex);
    }

    window.requestAnimationFrame(function() {
      updateProgress(carousel, getInstance(carousel));
      warmNearbyImages(carousel, getInstance(carousel));
    });
  }

  function markBuyItWithManualMediaIntent(carousel) {
    if (!carousel) {
      return;
    }

    var wrapper = getWrapper(carousel) || carousel;
    carousel.dataset.buyItWithManualMediaIntent = 'true';

    if (wrapper && wrapper.dataset) {
      wrapper.dataset.productMediaManualIntent = 'true';
    }

    var manualIntentEvent = null;
    if (typeof window.CustomEvent === 'function') {
      manualIntentEvent = new window.CustomEvent('product-card:manual-media-intent', { bubbles: true });
    } else if (document.createEvent) {
      manualIntentEvent = document.createEvent('CustomEvent');
      manualIntentEvent.initCustomEvent('product-card:manual-media-intent', true, false, {});
    }

    if (manualIntentEvent) {
      carousel.dispatchEvent(manualIntentEvent);
    }
  }

  function clearBuyItWithManualMediaIntent(carousel) {
    if (!carousel) {
      return;
    }

    var wrapper = getWrapper(carousel) || carousel;
    delete carousel.dataset.buyItWithManualMediaIntent;

    if (wrapper && wrapper.dataset) {
      delete wrapper.dataset.productMediaManualIntent;
    }
  }

  function bindTrackpadSwipe(carousel) {
    if (!carousel || carousel.dataset.buyItWithTrackpadBound === 'true') {
      return;
    }

    var lastSwipeAt = 0;

    carousel.addEventListener('wheel', function(event) {
      var horizontalDelta = event.deltaX || 0;
      var verticalDelta = event.deltaY || 0;

      if (Math.abs(horizontalDelta) < 24 || Math.abs(horizontalDelta) < Math.abs(verticalDelta) * 1.2) {
        return;
      }

      markBuyItWithManualMediaIntent(carousel);

      var now = Date.now();
      if (now - lastSwipeAt < 450) {
        event.preventDefault();
        return;
      }

      lastSwipeAt = now;
      event.preventDefault();
      moveCarousel(carousel, horizontalDelta > 0 ? 'next' : 'prev');
    }, { passive: false });

    carousel.dataset.buyItWithTrackpadBound = 'true';
  }

  function bindDesktopHoverReel(carousel) {
    if (carousel && carousel.closest('.buy-it-with-wrapper')) return;
    if (!carousel || carousel.dataset.buyItWithHoverReelBound === 'true') {
      return;
    }

    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) {
      return;
    }

    var wrapper = getWrapper(carousel) || carousel;
    var hoverTimer = null;
    var isHovering = false;
    var hoverInitialDelay = 1200;
    var hoverInterval = 2000;
    var hoverScrollState = window.__dsrcvProductImageHoverScrollState;
    var unsubscribeHoverScroll = null;

    function handleHoverScrollChange(isScrolling) {
      if (!isHovering) return;

      if (isScrolling) {
        if (hoverTimer) {
          window.clearTimeout(hoverTimer);
          hoverTimer = null;
        }
      } else if (wrapper.matches && wrapper.matches(':hover') && carousel.dataset.buyItWithManualMediaIntent !== 'true') {
        scheduleNext(hoverInitialDelay);
      } else {
        stopHoverReel();
      }
    }

    function stopHoverReel() {
      isHovering = false;
      if (hoverTimer) {
        window.clearTimeout(hoverTimer);
        hoverTimer = null;
      }
      if (unsubscribeHoverScroll) {
        unsubscribeHoverScroll();
        unsubscribeHoverScroll = null;
      }
    }

    function advanceHoverReel() {
      if (hoverScrollState && hoverScrollState.isScrolling) return;
      if (!isHovering) {
        stopHoverReel();
        return;
      }

      var instance = getInstance(carousel);
      var slideCount = getSlideCount(carousel, instance);

      if (slideCount < 2) {
        return;
      }

      moveCarousel(carousel, 'next');
    }

    function scheduleNext(delay) {
      if (hoverScrollState && hoverScrollState.isScrolling) return;
      if (hoverTimer) {
        window.clearTimeout(hoverTimer);
      }

      hoverTimer = window.setTimeout(function() {
        advanceHoverReel();
        if (isHovering && carousel.dataset.buyItWithManualMediaIntent !== 'true') {
          scheduleNext(hoverInterval);
        }
      }, delay);
    }

    function startHoverReel() {
      if (isHovering || (hoverScrollState && hoverScrollState.isScrolling) || carousel.dataset.buyItWithManualMediaIntent === 'true') {
        return;
      }

      isHovering = true;
      if (hoverScrollState) {
        unsubscribeHoverScroll = hoverScrollState.subscribe(handleHoverScrollChange);
      }
      warmNearbyImages(carousel, getInstance(carousel));
      warmImageAtIndex(carousel, getSelectedIndex(carousel, getInstance(carousel)) + 1);
      scheduleNext(hoverInitialDelay);
    }

    function resetHoverReel() {
      stopHoverReel();
    }

    function handleManualMediaIntent() {
      stopHoverReel();
    }

    function handleDirectManualMediaIntent() {
      markBuyItWithManualMediaIntent(carousel);
      stopHoverReel();
    }

    carousel.addEventListener('product-card:manual-media-intent', handleManualMediaIntent);
    carousel.addEventListener('pointerdown', handleDirectManualMediaIntent, { passive: true });
    carousel.addEventListener('touchstart', handleDirectManualMediaIntent, { passive: true });
    carousel.addEventListener('keydown', handleDirectManualMediaIntent);
    wrapper.addEventListener('pointerenter', startHoverReel);
    wrapper.addEventListener('mouseenter', startHoverReel);
    wrapper.addEventListener('pointerleave', resetHoverReel);
    wrapper.addEventListener('mouseleave', resetHoverReel);
    wrapper.addEventListener('focusout', stopHoverReel);
    var manualIntentInstance = getInstance(carousel);
    if (manualIntentInstance && typeof manualIntentInstance.on === 'function') {
      manualIntentInstance.on('dragStart', handleDirectManualMediaIntent);
    }
    carousel.dataset.buyItWithHoverReelBound = 'true';
  }

  function bindProgress(carousel) {
    if (window.DsrcvMobileProductMedia && window.DsrcvMobileProductMedia.bind(carousel)) return;
    var wrapper = getWrapper(carousel);

    if (!carousel || !wrapper) {
      return;
    }

    wrapper.classList.remove(HINT_CLASS);
    wrapper.dataset.recommendationSwipeHintShown = 'true';
    carousel.dataset.recommendationSwipeHintObserved = 'disabled';
    bindTrackpadSwipe(carousel);
    bindDesktopHoverReel(carousel);

    var progress = wrapper.querySelector('[data-buy-it-with-progress], [data-buy-it-with-carousel-progress]');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'ProductItem__ImageCarouselProgress';
      progress.setAttribute('data-buy-it-with-progress', '');
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span></span>';
      wrapper.appendChild(progress);
    } else if (!progress.hasAttribute('data-buy-it-with-progress')) {
      progress.setAttribute('data-buy-it-with-progress', '');
    }

    var instance = getInstance(carousel);
    var update = function () {
      updateProgress(carousel, getInstance(carousel) || instance);
    };

    if (carousel.dataset.buyItWithProgressDomBound !== 'true') {
      carousel.addEventListener('pointerup', update);
      carousel.addEventListener('touchend', update, { passive: true });
      carousel.addEventListener('keyup', update);
      carousel.addEventListener('transitionend', update);

      if ('MutationObserver' in window) {
        var selectedObserver = new MutationObserver(update);
        selectedObserver.observe(carousel, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
      }

      carousel.dataset.buyItWithProgressDomBound = 'true';
    }

    if (!instance) {
      updateProgress(carousel, null);

      var attempts = parseInt(carousel.getAttribute('data-buy-it-with-progress-attempts'), 10) || 0;
      if (attempts < 30) {
        carousel.setAttribute('data-buy-it-with-progress-attempts', String(attempts + 1));
        window.setTimeout(function () {
          bindProgress(carousel);
        }, 150);
      }
      return;
    }

    if (carousel.dataset.buyItWithProgressBound !== 'true') {
      instance.on('select', update);
      instance.on('settle', update);
      instance.on('dragEnd', update);
      carousel.dataset.buyItWithProgressBound = 'true';
    }

    updateProgress(carousel, instance);
  }

  function bindAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var carousels = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];

    Array.prototype.forEach.call(carousels, bindProgress);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAll(document);
  });
  window.addEventListener('load', function () {
    bindAll(document);
  });
  document.addEventListener('ajax-product:loaded', function (event) {
    bindAll(event.target || document);
  });
  document.addEventListener('dsrcv:mobile-media-change', function() { bindAll(document); });
  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target || document);
  });

  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) {
            return;
          }

          if (typeof node.matches === 'function' && node.matches(SELECTOR)) {
            bindProgress(node);
            return;
          }

          bindAll(node);
        });
      });
    });

    document.addEventListener('DOMContentLoaded', function () {
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

(function(win, doc) {
  if (!win || !doc) {
    return;
  }

  var CAROUSEL_SELECTOR = '[data-product-card-carousel]';
  var WRAPPER_SELECTOR = '[data-product-card-gallery]';
  var STORAGE_KEY = 'pdp-product-card-swipe-hint';
  var storageAvailable = null;
  var nudgeTriggered = false;
  var nudgeTimer = null;
  var mutationObserver = null;
  var productMediaCache = {};
  var isProductPage = false;
  var deferProductCards = false;
  var deferredCardObserver = null;
  var deferredCards = new Set();
  var visibleCardObserver = null;
  var visibleHintCards = new Set();

  function ready(callback) {
    if (typeof callback !== 'function') {
      return;
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function parseJsonSafely(value, fallback) {
    if (!value || typeof value !== 'string') {
      return fallback || {};
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback || {};
    }
  }

  function canUseSessionStorage() {
    if (storageAvailable !== null) {
      return storageAvailable;
    }

    try {
      var testKey = '__product_card_hint__';
      win.sessionStorage.setItem(testKey, '1');
      win.sessionStorage.removeItem(testKey);
      storageAvailable = true;
    } catch (error) {
      storageAvailable = false;
    }

    return storageAvailable;
  }

  function hasSeenNudge() {
    return canUseSessionStorage() && win.sessionStorage.getItem(STORAGE_KEY) === '1';
  }

  function markNudgeSeen() {
    if (canUseSessionStorage()) {
      win.sessionStorage.setItem(STORAGE_KEY, '1');
    }
  }

  function getCarouselInstance(node) {
    if (!node) {
      return null;
    }

    if (node.productCardCarousel) {
      return node.productCardCarousel;
    }

    if (win.Flickity && typeof win.Flickity.data === 'function') {
      return win.Flickity.data(node);
    }

    return null;
  }

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function getProductHandle(node) {
    if (!node) {
      return '';
    }

    var wrapper = node.closest(WRAPPER_SELECTOR) || node;
    var link = wrapper.querySelector('a[href*="/products/"]');
    if (!link) {
      return '';
    }

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? match[1] : '';
  }

  function getProductMedia(handle) {
    if (!handle || typeof win.fetch !== 'function') {
      return Promise.resolve(null);
    }

    if (!productMediaCache[handle]) {
      productMediaCache[handle] = win.fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response || !response.ok) {
          throw new Error('Product media unavailable');
        }

        return response.json();
      }).catch(function() {
        return null;
      });
    }

    return productMediaCache[handle];
  }

  function pickVideoSources(media) {
    var sources = Array.isArray(media && media.sources) ? media.sources : [];
    return sources.filter(function(source) {
      var type = (source.mime_type || source.mimeType || source.type || '').toLowerCase();
      var url = source.url || source.src || '';
      return url && (type.indexOf('video/mp4') !== -1 || /\.mp4(?:\?|$)/i.test(url));
    }).sort(function(a, b) {
      return (a.height || 0) - (b.height || 0);
    });
  }

  function buildVideoSlide(media, fallbackTitle, aspectRatio) {
    var sources = pickVideoSources(media);
    if (!sources.length) {
      return null;
    }

    var preview = media.preview_image || media.previewImage || {};
    var poster = preview.src || '';
    var mediaId = media.id || sources[0].url;
    var alt = media.alt || fallbackTitle || '';
    var ratio = aspectRatio || preview.aspect_ratio || (preview.width && preview.height ? preview.width / preview.height : 1);
    var sourceMarkup = sources.map(function(source) {
      var type = source.mime_type || source.mimeType || source.type || 'video/mp4';
      return '<source data-src="' + escapeAttribute(source.url || source.src) + '" type="' + escapeAttribute(type) + '">';
    }).join('');

    var cell = doc.createElement('div');
    cell.className = 'Carousel__Cell';
    cell.setAttribute('data-product-card-slide', '');
    cell.setAttribute('data-product-card-video-slide', '');
    cell.setAttribute('data-media-id', mediaId);
    cell.innerHTML =
      '<a href="' + escapeAttribute(getProductUrlForSlide(media)) + '" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--video" aria-label="' + escapeAttribute(alt) + '">' +
        '<div class="AspectRatio AspectRatio--withFallback" style="max-width:none; padding-bottom:' + (100 / ratio) + '%; --aspect-ratio:' + ratio + '">' +
          '<div class="VideoWrapper VideoWrapper--native">' +
            '<video class="ProductItem__Video" data-media-id="' + escapeAttribute(mediaId) + '" data-video-src="' + escapeAttribute(sources[0].url || sources[0].src) + '" poster="' + escapeAttribute(poster) + '" muted playsinline loop preload="none" tabindex="-1" aria-label="' + escapeAttribute(alt) + '">' +
              sourceMarkup +
            '</video>' +
          '</div>' +
        '</div>' +
      '</a>';

    return cell;
  }

  function getProductUrlForSlide(media) {
    return media && media.product_url ? media.product_url : '#';
  }

  function getCarouselLink(node) {
    var wrapper = node && (node.closest(WRAPPER_SELECTOR) || node);
    var link = wrapper && wrapper.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : '#';
  }

  function appendVideoSlides(node, productData) {
    if (!node || !productData || node.dataset.productCardMediaEnhanced === 'true') {
      return;
    }

    var media = Array.isArray(productData.media) ? productData.media : [];
    var videos = media.filter(function(item) {
      return /video/i.test(item.media_type || item.type || '') && pickVideoSources(item).length;
    });

    if (!videos.length) {
      node.dataset.productCardMediaEnhanced = 'true';
      return;
    }

    var existingIds = {};
    Array.prototype.forEach.call(node.querySelectorAll('[data-media-id]'), function(element) {
      var id = element.getAttribute('data-media-id');
      if (id) {
        existingIds[id] = true;
      }
    });

    var referenceImage = node.querySelector('.ProductItem__Image');
    var referenceRatio = referenceImage && referenceImage.getAttribute('width') && referenceImage.getAttribute('height')
      ? parseFloat(referenceImage.getAttribute('width')) / parseFloat(referenceImage.getAttribute('height'))
      : 1;
    var productUrl = getCarouselLink(node);
    var instance = getCarouselInstance(node);
    var appended = false;

    videos.forEach(function(video) {
      var mediaId = String(video.id || '');
      if (mediaId && existingIds[mediaId]) {
        return;
      }

      video.product_url = productUrl;
      var cell = buildVideoSlide(video, productData.title, referenceRatio);
      if (!cell) {
        return;
      }

      if (instance && typeof instance.append === 'function') {
        instance.append(cell);
      } else {
        node.appendChild(cell);
      }

      if (mediaId) {
        existingIds[mediaId] = true;
      }
      appended = true;
    });

    if (appended) {
      var slideCount = node.querySelectorAll('[data-product-card-slide]').length;
      node.setAttribute('data-slide-count', String(slideCount));
      if (instance && typeof instance.reloadCells === 'function') {
        instance.reloadCells();
      }
      if (instance && typeof instance.resize === 'function') {
        instance.resize();
      }
      bindProductCardProgress(node, instance || getCarouselInstance(node));
      delete node.dataset.productCardVideoBound;
      bindVideoLifecycle(node, instance || getCarouselInstance(node));
      bindNavControls(node, instance || getCarouselInstance(node));
      node.dispatchEvent(new win.CustomEvent('product-card:media-enhanced'));
    }

    node.dataset.productCardMediaEnhanced = 'true';
  }

  function enrichCarouselMedia(node) {
    if (!node || node.dataset.productCardMediaLoading === 'true' || node.dataset.productCardMediaEnhanced === 'true') {
      return;
    }

    var handle = getProductHandle(node);
    if (!handle) {
      return;
    }

    node.dataset.productCardMediaLoading = 'true';
    getProductMedia(handle).then(function(productData) {
      appendVideoSlides(node, productData);
      delete node.dataset.productCardMediaLoading;
    }, function() {
      delete node.dataset.productCardMediaLoading;
    });
  }

  function protectInnerCarousel(node) {
    if (!node) {
      return;
    }

    var guardTarget = node.closest(WRAPPER_SELECTOR) || node;
    if ((node.dataset && node.dataset.productCardGuard === 'true') || (guardTarget.dataset && guardTarget.dataset.productCardGuard === 'true')) {
      return;
    }

    var stopPropagation = function(event) {
      event.stopPropagation();
    };

    ['touchstart', 'touchmove', 'pointerdown', 'pointermove', 'mousedown', 'mousemove'].forEach(function(eventName) {
      guardTarget.addEventListener(eventName, stopPropagation, { passive: true });
    });

    if (node.dataset) {
      node.dataset.productCardGuard = 'true';
    }
    guardTarget.dataset.productCardGuard = 'true';
  }

  function requestNudge(delay) {
    if (nudgeTriggered || hasSeenNudge()) {
      nudgeTriggered = true;
      return;
    }

    if (nudgeTimer) {
      win.clearTimeout(nudgeTimer);
    }

    var timeout = typeof delay === 'number' ? delay : 600;
    nudgeTimer = win.setTimeout(function() {
      if (!triggerNudge()) {
        nudgeTimer = null;
      }
    }, Math.max(timeout, 0));
  }

  function findEligibleWrapper() {
    var carousels = doc.querySelectorAll(CAROUSEL_SELECTOR);

    for (var i = 0; i < carousels.length; i += 1) {
      var carousel = carousels[i];
      var slideCount = parseInt(carousel.getAttribute('data-slide-count'), 10);

      if (!slideCount || slideCount < 2) {
        continue;
      }

      var wrapper = carousel.closest(WRAPPER_SELECTOR);
      if (!wrapper || wrapper.dataset.swipeHintShown === 'true') {
        continue;
      }

      if (isProductPage) {
        if (carousel.dataset.productCardBound !== 'true' && !getCarouselInstance(carousel)) continue;
        var rect = wrapper.getBoundingClientRect();
        if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= win.innerHeight ||
            rect.right <= 0 || rect.left >= win.innerWidth) continue;
      }

      return wrapper;
    }

    return null;
  }

  function triggerNudge() {
    if (nudgeTriggered || hasSeenNudge()) {
      nudgeTriggered = true;
      return true;
    }

    var wrapper = findEligibleWrapper();
    if (!wrapper) {
      return false;
    }

    nudgeTriggered = true;
    nudgeTimer = null;
    wrapper.dataset.swipeHintShown = 'true';
    markNudgeSeen();
    return true;
  }

  function bindNavControls(node, instance) {
    if (!node || !instance) {
      return;
    }

    var id = node.id;
    if (!id) {
      return;
    }

    var selector = '[data-product-card-nav="' + id + '"]';
    var nav = doc.querySelector(selector);
    if (!nav || nav.dataset.productCardNavBound === 'true') {
      return;
    }

    var prevButton = nav.querySelector('[data-direction="prev"]');
    var nextButton = nav.querySelector('[data-direction="next"]');

    var pendingIndex = null;
    var cancelPhotoWait = null;
    var requestId = 0;
    function cancelPendingPhoto() {
      requestId += 1;
      if (cancelPhotoWait) cancelPhotoWait();
      cancelPhotoWait = null;
      pendingIndex = null;
    }
    function navigate(direction) {
      var current = getCarouselInstance(node) || instance;
      if (node.dataset.productCardManualDesktop !== 'true') {
        markProductCardManualMediaIntent(node);
        var method = direction < 0 ? 'previous' : 'next';
        if (typeof current[method] === 'function') current[method](true, false);
        return;
      }
      var slides = Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide]'));
      if (!slides.length || node.dataset.mobileMediaBound === 'true') return;
      var startIndex = pendingIndex === null ? getProductCardManualStartIndex(node, current) : pendingIndex;
      var target = (startIndex + direction + slides.length) % slides.length;
      cancelPendingPhoto();
      pendingIndex = target;
      var token = requestId;
      var modelMode = doc.body.classList.contains('model-image-active');
      var image = slides[target].querySelector('img');
      function commit() {
        if (token !== requestId) return;
        cancelPendingPhoto();
        if (!node.isConnected || node.dataset.mobileMediaBound === 'true' ||
            (getCarouselInstance(node) || instance) !== current ||
            modelMode !== doc.body.classList.contains('model-image-active')) return;
        markProductCardManualMediaIntent(node);
        // A ready destination replaces the visible photo in one paint. This also
        // avoids crossing unloaded intermediate cells after rapid arrow clicks.
        current.select(target, false, true);
        updateProductCardProgress(node, current);
        warmNearbyProductCardImages(node, current);
      }
      if (!image) { commit(); return; }
      function loaded() {
        if (!image.complete || image.naturalWidth < 1) return;
        image.removeEventListener('load', loaded);
        if (typeof image.decode === 'function') image.decode().then(commit, failed);
        else commit();
      }
      function failed() { if (token === requestId) cancelPendingPhoto(); }
      image.addEventListener('load', loaded);
      image.addEventListener('error', failed, { once: true });
      cancelPhotoWait = function() {
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
        if (mobileQuery && mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', cancelPendingPhoto);
      };
      if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', cancelPendingPhoto);
      warmProductCardImageAtIndex(node, current, target);
      loaded();
    }
    function preparePhotos() {
      if (node.dataset.productCardManualDesktop !== 'true' || node.dataset.mobileMediaBound === 'true' || !win.DsrcvCardPhotos) return;
      var current = getCarouselInstance(node) || instance;
      win.DsrcvCardPhotos.prepare(node, Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide]')),
        getProductCardManualStartIndex(node, current), true, true);
    }
    var wrapper = getProductCardWrapper(node);
    if (wrapper) {
      wrapper.addEventListener('pointerenter', preparePhotos);
      wrapper.addEventListener('focusin', preparePhotos);
    }
    node.addEventListener('product-card:view-change', cancelPendingPhoto);
    var mobileQuery = win.matchMedia && win.matchMedia('(max-width: 1007px)');
    var handlePrev = function(event) {
      event.preventDefault();
      event.stopPropagation();
      navigate(-1);
    };
    var handleNext = function(event) {
      event.preventDefault();
      event.stopPropagation();
      navigate(1);
    };

    if (prevButton) {
      prevButton.addEventListener('click', handlePrev);
    }

    if (nextButton) {
      nextButton.addEventListener('click', handleNext);
    }

    var updateNavState = function() {
      var canWrap = node.dataset.productCardManualDesktop === 'true' || (!!instance.options && !!instance.options.wrapAround);
      var slideCount = instance.slides ? instance.slides.length : 0;
      var hasMultiple = slideCount > 1;

      if (prevButton) {
        var canGoPrev = canWrap || instance.selectedIndex > 0;
        prevButton.disabled = !hasMultiple || !canGoPrev;
      }

      if (nextButton) {
        var canGoNext = canWrap || instance.selectedIndex < slideCount - 1;
        nextButton.disabled = !hasMultiple || !canGoNext;
      }
    };

    if (typeof instance.on === 'function') {
      instance.on('select', updateNavState);
      instance.on('settle', updateNavState);
    }

    updateNavState();
    nav.dataset.productCardNavBound = 'true';
  }

  function getProductCardSlideCount(node, instance) {
    if (instance && instance.slides && typeof instance.slides.length === 'number') {
      return instance.slides.length;
    }

    if (instance && instance.cells && typeof instance.cells.length === 'number') {
      return instance.cells.length;
    }

    var attrCount = parseInt(node && node.getAttribute('data-slide-count'), 10);

    if (attrCount) {
      return attrCount;
    }

    return node ? node.querySelectorAll('[data-product-card-slide]').length : 0;
  }

  function getProductCardSelectedIndex(instance, node) {
    if (instance && typeof instance.selectedIndex === 'number') {
      return instance.selectedIndex;
    }

    var domSelectedIndex = parseInt(node && node.dataset && node.dataset.productCardDomSelectedIndex, 10);
    if (!Number.isNaN(domSelectedIndex)) {
      return domSelectedIndex;
    }

    var slides = node ? Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide], .Carousel__Cell')) : [];
    var selectedSlide = node ? node.querySelector('.Carousel__Cell.is-selected, [data-product-card-slide].is-selected') : null;
    var selectedIndex = selectedSlide ? slides.indexOf(selectedSlide) : -1;

    return selectedIndex >= 0 ? selectedIndex : 0;
  }

  function updateProductCardProgress(node, instance) {
    var wrapper = node && node.closest(WRAPPER_SELECTOR);
    var progress = wrapper && wrapper.querySelector('[data-product-card-progress]');

    if (!wrapper || !progress) {
      return;
    }

    var slideCount = getProductCardSlideCount(node, instance);
    var selectedIndex = getProductCardSelectedIndex(instance, node);

    progress.hidden = slideCount < 2;
    progress.style.setProperty('--product-card-progress-count', Math.max(slideCount, 1));
    progress.style.setProperty('--product-card-progress-index', Math.min(Math.max(selectedIndex, 0), Math.max(slideCount - 1, 0)));
    progress.setAttribute('data-product-card-progress-count', String(slideCount));
    progress.setAttribute('data-product-card-progress-index', String(selectedIndex));
  }

  function getProductCardWrapper(node) {
    return node && (node.closest(WRAPPER_SELECTOR) || node);
  }

  function getProductCardManualStartIndex(node, instance) {
    var root = node.closest('.product-image-container-main');
    var model = root && root.querySelector('[data-model-media-id]');
    if (root && root.dataset.productCardSwipingMedia !== 'true' && model && doc.body.classList.contains('model-image-active')) {
      var mediaId = model.getAttribute('data-model-media-id');
      var slides = Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide]'));
      var modelIndex = slides.findIndex(function(slide) { return slide.getAttribute('data-media-id') === mediaId; });
      return modelIndex < 0 ? Math.min(1, slides.length - 1) : modelIndex;
    }
    return getProductCardSelectedIndex(instance, node);
  }

  function markProductCardManualMediaIntent(node) {
    if (!node) {
      return;
    }

    var wrapper = getProductCardWrapper(node);
    // Start a manual collection gesture from the image the customer is seeing.
    if (node.dataset.productCardManualDesktop === 'true') {
      var root = node.closest('.product-image-container-main');
      var active = getCarouselInstance(node);
      if (active && active.select) active.select(getProductCardManualStartIndex(node, active), false, true);
      if (root) root.dataset.productCardSwipingMedia = 'true';
    }
    node.dataset.productCardManualMediaIntent = 'true';

    if (wrapper && wrapper.dataset) {
      wrapper.dataset.productCardManualMediaIntent = 'true';
    }
  }

  function warmProductCardImageAtIndex(node, instance, index) {
    var slideCount = getProductCardSlideCount(node, instance);
    if (!node || slideCount < 1) {
      return;
    }

    var boundedIndex = index;
    if (boundedIndex < 0) {
      boundedIndex = slideCount - 1;
    }
    if (boundedIndex >= slideCount) {
      boundedIndex = 0;
    }

    var cell = instance && instance.cells && instance.cells[boundedIndex] ? instance.cells[boundedIndex].element : null;
    var slide = cell || node.querySelectorAll('[data-product-card-slide]')[boundedIndex];
    var image = slide && slide.querySelector ? slide.querySelector('img') : null;

    if (!image) {
      return;
    }
    if (win.DsrcvCardPhotos) {
      win.DsrcvCardPhotos.request(image);
      return;
    }

    image.loading = 'eager';

    if (image.dataset) {
      if (image.dataset.src && !image.getAttribute('src')) {
        image.setAttribute('src', image.dataset.src);
      }
      if (image.dataset.srcset && !image.getAttribute('srcset')) {
        image.setAttribute('srcset', image.dataset.srcset);
      }
    }

    if (win.lazySizes && win.lazySizes.loader && typeof win.lazySizes.loader.unveil === 'function') {
      win.lazySizes.loader.unveil(image);
    }

    if (typeof image.decode === 'function' && image.complete === false) {
      image.decode().catch(function() {});
    }
  }

  function warmNearbyProductCardImages(node, instance) {
    if (!node || !instance) {
      return;
    }

    var selectedIndex = getProductCardSelectedIndex(instance, node);
    if (win.DsrcvCardPhotos) {
      var hasIntent = node.dataset.productCardManualMediaIntent === 'true' || node.matches(':hover') || !!(getProductCardWrapper(node) && getProductCardWrapper(node).matches(':hover'));
      win.DsrcvCardPhotos.prepare(node, Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide]')), selectedIndex, hasIntent, true);
      return;
    }
    warmProductCardImageAtIndex(node, instance, selectedIndex + 1);
    warmProductCardImageAtIndex(node, instance, selectedIndex - 1);
  }

  function selectProductCardDomIndex(node, index) {
    var slides = node ? Array.prototype.slice.call(node.querySelectorAll('[data-product-card-slide], .Carousel__Cell')) : [];
    if (!node || slides.length < 2) {
      return;
    }

    var selectedIndex = index;
    if (selectedIndex < 0) selectedIndex = slides.length - 1;
    if (selectedIndex >= slides.length) selectedIndex = 0;

    var wrapper = getProductCardWrapper(node);
    var viewport = node.querySelector('.flickity-viewport');
    var slider = node.querySelector('.flickity-slider') || node;
    var wrapperHeight = wrapper && wrapper.getBoundingClientRect ? wrapper.getBoundingClientRect().height : 0;

    if (wrapper) {
      wrapper.style.overflow = 'hidden';
    }

    if (viewport && wrapperHeight) {
      viewport.style.height = wrapperHeight + 'px';
    }

    node.dataset.productCardDomSelectedIndex = String(selectedIndex);
    slider.style.left = '0px';
    slider.style.width = '100%';
    slider.style.height = '100%';
    slider.style.transition = slider.style.transition || 'transform 360ms cubic-bezier(0.22, 0.61, 0.36, 1)';

    slides.forEach(function(slide, slideIndex) {
      slide.style.position = 'absolute';
      slide.style.left = (slideIndex * 100) + '%';
      slide.style.width = '100%';
      slide.style.height = '100%';
      slide.classList.toggle('is-selected', slideIndex === selectedIndex);
    });

    slider.style.transform = 'translateX(-' + (selectedIndex * 100) + '%)';
    updateProductCardProgress(node, null);
  }

  function advanceProductCard(node, instance, direction) {
    var selectedIndex = getProductCardSelectedIndex(instance, node);
    var targetIndex = direction === 'prev' ? selectedIndex - 1 : selectedIndex + 1;

    warmProductCardImageAtIndex(node, instance, targetIndex);

    if (instance && typeof instance.next === 'function' && direction !== 'prev') {
      instance.next(true, false);
      updateProductCardProgress(node, instance);
      return;
    }

    if (instance && typeof instance.previous === 'function' && direction === 'prev') {
      instance.previous(true, false);
      updateProductCardProgress(node, instance);
      return;
    }

    selectProductCardDomIndex(node, targetIndex);
  }

  function bindProductCardProgress(node, instance) {
    var wrapper = node && node.closest(WRAPPER_SELECTOR);

    if (!wrapper) {
      return;
    }

    var progress = wrapper.querySelector('[data-product-card-progress]');

    if (!progress) {
      progress = doc.createElement('div');
      progress.className = 'ProductItem__ImageCarouselProgress';
      progress.setAttribute('data-product-card-progress', '');
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span></span>';
      wrapper.appendChild(progress);
    }

    if (node.dataset.productCardProgressBound !== 'true' && instance && typeof instance.on === 'function') {
      var update = function() {
        updateProductCardProgress(node, instance);
      };

      instance.on('select', update);
      instance.on('settle', update);
      instance.on('dragEnd', update);
      node.dataset.productCardProgressBound = 'true';
    }

    updateProductCardProgress(node, instance);
  }

  function bindProductCardHoverReel(node, instance) {
    if (!node || node.dataset.productCardHoverReelBound === 'true' || node.dataset.productCardManualDesktop === 'true') {
      return;
    }

    var wrapper = getProductCardWrapper(node);
    var hoverTimer = null;
    var isHovering = false;
    var lastHoverMoveStart = 0;
    var hoverInitialDelay = 1200;
    var hoverInterval = 2000;
    var hoverRevealedProductMedia = false;
    var hoverScrollState = win.__dsrcvProductImageHoverScrollState;
    var unsubscribeHoverScroll = null;

    function canUseHoverReel() {
      return !!(
        node.dataset.mobileMediaBound !== 'true' &&
        win.matchMedia &&
        win.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !win.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        win.matchMedia('(min-width: 641px)').matches
      );
    }

    function revealProductMediaForHover() {
      var root = node.closest('.product-image-container-main');

      if (
        root &&
        root.dataset &&
        doc.body &&
        doc.body.classList.contains('model-image-active') &&
        root.querySelector('.model-image-container')
      ) {
        root.dataset.productCardSwipingMedia = 'true';
        hoverRevealedProductMedia = true;
      }
    }

    function restoreModelMediaAfterHover() {
      var root = node.closest('.product-image-container-main');

      // A swipe or key press takes ownership of the visible media from hover.
      if (hoverRevealedProductMedia && node.dataset.productCardManualMediaIntent !== 'true' && root && root.dataset) {
        delete root.dataset.productCardSwipingMedia;
      }

      hoverRevealedProductMedia = false;
    }

    function resetProductCardToStart() {
      if (getProductCardSlideCount(node, instance) < 2) {
        return;
      }

      warmProductCardImageAtIndex(node, instance, 0);

      if (instance && typeof instance.select === 'function') {
        instance.select(0, false, true);
        updateProductCardProgress(node, instance);
        return;
      }

      selectProductCardDomIndex(node, 0);
    }

    function stopHoverReel(resetToStart) {
      isHovering = false;
      if (hoverTimer) {
        win.clearTimeout(hoverTimer);
        hoverTimer = null;
      }
      if (unsubscribeHoverScroll) {
        unsubscribeHoverScroll();
        unsubscribeHoverScroll = null;
      }
      if (resetToStart && node.dataset.productCardManualMediaIntent !== 'true') {
        resetProductCardToStart();
      }
      restoreModelMediaAfterHover();
    }

    function scheduleNext(delay) {
      if (hoverScrollState && hoverScrollState.isScrolling) return;
      if (hoverTimer) {
        win.clearTimeout(hoverTimer);
      }

      hoverTimer = win.setTimeout(function() {
        if (!canUseHoverReel() || !isHovering || node.dataset.productCardManualMediaIntent === 'true') {
          stopHoverReel(false);
          return;
        }

        if (getProductCardSlideCount(node, instance) > 1) {
          revealProductMediaForHover();
          advanceProductCard(node, instance, 'next');
          warmNearbyProductCardImages(node, instance);
        }

        if (isHovering && node.dataset.productCardManualMediaIntent !== 'true') {
          scheduleNext(hoverInterval);
        }
      }, delay);
    }

    function startHoverReel() {
      if (!canUseHoverReel() || isHovering || (hoverScrollState && hoverScrollState.isScrolling) || node.dataset.productCardManualMediaIntent === 'true') {
        return;
      }

      isHovering = true;
      if (hoverScrollState) {
        unsubscribeHoverScroll = hoverScrollState.subscribe(function(isScrolling) {
          if (!isHovering) return;
          if (isScrolling) {
            if (hoverTimer) {
              win.clearTimeout(hoverTimer);
              hoverTimer = null;
            }
          } else if (wrapper && wrapper.matches && wrapper.matches(':hover') && node.dataset.productCardManualMediaIntent !== 'true') {
            scheduleNext(hoverInitialDelay);
          } else {
            stopHoverReel(true);
          }
        });
      }
      warmNearbyProductCardImages(node, instance);
      warmProductCardImageAtIndex(node, instance, getProductCardSelectedIndex(instance, node) + 1);
      scheduleNext(hoverInitialDelay);
    }

    function startHoverReelFromMouseover(event) {
      if (!canUseHoverReel()) {
        return;
      }

      if (event && event.relatedTarget && wrapper && wrapper.contains(event.relatedTarget)) {
        return;
      }

      startHoverReel();
    }

    function startHoverReelFromMove() {
      if (!canUseHoverReel()) {
        return;
      }

      var now = Date.now ? Date.now() : new Date().getTime();
      if (now - lastHoverMoveStart < 250) {
        return;
      }

      lastHoverMoveStart = now;
      startHoverReel();
    }

    function handleDirectManualMediaIntent() {
      markProductCardManualMediaIntent(node);
      stopHoverReel(false);
    }

    function handleWheel(event) {
      var horizontalDelta = event && event.deltaX ? event.deltaX : 0;
      var verticalDelta = event && event.deltaY ? event.deltaY : 0;

      if (Math.abs(horizontalDelta) < 24 || Math.abs(horizontalDelta) < Math.abs(verticalDelta) * 1.2) {
        return;
      }

      handleDirectManualMediaIntent();
    }

    if (wrapper) {
      wrapper.addEventListener('pointerenter', startHoverReel);
      wrapper.addEventListener('mouseenter', startHoverReel);
      wrapper.addEventListener('mouseover', startHoverReelFromMouseover);
      wrapper.addEventListener('mousemove', startHoverReelFromMove);
      wrapper.addEventListener('pointerleave', function() {
        stopHoverReel(true);
      });
      wrapper.addEventListener('mouseleave', function() {
        stopHoverReel(true);
      });
      wrapper.addEventListener('focusout', function() {
        stopHoverReel(true);
      });
    }

    node.addEventListener('pointerdown', handleDirectManualMediaIntent, { passive: true });
    node.addEventListener('touchstart', handleDirectManualMediaIntent, { passive: true });
    node.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        handleDirectManualMediaIntent();
      } else {
        stopHoverReel(false);
      }
    });
    node.addEventListener('wheel', handleWheel, { passive: true });
    node.addEventListener('product-card:view-change', function() {
      delete node.dataset.productCardManualMediaIntent;
      if (wrapper && wrapper.dataset) delete wrapper.dataset.productCardManualMediaIntent;
      stopHoverReel(true);
      var root = node.closest('.product-image-container-main');
      if (root && root.dataset) delete root.dataset.productCardSwipingMedia;
    });

    if (instance && typeof instance.on === 'function') {
      instance.on('dragStart', handleDirectManualMediaIntent);
      instance.on('select', function() {
        updateProductCardProgress(node, instance);
        warmNearbyProductCardImages(node, instance);
      });
      instance.on('settle', function() {
        updateProductCardProgress(node, instance);
        warmNearbyProductCardImages(node, instance);
      });
    }

    node.dataset.productCardHoverReelBound = 'true';
  }

  function applyClickGuards(node, instance) {
    if (!node || !instance || typeof instance.on !== 'function') {
      return;
    }

    var wrapper = node.closest(WRAPPER_SELECTOR) || node;
    if (!wrapper || wrapper.dataset.productCardClickGuard === 'true') {
      return;
    }

    var dragStarted = false;
    var dragMoved = false;
    var dragJustHappened = false;
    var pointerStartX = null;
    var pointerStartY = null;
    var pointerDeltaExceeded = false;
    var POINTER_MOVE_THRESHOLD = 8;
    var DRAG_RESET_DELAY = 420;
    var dragResetTimer = null;
    var resetDragState = function() {
      dragStarted = false;
      dragMoved = false;
      dragJustHappened = false;
      pointerStartX = null;
      pointerStartY = null;
      pointerDeltaExceeded = false;
      if (dragResetTimer) {
        win.clearTimeout(dragResetTimer);
        dragResetTimer = null;
      }
      if (wrapper.dataset) {
        delete wrapper.dataset.productCardDragging;
      }
    };

    instance.on('dragStart', function() {
      dragStarted = true;
      dragMoved = false;
      dragJustHappened = false;
      if (wrapper.dataset) {
        wrapper.dataset.productCardDragging = 'true';
      }
    });

    instance.on('dragMove', function() {
      if (dragStarted) {
        dragMoved = true;
      }
    });

    instance.on('dragEnd', function() {
      if (dragStarted) {
        dragJustHappened = dragMoved || pointerDeltaExceeded || (typeof instance.dragged === 'boolean' && instance.dragged === true);
      }
      if (dragResetTimer) {
        win.clearTimeout(dragResetTimer);
      }
      dragResetTimer = win.setTimeout(resetDragState, DRAG_RESET_DELAY);
    });

    var handlePointerDown = function(event) {
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerDeltaExceeded = false;
    };

    var handlePointerMove = function(event) {
      if (pointerStartX === null || pointerStartY === null) {
        return;
      }

      if (Math.abs(event.clientX - pointerStartX) > POINTER_MOVE_THRESHOLD || Math.abs(event.clientY - pointerStartY) > POINTER_MOVE_THRESHOLD) {
        pointerDeltaExceeded = true;
      }
    };

    var handlePointerUp = function() {
      pointerStartX = null;
      pointerStartY = null;
    };

    wrapper.addEventListener('pointerdown', handlePointerDown, { passive: true, capture: true });
    wrapper.addEventListener('pointermove', handlePointerMove, { passive: true, capture: true });
    wrapper.addEventListener('pointerup', handlePointerUp, { passive: true, capture: true });
    if (!('PointerEvent' in win)) {
      wrapper.addEventListener('touchstart', function(event) {
        if (!event || !event.touches || !event.touches.length) {
          return;
        }
        handlePointerDown(event.touches[0]);
      }, { passive: true, capture: true });

      wrapper.addEventListener('touchmove', function(event) {
        if (!event || !event.touches || !event.touches.length) {
          return;
        }
        handlePointerMove(event.touches[0]);
      }, { passive: true, capture: true });

      wrapper.addEventListener('touchend', handlePointerUp, { passive: true, capture: true });
      wrapper.addEventListener('touchcancel', handlePointerUp, { passive: true, capture: true });
    }

    var handleClick = function(event) {
      var flickity = instance;
      var shouldBlock = dragMoved || pointerDeltaExceeded || dragJustHappened;

      if (flickity && (flickity.isPointerDown || flickity.dragged)) {
        shouldBlock = true;
      }

      if (!dragStarted && !shouldBlock) {
        return;
      }

      if (shouldBlock) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    wrapper.addEventListener('click', handleClick, true);
    wrapper.dataset.productCardClickGuard = 'true';
  }

  function bindSwipeFallback(node, instance) {
    if (!node || !instance || node.dataset.productCardSwipeFallback === 'true') {
      return;
    }

    var wrapper = node.closest(WRAPPER_SELECTOR) || node;
    var startX = null;
    var startY = null;
    var tracking = false;
    var blockedClickUntil = 0;
    var SWIPE_THRESHOLD = 36;
    var VERTICAL_TOLERANCE = 54;

    var getPoint = function(event) {
      if (event && event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0];
      }
      if (event && event.touches && event.touches.length) {
        return event.touches[0];
      }
      return event;
    };

    var handleStart = function(event) {
      if (node.dataset.mobileMediaBound === 'true') return;
      var point = getPoint(event);
      if (!point) {
        return;
      }
      startX = point.clientX;
      startY = point.clientY;
      tracking = true;
    };

    var handleEnd = function(event) {
      if (!tracking || startX === null || startY === null) {
        return;
      }

      var point = getPoint(event);
      if (!point) {
        tracking = false;
        return;
      }

      var deltaX = point.clientX - startX;
      var deltaY = point.clientY - startY;
      tracking = false;
      startX = null;
      startY = null;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaY) > VERTICAL_TOLERANCE) {
        return;
      }

      var root = node.closest('.product-image-container-main');
      var isModelOverlayActive = root &&
        root.dataset &&
        root.dataset.productCardSwipingMedia !== 'true' &&
        doc.body &&
        doc.body.classList.contains('model-image-active') &&
        root.querySelector('.model-image-container');

      if (root && root.dataset) {
        root.dataset.productCardSwipingMedia = 'true';
      }

      if (isModelOverlayActive && deltaX > 0 && typeof instance.select === 'function') {
        instance.select(0, false, true);
      } else if (deltaX < 0 && typeof instance.next === 'function') {
        instance.next(true, false);
      } else if (deltaX > 0 && typeof instance.previous === 'function') {
        instance.previous(true, false);
      }

      win.requestAnimationFrame(function() {
        syncCarouselVideos(node, instance);
      });
      win.setTimeout(function() {
        syncCarouselVideos(node, instance);
      }, 420);

      blockedClickUntil = Date.now() + 500;
      if (event.cancelable) {
        event.preventDefault();
      }
      event.stopPropagation();
    };

    var handleCancel = function() {
      tracking = false;
      startX = null;
      startY = null;
    };

    wrapper.addEventListener('click', function(event) {
      if (Date.now() > blockedClickUntil) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
    }, true);

    if ('PointerEvent' in win) {
      node.addEventListener('pointerdown', handleStart, { passive: true });
      node.addEventListener('pointerup', handleEnd, { passive: false });
      node.addEventListener('pointercancel', handleCancel, { passive: true });
    } else {
      node.addEventListener('touchstart', handleStart, { passive: true });
      node.addEventListener('touchend', handleEnd, { passive: false });
      node.addEventListener('touchcancel', handleCancel, { passive: true });
      node.addEventListener('mousedown', handleStart, { passive: true });
      node.addEventListener('mouseup', handleEnd, { passive: false });
    }

    node.dataset.productCardSwipeFallback = 'true';
  }

  function getVideoManager() {
    return win.theme && win.theme.lazyVideoManager ? win.theme.lazyVideoManager : null;
  }

  function attachCardVideoSources(video) {
    if (!video) {
      return;
    }

    var manager = getVideoManager();
    if (manager && typeof manager.attachSources === 'function') {
      manager.attachSources(video);
      return;
    }

    var primary = video.getAttribute('data-video-src');
    if (primary && !video.getAttribute('src')) {
      video.setAttribute('src', primary);
    }

    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function(source) {
      var sourceUrl = source.getAttribute('data-src');
      if (sourceUrl && !source.getAttribute('src')) {
        source.setAttribute('src', sourceUrl);
      }
    });

    video.dataset.sourcesAttached = 'true';
  }

  function playCardVideo(video) {
    if (!video) {
      return;
    }

    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    attachCardVideoSources(video);

    var manager = getVideoManager();
    if (manager && typeof manager.play === 'function') {
      manager.play(video);
      return;
    }

    video.setAttribute('preload', 'auto');
    try {
      video.load();
    } catch (error) {}

    var playPromise;
    try {
      playPromise = video.play();
    } catch (error) {
      playPromise = null;
    }

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  }

  function stopCardVideo(video) {
    if (!video) {
      return;
    }

    var manager = getVideoManager();
    if (manager && typeof manager.stop === 'function') {
      manager.stop(video);
      return;
    }

    try {
      video.pause();
    } catch (error) {}

    try {
      if (video.readyState > 0) {
        video.currentTime = 0;
      }
    } catch (error) {}
  }

  function warmAdjacentCardVideos(node, instance) {
    if (!node || !instance || !instance.cells || typeof instance.selectedIndex !== 'number') {
      return;
    }

    var manager = getVideoManager();
    var adjacentIndexes = [instance.selectedIndex - 1, instance.selectedIndex + 1];

    adjacentIndexes.forEach(function(index) {
      var cell = instance.cells[index];
      var element = cell && cell.element;
      var video = element && element.querySelector ? element.querySelector('video') : null;

      if (!video) {
        return;
      }

      attachCardVideoSources(video);
      if (manager && typeof manager.scheduleWarm === 'function') {
        manager.scheduleWarm(video);
      }
    });
  }

  function syncCarouselVideos(node, instance) {
    if (!node) {
      return;
    }

    var selectedElement = instance && instance.selectedElement ? instance.selectedElement : node.querySelector('.Carousel__Cell.is-selected');
    Array.prototype.forEach.call(node.querySelectorAll('video'), function(video) {
      if (selectedElement && selectedElement.contains(video)) {
        playCardVideo(video);
      } else {
        stopCardVideo(video);
      }
    });

    warmAdjacentCardVideos(node, instance);
  }

  function bindVideoLifecycle(node, instance) {
    if (!node || !instance || node.dataset.productCardVideoBound === 'true') {
      return;
    }

    if (!node.querySelector('video')) {
      return;
    }

    var scheduleSync = function() {
      win.requestAnimationFrame(function() {
        syncCarouselVideos(node, instance);
      });
    };

    if (typeof instance.on === 'function') {
      instance.on('select', scheduleSync);
      instance.on('settle', scheduleSync);
      instance.on('dragStart', function() {
        Array.prototype.forEach.call(node.querySelectorAll('video'), stopCardVideo);
      });
    }

    if ('IntersectionObserver' in win) {
      var observer = new win.IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            scheduleSync();
          } else {
            Array.prototype.forEach.call(node.querySelectorAll('video'), stopCardVideo);
          }
        });
      }, { threshold: 0.2 });

      observer.observe(node);
    }

    node.dataset.productCardVideoBound = 'true';
    scheduleSync();
  }

  function attachHooks(node) {
    if (!node) {
      return;
    }

    protectInnerCarousel(node);

    var instance = getCarouselInstance(node);
    if (instance && !node.dataset.productCardReadyHook && typeof instance.on === 'function') {
      node.dataset.productCardReadyHook = 'true';
    }

    bindProductCardProgress(node, instance);
    bindProductCardHoverReel(node, instance);

    if (instance) {
      applyClickGuards(node, instance);
      bindSwipeFallback(node, instance);
      bindNavControls(node, instance);
      bindVideoLifecycle(node, instance);
      enrichCarouselMedia(node);
    }

    requestNudge(800);
  }

  function instantiateCarousel(node) {
    if (!node) {
      return;
    }
    if (win.DsrcvMobileProductMedia && win.DsrcvMobileProductMedia.bind(node)) return;
    if (node.dataset.productCardManualDesktop === 'true' && node.closest('.NativeSearchPanel')) {
      // Search owns a manual gallery. Building Flickity here only measures hidden
      // cells and dispatches scroll events before search replaces that instance.
      // Retain the existing video media enrichment before the panel is opened.
      if (node.dataset.carouselBound !== 'native-search') enrichCarouselMedia(node);
      return;
    }

    var forceFirstSlide = Boolean(node.closest && node.closest('.NativeSearchPanel'));

    if (node.dataset.productCardBound === 'true') {
      attachHooks(node);
      if (forceFirstSlide) {
        var boundInstance = getCarouselInstance(node);
        if (boundInstance && typeof boundInstance.select === 'function') {
          boundInstance.select(0, false, true);
          updateProductCardProgress(node, boundInstance);
        }
      }
      return;
    }

    var existing = getCarouselInstance(node);
    if (existing) {
      node.productCardCarousel = existing;
      node.dataset.productCardBound = 'true';
      attachHooks(node);
      if (forceFirstSlide && typeof existing.select === 'function') {
        existing.select(0, false, true);
        updateProductCardProgress(node, existing);
      }
      return;
    }

    if (typeof win.Flickity !== 'function') {
      if (node.dataset.productCardWaiting === 'true') {
        return;
      }

      node.dataset.productCardWaiting = 'true';
      win.setTimeout(function() {
        delete node.dataset.productCardWaiting;
        instantiateCarousel(node);
      }, 180);
      return;
    }

    var config = parseJsonSafely(node.getAttribute('data-flickity-config'), {});

    try {
      node.productCardCarousel = new win.Flickity(node, config);
    } catch (error) {
      if (win.PDPDebug && typeof win.PDPDebug.log === 'function') {
        win.PDPDebug.log('product-card-carousel:init-error', error);
      }
      return;
    }

    node.dataset.productCardBound = 'true';
    if (forceFirstSlide && node.productCardCarousel && typeof node.productCardCarousel.select === 'function') {
      node.productCardCarousel.select(0, false, true);
      updateProductCardProgress(node, node.productCardCarousel);
    }
    attachHooks(node);
  }

  function observeVisibleCardHint(node) {
    if (!isProductPage || typeof win.IntersectionObserver !== 'function' || nudgeTriggered || hasSeenNudge()) return;
    if (!visibleCardObserver) {
      // Loading near the viewport and showing the hint are different moments.
      visibleCardObserver = new win.IntersectionObserver(function(entries) {
        if (nudgeTriggered || hasSeenNudge()) {
          visibleCardObserver.disconnect();
          visibleHintCards.clear();
          return;
        }
        entries.forEach(function(entry) {
          // Keep tracking until the hint is consumed. A quick scroll away
          // during its delay must still allow a later return to request it.
          if (entry.isIntersecting) requestNudge(800);
        });
      }, { rootMargin: '0px' });
    }
    if (visibleHintCards.has(node)) return;
    visibleHintCards.add(node);
    visibleCardObserver.observe(node);
  }

  function activateDeferredCard(node) {
    if (!deferredCards.has(node)) return;
    deferredCards.delete(node);
    if (deferredCardObserver) deferredCardObserver.unobserve(node);
    if (node.isConnected) {
      instantiateCarousel(node);
      observeVisibleCardHint(node);
    }
  }

  function scheduleCarousel(node) {
    if (!node || !node.isConnected) return;
    // Search retains its current eager initialisation and force-first-slide
    // repair. Collection and homepage galleries keep their existing behaviour.
    if (!deferProductCards || node.closest('.NativeSearchPanel') || node.dataset.productCardBound === 'true' || getCarouselInstance(node)) {
      instantiateCarousel(node);
      observeVisibleCardHint(node);
      return;
    }
    if (deferredCards.has(node)) return;
    if (!deferredCardObserver) {
      deferredCardObserver = new win.IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) activateDeferredCard(entry.target);
        });
      }, { rootMargin: '200px 0px' });
    }
    deferredCards.add(node);
    deferredCardObserver.observe(node);
  }

  function activateCardOnIntent(event) {
    var target = event.target;
    var wrapper = target && target.closest && target.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;
    var carousel = wrapper.querySelector(CAROUSEL_SELECTOR);
    activateDeferredCard(carousel);
  }

  function initCarousels(scope) {
    var root = scope && scope.querySelectorAll ? scope : doc;
    var carousels = root.querySelectorAll ? root.querySelectorAll(CAROUSEL_SELECTOR) : [];

    for (var i = 0; i < carousels.length; i += 1) {
      scheduleCarousel(carousels[i]);
    }

    if (!nudgeTriggered && !hasSeenNudge() && carousels.length) {
      requestNudge(900);
    }
  }

  function handleMutations(mutations) {
    mutations.forEach(function(mutation) {
      for (var idx = 0; idx < mutation.addedNodes.length; idx += 1) {
        var node = mutation.addedNodes[idx];

        if (!node || node.nodeType !== 1) {
          continue;
        }

        if (typeof node.matches === 'function' && node.matches(CAROUSEL_SELECTOR)) {
          scheduleCarousel(node);
          requestNudge(600);
          continue;
        }

        if (typeof node.querySelectorAll === 'function') {
          var nested = node.querySelectorAll(CAROUSEL_SELECTOR);
          if (nested && nested.length) {
            for (var i = 0; i < nested.length; i += 1) {
              scheduleCarousel(nested[i]);
            }
            requestNudge(600);
          }
        }
      }
    });
    // Removed recommendation cards must not stay retained by the observer.
    deferredCards.forEach(function(node) {
      if (!node.isConnected) {
        deferredCards.delete(node);
        if (deferredCardObserver) deferredCardObserver.unobserve(node);
      }
    });
    visibleHintCards.forEach(function(node) {
      if (!node.isConnected || nudgeTriggered || hasSeenNudge()) {
        visibleHintCards.delete(node);
        if (visibleCardObserver) visibleCardObserver.unobserve(node);
      }
    });
  }

  function setup() {
    nudgeTriggered = hasSeenNudge();
    isProductPage = Boolean(doc.body && doc.body.classList.contains('template-product'));
    deferProductCards = isProductPage && typeof win.IntersectionObserver === 'function';
    if (deferProductCards) {
      // Capture before gallery handlers so the first interaction is preserved.
      ['pointerover', 'pointerdown', 'mouseover', 'mousedown', 'touchstart', 'focusin'].forEach(function(eventName) {
        doc.addEventListener(eventName, activateCardOnIntent, { capture: true, passive: true });
      });
    }
    initCarousels(doc);
    doc.addEventListener('dsrcv:mobile-media-change', function() { initCarousels(doc); });

    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new win.MutationObserver(handleMutations);
    mutationObserver.observe(doc.body, {
      childList: true,
      subtree: true
    });

    win.__DSRCV_PRODUCT_CARD_SCRIPT__ = true;

    win.PDPDebug = win.PDPDebug || {};
    win.PDPDebug.productCardCarousel = {
      request: requestNudge,
      trigger: triggerNudge,
      getInstance: function(node) {
        return getCarouselInstance(node || doc.querySelector(CAROUSEL_SELECTOR));
      }
    };
  }

  ready(setup);
})(window, document);
(function(win) {
  var theme = win.theme = win.theme || {};
  if (theme.lazyVideoManager) {
    return;
  }

  var doc = win.document;
  var supportIdle = typeof win.requestIdleCallback === 'function';

  function getConnection() {
    return win.navigator && (win.navigator.connection || win.navigator.mozConnection || win.navigator.webkitConnection);
  }

  function canWarmConnection() {
    var connection = getConnection();
    if (!connection) {
      return true;
    }

    if (connection.saveData) {
      return false;
    }

    var effective = (connection.effectiveType || '').toLowerCase();
    if (!effective) {
      return true;
    }

    if (effective.indexOf('2g') !== -1 || effective.indexOf('slow') !== -1) {
      return false;
    }

    return true;
  }

  function setPreload(video, value) {
    if (!video) {
      return;
    }

    try {
      video.preload = value;
    } catch (error) {}

    if (value) {
      video.setAttribute('preload', value);
    } else {
      video.removeAttribute('preload');
    }
  }

  function attachSources(video) {
    if (!video || video.dataset.sourcesAttached === 'true') {
      return true;
    }

    var primary = video.getAttribute('data-video-src');
    if (primary) {
      video.setAttribute('src', primary);
    }

    var sources = video.querySelectorAll('source[data-src]');
    if (sources && sources.length) {
      Array.prototype.forEach.call(sources, function(source) {
        var src = source.getAttribute('data-src');
        if (src && !source.getAttribute('src')) {
          source.setAttribute('src', src);
        }
      });
    }

    video.dataset.sourcesAttached = 'true';
    return true;
  }

  function loadMetadata(video, options) {
    if (!video) {
      return;
    }

    attachSources(video);
    var alreadyWarmed = video.dataset.videoWarmState === 'metadata';
    if (alreadyWarmed && !(options && options.force)) {
      return;
    }

    setPreload(video, 'metadata');
    video.dataset.videoWarmState = 'metadata';

    try {
      video.load();
    } catch (error) {}
  }

  function attemptPlay(video) {
    var playPromise;
    try {
      playPromise = video.play();
    } catch (error) {
      playPromise = null;
    }

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  }

  function playVideo(video) {
    if (!video) {
      return;
    }

    if (!video.paused && !video.ended && video.readyState >= 2) {
      return;
    }

    loadMetadata(video, { force: true });
    setPreload(video, 'auto');

    if (video.readyState >= 2) {
      attemptPlay(video);
    } else {
      var onReady = function() {
        video.removeEventListener('loadeddata', onReady);
        video.removeEventListener('canplay', onReady);
        attemptPlay(video);
      };

      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });

      try {
        video.load();
      } catch (error) {}
    }
  }

  function stopVideo(video) {
    if (!video) {
      return;
    }

    try {
      video.pause();
    } catch (error) {}

    try {
      if (video.readyState > 0) {
        video.currentTime = 0;
      }
    } catch (error) {}
  }

  function scheduleWarm(video, options) {
    if (!video || video.dataset.videoWarmScheduled === 'true') {
      return;
    }

    if (options && options.force) {
      loadMetadata(video, options);
      return;
    }

    if (!canWarmConnection()) {
      return;
    }

    video.dataset.videoWarmScheduled = 'true';

    var runner = function() {
      video.dataset.videoWarmScheduled = '';
      loadMetadata(video);
    };

    if (options && options.immediate) {
      (win.requestAnimationFrame || win.setTimeout)(runner);
      return;
    }

    if (supportIdle) {
      win.requestIdleCallback(function() {
        runner();
      }, { timeout: 2000 });
    } else {
      win.setTimeout(runner, 300);
    }
  }

  theme.lazyVideoManager = {
    attachSources: attachSources,
    warm: loadMetadata,
    scheduleWarm: scheduleWarm,
    play: playVideo,
    stop: stopVideo,
    canWarmConnection: canWarmConnection,
    setPreload: setPreload
  };
})(window);

Shopify.formatMoney = function(cents, format) {
	//console.log(format)
		if (typeof cents === 'string') {
				cents = cents.replace('.', '')
		}
		var value = '';
		var placeholderRegex = /{{\s*(\w+)\s*}}/;
		var formatString = format || window.theme?.moneyFormat || window.Shopify.moneyFormat;
		this.money_format = this.money_format || false;
		var defaultOption = function(opt, def) {
				return (typeof opt === 'undefined' ? def : opt)
		};
		var formatWithDelimiters = function(number, precision, thousands, decimal) {
				precision = defaultOption(precision, 2);
				thousands = defaultOption(thousands, ',');
				decimal = defaultOption(decimal, '.');
				if (isNaN(number) || number == null) {
						return 0
				}
				number = (number / 100.0).toFixed(precision);
				var parts = number.split('.')
					, dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
					, cents = parts[1] ? (decimal + parts[1]) : '';
				return dollars + cents
		};
		switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
		case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
		case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
		case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break
		}
		return formatString.replace(placeholderRegex, value)
};
$(window).on('scroll', function(){
	if($(".ucd-drawer-open").length) {
		var $top = $('#sidebar-cart').css('max-height');
		$('.template-product .custom-cart-wrapper').css('top', $top);
	}
});

// Keep every original review; start with comments about this kind of garment.
function orderProductReviewPhotos(wall) {
  if (!wall || typeof wall.querySelectorAll !== 'function') return;
  const widget = wall.closest('#stamped-reviews-widget');
  const productType = widget && widget.getAttribute('data-dsrcv-product-type') || '';
  const categories = [
    {key: 'tee', pattern: /\b(?:t[ -]?shirts?|tees?)\b/i},
    {key: 'polo', pattern: /\bpolos?\b/i},
    {key: 'shirt', pattern: /\bshirts?\b/i},
    {key: 'hoodie', pattern: /\bhoodies?\b/i},
    {key: 'sweatshirt', pattern: /\bsweatshirts?\b/i},
    {key: 'trouser', pattern: /\b(?:trousers?|sweatpants?|jeans|denim)\b/i},
    {key: 'short', pattern: /\bshorts\b/i},
    {key: 'jacket', pattern: /\b(?:jackets?|outerwear)\b/i}
  ];
  const current = categories.find(category => category.pattern.test(productType));
  if (!current) return;
  const cards = Array.from(wall.children).filter(card => card.querySelector('.stamped-reviews-message'));
  const ranked = cards.map((card, index) => {
    const text = card.querySelector('.stamped-reviews-message').textContent || '';
    const mentions = categories.filter(category => category.pattern.test(text));
    // A T-shirt match also contains the word shirt. Only the first, specific category wins.
    const related = mentions.length && mentions[0].key === current.key;
    return {card, index, rank: related ? 0 : mentions.length ? 2 : 1};
  }).sort((a, b) => a.rank - b.rank || a.index - b.index);
  if (ranked.every((entry, index) => entry.card === cards[index])) return;
  ranked.forEach(entry => wall.appendChild(entry.card));
}

function configureProductReviewRotation(wall, motion) {
  if (wall.data('dsrcv-review-rotation')) return;
  wall.data('dsrcv-review-rotation', true);
  function update() {
    const playing = wall.slick('getSlick').slideCount > 1 && !motion.matches;
    wall.slick('slickSetOption', 'autoplay', playing, false);
    wall.slick('slickSetOption', 'autoplaySpeed', 3000, false);
    wall.slick('slickSetOption', 'speed', motion.matches ? 0 : 300, false);
    wall.find('.slick-list').attr('aria-live', playing ? 'off' : 'polite');
    wall.slick(playing ? 'slickPlay' : 'slickPause');
  }
  wall.on('reInit.dsrcvReviewRotation', update);
  if (motion.addEventListener) motion.addEventListener('change', update);
  else if (motion.addListener) motion.addListener(update);
  wall.one('destroy', function () {
    wall.off('reInit.dsrcvReviewRotation', update);
    wall.removeData('dsrcv-review-rotation');
    if (motion.removeEventListener) motion.removeEventListener('change', update);
    else if (motion.removeListener) motion.removeListener(update);
  });
  update();
}

// Stamped can render after page load. Initialise each non-empty photo wall once.
function initializeProductReviewPhotos() {
  if (typeof jQuery.fn.slick !== 'function') return false;
  let ready = false;
  jQuery('#stamped-reviews-widget .stamped-wall-photos-wrapper').each(function () {
    const wall = jQuery(this);
    // Missing provider country metadata must not appear as a customer location.
    this.querySelectorAll('.stamped-reviews-location').forEach(location => {
      const missing = /^(?:undefined|null|n\/a)?$/i.test(location.textContent.trim());
      location.hidden = missing;
      if (missing && location.textContent) location.textContent = '';
    });
    if (wall.hasClass('slick-initialized')) {
      configureProductReviewRotation(wall, window.matchMedia('(prefers-reduced-motion: reduce)'));
      ready = true;
      return;
    }
    orderProductReviewPhotos(this);
    wall.children('div:empty').remove();
    if (!wall.children().length) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    wall.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: !motion.matches,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      swipe: true,
      speed: motion.matches ? 0 : 300,
      adaptiveHeight: false,
      arrows: true,
    });
    configureProductReviewRotation(wall, motion);
    ready = true;
  });
  return ready;
}

// Watch the provider's actual DOM arrival, including replacement widgets. There is
// no deadline: a slow provider must behave like one that rendered at page load.
function watchProductReviewPhotos() {
  const widget = document.getElementById('stamped-reviews-widget');
  if (!widget) return;
  let pending = null;
  function schedule() {
    if (pending !== null) return;
    pending = setTimeout(function () {
      pending = null;
      initializeProductReviewPhotos();
    }, 100);
  }
  const observer = new MutationObserver(function (records) {
    if (records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return target && target.closest('#stamped-reviews-widget') ||
        Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
          (node.id === 'stamped-reviews-widget' || node.querySelector('#stamped-reviews-widget')));
    })) schedule();
  });
  observer.observe(widget.parentNode, {childList: true, subtree: true});
  document.addEventListener('stamped:reviews:loaded', schedule);
  // Also recover when the slider library itself was loaded after the reviews.
  document.addEventListener('load', schedule, true);
  initializeProductReviewPhotos();
  function stop() {
    observer.disconnect();
    clearTimeout(pending);
    document.removeEventListener('stamped:reviews:loaded', schedule);
    document.removeEventListener('load', schedule, true);
  }
  window.addEventListener('pagehide', function (event) {
    if (!event.persisted) stop();
  }, {once: true});
  return stop;
}

jQuery(document).ready(watchProductReviewPhotos);


function animateInventoryBar(){
	if($(".inventory-stock__inner-bar").length){
		$(".inventory-stock__inner-bar").addClass("preload");
		$(".inventory-stock__inner-bar").width("100%");
		setTimeout(function(){ 
			$(".inventory-stock__inner-bar").removeClass("preload");
			$(".inventory-stock__inner-bar").width ("14%"); 
		}, 300);
	}
}
 
$(function() {
	animateInventoryBar();

	const DELIVERY_RETURNS_CONTAINER_SELECTOR = "[data-delivery-returns]";
	const DELIVERY_RETURNS_ENTRY_SELECTOR = ".ProductTabs__DeliveryReturnsEntry[data-country]";

	const normalizeCountryCode = (value) => {
		if (!value) {
			return "";
		}
		return String(value).trim().toUpperCase();
	};

	const showDeliveryReturnsEntry = (countryCode) => {
		const containers = document.querySelectorAll(DELIVERY_RETURNS_CONTAINER_SELECTOR);
		if (!containers.length) {
			return false;
		}

		const normalizedCountry = normalizeCountryCode(countryCode);
		let handled = false;

		containers.forEach((container) => {
			const entries = container.querySelectorAll(DELIVERY_RETURNS_ENTRY_SELECTOR);
			if (!entries.length) {
				return;
			}

			let selectedEntry = null;
			let restOfWorldEntry = null;
			let firstEntry = null;

			entries.forEach((entry) => {
				const entryCountry = normalizeCountryCode(entry.getAttribute("data-country"));
				if (!firstEntry) {
					firstEntry = entry;
				}
				if (!restOfWorldEntry && entryCountry === "REST") {
					restOfWorldEntry = entry;
				}
				if (!selectedEntry && entryCountry === normalizedCountry && normalizedCountry) {
					selectedEntry = entry;
				}
				entry.classList.remove("is-active");
				entry.setAttribute("hidden", "hidden");
				entry.setAttribute("aria-hidden", "true");
			});

			const target = selectedEntry || restOfWorldEntry || firstEntry;
			if (!target) {
				return;
			}

			target.removeAttribute("hidden");
			target.removeAttribute("aria-hidden");
			target.classList.add("is-active");
			handled = true;
		});

		return handled;
	};

	const showLegacyCountryTabs = (countryCode) => {
		const $countryTabs = $(".Collapsible[data-country]");
		if (!$countryTabs.length) {
			return false;
		}

		$countryTabs.hide();
		const normalizedCountry = normalizeCountryCode(countryCode);
		let handled = false;

		if (normalizedCountry) {
			const $matchedTabs = $countryTabs.filter(function() {
				return normalizeCountryCode($(this).data("country")) === normalizedCountry;
			});
			if ($matchedTabs.length) {
				$matchedTabs.show();
				handled = true;
			}
		}

		if (!handled) {
			const $restTabs = $countryTabs.filter(function() {
				return normalizeCountryCode($(this).data("country")) === "REST";
			});
			if ($restTabs.length) {
				$restTabs.show();
				handled = true;
			}
		}

		if (!handled) {
			const firstCountry = normalizeCountryCode($countryTabs.first().data("country"));
			const $fallbackTabs = firstCountry
				? $countryTabs.filter(function() {
					return normalizeCountryCode($(this).data("country")) === firstCountry;
				})
				: $countryTabs.first();

			if ($fallbackTabs.length) {
				$fallbackTabs.show();
				handled = true;
			}
		}

		return handled;
	};

	const applyCountrySpecificTabs = (countryCode) => {
		if (showDeliveryReturnsEntry(countryCode)) {
			return true;
		}
		return showLegacyCountryTabs(countryCode);
	};

	const resolveDocumentCountry = () => {
		// Delivery and returns follow the selected Shopify market, not the IP suggestion.
		const marketCountry = normalizeCountryCode(window.Shopify && window.Shopify.country);
		if (marketCountry) {
			return marketCountry;
		}
		if (document.body && typeof document.body.getAttribute === "function") {
			const bodyCountry = document.body.getAttribute("data-country");
			if (bodyCountry) {
				return bodyCountry;
			}
		}

		if (document.documentElement && typeof document.documentElement.getAttribute === "function") {
			const htmlCountry = document.documentElement.getAttribute("data-country");
			if (htmlCountry) {
				return htmlCountry;
			}
		}

		return "";
	};

	applyCountrySpecificTabs(resolveDocumentCountry());

	if (typeof MutationObserver === "function") {
		const observerTarget = document.body || document.documentElement;
		if (observerTarget) {
			const observer = new MutationObserver(function() {
				applyCountrySpecificTabs(resolveDocumentCountry());
			});
			try {
				observer.observe(observerTarget, { attributes: true, attributeFilter: ["data-country"] });
			} catch (error) {
				if (window && window.PDPDebug && typeof window.PDPDebug.log === "function") {
					window.PDPDebug.log("delivery-returns-country-observer-error", error);
				}
			}
		}
	}

	if(window.location.href.includes('/challenge')){
		$([document.documentElement, document.body]).animate({
			scrollTop: $('main').offset().top - 200
		}, 5);
	}

	$(".Collapsible span.money").each(function( index ) {
		let _amount = jQuery(this).text();

        if(jQuery(this).closest('.Collapsible__Button').length){

          if(jQuery(this).closest('.Collapsible__Button').text().includes("DELIVERY")) {
            jQuery(this).closest('.Collapsible__Button').closest('.Collapsible').addClass("delivery-accordion");
          }

          
          let convertedAmount = Shopify.formatMoney(jQuery(this).text()*100*Shopify.currency.rate, shopMoneyFormat);
          
          let $currenyAmountOldHtml = `${$(convertedAmount).text()}`;
          
           let $currenyAmountNewHtml = convertCurrencyIntoMultipleOf5($currenyAmountOldHtml);
          //console.log($currenyAmountOldHtml, $currenyAmountNewHtml);
          jQuery(this).html($currenyAmountNewHtml);
          
        } else {

          jQuery(this).html(Shopify.formatMoney(jQuery(this).text()*100*Shopify.currency.rate, shopMoneyFormat));
        }
		
	});

	//show product tabs based on country
	fetch('/browsing_context_suggestions.json').then(function (res) {
		return res.json()
	}).then(function (data) {
		let detectedCountry = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
		let marketCountry = normalizeCountryCode(window.Shopify && window.Shopify.country);
		let countryHandle = marketCountry || normalizeCountryCode(detectedCountry) || resolveDocumentCountry();
		if(countryHandle){
			$("body").attr("data-country",countryHandle);
			if(countryHandle === 'GB'){
				$('#klarna__info-container').show();
				window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
				window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
			}
			
			applyCountrySpecificTabs(countryHandle);
		}
	});
});


$(document).bind("inventory.animation", function(e, status){
	animateInventoryBar();
});

window.addEventListener('Upside::UCD::CartBuilt' , function(e) {
	let cartIcon_blank = document.querySelectorAll('.cart-icon.blank');
	let cartIcon_fill = document.querySelectorAll('.cart-icon.fill');
	if(e.detail.cart.item_count === 0) {
		$(cartIcon_fill).hide();
		$(cartIcon_blank).show();
	} else {
		 $(cartIcon_fill).show();
		$(cartIcon_blank).hide();
	}
});

const formatUpsellCartDrawerMessages = (() => {
	const WEEKDAY_PATTERN = /(monday|tuesday|wednesday|thursday|friday|saturday|sunday)/gi;

	const capitaliseWeekdaysInHtml = (html) =>
		html.replace(WEEKDAY_PATTERN, (match) =>
			match.charAt(0).toUpperCase() + match.slice(1).toLowerCase()
		);

	const sentenceCase = (value) => {
		if (!value) {
			return value;
		}
		const trimmed = value.trim();
		if (!trimmed) {
			return trimmed;
		}
		const lower = trimmed.toLowerCase();
		return capitaliseWeekdaysInHtml(lower.charAt(0).toUpperCase() + lower.slice(1));
	};

	const deadlineIconSrc = '/cdn/shop/files/clorck_wider_2.svg?v=1719209320';

	const updateTextElements = (elements, formatter) => {
		elements.forEach((el) => {
			const original = el.textContent;
			if (!original) {
				return;
			}
			const formatted = formatter(original);
			if (formatted !== original) {
				el.textContent = formatted;
			}
		});
	};

	const updateHtmlElements = (elements, formatter) => {
		elements.forEach((el) => {
			const original = el.innerHTML;
			if (!original) {
				return;
			}
			const formatted = formatter(original);
			if (formatted !== original) {
				el.innerHTML = formatted;
			}
		});
	};

	const normaliseDeadlineText = (value) => {
		const formatted = capitaliseWeekdaysInHtml((value || '').replace(/\s+/g, ' ').trim());
		return formatted;
	};

	const ensureCartDeadlineMessage = (root) => {
		const row = root.querySelector('.special-offer-message[data-name="order_deadline"]');
		if (!row) {
			return;
		}

		const existingText = normaliseDeadlineText(row.textContent);
		const hasVisibleText = row.textContent.replace(/\s+/g, '').length > 0;
		let icon = row.querySelector('img');
		let span = row.querySelector(':scope > span');

		if (!hasVisibleText) {
			row.classList.add('is-hidden');
			return;
		}

		if (!icon) {
			icon = document.createElement('img');
			icon.src = deadlineIconSrc;
			icon.width = 20;
			icon.alt = '';
			icon.setAttribute('aria-hidden', 'true');
			row.insertBefore(icon, row.firstChild);
		}

		if (!span) {
			span = document.createElement('span');
			row.appendChild(span);
		}

		if (span.textContent !== existingText) span.textContent = existingText;

		row.classList.remove('is-hidden');
	};

	return () => {
		const root = document.querySelector('#upside-ucd-cart-drawer');
		if (!root) {
			return;
		}

		ensureCartDeadlineMessage(root);

		const sentenceTargets = root.querySelectorAll('.special-offer-message span');
		if (sentenceTargets.length) {
			updateTextElements(sentenceTargets, sentenceCase);
		} else {
			updateTextElements(root.querySelectorAll('.special-offer-message'), sentenceCase);
		}

		updateHtmlElements(
			root.querySelectorAll(
				'.special-offer-message[data-name="order_deadline"] span, .trustblox-1-viewcart-message, #shipping-estimate-text, .ucd-other-messages .trustblox-message, .trustblox-1-viewcart-wrap .trustblox-message'
			),
			capitaliseWeekdaysInHtml
		);
	};
})();

const stabilizeUcdCheckoutSummary = (() => {
	let latestCart = null;
	let fetchPromise = null;
	let scheduledTimer = null;

	const normaliseLabel = (value) =>
		(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

	const isBlank = (value) =>
		!(value || '').replace(/\s+/g, '').trim();

	const textFromHtml = (html) => {
		const template = document.createElement('template');
		template.innerHTML = html || '';
		return template.content.textContent.replace(/\s+/g, ' ').trim();
	};

	const formatMoneyForDrawer = (cents) => {
		if (typeof cents !== 'number' || !Number.isFinite(cents)) {
			return '';
		}

		if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
			try {
				const formatted = window.Shopify.formatMoney(cents, window.theme?.moneyFormat || window.Shopify.moneyFormat);
				if (formatted) {
					return textFromHtml(formatted);
				}
			} catch (error) {}
		}

		const currency = latestCart?.currency || window.Shopify?.currency?.active || 'GBP';
		try {
			return new Intl.NumberFormat('en-GB', {
				style: 'currency',
				currency,
				maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
			}).format(cents / 100);
		} catch (error) {
			return `£${Math.round(cents / 100)}`;
		}
	};

	const cartFromEvent = (event) => {
		const detail = event && event.detail;
		if (!detail) {
			return null;
		}
		if (detail.cart && typeof detail.cart === 'object') {
			return detail.cart.cart && typeof detail.cart.cart === 'object' ? detail.cart.cart : detail.cart;
		}
		if (detail.data && typeof detail.data === 'object') {
			return detail.data.cart && typeof detail.data.cart === 'object' ? detail.data.cart : detail.data;
		}
		return null;
	};

	const getValueNode = (row) => {
		let value = row.querySelector('.ucd-foot-value');
		if (!value) {
			value = document.createElement('div');
			value.className = 'ucd-foot-value';
			row.appendChild(value);
		}

		let paragraph = value.querySelector('p');
		if (!paragraph) {
			paragraph = document.createElement('p');
			value.appendChild(paragraph);
		}

		return paragraph;
	};

	const setValueIfNeeded = (row, value, options = {}) => {
		if (!row || !value) {
			return;
		}

		const target = getValueNode(row);
		if (options.force || isBlank(target.textContent)) {
			target.textContent = value;
		}
	};

	const repairWithCart = (cart) => {
		const root = document.querySelector('#upside-ucd-cart-drawer');
		if (!root) {
			return;
		}

		if (cart && typeof cart === 'object') {
			latestCart = cart;
		}

		const activeCart = latestCart || {};
		const subtotalCents = typeof activeCart.items_subtotal_price === 'number'
			? activeCart.items_subtotal_price
			: activeCart.original_total_price;
		const totalCents = typeof activeCart.total_price === 'number'
			? activeCart.total_price
			: subtotalCents;
		const subtotalText = formatMoneyForDrawer(subtotalCents);
		const totalText = formatMoneyForDrawer(totalCents);

		let subtotalFallback = '';

		root.querySelectorAll('.ucd-checkout-btn-container .ucd-footer-grid').forEach((row) => {
			const label = normaliseLabel(row.querySelector('.ucd-foot-label')?.textContent || row.textContent);
			const valueNode = row.querySelector('.ucd-foot-value p, .ucd-foot-value');

			if (label.includes('subtotal')) {
				if (!isBlank(valueNode?.textContent)) {
					subtotalFallback = valueNode.textContent.replace(/\s+/g, ' ').trim();
				}
				setValueIfNeeded(row, subtotalText || subtotalFallback);
				return;
			}

			if (label.includes('shipping') || label.includes('returns')) {
				setValueIfNeeded(row, 'Free');
				return;
			}

			if (label === 'total' || label.endsWith(' total')) {
				setValueIfNeeded(row, totalText || subtotalFallback, { force: isBlank(valueNode?.textContent) });
			}
		});
	};

	const fetchCart = () => {
		if (fetchPromise) {
			return fetchPromise;
		}

		fetchPromise = fetch('/cart.js', {
			credentials: 'same-origin',
			headers: { Accept: 'application/json' },
		})
			.then((response) => response.ok ? response.json() : null)
			.then((cart) => {
				if (cart) {
					latestCart = cart;
				}
				return cart;
			})
			.catch(() => null)
			.finally(() => {
				fetchPromise = null;
			});

		return fetchPromise;
	};

	return (event) => {
		const eventCart = cartFromEvent(event);
		if (eventCart) {
			latestCart = eventCart;
		}

		window.clearTimeout(scheduledTimer);
		repairWithCart(latestCart);

		scheduledTimer = window.setTimeout(() => {
			fetchCart().then((cart) => {
				repairWithCart(cart || latestCart);
			});
		}, 150);
	};
})();

const ensureUpsellCartObserver = () => {
	const root = document.querySelector('#upside-ucd-cart-drawer');
	if (!root || root.__ucdMessageObserver) {
		return root;
	}
	const observer = new MutationObserver(() => {
		triggerUpsellCartDrawerFormatting();
		stabilizeUcdCheckoutSummary();
	});
	observer.observe(root, { childList: true, subtree: true, characterData: true });
	root.__ucdMessageObserver = observer;
	return root;
};

const triggerUpsellCartDrawerFormatting = () => {
	ensureUpsellCartObserver();
	window.clearTimeout(triggerUpsellCartDrawerFormatting._timer);
	formatUpsellCartDrawerMessages();
	triggerUpsellCartDrawerFormatting._timer = window.setTimeout(
		formatUpsellCartDrawerMessages,
		400
	);
};

['Upside::UCD::CartBuilt', 'Upside::UCD::CartUpdated', 'Upside::UCD::CartLoaded', 'Upside::UCD::CartVisible'].forEach((eventName) => {
	window.addEventListener(eventName, (event) => {
		triggerUpsellCartDrawerFormatting();
		stabilizeUcdCheckoutSummary(event);
	});
});

document.addEventListener('DOMContentLoaded', () => {
	triggerUpsellCartDrawerFormatting();
	stabilizeUcdCheckoutSummary();
});

document.addEventListener('product:added', function(event) {
	if (typeof pintrk === 'function') {
		pintrk('track', 'addtocart');
	}
});

document.addEventListener('upsideproduct:added', function(event) {
	if (typeof pintrk === 'function') {
		pintrk('track', 'addtocart');
	}
});

$(document).ready(function() {
	// Slider code
	var $product_custom_slideshow = $('.Product__Slideshow.bottom').flickity({
		wrapAround: true,
		autoplay:true,
		prevNextButtons: true,
		pageDots: true,
		adaptiveHeight: true,
		draggable:true,
		freeScroll: false,
		contain: true
	});
	// var $product_custom_slideshowDesktop = $('.Product__Slideshow.top').flickity({
	// 	draggable:true
	// });
  
 
var $productCustomSlideshowMobile = $('.Product__SlideshowNav.Product__SlideshowNav--thumbnails.mobile__view .Product__SlideshowNavScroller').flickity({
		wrapAround: true,
		autoplay:true,
		prevNextButtons: false,
		pageDots: false,
		adaptiveHeight: false,
		draggable:true,
		freeScroll: false,
		contain: true,
		asNavFor: ".Product__Slideshow.bottom"
	});

	
	$productCustomSlideshowMobile.on( 'dragEnd.flickity', function( event, pointer, moveVector ) {
	
	 let selectedThumbMediaId =  $(".Product__SlideshowNavImage.is-selected:visible").data('media-id')
		
	 let mainSliderIndex = $(`#Media${selectedThumbMediaId}`).index();
	 
		$('.Product__Slideshow:visible').flickity( 'select', mainSliderIndex );
	
	});

	$('.Product__Slideshow.bottom').append(' <div class="carousel-tracker"><span class="carousel-tracker-bar"></span></div>');

	$product_custom_slideshow.on( 'scroll.flickity', function( event, progress ) {
		//progress = Math.max( 0, Math.min( 1, progress ) );
		// $progressBar.width( progress * 100 + '%' );
		//console.log(event,progress);
		carouselProgress();

	});
	function carouselProgress(){
		var $slide_width;
		var $slideNumber = ($(".Product__Slideshow.bottom .Product__SlideItem").length);
		var $leftBlock = 100 / $slideNumber;
		$slide_width = $leftBlock + '%';
		$('.Product__Slideshow.bottom ol.flickity-page-dots').find('.Product__Slideshow.bottom li.dot.is-selected').css( 'width', $slide_width);

		// $(this).find('.Product__Slideshow.bottom .flickity-page-dots');
		var currentIndex = $('.Product__Slideshow.bottom ol li.dot.is-selected').index();
		var $newLeftVal = $slideNumber*$leftBlock *(currentIndex) + '%';
		$slide_width = $leftBlock + '%'

		$('.carousel-tracker-bar ').css( 'transform' , 'translateX('+$newLeftVal+')' );
		$('.carousel-tracker-bar ').css( 'width', $slide_width);
	}
});

(function () {
	var CAROUSEL_SELECTOR = '[data-product-campaign-image-carousel]';
	var GALLERY_SELECTOR = '[data-product-campaign-gallery]';
	var IMAGE_SELECTOR = '.ProductCampaignMedia__Image';
	var PROGRESS_SELECTOR = '[data-product-campaign-carousel-progress]';
	var ZOOM_SELECTOR = '[data-action="open-campaign-image-zoom"]';
	var mobileCampaign = window.matchMedia ? window.matchMedia('(max-width: 1006px)') : null;

	function getMobileRail(carousel) {
		return carousel && mobileCampaign && mobileCampaign.matches && carousel.closest('[data-product-campaign-rail]');
	}

	function bindMobileRail(carousel, rail) {
		if (rail.dataset.productCampaignRailBound === 'true') return;
		rail.dataset.productCampaignRailBound = 'true';
		rail.addEventListener('scroll', function () {
			if (!getMobileRail(carousel)) return;
			var left = rail.getBoundingClientRect().left + parseFloat(window.getComputedStyle(rail).paddingLeft || 0);
			var nearest = 0;
			var distance = Infinity;
			getSlides(carousel).forEach(function (slide, index) {
				var delta = Math.abs(slide.getBoundingClientRect().left - left);
				if (delta < distance) { distance = delta; nearest = index; }
			});
			carousel.dataset.productCampaignMobileIndex = String(nearest);
		}, { passive: true });
	}

	function normaliseUrl(url) {
		if (!url) {
			return null;
		}
		if (url.indexOf('//') === 0) {
			return 'https:' + url;
		}
		return url;
	}

	function parseSrcset(srcset) {
		if (!srcset) {
			return [];
		}

		return srcset
			.split(',')
			.map(function (entry) {
				var parts = entry.trim().split(' ');
				var width = parts.length > 1 ? parseInt(parts[1], 10) : 0;
				return {
					url: normaliseUrl(parts[0]),
					width: isNaN(width) ? 0 : width,
				};
			})
			.filter(function (item) {
				return !!item.url;
			})
			.sort(function (a, b) {
				return a.width - b.width;
			});
	}

	function getInstance(carousel) {
		var instance = carousel && carousel.productCampaignCarousel;

		if (instance && typeof instance.getFlickityInstance === 'function') {
			instance = instance.getFlickityInstance();
		}

		if (instance && instance.flickityInstance) {
			instance = instance.flickityInstance;
		}

		if (instance && typeof instance.on === 'function') {
			return instance;
		}

		if (window.Flickity && typeof window.Flickity.data === 'function') {
			try {
				instance = window.Flickity.data(carousel);
			} catch (error) {
				instance = null;
			}
		}

		return instance && typeof instance.on === 'function' ? instance : null;
	}

	function getSlides(carousel) {
		return carousel ? Array.prototype.slice.call(carousel.querySelectorAll('[data-product-campaign-image-slide]')) : [];
	}

	function getSelectedIndex(carousel, instance) {
		if (getMobileRail(carousel)) {
			return parseInt(carousel.dataset.productCampaignMobileIndex, 10) || 0;
		}
		if (instance && typeof instance.selectedIndex === 'number') {
			return instance.selectedIndex;
		}

		var slides = getSlides(carousel);
		var selectedSlide = carousel ? carousel.querySelector('[data-product-campaign-image-slide].is-selected') : null;
		var selectedIndex = selectedSlide ? slides.indexOf(selectedSlide) : -1;

		return selectedIndex >= 0 ? selectedIndex : 0;
	}

	function updateProgress(carousel) {
		var gallery = carousel && carousel.closest(GALLERY_SELECTOR);
		var progress = gallery && gallery.querySelector(PROGRESS_SELECTOR);

		if (!progress) {
			return;
		}

		var instance = getInstance(carousel);
		var slideCount = instance && instance.slides ? instance.slides.length : getSlides(carousel).length;
		var selectedIndex = Math.min(Math.max(getSelectedIndex(carousel, instance), 0), Math.max(slideCount - 1, 0));
		getSlides(carousel).forEach(function (slide, index) {
			slide.tabIndex = getMobileRail(carousel) || index === selectedIndex ? 0 : -1;
		});

		progress.hidden = slideCount < 2;
		progress.style.setProperty('--product-card-progress-count', Math.max(slideCount, 1));
		progress.style.setProperty('--product-card-progress-index', selectedIndex);
		progress.setAttribute('data-product-card-progress-count', String(slideCount));
		progress.setAttribute('data-product-card-progress-index', String(selectedIndex));
	}

	function moveCarousel(carousel, direction) {
		var instance = getInstance(carousel);

		if (!instance) {
			return;
		}

		if (direction === 'next' && typeof instance.next === 'function') {
			instance.next(true);
		} else if (direction !== 'next' && typeof instance.previous === 'function') {
			instance.previous(true);
		}

		window.requestAnimationFrame(function () {
			updateProgress(carousel);
		});
	}

	function navigateCampaign(event) {
		var button = event.target.closest('[data-product-campaign-direction]');
		if (!button || event.defaultPrevented) return;

		var gallery = button.closest(GALLERY_SELECTOR);
		var carousel = gallery && gallery.querySelector(CAROUSEL_SELECTOR);
		if (!carousel) return;

		event.preventDefault();
		moveCarousel(carousel, button.getAttribute('data-product-campaign-direction'));
	}

	function bindTrackpad(carousel) {
		if (!carousel || carousel.dataset.productCampaignTrackpadBound === 'true') {
			return;
		}

		var lastSwipeAt = 0;

		carousel.addEventListener('wheel', function (event) {
			if (getMobileRail(carousel)) return;
			var horizontalDelta = event.deltaX || 0;
			var verticalDelta = event.deltaY || 0;

			if (Math.abs(horizontalDelta) < 24 || Math.abs(horizontalDelta) < Math.abs(verticalDelta) * 1.2) {
				return;
			}

			var now = Date.now();
			if (now - lastSwipeAt < 450) {
				event.preventDefault();
				return;
			}

			lastSwipeAt = now;
			event.preventDefault();
			carousel.dispatchEvent(new CustomEvent('product-campaign:manual-interaction'));
			moveCarousel(carousel, horizontalDelta > 0 ? 'next' : 'previous');
		}, { passive: false });

		carousel.dataset.productCampaignTrackpadBound = 'true';
	}

	function initCarousel(carousel) {
		if (!carousel) return;
		var rail = getMobileRail(carousel);
		if (rail) {
			var active = getInstance(carousel);
			if (active) {
				carousel.dataset.productCampaignMobileIndex = String(active.selectedIndex || 0);
				var owner = carousel.productCampaignCarousel;
				if (owner && typeof owner.destroy === 'function') owner.destroy();
				else if (typeof active.destroy === 'function') active.destroy();
				carousel.productCampaignCarousel = null;
				delete carousel.dataset.productCampaignCarouselReady;
				var selected = getSlides(carousel)[parseInt(carousel.dataset.productCampaignMobileIndex, 10) || 0];
				if (selected) rail.scrollLeft += selected.getBoundingClientRect().left - rail.getBoundingClientRect().left - parseFloat(window.getComputedStyle(rail).paddingLeft || 0);
			}
			rail.tabIndex = 0;
			getSlides(carousel).forEach(function (slide) { slide.tabIndex = 0; });
			bindMobileRail(carousel, rail);
			return;
		}
		var desktopRail = carousel.closest('[data-product-campaign-rail]');
		if (desktopRail) desktopRail.removeAttribute('tabindex');
		if (carousel.dataset.productCampaignCarouselReady === 'true') return;

		var config = {};
		try {
			config = JSON.parse(carousel.getAttribute('data-flickity-config') || '{}');
		} catch (error) {
			config = {};
		}

		if (window.theme && typeof window.theme.Carousel === 'function') {
			carousel.productCampaignCarousel = new window.theme.Carousel(carousel);
		} else if (window.Flickity) {
			carousel.productCampaignCarousel = new window.Flickity(carousel, config);
		}

		var instance = getInstance(carousel);
		if (instance && typeof instance.on === 'function') {
			if (typeof instance.select === 'function' && carousel.dataset.productCampaignMobileIndex !== undefined) {
				instance.select(parseInt(carousel.dataset.productCampaignMobileIndex, 10) || 0, false, true);
			}
			instance.on('select', function () {
				updateProgress(carousel);
			});
			instance.on('scroll', function () {
				updateProgress(carousel);
			});
			instance.on('dragEnd', function () {
				updateProgress(carousel);
			});
			instance.on('settle', function () {
				updateProgress(carousel);
			});
		}

		bindTrackpad(carousel);
		updateProgress(carousel);
		carousel.dataset.productCampaignCarouselReady = 'true';
	}

	function deriveOriginalSrc(img) {
		var original = img.getAttribute('data-original-src') || img.getAttribute('data-src');
		if (original) {
			return normaliseUrl(original);
		}

		var srcset = parseSrcset(img.getAttribute('data-srcset') || img.getAttribute('srcset'));
		if (srcset.length) {
			return srcset[srcset.length - 1].url;
		}

		return normaliseUrl(img.currentSrc || img.getAttribute('src'));
	}

	function buildZoomItems(gallery) {
		var carousel = gallery && gallery.querySelector(CAROUSEL_SELECTOR);

		return getSlides(carousel)
			.map(function (slide, index) {
				var img = slide.querySelector('img');
				var src = img && deriveOriginalSrc(img);

				if (!img || !src) {
					return null;
				}

				var width = parseInt(img.getAttribute('data-max-width'), 10) || img.naturalWidth || 1200;
				var height = parseInt(img.getAttribute('data-max-height'), 10) || img.naturalHeight || width;

				return {
					src: src,
					w: width,
					h: height,
					msrc: normaliseUrl(img.currentSrc || img.getAttribute('src')),
					index: index,
				};
			})
			.filter(Boolean);
	}

	function openZoom(event) {
		var trigger = event.target.closest(ZOOM_SELECTOR);
		var image = event.target.closest(IMAGE_SELECTOR);
		var opener = trigger || image;

		if (!opener || event.defaultPrevented || typeof PhotoSwipe !== 'function') {
			return;
		}

		var galleryElement = opener.closest(GALLERY_SELECTOR);
		var carousel = galleryElement && galleryElement.querySelector(CAROUSEL_SELECTOR);
		var items = buildZoomItems(galleryElement);
		var container = document.querySelector('.pswp');

		if (!items.length || !container) {
			return;
		}

		event.preventDefault();

		var instance = getInstance(carousel);
		var clickedSlide = opener.closest('[data-product-campaign-image-slide]');
		var clickedIndex = clickedSlide ? getSlides(carousel).indexOf(clickedSlide) : -1;
		var activeIndex = clickedIndex >= 0 ? clickedIndex : getSelectedIndex(carousel, instance);
		var startIndex = Math.min(Math.max(activeIndex, 0), Math.max(items.length - 1, 0));
		var controlAreaHeight = window.innerWidth < 1008 ? 112 : 104;

		container.classList.add('pswp--campaign-media');
		var gallery = new PhotoSwipe(container, false, items, {
			index: startIndex,
			showHideOpacity: true,
			loop: true,
			history: false,
			closeOnVerticalDrag: true,
			pinchToClose: true,
			allowPanToNext: true,
			bgOpacity: 1,
			tapToToggleControls: false,
			timeToIdle: 999999,
			timeToIdleOutside: 999999,
			getViewportSizeFn: function () {
				return {
					x: document.documentElement.clientWidth || window.innerWidth,
					y: Math.max(320, (document.documentElement.clientHeight || window.innerHeight) - controlAreaHeight),
				};
			},
			getDoubleTapZoom: function (isMouseClick, item) {
				return isMouseClick ? 1 : item.initialZoomLevel < 0.7 ? 1 : 1.33;
			},
		});
		var previousButton = container.querySelector('.pswp__button--prev');
		var nextButton = container.querySelector('.pswp__button--next');
		var closeButton = container.querySelector('.pswp__button--close');
		var controlBindings = [];

		function bindControl(button, action) {
			if (!button) {
				return;
			}

			var handler = function (controlEvent) {
				controlEvent.preventDefault();
				controlEvent.stopPropagation();
				action();
			};

			button.addEventListener('click', handler);
			button.addEventListener('touchend', handler);
			controlBindings.push({ button: button, handler: handler });
		}

		bindControl(previousButton, function () {
			gallery.prev();
		});
		bindControl(nextButton, function () {
			gallery.next();
		});
		bindControl(closeButton, function () {
			gallery.close();
		});

		gallery.listen('close', function () {
			controlBindings.forEach(function (binding) {
				binding.button.removeEventListener('click', binding.handler);
				binding.button.removeEventListener('touchend', binding.handler);
			});
			container.classList.remove('pswp--campaign-media');
		});
		gallery.listen('destroy', function () {
			if (opener.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
		});
		gallery.init();
	}

	function initAll(scope) {
		var root = scope && scope.querySelectorAll ? scope : document;
		Array.prototype.forEach.call(root.querySelectorAll(CAROUSEL_SELECTOR), initCarousel);
	}

	document.addEventListener('click', navigateCampaign);
	document.addEventListener('click', openZoom);
	document.addEventListener('keydown', function (event) {
		if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-product-campaign-image-slide][role="button"]')) openZoom(event);
	});
	if (mobileCampaign) {
		var syncCampaignLayout = function () { initAll(document); };
		if (mobileCampaign.addEventListener) mobileCampaign.addEventListener('change', syncCampaignLayout);
		else if (mobileCampaign.addListener) mobileCampaign.addListener(syncCampaignLayout);
	}
	document.addEventListener('DOMContentLoaded', function () {
		initAll(document);
	});
	window.addEventListener('load', function () {
		initAll(document);
	});
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target || document);
	});
})();

function getKlarnaModal() {
	return document.querySelector('[data-klarna-modal]');
}

function setKlarnaModalLink(url) {
	var modal = getKlarnaModal();
	if (!modal) {
		return;
	}

	var cta = modal.querySelector('[data-klarna-modal-cta]');
	if (!cta) {
		return;
	}

	cta.href = url || 'https://www.klarna.com/uk/what-is-klarna/';
}

function openKlarnaModal(url) {
	var modal = getKlarnaModal();
	if (!modal) {
		return;
	}

	window.__klarnaModalTrigger = document.activeElement;
	setKlarnaModalLink(url);
	modal.classList.add('klarna-modal--visible');
	modal.setAttribute('aria-hidden', 'false');
	document.body.classList.add('klarna-modal-open');

	var focusTarget =
		modal.querySelector('[data-klarna-modal-focus]') ||
		modal.querySelector('button, [href], [tabindex]:not([tabindex="-1"])');

	if (focusTarget) {
		focusTarget.focus();
	}
}

function closeKlarnaModal() {
	var modal = getKlarnaModal();
	if (!modal) {
		return;
	}

	modal.classList.remove('klarna-modal--visible');
	modal.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('klarna-modal-open');

	var lastTrigger = window.__klarnaModalTrigger;
	if (lastTrigger && typeof lastTrigger.focus === 'function') {
		lastTrigger.focus();
	}

	window.__klarnaModalTrigger = null;
}

$(document).on('click', '[data-klarna-close]', function(e) {
	e.preventDefault();
	closeKlarnaModal();
});

$(document).on('click', '[data-klarna-modal]', function(e) {
	if (e.target === this) {
		e.preventDefault();
		closeKlarnaModal();
	}
});

$(document).on('click', '[data-klarna-modal-body]', function(e) {
	e.stopPropagation();
});

$(document).on('keydown', function(e) {
	if (e.key === 'Escape') {
		closeKlarnaModal();
	}
});

document.addEventListener('click', function(event) {
	var trigger = event.target.closest('[data-klarna-modal-link]');
	if (!trigger) {
		return;
	}

	event.preventDefault();
	var url = trigger.getAttribute('data-klarna-learn-url') || 'https://www.klarna.com/uk/what-is-klarna/';
	openKlarnaModal(url);
});
// if($(".ColorProductsWrapper li.colorProduct").length>=4){
// 	 $(".ColorProductsWrapper").flickity({
// 		pageDots: false,
// 		prevNextButtons:false,
// 		contain:true,
// 		cellAlign: 'left',
// 		draggable: true
// 	});
// }

$("#sidebar-menu .Drawer__Content nav.SidebarMenu__Nav .Collapsible button.Collapsible__Button").each(function() {
	var d = $(this).text().replace(/\s+/, "");
	$(this).parent().addClass(d)
});

// Buy it with JS
$(document).on("change", ".ProductForm__Option.buy-it-with :input", function(e) {

	let $this = $(this);
	let $form = $this.closest('form');
	let $submitButton = $form.find(".ProductForm__AddToCart");
	let isButtonVisible = $form.find(".ProductForm__AddToCart").is(":visible");
	
	$form.closest('.ProductItem').find('.ProductForm__Error_Wrapper').remove();
	
	let productDataJson = JSON.parse($form.closest(".buy-it-with-product-item").find("[data-product-json]").html()) || [];
	let variants = productDataJson.product.variants;
	
	let $options = $form.find('[data-option-position]');
	
	let option1 = null;
	let option2 = null;
	let option3 = null;
	
	let size = $form.find('[data-option-name="size"] :input:checked').val();
	let variant = variants.find(variant => variant.option1 == size);
	 
	if(variant) {
	$form.find('[name="id"]').val(variant.id);
		
	}
	
	if(variant && !variant.available) {
		
		let $errorElement = $(`<span class="ProductForm__Error_Wrapper"><span class="ProductForm__Error Alert Alert--error">Selected size is not available</span> <br /></span>`);
		
		$errorElement.insertAfter($form);
		
			setTimeout(function () {
			$errorElement.remove();
		}, 2500);

		return;
	}
	
//   if(!isButtonVisible) {
	
		$submitButton.click();
		
		$this.attr("disabled", true);
		
		setTimeout(function() {
		
			$this.siblings('label').html('ADDED');
		}, 200);
//   } 
	
}) 

$(document).ready(function(){   
		$(".buy-it-with-button-toggle-wrapper .toggle-button").click(function(){
			$(this).parent().siblings(".ProductFormBuyItWith").slideToggle(); 
			$(this).parent().parent(".ProductItem ").toggleClass("show-hidden-info");       
		});
	 
		$('.buy-it-with-button-toggle-wrapper .toggle-button').click(function() {
			$(this).parent().siblings('.ProductItem__Wrapper').children('.ProductItem__Info--center').slideToggle('');
			$(this).parent().siblings('.ProductItem__Wrapper').children('.ProductItem__Info--center').toggleClass('hide-info');
		});
		
		$('.ProductItem__Info-toggle-closed .close-icon').click(function() {
			$(this).parent().parent('.buy-it-with-inner-wrapper .ProductFormBuyItWith').slideToggle('');
			$(this).parent().parent().siblings(".ProductItem__Wrapper").children('.ProductItem__Info--center').slideToggle('');   
		});
	
});
	
$(document).ready(function(){
	$(".cm-contact-button.email-us-button > a").click(function(){
		var $trigger = $(this);
		var $wrapper = $(".contact-us-template .contact-form-wrapper");
		var isExpanded = $trigger.attr("aria-expanded") === "true";
		$trigger.attr("aria-expanded", (!isExpanded).toString());
		$wrapper.stop(true, true).slideToggle(200, function() {
			$wrapper.toggleClass("is-open", $wrapper.is(":visible"));
		});
		return false;
	});
	
	if($(".contact-form-wrapper .Alert--success").length || $(".contact-form-wrapper .Alert--error").length) {
	
		$(".contact-us-template .contact-form-wrapper").show().addClass("is-open");
		$(".cm-contact-button.email-us-button > a").attr("aria-expanded", "true");
	}
	

	$(document).on('click', '[data-plyr="play"]', function(){
		var $el = $(this),
				$el_wrap = $el.closest('.plyr'),
				$video = $el_wrap.find('video')[0];
		//     console.log($video.attr('poster'));
		//console.log($video.paused)
		if($video != null) {
			if ($video.paused) {
				$video.play();
			}
			else {
				$video.pause();
			}
		}
	});
	if($('body').hasClass('template-collection')) {
		stickyFiltersAdjust();
	}
});

$(document).on('click', '.show-more', function(e) {
	
	$(this).closest(".description-wrapper").find(".short-description").addClass('hide');
	$(this).closest(".description-wrapper").find(".full-description").removeClass('hide');

	$(this).removeClass('show-more').addClass('show-less').html("Show less");
});

$(document).on('click', '.show-less', function(e) {

	$(this).closest(".description-wrapper").find(".short-description").removeClass('hide');
	$(this).closest(".description-wrapper").find(".full-description").addClass('hide');

	$(this).addClass('show-more').removeClass('show-less').html("Show More");
	
});

function stickyFiltersAdjust() {
	var $top = $('.top-sticky-header').outerHeight();
	$('.CollectionToolbar').css({
		top:$top
	});
	$('#boost-pfs-filter-tree2').css({
		top:$top
	});
}

$(window).on('resize', function(){
	if($('body').hasClass('template-collection')) {
		stickyFiltersAdjust();
	}
});

$(window).on('scroll', function(){
	if($('body').hasClass('template-collection')) {
		stickyFiltersAdjust();
	}
});

$(document).on('click', '.model-image-switcher__toggle', function(event){
	event.preventDefault();
	var isModelActive = document.body.classList.contains('model-image-active');
	var nextMode = isModelActive ? 'product' : 'model';

	if (window.setCollectionViewMode) {
		window.setCollectionViewMode(nextMode);
	} else {
		$('body').toggleClass('model-image-active');
	}
});

function convertCurrencyIntoMultipleOf5(currencyText) {
  currencyText = currencyText.replaceAll(",", ".");
let currencyAmountParts = currencyText.split("");
let currencySymbol = currencyAmountParts.shift();
let currencyAmountWithoutSymbol = currencyAmountParts.join("");
currencyAmountWithoutSymbol = Math.floor(currencyAmountWithoutSymbol);
currencyAmountWithoutSymbol = currencyAmountWithoutSymbol % 5 == 0 ? currencyAmountWithoutSymbol :(currencyAmountWithoutSymbol + ((5-(currencyAmountWithoutSymbol % 5)) % 5));
return currencySymbol + currencyAmountWithoutSymbol;

}
function convertCurrencyIntoNearest(currencyText) {
  currencyText = currencyText.replaceAll(",", ".");
let currencyAmountParts = currencyText.split("");

let currencySymbol = currencyAmountParts.shift();
let currencyAmountWithoutSymbol = currencyAmountParts.join("");
currencyAmountWithoutSymbol = Math.ceil(currencyAmountWithoutSymbol);
return currencySymbol + currencyAmountWithoutSymbol;

}
document.addEventListener("codeblackbelt:shipping-rates-calculator-plus:rates-rendered", function(e){
window._shipping_rates = e.detail.shippingRates;
updateDeliveryTabsText(e.detail.shippingRates);
});
function updateDeliveryTabsText(_shipping_rates) {

  Array.from($(".delivery-accordion:visible p")).forEach(element => {

    //jQuery(this).html(Shopify.formatMoney(jQuery(this).text()*100*Shopify.currency.rate, shopMoneyFormat));

    if($(element).find('[data-geolizr-price]').length) {
       let elementText = $(element).find('strong').text();
      let deliveryName = elementText.split(" delivery ")[0]
      deliveryName = deliveryName.trim().toLowerCase() || "";

       let matchedShippingRate = typeof _shipping_rates !== "undefined" &&  _shipping_rates ? _shipping_rates.find(shipping_rate => shipping_rate.code.toLowerCase().includes(deliveryName)): false;

      let $elementOldHtml =  $(element).html();
      let oldHtmlParts = $elementOldHtml.split("|");

      if(oldHtmlParts[0]){

       let oldHtmlParts0 =  oldHtmlParts[0].split('<span class="money">');
       let freeDeliveryAmount0 =  oldHtmlParts0[oldHtmlParts0.length-1];
        freeDeliveryAmount0 = freeDeliveryAmount0.split('</span>')[0];
       
        if(freeDeliveryAmount0.includes('<span class="geolizr-currency"')){
          freeDeliveryAmount0Parts = freeDeliveryAmount0.split(">");
          freeDeliveryAmount0 = freeDeliveryAmount0Parts[freeDeliveryAmount0Parts.length-1];
        }
         freeDeliveryAmount0 = convertCurrencyIntoNearest(freeDeliveryAmount0);
      
        oldHtmlParts[0] = oldHtmlParts0[0]+`<span class="money">${freeDeliveryAmount0}</span></strong>`;
       
      }
      if(oldHtmlParts[1] && matchedShippingRate){
       let $deliveryDays = matchedShippingRate.description.split(" (")[0] || oldHtmlParts[1];
       oldHtmlParts[1] = $deliveryDays; 
      }

      if(oldHtmlParts[2]) {
       let oldHtmlParts2 =  oldHtmlParts[2].split('<span class="money">');
       let freeDeliveryAmount =  oldHtmlParts2[oldHtmlParts2.length-1];
        freeDeliveryAmount = freeDeliveryAmount.split('</span>')[0];
       if(freeDeliveryAmount.includes('<span class="geolizr-currency"')){
          freeDeliveryAmountParts = freeDeliveryAmount.split(">");
          freeDeliveryAmount = freeDeliveryAmountParts[freeDeliveryAmountParts.length-1];
        }
      
        freeDeliveryAmount = convertCurrencyIntoMultipleOf5(freeDeliveryAmount);
        oldHtmlParts[2] = oldHtmlParts2[0]+`<span class="money">${freeDeliveryAmount}</span>`;
      }
      let $elementNewHtml = oldHtmlParts.join(" | ");
      $(element).html($elementNewHtml);
    }
    
});
}

$(function(){
    fetch(`${window.routes.cartUrl}.js`).then(response => response.json()).then(response => {
    if(response.item_count === 0){
          setTimeout(function(){
      updateDeliveryTabsText();
    }, 2000);
    }
    })
});



$("#modal_switcher").click(function(){
  $("body").toggleClass("show_modal_switcher");
});

$("#collection-model-popover button.Popover__Close, .PageOverlay, #collection-model-popover .Popover__ValueList > button").click(function(){
  $("body").removeClass("show_modal_switcher");
});

$("#collection-model-popover button.Popover__Close, .PageOverlay, #collection-model-popover .Popover__ValueList > button").click(function(){
  $("body").removeClass("show_modal_switcher");
});


$("#collection-model-popover .Popover__ValueList > button#featured_madel").click(function(){
  if (typeof window.setCollectionViewMode === 'function') {
    window.setCollectionViewMode('model');
  } else {
    $("body").addClass("model-image-active");
  }
});

$("#collection-model-popover .Popover__ValueList > button#featured_image").click(function(){
  if (typeof window.setCollectionViewMode === 'function') {
    window.setCollectionViewMode('product');
  } else {
    $("body").removeClass("model-image-active");
  }
});







/* Listening for reviews widget loaded event
function addEventListenerStamped(el, eventName, handler) { 
   if (el.addEventListener) { el.addEventListener(eventName, handler); }
   else { el.attachEvent('on' + eventName, function () { handler.call(el); }); } 
}

$(function(){
  addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
    console.log(e);
    console.log($("#stamped-reviews-widget .stamped-wall-photos-wrapper"));
    let $stampedWallSlider = $("#stamped-reviews-widget .stamped-wall-photos-wrapper");
    if($stampedWallSlider.length) {
      $stampedWallSlider.children('div:empty').remove();
      $stampedWallSlider.slick({
         slidesToShow: 1,
         infinite:true,
         slidesToScroll: 1,
         autoplay: true, 
         autoplaySpeed: 2000,
         arrows: true
      });
    }

  });
}); */ 




$(document).ready(function(){
 function primeSearchResults() {
   const inputs = Array.prototype.slice.call(document.querySelectorAll('.Search__SearchBar .Search__Input'));
   const input = inputs.find(function (searchInput) {
     const search = searchInput.closest('.Search');
     const rect = searchInput.getBoundingClientRect();

     return search && search.getAttribute('aria-hidden') === 'false' && rect.width > 0 && rect.height > 0;
   });

   if (!input) {
     return;
   }

   input.focus();

   if (window.jQuery && window.boostPFS && window.boostPFS.search && window.boostPFS.search.children) {
     const searchBoxId = window.jQuery(input).data('searchBox');
     const boostSearchInput = window.boostPFS.search.children.find(function (child) {
       return child.id === searchBoxId;
     });

     if (boostSearchInput && boostSearchInput.searchAutoComplete && typeof boostSearchInput.searchAutoComplete.showOnClickSuggestion === 'function') {
       boostSearchInput.searchAutoComplete.showOnClickSuggestion();
     }
   }
 }

 $(document).on('click', '[data-action="toggle-search"], [data-action="open-search"]', function () {
   setTimeout(primeSearchResults, 120);
   setTimeout(primeSearchResults, 360);
   setTimeout(primeSearchResults, 700);
 });
  $('.ProductItem__LabelList .ProductItem__Label').each(function(){
    if ($(this).text().trim() === 'On sale') {
      $(this).hide();
    }
});
});

// to fix the overlapping issue of the announcemnt bar
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('#shopify-section-announcement-timer');
    const anchor = section ? section.querySelector('a.timer_inner') : null;

    const hasVisibleContent = (el) => {
      if (!el) return false;
      return el.textContent.trim().length > 0;
    };

    const updateBodyClass = () => {
      if (section && anchor && hasVisibleContent(anchor)) {
        document.body.classList.add('announcement-bar-visible');
      } else {
        document.body.classList.remove('announcement-bar-visible');
      }
    };

    updateBodyClass(); // Initial check

    // Set up observer on the announcement section
    const announcementObserver = new MutationObserver(updateBodyClass);

    if (section) {
      announcementObserver.observe(section, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  });
// ends

// flickity slider js starts
  $(document).ready(function () {
    if (typeof Flickity === 'undefined') return;
    document.querySelectorAll('[data-product-gallery-progress]').forEach(progress => {
      const element = progress.closest('.Product__Gallery').querySelector('[data-product-gallery="desktop"]');
      const gallery = element && Flickity.data(element);
      if (!gallery) return;
      function updateGalleryProgress() {
        const count = gallery.slides.length;
        progress.hidden = count < 2;
        progress.style.setProperty('--gallery-progress-count', Math.max(count, 1));
        progress.style.setProperty('--gallery-progress-index', Math.max(0, Math.min(gallery.selectedIndex, count - 1)));
      }
      gallery.on('select', updateGalleryProgress);
      gallery.on('resize', updateGalleryProgress);
      updateGalleryProgress();
    });
  });
// flickity slider js ends

window.addEventListener("Upside::UCD::CartLoaded", function(e) {
  // Function to convert string to Title Case
  var toTitleCase = str =>
    str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());

  // Polling function for `.upside-ucd-recommended-products-container h2`
  var h2Interval = setInterval(() => {
    var h2 = document.querySelector('#upside-ucd-recommended-products-container h2');
    if (h2) {
      h2.textContent = toTitleCase(h2.textContent);
      clearInterval(h2Interval);
    }
  }, 100);
});

// window.addEventListener("Upside::UCD::CartLoaded", function () {
//   var toTitleCase = str =>
//     str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
//   // when product is added from the upsells
//     var toTitleCase = str =>
//     str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());

//   // Polling function for `.upside-ucd-recommended-products-container h2`
//   var h2Interval = setInterval(() => {
//     var h2 = document.querySelector('.ucd-items-container h2');
//     if (h2) {
//       h2.textContent = toTitleCase(h2.textContent);
//       clearInterval(h2Interval);
//     }
//   }, 2500);
//   // ends
// });

// when cart updates this function runs
// window.addEventListener("Upside::UCD::CartUpdated", function(e) {
//   var toTitleCase = str =>
//     str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
//    var toTitleCase = str =>
//     str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
// });

// // slider on hover effect
//   const carousel = document.querySelector('.custom_carousel');
//   const flkty = new Flickity(carousel, {
//     cellAlign: 'left',
//     contain: true,
//     wrapAround: true,
//     autoPlay: false, // autoplay is off
//     draggable: true,
//     prevNextButtons: false,
//     pageDots: false
//   });

//   let hoverInterval;

//   carousel.addEventListener('mouseenter', () => {
//     // Start sliding every 1 second
//     hoverInterval = setInterval(() => {
//       flkty.next();
//     }, 800);
//   });

//   carousel.addEventListener('mouseleave', () => {
//     // Stop sliding when mouse leaves
//     clearInterval(hoverInterval);
//   });
// // ends
const addToCartButton = document.querySelector('#add-to-cart');
const cartWrapper = addToCartButton ? addToCartButton.closest('.custom-cart-wrapper') : null;
let shopPayButton = cartWrapper ? cartWrapper.querySelector('.shopify-payment-button') : document.querySelector('.shopify-payment-button');
let addToCartLabelSpan = addToCartButton ? addToCartButton.querySelector('[data-add-to-cart-label]') : null;
const deferredSubmitButton = cartWrapper ? cartWrapper.querySelector('button.deferred') : null;
const preOrderVariantIds = new Set();
let currentVariantId = null;
let initialVariantId = null;
let lastAppliedAddToCartLabel = null;
let lastKnownAddToCartLabels = [];
const templateForcesPreorder = cartWrapper?.dataset.templatePreorder === 'true';
const requiresVariantSelection = cartWrapper
  ? (cartWrapper.dataset.requiresSelection === 'true'
    || (!Object.prototype.hasOwnProperty.call(cartWrapper.dataset, 'requiresSelection')
      && cartWrapper.classList.contains('variant-no-selection')))
  : false;
let variantInteractionOccurred = false;
const initialVariantFromUrl = (() => {
  try {
    return new URL(window.location.href).searchParams.get('variant');
  } catch (error) {
    return null;
  }
})();

const resolveShopPayButton = () => {
  if (shopPayButton && shopPayButton.isConnected) {
    return shopPayButton;
  }

  let candidate = null;
  if (cartWrapper) {
    candidate = cartWrapper.querySelector('.shopify-payment-button');
  }

  if (!candidate) {
    candidate = document.querySelector('.shopify-payment-button');
  }

  shopPayButton = candidate || null;
  return shopPayButton;
};

let deferredShopPayResyncHandle = null;

const scheduleShopPayResync = (delay = 250) => {
  if (typeof window === 'undefined' || typeof window.setTimeout !== 'function') {
    return;
  }
  if (deferredShopPayResyncHandle) {
    window.clearTimeout(deferredShopPayResyncHandle);
  }
  deferredShopPayResyncHandle = window.setTimeout(() => {
    deferredShopPayResyncHandle = null;
    if (typeof requestShopPaySync === 'function') {
      requestShopPaySync();
    }
  }, delay);
};

const setShopPayVisibility = (button, visible) => {
  if (!button) {
    return;
  }
  if (visible) {
    button.classList.remove('hide-shop-pay');
    if (button.style.getPropertyValue('display') === 'none') {
      button.style.removeProperty('display');
    }
  } else {
    button.classList.add('hide-shop-pay');
    button.style.setProperty('display', 'none', 'important');
  }
};

const WAITLIST_BUTTON_SELECTORS = [
  'button#BIS_trigger',
  'button.timesact-button-bis',
  'button.timesact-button-cs',
];

const readPrimaryProductJson = () => {
  const script = document.querySelector('[data-product-json]');
  if (!script) {
    return null;
  }

  try {
    return JSON.parse(script.textContent || '{}');
  } catch (error) {
    if (window.PDPDebug && typeof window.PDPDebug.log === 'function') {
      window.PDPDebug.log('product-json-parse-error', error);
    }
    return null;
  }
};

const resolveProductVariant = (variantId) => {
  if (!variantId) {
    return null;
  }

  const productJson = readPrimaryProductJson();
  if (!productJson || !productJson.product || !Array.isArray(productJson.product.variants)) {
    return null;
  }

  const id = String(variantId);
  for (let index = 0; index < productJson.product.variants.length; index += 1) {
    const variant = productJson.product.variants[index];
    if (String(variant.id) === id) {
      return variant;
    }
  }

  return null;
};

const isVariantAvailableForPurchase = (variantId) => {
  const variant = resolveProductVariant(variantId);
  if (!variant) {
    return true;
  }

  if (typeof variant.available === 'boolean') {
    return variant.available;
  }

  return true;
};

const findVisibleWaitlistButton = (root) => {
  const scope = root || cartWrapper || document;
  if (!scope || typeof scope.querySelector !== 'function') {
    return null;
  }

  for (let index = 0; index < WAITLIST_BUTTON_SELECTORS.length; index += 1) {
    const selector = WAITLIST_BUTTON_SELECTORS[index];
    const candidate = scope.querySelector(selector);
    if (!candidate) {
      continue;
    }

    if (candidate.hasAttribute('hidden') || candidate.hidden || candidate.getAttribute('aria-hidden') === 'true') {
      continue;
    }

    const style = window.getComputedStyle(candidate);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      continue;
    }

    if (candidate.offsetParent === null && style.position !== 'fixed') {
      continue;
    }

    const rect = candidate.getBoundingClientRect();
    if (!rect || (rect.width === 0 && rect.height === 0)) {
      continue;
    }

    if (typeof style.pointerEvents === 'string' && style.pointerEvents === 'none') {
      continue;
    }

    return candidate;
  }

  return null;
};

const isWaitlistVisible = (root) => Boolean(findVisibleWaitlistButton(root));

(function initPdpPreorderWaitlist() {
  const waitlistButton = document.querySelector('[data-pdp-waitlist-trigger]');
  const wrapper = document.querySelector('#cart-btn-wrapper');

  if (!waitlistButton || !wrapper) {
    return;
  }

  const nativeWaitlistEndpoint = typeof window.NativePreorderWaitlistEndpoint === 'string'
    ? window.NativePreorderWaitlistEndpoint.trim()
    : '';

  const getProductData = () => {
    const script = document.querySelector('[data-product-json]');
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  const getCurrentVariantId = () => {
    const idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idField && idField.value) {
      return String(idField.value);
    }

    try {
      const urlVariant = new URL(window.location.href).searchParams.get('variant');
      if (urlVariant) {
        return String(urlVariant);
      }
    } catch (error) {
      return null;
    }

    return null;
  };

  const resolveCurrentVariant = () => {
    const productData = getProductData();
    const variantId = getCurrentVariantId();
    const variants = productData && productData.product && Array.isArray(productData.product.variants)
      ? productData.product.variants
      : [];

    return variants.find((variant) => String(variant.id) === String(variantId)) || null;
  };

  const setButtonVisible = (visible) => {
    waitlistButton.hidden = !visible;
    waitlistButton.setAttribute('aria-hidden', visible ? 'false' : 'true');
    waitlistButton.disabled = !visible;
  };

  const updateVisibility = () => {
    const isSelected = wrapper.getAttribute('data-variant-selected') === 'true';
    const isPreorder = wrapper.getAttribute('data-preorder-active') === 'true';
    const nativeWaitlist = findVisibleWaitlistButton(wrapper);

    setButtonVisible(Boolean(isSelected && isPreorder && !nativeWaitlist && nativeWaitlistEndpoint));
  };

  const ensureModal = () => {
    let modal = document.querySelector('[data-pdp-waitlist-modal]');

    if (modal) {
      return modal;
    }

    modal = document.createElement('div');
    modal.className = 'PdpWaitlistModal';
    modal.setAttribute('data-pdp-waitlist-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'PdpWaitlistModalTitle');
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="PdpWaitlistModal__Overlay" data-pdp-waitlist-close></div>',
      '<div class="PdpWaitlistModal__Dialog">',
      '<button type="button" class="PdpWaitlistModal__Close" data-pdp-waitlist-close aria-label="Close">&times;</button>',
      '<h2 class="PdpWaitlistModal__Title" id="PdpWaitlistModalTitle">Join the waitlist</h2>',
      '<p class="PdpWaitlistModal__Description" data-pdp-waitlist-description>Enter your email and we will let you know when this pre-order is ready.</p>',
      '<form data-pdp-waitlist-form>',
      '<input class="PdpWaitlistModal__Input" data-pdp-waitlist-email type="email" autocomplete="email" required placeholder="Email address" aria-label="Email address">',
      '<button class="PdpWaitlistModal__Submit Button Button--primary Button--full" type="submit">Join the waitlist</button>',
      '<p class="PdpWaitlistModal__Message" data-pdp-waitlist-message role="status" aria-live="polite"></p>',
      '</form>',
      '</div>',
    ].join('');
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-pdp-waitlist-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => closeModal(modal));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal(modal);
      }
    });

    modal.querySelector('[data-pdp-waitlist-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      submitWaitlist(modal);
    });

    return modal;
  };

  const setModalMessage = (modal, message, type) => {
    const messageEl = modal.querySelector('[data-pdp-waitlist-message]');
    if (!messageEl) {
      return;
    }

    messageEl.textContent = message || '';
    messageEl.classList.toggle('PdpWaitlistModal__Message--error', type === 'error');
    messageEl.classList.toggle('PdpWaitlistModal__Message--success', type === 'success');
  };

  const trackWaitlistIntent = (eventName, extra) => {
    const productData = getProductData();
    const product = productData && productData.product;
    const variant = resolveCurrentVariant();
    const detail = Object.assign({
      event: eventName,
      product_id: product ? product.id : null,
      product_title: product ? product.title : '',
      variant_id: variant ? variant.id : null,
      variant_title: variant ? (variant.public_title || variant.title || '') : '',
      source: 'pdp_waitlist'
    }, extra || {});

    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(detail);
    }

    window._learnq = window._learnq || [];
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['track', eventName === 'joined_waitlist' ? 'Joined Waitlist' : 'Join Waitlist Started', {
        ProductID: detail.product_id,
        Name: detail.product_title,
        VariantID: detail.variant_id,
        Variant: detail.variant_title,
        URL: window.location.href,
        Source: detail.source
      }]);
    }

    if (eventName === 'joined_waitlist') {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: detail.product_title,
          content_ids: detail.product_id ? [detail.product_id] : [],
          content_type: 'product_group'
        });
      }

      if (typeof window.pintrk === 'function') {
        window.pintrk('track', 'lead');
      }
    }
  };

  const closeModal = (modal) => {
    modal.hidden = true;
    waitlistButton.focus();
  };

  const openModal = () => {
    const modal = ensureModal();
    const productData = getProductData();
    const variant = resolveCurrentVariant();
    const productTitle = productData && productData.product ? productData.product.title : 'this product';
    const variantTitle = variant && variant.public_title && variant.public_title !== 'Default Title'
      ? ` in ${variant.public_title}`
      : '';
    const description = modal.querySelector('[data-pdp-waitlist-description]');

    if (description) {
      description.textContent = `Enter your email and we will let you know when ${productTitle}${variantTitle} is ready.`;
    }

    setModalMessage(modal, '', null);
    modal.hidden = false;
    trackWaitlistIntent('join_waitlist_started');

    const input = modal.querySelector('[data-pdp-waitlist-email]');
    if (input) {
      input.value = '';
      input.setAttribute('aria-invalid', 'false');
      input.focus();
    }
  };

  const submitWaitlist = (modal) => {
    const input = modal.querySelector('[data-pdp-waitlist-email]');
    const submit = modal.querySelector('.PdpWaitlistModal__Submit');
    const productData = getProductData();
    const product = productData && productData.product;
    const variant = resolveCurrentVariant();
    const email = input ? input.value.trim() : '';

    if (!input || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      setModalMessage(modal, 'Enter a valid email address.', 'error');
      return;
    }

    if (!product || !variant) {
      setModalMessage(modal, 'Something went wrong. Please retry.', 'error');
      return;
    }

    if (!nativeWaitlistEndpoint) {
      setModalMessage(modal, 'Waitlist is not available right now.', 'error');
      return;
    }

    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Joining...';
    }

    const request = new XMLHttpRequest();
    request.open('POST', nativeWaitlistEndpoint, true);
    request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    request.onreadystatechange = function () {
      if (request.readyState !== 4) {
        return;
      }

      if (submit) {
        submit.disabled = false;
        submit.textContent = 'Join the waitlist';
      }

      if (request.status >= 200 && request.status < 300) {
        input.value = '';
        input.setAttribute('aria-invalid', 'false');
        setModalMessage(modal, 'You are on the waitlist. We will email you when it is ready.', 'success');
        trackWaitlistIntent('joined_waitlist', { method: 'email' });
        return;
      }

      setModalMessage(modal, 'Something went wrong. Please retry.', 'error');
    };

    request.send(JSON.stringify({
      type: 'EMAIL',
      status: 'PENDING',
      value: email,
      productId: product.id,
      variantId: variant.id,
      productName: variant.name || product.title,
      isSubNewsletter: false,
    }));
  };

  waitlistButton.addEventListener('click', () => {
    const nativeWaitlist = findVisibleWaitlistButton(wrapper);

    if (nativeWaitlist) {
      nativeWaitlist.click();
      return;
    }

    openModal();
  });

  const observer = new MutationObserver(updateVisibility);
  observer.observe(wrapper, {
    attributes: true,
    attributeFilter: ['data-preorder-active', 'data-variant-selected'],
  });

  ['change', 'variant:change', 'variant:changed', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      window.setTimeout(updateVisibility, 50);
    });
  });

  [0, 250, 750, 1500].forEach((delay) => {
    window.setTimeout(updateVisibility, delay);
  });
})();

if (cartWrapper?.dataset.preorderVariantIds) {
  cartWrapper.dataset.preorderVariantIds

    .split(',')
    .map(id => id.trim())
    .filter(Boolean)
    .forEach(id => preOrderVariantIds.add(id));


if (window.PDPDebug) {
  window.PDPDebug.collectPreorderState = function(context) {
    var ids = [];
    preOrderVariantIds.forEach(function(id) {
      ids.push(id);
    });

    var wrapperState = null;
    if (cartWrapper) {
      wrapperState = {
        preorderAttribute: cartWrapper.getAttribute('data-preorder-active'),
        hasPreorderClass: cartWrapper.classList.contains('has-preorder'),
      };
    }

    var shopPayHidden = null;
    var currentShopPayButton = resolveShopPayButton();
    if (currentShopPayButton) {
      shopPayHidden = currentShopPayButton.classList.contains('hide-shop-pay');
    }

    return {
      context: context || 'snapshot',
      timestamp: new Date().toISOString(),
      variantId: currentVariantId,
      requiresVariantSelection: requiresVariantSelection,
      templateForcesPreorder: templateForcesPreorder,
      knownPreorderVariantIds: ids,
      cartWrapperState: wrapperState,
      shopPayHidden: shopPayHidden,
      addToCartLabel: addToCartButton ? (addToCartButton.textContent || '').trim() : null,
    };
  };

  window.PDPDebug.logPreorderState = function(context) {
    if (!window.__PDP_DEBUG__) {
      return null;
    }
    var snapshot = window.PDPDebug.collectPreorderState(context);
    window.PDPDebug.log('preorder-state', snapshot);
    return snapshot;
  };

  if (window.__PDP_DEBUG__) {
    window.PDPDebug.logPreorderState('bootstrap');
  }
}

}

const syncVariantIdFromForm = () => {
  if (!addToCartButton || !addToCartButton.form) {
    return currentVariantId;
  }
  const idInput = addToCartButton.form.querySelector('[name="id"]');
  if (idInput && idInput.value) {
    currentVariantId = String(idInput.value);
    return currentVariantId;
  }
  return currentVariantId;
};

if (requiresVariantSelection) {
  initialVariantId = syncVariantIdFromForm();
} else {
  initialVariantId = syncVariantIdFromForm();
}

const detectPreorderViaContent = () => {
  if (!addToCartButton) {
    return false;
  }
  const buttonText = (addToCartButton.textContent || '').trim();
  if (buttonText.includes('Pre-order')) {
    return true;
  }
  return Array.from(addToCartButton.querySelectorAll('span')).some((span) => {
    const text = span.textContent.trim();
    if (text !== 'Pre-order') {
      return false;
    }
    const style = window.getComputedStyle(span);
    return style.display !== 'none' && style.visibility !== 'hidden';
  });
};

const detectVariantSelection = () => {
  if (!addToCartButton || !addToCartButton.form) {
    return false;
  }

  if (!requiresVariantSelection) {
    return true;
  }

  // A deep link is a choice only if it resolves to this product and the form agrees.
  const linkedVariant = initialVariantFromUrl && resolveProductVariant(initialVariantFromUrl);
  const linkedVariantField = addToCartButton.form.querySelector('[name="id"]');
  if (linkedVariant && linkedVariantField && String(linkedVariantField.value).trim() === String(linkedVariant.id)) {
    return true;
  }

  if (!variantInteractionOccurred && cartWrapper?.dataset.variantSelected === 'false') {
    return false;
  }

  const form = addToCartButton.form;

  const swatchRadios = form.querySelectorAll('.SizeSwatch__Radio');
  if (swatchRadios.length > 0) {
    if (Array.from(swatchRadios).some((radio) => radio.checked)) {
      return true;
    }
  }

  const variantSelect = form.querySelector('select[name="id"]');
  if (variantSelect) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption && selectedOption.value !== '' && !selectedOption.disabled && !selectedOption.hasAttribute('disabled')) {
      return true;
    }
  }

  const variantInput = form.querySelector('[name="id"]');
  if (variantInput && typeof variantInput.value === 'string') {
    const variantValue = variantInput.value.trim();
    if (variantValue) {
      if (form.querySelectorAll('.ProductForm__Option').length === 0) {
        return true;
      }

      if (variantInteractionOccurred) {
        return true;
      }

      if (initialVariantFromUrl && variantValue === initialVariantFromUrl) {
        return true;
      }

      if (initialVariantId && variantValue !== initialVariantId) {
        return true;
      }
    }
  }

  if (cartWrapper?.dataset.variantSelected === 'true') {
    return true;
  }

  if (cartWrapper) {
    if (cartWrapper.dataset.variantSelected === 'false') {
      return false;
    }
    if (cartWrapper.classList.contains('variant-no-selection')) {
      return false;
    }
  }

  return false;
};

const applyVariantSelectionState = (hasSelection) => {
  if (!cartWrapper) {
    return;
  }

  cartWrapper.dataset.variantSelected = hasSelection ? 'true' : 'false';

  if (!requiresVariantSelection) {
    return;
  }

  cartWrapper.classList.toggle('variant-no-selection', !hasSelection);

  if (addToCartButton) {
    addToCartButton.classList.toggle('select-your-size', !hasSelection);
  }
};

const matchingPdpOptionVariants = (variants, position, value, selectedOptions) => variants.filter((variant) => {
  if (variant.options[position - 1] !== value) return false;
  return Object.entries(selectedOptions).every(([otherPosition, otherValue]) =>
    Number(otherPosition) === position || variant.options[Number(otherPosition) - 1] === otherValue);
});

const updatePdpSizeAvailability = () => {
  const form = addToCartButton && addToCartButton.form;
  const product = readPrimaryProductJson()?.product;
  if (!form || !Array.isArray(product?.variants)) return;
  const selectedOptions = {};
  form.querySelectorAll('[data-option-position]:checked').forEach((radio) => {
    selectedOptions[radio.dataset.optionPosition] = radio.value;
  });
  form.querySelectorAll('.SizeSwatch__Radio').forEach((radio) => {
    const label = radio.nextElementSibling;
    if (!label || !label.classList.contains('SizeSwatch')) return;
    const matching = matchingPdpOptionVariants(product.variants, Number(radio.dataset.optionPosition), radio.value, selectedOptions);
    const available = matching.filter((variant) => variant.available);
    const isUnavailable = available.length === 0;
    const isPreorder = !isUnavailable && (templateForcesPreorder || available.every((variant) => preOrderVariantIds.has(String(variant.id))));
    label.classList.toggle('SizeSwatch--unavailable', isUnavailable);
    label.parentElement.classList.toggle('preOrderBadge', isPreorder);
    const status = matching.length === 0 ? ' — Unavailable combination' : isUnavailable ? ' — Out of stock, join the waitlist' : isPreorder ? ' — Pre-order' : '';
    radio.setAttribute('aria-label', radio.value + status);
    label.title = radio.value + status;
  });
};

const resolveLabelValue = (value, fallback) => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }
  return fallback;
};

const ensureAddToCartLabelSpan = () => {
  if (!addToCartButton) {
    return null;
  }

  if (addToCartLabelSpan && addToCartLabelSpan.isConnected) {
    return addToCartLabelSpan;
  }

  addToCartLabelSpan = addToCartButton.querySelector('[data-add-to-cart-label]');
  if (addToCartLabelSpan && addToCartLabelSpan.isConnected) {
    return addToCartLabelSpan;
  }

  const newSpan = document.createElement('span');
  newSpan.setAttribute('data-add-to-cart-label', '');
  addToCartButton.insertAdjacentElement('afterbegin', newSpan);
  addToCartLabelSpan = newSpan;
  return addToCartLabelSpan;
};

const removeDuplicateLabelNodes = (label, knownLabels) => {
  if (!addToCartButton) {
    return;
  }

  const shouldPreserveAddToCartNode = (node) => {
    if (!node) {
      return false;
    }

    if (node === addToCartLabelSpan) {
      return true;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      return !node.textContent || node.textContent.trim() === '';
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (node.matches('[data-add-to-cart-label]')) {
      return true;
    }

    if (node.matches('.Button__SeparatorDot')) {
      return true;
    }

    if (node.matches('[data-button-price]') || node.hasAttribute('data-money-convertible')) {
      return true;
    }

    if (node.matches('.cart-bag-icon')) {
      return true;
    }

    if (node.parentElement && node.parentElement.classList && node.parentElement.classList.contains('cart-bag-icon')) {
      return true;
    }

    return false;
  };

  const normalizedLabels = new Set();
  const collect = (value) => {
    if (value && typeof value === 'string') {
      normalizedLabels.add(value.trim().toLowerCase());
    }
  };

  collect(label);
  if (Array.isArray(knownLabels)) {
    knownLabels.forEach(collect);
  }

  try {
    if (typeof window !== 'undefined' && window.languages && typeof window.languages.productFormAddToCart === 'string') {
      collect(window.languages.productFormAddToCart);
    }
  } catch (error) {
    // ignore contextual issues (e.g., SSR)
  }

  if (normalizedLabels.size === 0) {
    return;
  }

  addToCartButton.childNodes.forEach((node) => {
    if (!node || node === addToCartLabelSpan) {
      return;
    }

    if (!shouldPreserveAddToCartNode(node)) {
      node.parentNode?.removeChild(node);
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.trim();
      if (text && normalizedLabels.has(text.toLowerCase())) {
        node.parentNode?.removeChild(node);
      }
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.matches('[data-add-to-cart-label]')) {
        if (node !== addToCartLabelSpan) {
          node.remove();
        }
        return;
      }

      if (node.matches('.Button__SeparatorDot')) {
        return;
      }

      const text = node.textContent.trim();
      const hasMoneyAttr = node.hasAttribute('data-money-convertible');
      const hasClasses = node.classList && node.classList.length > 0;

      if (!hasMoneyAttr && !hasClasses && text && normalizedLabels.has(text.toLowerCase())) {
        node.remove();
      }
    }
  });
};

const setAddToCartLabel = (label, knownLabels) => {
  if (!label) {
    return;
  }

  const labelSpan = ensureAddToCartLabelSpan();
  if (labelSpan) {
    const current = labelSpan.textContent ? labelSpan.textContent.trim() : '';
    if (current !== label) {
      labelSpan.textContent = label;
    }
  }

  if (deferredSubmitButton) {
    const currentDeferred = deferredSubmitButton.textContent ? deferredSubmitButton.textContent.trim() : '';
    if (currentDeferred !== label) {
      deferredSubmitButton.textContent = label;
    }
  }

  removeDuplicateLabelNodes(label, knownLabels);

  lastAppliedAddToCartLabel = label;
  lastKnownAddToCartLabels = Array.isArray(knownLabels) ? knownLabels.filter(Boolean) : [];

  const scheduleCleanup = (scheduler) => {
    if (typeof scheduler === 'function') {
      scheduler(() => removeDuplicateLabelNodes(label, knownLabels));
    }
  };

  if (typeof window !== 'undefined') {
    if (typeof window.requestAnimationFrame === 'function') {
      scheduleCleanup(window.requestAnimationFrame.bind(window));
    }
    if (typeof window.setTimeout === 'function') {
      scheduleCleanup((fn) => window.setTimeout(fn, 0));
    }
    if (typeof window.requestIdleCallback === 'function') {
      scheduleCleanup(window.requestIdleCallback.bind(window));
    }
  }
};

const updateAddToCartLabelState = (variantSelected, isPreorder) => {
  if (!addToCartButton) {
    return;
  }

  const selectLabel = resolveLabelValue(addToCartButton.dataset.selectLabel, null);
  const preorderLabel = resolveLabelValue(addToCartButton.dataset.preorderLabel, selectLabel);
  const addLabel = resolveLabelValue(addToCartButton.dataset.addLabel, selectLabel || preorderLabel);
  const soldOutLabel = resolveLabelValue(addToCartButton.dataset.soldOutLabel, window.languages?.productFormSoldOut);

  let targetLabel = addLabel;

  if (!variantSelected && requiresVariantSelection) {
    targetLabel = selectLabel || addLabel;
  } else if (!isVariantAvailableForPurchase(currentVariantId || syncVariantIdFromForm())) {
    targetLabel = soldOutLabel || addLabel;
    addToCartButton.disabled = true;
  } else if (isPreorder) {
    targetLabel = preorderLabel || addLabel;
  }

  setAddToCartLabel(targetLabel, [selectLabel, preorderLabel, addLabel]);
};

const computePreorderState = () => {
  if (!cartWrapper) {
    return false;
  }

  if (cartWrapper.classList.contains('variant-no-selection')) {
    return false;
  }

  if (templateForcesPreorder) {
    return true;
  }

  const variantId = syncVariantIdFromForm();
  if (variantId && preOrderVariantIds.size > 0) {
    return preOrderVariantIds.has(variantId);
  }

  if (variantId && preOrderVariantIds.size === 0) {
    return false;
  }

  return detectPreorderViaContent();
};

function updatePreorderState() {
  if (!addToCartButton) {
    return false;
  }

  const isPreorder = computePreorderState();
  const icon = addToCartButton.querySelector('svg#Layer_1');
  if (isPreorder) {
    addToCartButton.classList.add('is-preorder');
    icon?.classList.remove('hidden-icon');
  } else {
    addToCartButton.classList.remove('is-preorder');
    icon?.classList.add('hidden-icon');
  }

  if (cartWrapper) {
    cartWrapper.setAttribute('data-preorder-active', isPreorder ? 'true' : 'false');
    cartWrapper.classList.toggle('has-preorder', isPreorder);
  }

  return isPreorder;
}

const checkAndToggleShopPay = () => {
  updatePdpSizeAvailability();
  const variantSelected = detectVariantSelection();
  applyVariantSelectionState(variantSelected);

  const isPreorder = updatePreorderState();

  updateAddToCartLabelState(variantSelected, isPreorder);

  const paymentButton = resolveShopPayButton();
  if (!paymentButton) {
    return;
  }

  if (!variantSelected && requiresVariantSelection) {
    setShopPayVisibility(paymentButton, false);
    return;
  }

  const variantId = currentVariantId || syncVariantIdFromForm();
  const variantAvailable = variantId ? isVariantAvailableForPurchase(variantId) : true;
  const waitlistActive = isWaitlistVisible(cartWrapper);
  if (cartWrapper) {
    cartWrapper.classList.toggle('has-waitlist', waitlistActive);
  }
  const addToCartDisabled = Boolean(addToCartButton && addToCartButton.disabled);
  const shouldRetrySoon = variantAvailable && (waitlistActive || addToCartDisabled);

  if (!variantAvailable || waitlistActive || addToCartDisabled) {
    setShopPayVisibility(paymentButton, false);
    if (shouldRetrySoon) {
      scheduleShopPayResync();
    }
    return;
  }

  if (isPreorder) {
    setShopPayVisibility(paymentButton, false);
  } else {
    setShopPayVisibility(paymentButton, true);
  }
};

const requestShopPaySync = () => {
  const scheduler = typeof window.requestAnimationFrame === 'function'
    ? window.requestAnimationFrame.bind(window)
    : (fn) => window.setTimeout(fn, 0);
  scheduler(() => {
    syncVariantIdFromForm();
    resolveShopPayButton();
    checkAndToggleShopPay();
    if (window.PDPDebug && typeof window.PDPDebug.logPreorderState === 'function') {
      window.PDPDebug.logPreorderState('requestShopPaySync');
    }
  });
};

if (addToCartButton) {
  const observer = new MutationObserver(() => {
    requestShopPaySync();
    if (lastAppliedAddToCartLabel) {
      removeDuplicateLabelNodes(lastAppliedAddToCartLabel, lastKnownAddToCartLabels);
    }
  });
  observer.observe(addToCartButton, { childList: true, subtree: true });

  const handleVariantEvent = (event) => {
    const previousVariantId = currentVariantId;
    if (event && event.detail) {
      let variantId = null;
      if (event.detail.variant && event.detail.variant.id) {
        variantId = event.detail.variant.id;
      } else if (event.detail.variantId) {
        variantId = event.detail.variantId;
      } else if (event.detail.id && typeof event.detail.id !== 'object') {
        variantId = event.detail.id;
      } else if (typeof event.detail === 'number' || typeof event.detail === 'string') {
        variantId = event.detail;
      }

      if (variantId) {
        currentVariantId = String(variantId);
      } else {
        syncVariantIdFromForm();
      }
    } else {
      syncVariantIdFromForm();
    }

    if (!variantInteractionOccurred) {
      if ((event && event.isTrusted) || (currentVariantId && currentVariantId !== previousVariantId)) {
        variantInteractionOccurred = true;
      } else if (currentVariantId && initialVariantId && currentVariantId !== initialVariantId) {
        variantInteractionOccurred = true;
      }
    }

    if (window.PDPDebug && typeof window.PDPDebug.log === 'function') {
      var detailKeys = [];
      if (event && event.detail && typeof event.detail === 'object') {
        for (var key in event.detail) {
          if (Object.prototype.hasOwnProperty.call(event.detail, key)) {
            detailKeys.push(key);
          }
        }
      }
      window.PDPDebug.log('variant-event', {
        eventType: event ? event.type : null,
        derivedVariantId: currentVariantId,
        detailKeys: detailKeys,
      });
    }

    requestShopPaySync();
  };

  ['variant:change', 'variant:changed', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, handleVariantEvent);
  });
}

if (cartWrapper) {
  const paymentObserver = new MutationObserver(() => {
    const button = resolveShopPayButton();
    if (!button) {
      return;
    }
    if (requiresVariantSelection && cartWrapper.dataset.variantSelected === 'false') {
      setShopPayVisibility(button, false);
    }
    requestShopPaySync();
  });

  paymentObserver.observe(cartWrapper, { childList: true, subtree: true });
}

document.addEventListener('change', function (e) {
  const target = e.target;
  const isSizeRadio = target && target.classList && target.classList.contains('SizeSwatch__Radio');
  const isVariantSelect = target && typeof target.matches === 'function' && target.matches('[name="id"]');
  if (isSizeRadio || isVariantSelect) {
    if (e.isTrusted) {
      variantInteractionOccurred = true;
    }
    requestShopPaySync();
  }
});

const initPreorderState = () => {
  requestShopPaySync();
  document.querySelectorAll('.SizeSwatch__Radio').forEach((radio) => {
    radio.addEventListener('change', requestShopPaySync);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPreorderState);
} else {
  initPreorderState();
}

// add class in mega menu

document.addEventListener('DOMContentLoaded', function() {
  const horizontalList = document.querySelector('.HorizontalList--spacingExtraLoose');
  const stickyHeader = document.querySelector('.top-sticky-header');

  if (horizontalList && stickyHeader) {
    horizontalList.addEventListener('mouseenter', () => {
      stickyHeader.classList.add('menu_expanded');
    });

    horizontalList.addEventListener('mouseleave', () => {
      stickyHeader.classList.remove('menu_expanded');
    });
  }
});
// ends
// Function to check which button is visible and update the body class
function checkVisibleButtonAndUpdateBody() {
  // Get all buttons inside the cart wrapper
  const cartButtons = document.querySelectorAll('#cart-btn-wrapper button');
  const body = document.body;

  // Loop through each button to check its display property
  let isJoinWaitlistVisible = false;

  cartButtons.forEach(button => {
    const style = window.getComputedStyle(button); // Get computed styles
    const cart_buttonText = button.textContent.trim();
    // Check if button is visible (display: block)
    if (style.display === 'block') {
      const buttonText = button.textContent.trim();
      // If visible button text is "Join The Waitlist", set the flag
      if (buttonText === "Join The Waitlist") {
        isJoinWaitlistVisible = true;       
      } else {
      }
    }
  });
  if (isJoinWaitlistVisible) {
    body.classList.add('special-button-active');
  } else {
    body.classList.remove('special-button-active');
  }
}

// Attach change event listener to the size radio buttons
const sizeRadios = document.querySelectorAll('.SizeSwatch__Radio');
sizeRadios.forEach(radio => {
  radio.addEventListener('change', () => {
    setTimeout(() => {
      checkVisibleButtonAndUpdateBody(); // Check for the visible button after size change
    }, 100);
  });
});

// search code starts
// Open search
(function attachSearchOpenHandlers() {
  const toggleSearch = document.querySelector('[data-action="toggle-search"]');

  if (toggleSearch) {
    toggleSearch.addEventListener('click', function(e) {
      e.preventDefault();
      const input = document.querySelector('.shopify-section--header .boost-pfs-search-box');
      if (input) {
        input.focus();
        input.select();
        input.classList.add("showfocused");
      }
    });
  }

  function collapseSidebarNavigation() {
    document.querySelectorAll('#sidebar-menu .Collapsible__Button[aria-expanded="true"]').forEach(function(button) {
      const inner = button.nextElementSibling;

      button.setAttribute('aria-expanded', 'false');

      if (inner && inner.classList && inner.classList.contains('Collapsible__Inner')) {
        inner.setAttribute('aria-hidden', 'true');
        inner.style.height = '0px';
        inner.style.overflow = 'hidden';
        inner.style.visibility = '';
      }
    });
  }

  function markSidebarSearchActive() {
    collapseSidebarNavigation();
    document.body.classList.add('sidebar-search-active');
  }

  function clearSidebarSearchActive() {
    document.body.classList.remove('sidebar-search-active');
  }

  function closeSidebarSearchResults() {
    clearSidebarSearchActive();
    document.body.classList.remove('boost-pfs-search-suggestion-open-body');

    document.querySelectorAll('#sidebar-menu .Search__Input').forEach(function(input) {
      input.value = '';
      input.blur();
    });

    document.querySelectorAll('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open').forEach(function(wrapper) {
      wrapper.classList.remove('boost-pfs-search-suggestion-open');
      wrapper.style.display = 'none';
    });

    if (window.boostPFS && window.boostPFS.search && window.boostPFS.search.children) {
      window.boostPFS.search.children.forEach(function(searchInput) {
        if (searchInput && searchInput.searchAutoComplete) {
          searchInput.searchAutoComplete.isOpen = false;
        }
      });
    }
  }

  function isNavigableHref(href) {
    return href && href !== '#' && href.indexOf('javascript:') !== 0;
  }

  document.addEventListener('click', function(event) {
    const target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    if (target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')) {
      closeSidebarSearchResults();
      return;
    }

    const sidebarNavLink = target.closest('#sidebar-menu .SidebarMenu__Nav a[href]');
    if (!sidebarNavLink || !isNavigableHref(sidebarNavLink.getAttribute('href'))) {
      return;
    }

    closeSidebarSearchResults();

    if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = sidebarNavLink.href;
    }
  }, true);

  document.addEventListener('click', function(event) {
    const target = event.target;
    const sidebar = document.getElementById('sidebar-menu');
    const mustardRoot = document.getElementById('mustard-root');

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    if (target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')) {
      closeSidebarSearchResults();
      return;
    }

    const sidebarNavLink = target.closest('#sidebar-menu .SidebarMenu__Nav a[href]');
    if (sidebarNavLink && isNavigableHref(sidebarNavLink.getAttribute('href'))) {
      closeSidebarSearchResults();
      if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        window.location.href = sidebarNavLink.href;
      }
      return;
    }

    if (target.closest('#sidebar-menu .Search__Input, #sidebar-menu .Search__Form, #sidebar-menu .Search__SearchBar')) {
      markSidebarSearchActive();
      return;
    }

    if (target.closest('#sidebar-menu [data-action="close-search"], #sidebar-menu [data-action="close-drawer"]')) {
      closeSidebarSearchResults();
      return;
    }

    if (
      document.body.classList.contains('sidebar-search-active') &&
      sidebar &&
      sidebar.getAttribute('aria-hidden') !== 'false' &&
      (!mustardRoot || mustardRoot.style.display === 'none')
    ) {
      closeSidebarSearchResults();
    }
  });

  const sidebar = document.getElementById('sidebar-menu');

  if (sidebar) {
    const sidebarCloseObserver = new MutationObserver(function() {
      if (sidebar.getAttribute('aria-hidden') !== 'false') {
        closeSidebarSearchResults();
      }
    });

    sidebarCloseObserver.observe(sidebar, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  document.addEventListener('focusin', function(event) {
    const target = event.target;
    if (target && typeof target.closest === 'function' && target.closest('#sidebar-menu .Search__Input, #mustard-root #mu-search-bar')) {
      markSidebarSearchActive();
    }
  });
})();
// ends

(function attachHeaderSearchCloseCleanup() {
  const search = document.getElementById('Search');

  function closeBoostSuggestionLayer() {
    document.body.classList.remove('boost-pfs-search-suggestion-open-body');

    document.querySelectorAll('.boost-pfs-search-suggestion-wrapper').forEach(function(wrapper) {
      wrapper.classList.remove('boost-pfs-search-suggestion-open');
      wrapper.style.display = 'none';
      wrapper.style.pointerEvents = 'none';
    });

    document.querySelectorAll('.boost-pfs-search-suggestion, .boost-pfs-search-suggestion-popover').forEach(function(layer) {
      layer.style.display = 'none';
      layer.style.pointerEvents = 'none';
    });

    if (window.boostPFS && window.boostPFS.search && window.boostPFS.search.children) {
      window.boostPFS.search.children.forEach(function(searchInput) {
        if (searchInput && searchInput.searchAutoComplete) {
          searchInput.searchAutoComplete.isOpen = false;
        }
      });
    }
  }

  function cleanupClosedSearch() {
    if (search && search.getAttribute('aria-hidden') !== 'true') {
      return;
    }

    closeBoostSuggestionLayer();
  }

  function scheduleCleanup() {
    requestAnimationFrame(function() {
      cleanupClosedSearch();
      setTimeout(cleanupClosedSearch, 220);
    });
  }

  document.addEventListener('click', function(event) {
    const target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    if (target.closest('#Search [data-action="close-search"], .PageOverlay')) {
      scheduleCleanup();
    }
  }, true);

  document.addEventListener('search:close', scheduleCleanup);

  if (search) {
    new MutationObserver(scheduleCleanup).observe(search, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
})();

(function attachBoostSuggestionPriceFormatter() {
  const TRAILING_ZERO_PATTERN = /(\d+(?:[\s\u00A0\u202F,\.]\d{3})*)([.,])00(?=\D|$)/g;
  const PRICE_SELECTOR = '.boost-pfs-search-suggestion-product-price';
  const PRICE_PATTERN = /(?:£|\$|€)\s*\d|(?:\d+[.,]\d{2})/;
  const NODE_TYPES = window.Node || {};
  const TEXT_NODE = NODE_TYPES.TEXT_NODE || 3;
  const ELEMENT_NODE = NODE_TYPES.ELEMENT_NODE || 1;

  function stripTrailingZeroDecimals(value) {
    return typeof value === 'string' ? value.replace(TRAILING_ZERO_PATTERN, '$1') : value;
  }

  function updateTextNodes(node) {
    if (!node) {
      return;
    }

    if (node.nodeType === TEXT_NODE) {
      const cleaned = stripTrailingZeroDecimals(node.textContent);
      if (cleaned !== node.textContent) {
        node.textContent = cleaned;
      }
      return;
    }

    if (node.nodeType === ELEMENT_NODE && node.childNodes && node.childNodes.length) {
      node.childNodes.forEach(updateTextNodes);
    }
  }

  function parsePrice(value) {
    const match = (value || '').replace(/\s/g, '').match(/(?:£|\$|€)?(\d+(?:[,.]\d{1,2})?)/);
    return match ? Number(match[1].replace(',', '.')) : null;
  }

  function markComparePrice(container) {
    if (!container || typeof container.querySelectorAll !== 'function') {
      return;
    }

    const candidates = Array.from(container.querySelectorAll('span, s, del'))
      .filter(function (element) {
        return PRICE_PATTERN.test(element.textContent || '');
      })
      .map(function (element) {
        return {
          element: element,
          value: parsePrice(element.textContent)
        };
      })
      .filter(function (candidate) {
        return candidate.value !== null;
      });

    container.querySelectorAll('.boost-search-compare-price').forEach(function (element) {
      element.classList.remove('boost-search-compare-price');
    });

    container.querySelectorAll('s, del').forEach(function (element) {
      element.classList.add('boost-search-compare-price');
    });

    if (candidates.length < 2) {
      return;
    }

    const highest = candidates.reduce(function (currentHighest, candidate) {
      return candidate.value > currentHighest.value ? candidate : currentHighest;
    }, candidates[0]);

    highest.element.classList.add('boost-search-compare-price');
  }

  function formatPrices(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    const targets = root.matches && root.matches(PRICE_SELECTOR)
      ? [root]
      : root.querySelectorAll(PRICE_SELECTOR);

    if (!targets || !targets.length) {
      return;
    }

    targets.forEach(function (target) {
      updateTextNodes(target);
      markComparePrice(target);
    });
  }

  function handleMutations(mutations) {
    mutations.forEach(mutation => {
      if (!mutation.addedNodes || !mutation.addedNodes.length) {
        return;
      }

      mutation.addedNodes.forEach(node => {
        if (node.nodeType === ELEMENT_NODE && node.closest) {
          if (node.matches && node.matches(PRICE_SELECTOR)) {
            formatPrices(node);
            return;
          }

          const priceDescendant = node.querySelector && node.querySelector(PRICE_SELECTOR);
          if (priceDescendant) {
            formatPrices(node);
          }
        }
      });
    });
  }

  function startObserver() {
    if (typeof MutationObserver === 'undefined' || !document.body) {
      return;
    }

    formatPrices(document.body);

    const observer = new MutationObserver(handleMutations);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();

(function attachMustardSearchFormatter() {
  const ROOT_SELECTOR = '#mustard-root';
  const PRICE_CONTAINER_SELECTOR = '[class*="mu-flex"][class*="mu-justify-center"]';
  const PRICE_PATTERN = /(?:£|\$|€)\s*\d|(?:\d+[.,]\d{2})/;
  const ELEMENT_NODE = 1;

  function isVisible(element) {
    return !!(element && element.offsetParent !== null);
  }

  function parsePrice(value) {
    const match = (value || '').replace(/\s/g, '').match(/(?:£|\$|€)?(\d+(?:[,.]\d{1,2})?)/);
    return match ? Number(match[1].replace(',', '.')) : null;
  }

  function formatMustardPrices(root) {
    const mustardRoot = root && root.matches && root.matches(ROOT_SELECTOR)
      ? root
      : document.querySelector(ROOT_SELECTOR);

    if (!mustardRoot || typeof mustardRoot.querySelectorAll !== 'function') {
      return;
    }

    mustardRoot.querySelectorAll('.mu-line-through').forEach(function (element) {
      element.classList.add('mustard-compare-price');
    });

    mustardRoot.querySelectorAll(PRICE_CONTAINER_SELECTOR).forEach(function (container) {
      const candidates = Array.from(container.querySelectorAll('p, span, div'))
        .filter(function (element) {
          return isVisible(element) && PRICE_PATTERN.test(element.textContent || '');
        })
        .map(function (element) {
          return {
            element: element,
            value: parsePrice(element.textContent)
          };
        })
        .filter(function (candidate) {
          return candidate.value !== null;
        });

      if (candidates.length < 2) {
        return;
      }

      const highest = candidates.reduce(function (currentHighest, candidate) {
        return candidate.value > currentHighest.value ? candidate : currentHighest;
      }, candidates[0]);

      highest.element.classList.add('mustard-compare-price');
    });
  }

  function startObserver() {
    if (typeof MutationObserver === 'undefined' || !document.body) {
      return;
    }

    formatMustardPrices(document.body);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) {
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === ELEMENT_NODE && (node.matches(ROOT_SELECTOR) || node.querySelector(ROOT_SELECTOR))) {
            formatMustardPrices(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();

(function normalizeBoostSuggestionHeadings() {
  const WRAPPER_SELECTOR = '.boost-pfs-search-suggestion-wrapper';
  const HEADER_SELECTOR = `${WRAPPER_SELECTOR} .boost-pfs-search-suggestion-header`;
  const RECENT_ITEMS_SELECTOR = `${WRAPPER_SELECTOR} .boost-pfs-search-suggestion-group[data-group=\"recent\"] .boost-pfs-search-suggestion-item a`;
  const POPULAR_GROUP_SELECTOR = `${WRAPPER_SELECTOR} .boost-pfs-search-suggestion-group[data-group=\"suggestions\"]`;
  const TITLE_MAP = {
    'recent searches': 'Recent Searches',
    'trending products': 'Selected for You'
  };

  function titleCase(value) {
    if (!value) {
      return value;
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return value;
    }
    const mapped = TITLE_MAP[trimmed.toLowerCase()];
    if (mapped) {
      return mapped;
    }
    return trimmed.replace(/\w\S*/g, function (word, index) {
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word;
    });
  }

  function sentenceCase(value) {
    if (!value) {
      return value;
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return value;
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }

  function updateHeadings(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll(HEADER_SELECTOR).forEach(function (heading) {
      const nextText = titleCase(heading.textContent);
      if (nextText && heading.textContent !== nextText) {
        heading.textContent = nextText;
      }
    });
  }

  function updateRecentEntries(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll(RECENT_ITEMS_SELECTOR).forEach(function (anchor) {
      const original = anchor.textContent;
      if (!original) {
        return;
      }
      const nextText = sentenceCase(original);
      if (nextText !== original) {
        anchor.textContent = nextText;
      }
    });
  }

  function removePopularGroup(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll(POPULAR_GROUP_SELECTOR).forEach(function (group) {
      group.remove();
    });
  }

  function processTree(root) {
    removePopularGroup(root);
    updateHeadings(root);
    updateRecentEntries(root);
  }

  function initObserver() {
    if (typeof MutationObserver === 'undefined' || !document.body) {
      return;
    }

    const target = document.body;
    processTree(target);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) {
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.matches && node.matches(WRAPPER_SELECTOR)) {
            processTree(node);
            return;
          }
          if (node.matches && node.matches(HEADER_SELECTOR)) {
            updateHeadings(node);
            return;
          }
          if (node.querySelector) {
            processTree(node);
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();

// collection page sentence case js starts
// ends
// Initially hide the modal button wrapper
document.querySelectorAll('.view_modal_button_wrapper').forEach(el => {
  el.style.display = 'none';
});

// Set up the MutationObserver
const coll_filterobserver = new MutationObserver((mutations, observer) => {
const filterWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');
const modalWrapper = document.querySelector('.view_modal_button_wrapper');

  if (filterWrapper && filterWrapper.textContent.trim().length > 0 && modalWrapper) {
    // Show the modal button only if the filter wrapper has text
    modalWrapper.style.display = 'block';

    // Stop observing after it's shown
    observer.disconnect();
  }
});

// Start observing the DOM for changes
coll_filterobserver.observe(document.body, {
  childList: true,
  subtree: true
});


// show preorder message on the basis of the location
// document.addEventListener("DOMContentLoaded", function () {
//   function waitForGeolizrData(callback) {
//     if (
//       window.Geolizr &&
//       window.Geolizr.geoData &&
//       window.Geolizr.geoData.countryName
//     ) {
//       callback(window.Geolizr.geoData.countryName);
//     } else {
//       setTimeout(() => waitForGeolizrData(callback), 100);
//     }
//   }

//   waitForGeolizrData(function (countryName) {
//     console.log("Detected country:", countryName);

//     const normalized = countryName ? countryName.toUpperCase() : '';
//     const isUK = normalized === 'UNITED KINGDOM' || normalized === 'GB';

//     function updatePreorderText() {
//       const preorderContainer = document.querySelector('.timesact-preorder-description');
//       if (!preorderContainer) return;

//       const preorderParagraph = preorderContainer.querySelector('.pre_order');
//       if (preorderParagraph) {
//         const originalText = preorderParagraph.textContent.trim();
//         const match = originalText.match(/(?:The estimated shipping date is )(.+?\d{4})/);
//         if (match) {
//           const datePart = match[1];
//           preorderParagraph.textContent = `Estimated to restock ${datePart}`;
//         }

//         const existingCustom = preorderContainer.querySelector('.custom-shipping-info');
//         if (!existingCustom) {
//           const customPara = document.createElement('p');
//           customPara.className = 'custom-shipping-info';
//           customPara.style.marginTop = '10px';
//           customPara.textContent = isUK
//             ? `In-stock items ship immediately. Pre-order items ship once restocked.`
//             : `When mixing pre-order and in-stock items, all items will ship together once available.`;
//           preorderParagraph.insertAdjacentElement('afterend', customPara);
//         }
//       }
//     }

//     const observer = new MutationObserver((mutations) => {
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === 1 && (
//             node.classList.contains('timesact-preorder-description') ||
//             node.querySelector('.timesact-preorder-description')
//           )) {
//             updatePreorderText();
//           }
//         });
//       });
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });

//     updatePreorderText();
//   });
// });
// ends **********


// product page scroll js
const right = document.querySelector('.Product__Info');

function onScroll() {
  if (window.innerWidth <= 768 || !right) return; // Skip for mobile or if element doesn't exist

  const rect = right.getBoundingClientRect();
  if (rect.bottom <= window.innerHeight) {
    document.body.classList.add('left-scrolling');
  } else {
    document.body.classList.remove('left-scrolling');
  }
}

if (window.innerWidth > 768 && right) {
  window.addEventListener('scroll', onScroll);
}

(function() {
	function computeHeaderMetrics() {
		var wrapper = document.querySelector('.top-sticky-header');
		if (!wrapper) {
			return { headerHeight: 0, bannerHeight: 0, placeholderHeight: 0 };
		}
		var headerHeight = 0;
		var bannerHeight = 0;
		var placeholderHeight = 0;
		Array.prototype.forEach.call(wrapper.children, function(node) {
			if (!(node instanceof HTMLElement)) {
				return;
			}
			var rect = node.getBoundingClientRect();
			var height = (rect && rect.height) ? rect.height : 0;
			if (height <= 0 && node.offsetHeight) {
				height = node.offsetHeight;
			}
			if (height <= 0) {
				return;
			}
			if (node.id === 'fsb_container') {
				bannerHeight = height;
				return;
			}
			if (node.id === 'free-shipping-bar-placeholder') {
				placeholderHeight = height;
				return;
			}
			if (node.id === 'shopify-section-announcement') {
				var internalBanner = node.querySelector('#fsb_container');
				if (internalBanner) {
					var internalRect = internalBanner.getBoundingClientRect();
					var internalHeight = (internalRect && internalRect.height) ? internalRect.height : 0;
					if (internalHeight <= 0 && internalBanner.offsetHeight) {
						internalHeight = internalBanner.offsetHeight;
					}
					if (internalHeight > 0) {
						bannerHeight = internalHeight;
						height = Math.max(height - internalHeight, 0);
					}
				}
			}
			var styles = window.getComputedStyle(node);
			var marginTop = parseFloat(styles.marginTop) || 0;
			var marginBottom = parseFloat(styles.marginBottom) || 0;
			headerHeight += height + marginTop + marginBottom;
		});
		return {
			headerHeight: headerHeight,
			bannerHeight: bannerHeight,
			placeholderHeight: placeholderHeight
		};
	}

	function runStickyUpdate() {
		if (!document.body.classList.contains('template-product')) {
			return;
		}
	var metrics = computeHeaderMetrics();
	var numericThreshold = isFinite(metrics.headerHeight) ? Math.max(Math.round(metrics.headerHeight), 0) : 0;
	var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
	// Product chrome stays visible even while the gallery itself is sticky.
	var shouldStickDesktop = viewportWidth >= 1008;
	var isMobileViewport = viewportWidth < 1008;
	document.body.classList.toggle('main-sticky', shouldStickDesktop);
	document.body.classList.toggle('fsb-banner-sticky', shouldStickDesktop || isMobileViewport);

	var offsetValue = numericThreshold + 'px';
	var container = document.getElementById('fsb_container');
	var placeholder = document.getElementById('free-shipping-bar-placeholder');
	var bannerHeight = metrics.bannerHeight;
	if (!bannerHeight && container && container.getBoundingClientRect) {
		bannerHeight = container.getBoundingClientRect().height;
	}
	if (!bannerHeight) {
		bannerHeight = metrics.placeholderHeight;
	}
	if (!bannerHeight) {
		var placeholderHeightValue = window.getComputedStyle(document.documentElement).getPropertyValue('--free-shipping-placeholder-height');
		var parsedPlaceholder = parseFloat(placeholderHeightValue);
		if (!isNaN(parsedPlaceholder) && parsedPlaceholder > 0) {
			bannerHeight = parsedPlaceholder;
		}
	}
	if (!bannerHeight) {
		bannerHeight = 35;
	}
	var bannerValue = Math.max(Math.round(bannerHeight), 0) + 'px';
	var mobileOffsetValue = Math.max(Math.round(numericThreshold + bannerHeight), 0) + 'px';

	document.documentElement.style.setProperty('--free-shipping-sticky-offset', offsetValue);
	document.documentElement.style.setProperty('--free-shipping-banner-height', bannerValue);
	document.documentElement.style.setProperty('--free-shipping-mobile-offset', mobileOffsetValue);
	document.documentElement.style.setProperty('--free-shipping-placeholder-height', bannerValue);

	if (placeholder) {
		placeholder.style.setProperty('--free-shipping-placeholder-height', bannerValue);
		placeholder.classList.add('is-hidden');
	}

	if (container) {
		container.style.setProperty('--free-shipping-banner-height', bannerValue);
		if (shouldStickDesktop) {
			container.style.setProperty('--free-shipping-sticky-offset', offsetValue);
			container.style.visibility = 'visible';
			container.style.opacity = '';
			container.style.height = '';
			container.style.position = 'fixed';
			container.style.top = offsetValue;
			container.style.left = '0';
			container.style.right = '0';
			container.style.width = '100%';
			container.style.pointerEvents = '';
			container.style.transform = '';
			container.style.display = 'block';
			container.style.zIndex = '902';
		} else if (isMobileViewport) {
			container.style.setProperty('--free-shipping-sticky-offset', offsetValue);
			container.style.visibility = 'visible';
			container.style.opacity = '';
			container.style.height = '';
			container.style.position = '';
			container.style.top = '';
			container.style.left = '';
			container.style.right = '';
			container.style.width = '100%';
			container.style.pointerEvents = '';
			container.style.transform = '';
			container.style.display = 'block';
			container.style.zIndex = '';
		} else {
			container.style.removeProperty('--free-shipping-sticky-offset');
			container.style.visibility = '';
			container.style.opacity = '';
			container.style.height = '';
			container.style.pointerEvents = '';
			container.style.transform = '';
			container.style.display = '';
			container.style.position = '';
			container.style.top = '';
			container.style.left = '';
			container.style.right = '';
			container.style.width = '';
			container.style.zIndex = '';
		}

		if (shouldStickDesktop) {
			var slidesRoot = container.querySelector('#fsb_theme_background');
			if (
				slidesRoot &&
				slidesRoot.classList.contains('slick-initialized') &&
				typeof window.jQuery === 'function' &&
				window.jQuery(slidesRoot).slick
			) {
				try {
					window.jQuery(slidesRoot).slick('setPosition');
				} catch (error) {
					console.warn('FSB slick refresh error', error);
				}
			}
		}
	}
	}

	var requested = false;
	function scheduleStickyUpdate() {
		if (requested) {
			return;
		}
		requested = true;
		requestAnimationFrame(function() {
			requested = false;
			runStickyUpdate();
		});
	}

	function initStickyWatcher() {
		if (!document.body.classList.contains('template-product')) {
			return;
		}
		scheduleStickyUpdate();
		// Position is owned by CSS. Only geometry changes need a banner refresh;
		// scroll callbacks race native fixed positioning during iOS toolbar changes.
		window.addEventListener('load', scheduleStickyUpdate);
		window.addEventListener('resize', scheduleStickyUpdate);
		var headerStack = document.querySelector('.top-sticky-header');
		if (headerStack && typeof ResizeObserver !== 'undefined') {
			new ResizeObserver(scheduleStickyUpdate).observe(headerStack);
		}
		document.addEventListener('shopify:section:load', function(event) {
			if (event && event.target && event.target.querySelector && event.target.querySelector('[data-product-gallery]')) {
				scheduleStickyUpdate();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initStickyWatcher);
	} else {
		initStickyWatcher();
	}
	})();

	(function() {
		function syncMobileHeaderStack() {
            function setStackStyle(style, name, value) {
              if (style.getPropertyValue(name) === value) return;
              if (value) style.setProperty(name, value);
              else style.removeProperty(name);
            }
			var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
			var viewportHeight = Math.round((window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight || 0);
			if (viewportHeight > 0) {
				setStackStyle(document.documentElement.style, '--window-height', viewportHeight + 'px');
			}

			if (viewportWidth > 1007) {
				setStackStyle(document.documentElement.style, '--mobile-header-stack-height', '');
				setStackStyle(document.documentElement.style, '--product-mobile-header-stack-height', '');
				return;
			}

		var headerStack = document.querySelector('.top-sticky-header');
		if (!headerStack) {
			return;
		}

			var rect = headerStack.getBoundingClientRect();
			var height = rect && rect.height ? rect.height : headerStack.offsetHeight;
			if (height > 0) {
				var stackHeight = Math.ceil(height) + 'px';
				setStackStyle(document.documentElement.style, '--mobile-header-stack-height', stackHeight);
				setStackStyle(document.documentElement.style, '--product-mobile-header-stack-height', stackHeight);
			}

			var placeholder = document.getElementById('free-shipping-bar-placeholder');
		if (placeholder) {
			if (!placeholder.classList.contains('is-hidden')) placeholder.classList.add('is-hidden');
		}

		var freeShippingBar = document.getElementById('fsb_container');
		if (freeShippingBar && headerStack.contains(freeShippingBar)) {
			setStackStyle(freeShippingBar.style, 'position', '');
			setStackStyle(freeShippingBar.style, 'top', '');
			setStackStyle(freeShippingBar.style, 'left', '');
			setStackStyle(freeShippingBar.style, 'right', '');
			setStackStyle(freeShippingBar.style, 'width', '100%');
			setStackStyle(freeShippingBar.style, 'transform', '');
			setStackStyle(freeShippingBar.style, 'visibility', 'visible');
			setStackStyle(freeShippingBar.style, 'opacity', '');
			setStackStyle(freeShippingBar.style, 'height', '');
			setStackStyle(freeShippingBar.style, 'display', 'block');
		}
		}

		var syncRequested = false;
		function scheduleMobileHeaderStackSync(event) {
			// Product headers never change height because the page was scrolled.
			// Keep viewport resize and ResizeObserver updates for menus/keyboard/orientation.
			if (event && event.type === 'scroll' && document.body.classList.contains('template-product')) {
				return;
			}
			if (syncRequested) {
				return;
			}
			syncRequested = true;
			requestAnimationFrame(function() {
				syncRequested = false;
				syncMobileHeaderStack();
			});
		}

		function initMobileHeaderStackSync() {
			scheduleMobileHeaderStackSync();
			window.addEventListener('load', scheduleMobileHeaderStackSync);
			window.addEventListener('resize', scheduleMobileHeaderStackSync);
			window.addEventListener('orientationchange', scheduleMobileHeaderStackSync);
			window.addEventListener('scroll', scheduleMobileHeaderStackSync, { passive: true });
			document.addEventListener('shopify:section:load', scheduleMobileHeaderStackSync);

			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', scheduleMobileHeaderStackSync);
				window.visualViewport.addEventListener('scroll', scheduleMobileHeaderStackSync);
			}

			var headerStack = document.querySelector('.top-sticky-header');
			if (headerStack && typeof ResizeObserver !== 'undefined') {
				var observer = new ResizeObserver(scheduleMobileHeaderStackSync);
				observer.observe(headerStack);
			}
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initMobileHeaderStackSync);
		} else {
			initMobileHeaderStackSync();
		}
	})();


// Toggle pre-order shipping messaging based on customer location and variant state
function setupPreorderMessaging() {
  let messageEl = document.querySelector("[data-preorder-shipping-message]");
  let initialized = false;
  const observedContainers = new WeakSet();

  const UK_PREORDER_MESSAGE = "If your order contains a mix of in-stock and pre-order items, in-stock items will ship immediately and pre-order items ship once restocked.";
  const INTERNATIONAL_PREORDER_MESSAGE = "When mixing pre-order and in-stock items, all items will ship together once available.";
  const UK_HANDLES = new Set(["GB", "UK"]);

  const scheduleRender = typeof window !== "undefined" && typeof window.requestAnimationFrame === "function"
    ? window.requestAnimationFrame.bind(window)
    : (fn) => setTimeout(fn, 0);

  const normalizeCountryHandle = (value) => {
    if (!value) {
      return "";
    }
    return String(value).trim().toUpperCase();
  };

  const locationState = {
    resolved: false,
    isUK: false
  };

  let pendingCountryPromise = null;

  const settleLocationFromHandle = (handle) => {
    const normalized = normalizeCountryHandle(handle);
    if (!normalized) {
      return false;
    }
    locationState.isUK = UK_HANDLES.has(normalized);
    locationState.resolved = true;
    return true;
  };

  const settleLocationFromDom = () => {
    if (typeof document === "undefined") {
      return false;
    }
    const candidates = [
      normalizeCountryHandle(typeof window !== "undefined" && window.Shopify ? window.Shopify.country : ""),
      normalizeCountryHandle(document.body ? document.body.getAttribute("data-country") : ""),
      normalizeCountryHandle(document.documentElement ? document.documentElement.getAttribute("data-country") : "")
    ];

    for (let index = 0; index < candidates.length; index += 1) {
      if (settleLocationFromHandle(candidates[index])) {
        return true;
      }
    }
    return false;
  };

  const ensureCountryResolved = () => {
    if (locationState.resolved) {
      return Promise.resolve(locationState.isUK);
    }

    if (settleLocationFromDom()) {
      return Promise.resolve(locationState.isUK);
    }

    if (pendingCountryPromise) {
      return pendingCountryPromise;
    }

    if (typeof fetch !== "function") {
      locationState.resolved = true;
      locationState.isUK = false;
      return Promise.resolve(locationState.isUK);
    }

    pendingCountryPromise = fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
      .then((response) => {
        if (!response || typeof response.json !== "function") {
          return null;
        }
        return response.json().catch(() => null);
      })
      .then((data) => {
        const handle = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle
          ? data.detected_values.country.handle
          : null;
        settleLocationFromHandle(handle);
        if (!locationState.resolved) {
          locationState.resolved = true;
          locationState.isUK = false;
        }
        return locationState.isUK;
      })
      .catch(() => {
        locationState.resolved = true;
        locationState.isUK = false;
        return locationState.isUK;
      })
      .finally(() => {
        pendingCountryPromise = null;
      });

    return pendingCountryPromise;
  };

  const observeCountryAttribute = () => {
    if (locationState.resolved || typeof MutationObserver !== "function") {
      return;
    }

    const target = document.body || document.documentElement;
    if (!target) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (locationState.resolved) {
        observer.disconnect();
        return;
      }
      if (settleLocationFromDom()) {
        observer.disconnect();
        scheduleRender(renderMessage);
      }
    });

    try {
      observer.observe(target, { attributes: true, attributeFilter: ["data-country"] });
    } catch (observerError) {
      if (window?.PDPDebug?.log) {
        window.PDPDebug.log("preorder-country-observer-error", observerError);
      }
    }
  };

  const resolveMessageCopy = () => {
    if (!locationState.resolved) {
      return null;
    }
    const dispatchConfig = window.dsrcvDeliveryPromiseConfig || {};
    if (locationState.isUK && dispatchConfig.blackFridayDispatch === true) {
      return dispatchConfig.strings && dispatchConfig.strings.blackFridayMixedOrder || '';
    }
    return locationState.isUK ? UK_PREORDER_MESSAGE : INTERNATIONAL_PREORDER_MESSAGE;
  };

  const syncCartNoticeProperty = (messageCopy, enabled) => {
    const noticeInput = document.querySelector("[data-preorder-cart-notice]");
    if (noticeInput?.closest("form")?.dataset.preorderPdpNoticeOwner === "true") return;
    if (!noticeInput) {
      return;
    }

    if (enabled && messageCopy) {
      noticeInput.value = "Pre-order shipping notice: " + messageCopy;
      noticeInput.disabled = false;
      return;
    }

    noticeInput.value = "";
    noticeInput.disabled = true;
  };

  const syncCartEstimatedDateProperty = (estimatedDate, enabled) => {
    if (document.querySelector("[data-preorder-cart-notice]")?.closest("form")?.dataset.preorderPdpNoticeOwner === "true") return;
    const dateInputs = Array.from(document.querySelectorAll('input[name="properties[Estimated shipping date]"]'));
    const managedInput = dateInputs.find((input) => input.hasAttribute("data-preorder-estimated-ship-date"));
    const renderedInput = dateInputs.find((input) => !input.hasAttribute("data-preorder-estimated-ship-date"));
    const dateInput = renderedInput || managedInput;
    if (!dateInput) {
      return;
    }

    if (enabled && estimatedDate) {
      dateInput.value = estimatedDate;
      dateInput.disabled = false;
      if (managedInput && renderedInput && managedInput !== renderedInput) {
        managedInput.value = "";
        managedInput.disabled = true;
      }
      return;
    }

    dateInput.value = "";
    dateInput.disabled = true;
  };

  const findEstimatedAnchor = () => (
    document.querySelector(".pre-order-estimated-ship-date") ||
    document.querySelector(".timesact-preorder-description .pre_order") ||
    document.querySelector(".pre_order")
  );

  const createMessageEl = () => {
    const anchor = findEstimatedAnchor();
    if (!anchor || !anchor.parentElement) {
      return null;
    }

    const el = document.createElement("p");
    el.className = "pre-order-shipping-message";
    el.setAttribute("data-preorder-shipping-message", "");
    el.setAttribute("hidden", "hidden");

    const wrapperForTemplate = anchor.closest(".custom-cart-wrapper");
    if (wrapperForTemplate && wrapperForTemplate.getAttribute("data-template-preorder") === "true") {
      el.dataset.preorderTemplate = "true";
    }

    anchor.insertAdjacentElement("afterend", el);
    return el;
  };

  const ensureMessageEl = () => {
    if (messageEl && document.contains(messageEl)) {
      return messageEl;
    }
    messageEl = document.querySelector("[data-preorder-shipping-message]");
    if (messageEl && document.contains(messageEl)) {
      return messageEl;
    }
    messageEl = createMessageEl();
    return messageEl;
  };

  const relocateMessageEl = (target) => {
    if (!target) {
      return;
    }
    const el = ensureMessageEl();
    if (!el) {
      return;
    }
    if (target.nextElementSibling !== el) {
      target.insertAdjacentElement("afterend", el);
    }
  };

  const deadlineSelectors = [
    ".trustblox-1-timer-textual.trustblox-1-style-bordered",
    ".trustblox-1-timer-wrap",
    ".trustblox-1-viewcart-wrap"
  ];

  const purgeHeaderDeadlineNodes = () => {
    const header = document.querySelector(".top-sticky-header");
    if (!header) {
      return;
    }
    deadlineSelectors.forEach((selector) => {
      header.querySelectorAll(selector).forEach((node) => {
        if (node && node.parentElement) {
          node.parentElement.removeChild(node);
        }
      });
    });
  };

  let headerDeadlineObserver = null;

  const ensureHeaderDeadlineObserver = () => {
    const header = document.querySelector(".top-sticky-header");
    if (!header) {
      return false;
    }
    purgeHeaderDeadlineNodes();
    if (headerDeadlineObserver) {
      return true;
    }
    headerDeadlineObserver = new MutationObserver(() => {
      purgeHeaderDeadlineNodes();
    });
    headerDeadlineObserver.observe(header, { childList: true, subtree: true });
    return true;
  };

  const initPreorderMessaging = () => {
    ensureHeaderDeadlineObserver();

    if (initialized) {
      return true;
      }

      const el = ensureMessageEl();
      if (!el) {
        return false;
      }

    const sectionEl = el.closest("[data-section-type='product']");
    const productJsonEl = sectionEl
      ? sectionEl.querySelector("[data-product-json]")
      : document.querySelector("[data-product-json]");
    const preOrderIds = new Set();
    const variantForm = el.closest("form");
    const wrapper = el.closest(".custom-cart-wrapper");
    const templateIsPreorder = el.dataset.preorderTemplate === "true";
    let currentVariantId = null;

    if (productJsonEl) {
      try {
        const parsed = JSON.parse(productJsonEl.textContent || "{}");
        if (Array.isArray(parsed.preorder_variant_ids)) {
          parsed.preorder_variant_ids.forEach(function (id) {
            if (id) {
              preOrderIds.add(String(id));
            }
          });
        }
        if (parsed.selected_variant_id) {
          currentVariantId = String(parsed.selected_variant_id);
        }
      } catch (error) {
        console.warn("Unable to parse product JSON for pre-order messaging", error);
      }
    }

    const updateVariantFromUrl = () => {
      let variantParam = null;
      try {
        variantParam = new URL(window.location.href).searchParams.get("variant");
      } catch (urlError) {
        variantParam = null;
      }
      if (variantParam && String(variantParam) !== currentVariantId) {
        currentVariantId = String(variantParam);
        return true;
      }
      return false;
    };

    updateVariantFromUrl();

    const getEstimatedDateNode = () => {
      const preOrderInfoContainer = el.closest(".pre-order-information");
      if (preOrderInfoContainer) {
        const estimate = preOrderInfoContainer.querySelector(".pre-order-estimated-ship-date");
        if (estimate) {
          return estimate;
        }
      }

      const siblingEstimate = el.previousElementSibling;
      if (
        siblingEstimate &&
        siblingEstimate.classList &&
        siblingEstimate.classList.contains("pre_order") &&
        siblingEstimate.textContent.trim().length > 0
      ) {
        return siblingEstimate;
      }

      const timesactEstimate = document.querySelector(".timesact-preorder-description .pre_order");
      if (timesactEstimate && timesactEstimate.textContent.trim().length > 0) {
        return timesactEstimate;
      }

      return document.querySelector(".pre-order-estimated-ship-date") || siblingEstimate || null;
    };

    const hasVisibleEstimatedDate = () => {
      const estimatedEl = getEstimatedDateNode();
      if (!estimatedEl) {
        return false;
      }
      const isEmptyThemePreorderAnchor =
        estimatedEl.classList &&
        estimatedEl.classList.contains("pre_order") &&
        estimatedEl.textContent.replace(/\s+/g, "").length === 0;

      if (!isEmptyThemePreorderAnchor && estimatedEl.textContent.replace(/\s+/g, "").length === 0) {
        return false;
      }

      const infoContainer =
        estimatedEl.closest(".pre-order-information") ||
        estimatedEl.closest(".timesact-preorder-description") ||
        estimatedEl.closest("[data-type='pre-order-section']") ||
        estimatedEl;

      if (infoContainer && infoContainer.hasAttribute("hidden")) {
        return false;
      }

      const infoStyles = infoContainer ? window.getComputedStyle(infoContainer) : null;
      if (infoStyles && (infoStyles.display === "none" || infoStyles.visibility === "hidden")) {
        return false;
      }

      const estimatedStyles = window.getComputedStyle(estimatedEl);
      if (estimatedStyles.display === "none" || estimatedStyles.visibility === "hidden") {
        return false;
      }

      relocateMessageEl(estimatedEl);
      return true;
    };

    const updateVariantFromForm = () => {
      if (!variantForm) {
        updateVariantFromUrl();
        return;
      }
      const idInput = variantForm.querySelector('[name="id"]');
      if (idInput && idInput.value) {
        currentVariantId = String(idInput.value);
        return;
      }
      updateVariantFromUrl();
    };

    const wrapperSignalsPreorder = () => {
      if (!wrapper) {
        return true;
      }
      const attr = wrapper.getAttribute("data-preorder-active");
      return attr === null ? true : attr === "true";
    };

    const isVariantPreorder = () => {
      if (!wrapperSignalsPreorder()) {
        return false;
      }
      if (templateIsPreorder) {
        return true;
      }
      if (preOrderIds.size === 0) {
        return false;
      }
      if (!currentVariantId) {
        updateVariantFromForm();
      }
      return currentVariantId ? preOrderIds.has(String(currentVariantId)) : false;
    };

    const findDeadlineBlocks = () => {
      const nodes = new Set();
      const scopes = [];

      if (variantForm) {
        scopes.push(variantForm);
      }

      if (wrapper && !scopes.includes(wrapper)) {
        scopes.push(wrapper);
      }

      const productRoot =
        el.closest("[data-section-type='product']") ||
        document.querySelector("[data-section-type='product']") ||
        document;

      if (productRoot && !scopes.includes(productRoot)) {
        scopes.push(productRoot);
      }

      scopes.forEach((scope) => {
        deadlineSelectors.forEach((selector) => {
          scope.querySelectorAll(selector).forEach((node) => {
            if (node) {
              nodes.add(node);
            }
          });
        });
      });

      return Array.from(nodes);
    };

    const applyDeadlineVisibility = (shouldShow) => {
      findDeadlineBlocks().forEach((node) => {
        if (shouldShow) {
          if (node.dataset.preorderHidden === "true") {
            const inlineDisplay = node.dataset.preorderInlineDisplay || "";
            if (inlineDisplay) {
              node.style.display = inlineDisplay;
            } else {
              node.style.removeProperty("display");
            }
          }
          delete node.dataset.preorderHidden;
          delete node.dataset.preorderInlineDisplay;
          return;
        }
        if (!node.dataset.preorderHidden) {
          node.dataset.preorderInlineDisplay = node.style.display || "";
        }
        node.dataset.preorderHidden = "true";
        node.style.display = "none";
      });
    };

    const resolveDeadlineVisibilityState = () => {
      const variantSelected =
        typeof detectVariantSelection === "function" ? detectVariantSelection() : true;
      const variantIsPreorder = variantSelected ? isVariantPreorder() : false;

      let variantAvailable = true;
      if (!variantSelected) {
        variantAvailable = false;
      } else {
        if (!currentVariantId) {
          updateVariantFromForm();
        }
        const activeVariantId = currentVariantId;
        if (activeVariantId && typeof isVariantAvailableForPurchase === "function") {
          try {
            variantAvailable = Boolean(isVariantAvailableForPurchase(activeVariantId));
          } catch (availabilityError) {
            if (window?.PDPDebug?.log) {
              window.PDPDebug.log("deadline-availability-error", availabilityError);
            }
            variantAvailable = true;
          }
        } else if (!activeVariantId) {
          variantAvailable = false;
        }
      }

      let waitlistActive = false;
      if (wrapper && typeof isWaitlistVisible === "function") {
        try {
          waitlistActive = Boolean(isWaitlistVisible(wrapper));
        } catch (waitlistError) {
          if (window?.PDPDebug?.log) {
            window.PDPDebug.log("deadline-waitlist-error", waitlistError);
          }
          waitlistActive = false;
        }
      }

      return {
        variantSelected,
        variantIsPreorder,
        variantAvailable,
        waitlistActive
      };
    };

    const shouldShowDeadline = (state) =>
      state.variantSelected && !state.variantIsPreorder && state.variantAvailable && !state.waitlistActive;

    let deadlineObserver = null;

    const ensureDeadlineObserver = () => {
      if (!variantForm || deadlineObserver) {
        return;
      }
      deadlineObserver = new MutationObserver(() => {
        const deadlineState = resolveDeadlineVisibilityState();
        applyDeadlineVisibility(shouldShowDeadline(deadlineState));
      });
      deadlineObserver.observe(variantForm, { childList: true, subtree: true });
    };

    const renderMessage = () => {
      const ensuredEl = ensureMessageEl();
      if (!ensuredEl) {
        return;
      }
      const deadlineState = resolveDeadlineVisibilityState();
      applyDeadlineVisibility(shouldShowDeadline(deadlineState));
      if (!deadlineState.variantSelected || !deadlineState.variantIsPreorder || !hasVisibleEstimatedDate()) {
        syncCartNoticeProperty("", false);
        syncCartEstimatedDateProperty("", false);
        ensuredEl.textContent = "";
        ensuredEl.setAttribute("hidden", "hidden");
        return;
      }
      const messageCopy = resolveMessageCopy();
      if (!messageCopy) {
        ensureCountryResolved().then(() => {
          scheduleRender(renderMessage);
        });
        syncCartNoticeProperty("", false);
        syncCartEstimatedDateProperty("", false);
        ensuredEl.textContent = "";
        ensuredEl.setAttribute("hidden", "hidden");
        return;
      }
      const estimatedDateNode = getEstimatedDateNode();
      const estimatedDateText = estimatedDateNode ? estimatedDateNode.textContent.replace(/\s+/g, " ").trim() : "";
      syncCartNoticeProperty(messageCopy, true);
      syncCartEstimatedDateProperty(estimatedDateText, true);
      ensuredEl.textContent = messageCopy;
      ensuredEl.removeAttribute("hidden");
    };

    const observeContainerForMessage = (container) => {
      if (!container || observedContainers.has(container)) {
        return;
      }

      const containerObserver = new MutationObserver((mutationList) => {
        let removedPreorderMessage = false;

        mutationList.forEach((mutation) => {
          if (mutation.type !== "childList") {
            return;
          }

          mutation.removedNodes.forEach((node) => {
            if (!(node instanceof Element)) {
              return;
            }
            if (
              node.matches?.("[data-preorder-shipping-message]") ||
              node.querySelector?.("[data-preorder-shipping-message]")
            ) {
              removedPreorderMessage = true;
            }
          });
        });

        const containerMissingMessage =
          !(container instanceof Element) ||
          !container.querySelector("[data-preorder-shipping-message]");

        if (!removedPreorderMessage && !containerMissingMessage) {
          return;
        }

        messageEl = null;
        scheduleRender(renderMessage);
      });

      try {
        containerObserver.observe(container, { childList: true, subtree: true });
        observedContainers.add(container);
      } catch (observerError) {
        if (window?.PDPDebug?.log) {
          window.PDPDebug.log("preorder-message-observer-error", observerError);
        }
      }
    };

    const observePreorderInfo = () => {
      const estimatedEl = getEstimatedDateNode();
      if (!estimatedEl) {
        return;
      }

      const estimatedObserver = new MutationObserver(() => {
        renderMessage();
      });
      estimatedObserver.observe(estimatedEl, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true
      });

      const infoContainer =
        el.closest(".pre-order-information") ||
        el.closest(".timesact-preorder-description") ||
        estimatedEl.closest(".timesact-preorder-description");

      if (infoContainer) {
        const infoObserver = new MutationObserver(() => {
          renderMessage();
        });
        infoObserver.observe(infoContainer, {
          attributes: true,
          attributeFilter: ["style", "class", "hidden"],
          childList: true,
          subtree: true
        });
      }

      if (estimatedEl.parentElement) {
        observeContainerForMessage(estimatedEl.parentElement);
      }
      if (!infoContainer) {
        observeContainerForMessage(estimatedEl.closest("span, div, p"));
      }
      if (infoContainer) {
        observeContainerForMessage(infoContainer);
      }
      if (variantForm) {
        observeContainerForMessage(variantForm);
      }
    };

    observePreorderInfo();
    ensureDeadlineObserver();

    observeCountryAttribute();
    ensureCountryResolved().then(() => {
      if (isVariantPreorder()) {
        scheduleRender(renderMessage);
      }
    });

    const scheduleUrlSync = () => {
      setTimeout(() => {
        if (updateVariantFromUrl()) {
          renderMessage();
        }
      }, 50);
    };

    const handleVariantEvent = (event) => {
      if (event && event.detail) {
        const detail =
          event.detail.variant ||
          event.detail.variantId ||
          event.detail.id ||
          event.detail;
        const variantId = detail && detail.id ? detail.id : detail;
        if (variantId) {
          currentVariantId = String(variantId);
        }
      } else {
        updateVariantFromForm();
      }
      renderMessage();
      scheduleUrlSync();
    };

    if (variantForm) {
      variantForm.addEventListener("change", () => {
        updateVariantFromForm();
        renderMessage();
      });
    }

    document.addEventListener("variant:change", handleVariantEvent);
    document.addEventListener("variant:changed", handleVariantEvent);
    document.addEventListener("product:variant-change", handleVariantEvent);

    window.addEventListener("popstate", () => {
      if (updateVariantFromUrl()) {
        renderMessage();
      }
    });

    if (wrapper) {
      const wrapperObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "data-preorder-active") {
            if (mutation.target.getAttribute("data-preorder-active") !== "true") {
              const ensuredEl = ensureMessageEl();
              if (ensuredEl) {
                ensuredEl.textContent = "";
                ensuredEl.setAttribute("hidden", "hidden");
              }
              return;
            }
            renderMessage();
          }
        });
      });
      wrapperObserver.observe(wrapper, { attributes: true, attributeFilter: ["data-preorder-active"] });
    }

    if (!currentVariantId) {
      updateVariantFromForm();
    }
    updateVariantFromUrl();
    renderMessage();
    initialized = true;
    return true;
  };

  if (!initPreorderMessaging()) {
    const waitObserver = new MutationObserver(() => {
      if (initPreorderMessaging()) {
        waitObserver.disconnect();
      }
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupPreorderMessaging);
} else {
  setupPreorderMessaging();
}

(function () {
  const INVENTORY_SELECTOR = '.ProductForm__Inventory';
  const INVENTORY_CLASS = 'inventory_InStock';
  const INVENTORY_ICON_CLASS = 'inventory-status-icon';
  const INVENTORY_ICON_LOW_CLASS = 'inventory-status-icon--low';
  const INVENTORY_ICON_WRAPPER_CLASS = 'has-inventory-icon';
  const FALLBACK_IN_STOCK = 'In stock';
  const FALLBACK_LOW_STOCK = 'Almost sold out';
  const variantParamSelected = (() => {
    try {
      return Boolean(new URL(window.location.href).searchParams.get('variant'));
    } catch (error) {
      return false;
    }
  })();
  let inventoryInteractionOccurred = variantParamSelected;
  let lastAppliedInventoryVariantId = null;

  const parseProductJson = () => {
    const script = document.querySelector('[data-product-json]');
    if (!script) {
      return null;
    }
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      if (window.PDPDebug && typeof window.PDPDebug.log === 'function') {
        window.PDPDebug.log('inventory-json-parse-error', error);
      }
      return null;
    }
  };

  const resolveVariantInventory = (variantId) => {
    if (!variantId) {
      return null;
    }
    const productJson = parseProductJson();
    if (!productJson || !productJson.inventories) {
      return null;
    }
    return productJson.inventories[String(variantId)] || null;
  };

  const resolveVariantId = (detail) => {
    if (!detail) {
      return null;
    }
    if (detail.variant && detail.variant.id) {
      return String(detail.variant.id);
    }
    if (detail.variantId) {
      return String(detail.variantId);
    }
    if (detail.id && typeof detail.id !== 'object') {
      return String(detail.id);
    }
    if (typeof detail === 'number' || typeof detail === 'string') {
      return String(detail);
    }
    return null;
  };

  const resolveLabels = (node) => {
    if (!node || !node.dataset) {
      return {
        inStock: FALLBACK_IN_STOCK,
        lowStock: FALLBACK_LOW_STOCK,
      };
    }
    return {
      inStock: node.dataset.inStockLabel || node.dataset.instockLabel || FALLBACK_IN_STOCK,
      lowStock: node.dataset.lowStockLabel || node.dataset.lowstockLabel || FALLBACK_LOW_STOCK,
    };
  };

  const asNumber = (value) => {
    const parsed = typeof value === 'number' ? value : parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : NaN;
  };

  const deriveMessage = (node, variantInventory) => {
    if (!variantInventory) {
      return {
        message: '',
        state: '',
      };
    }

    const labels = resolveLabels(node);
    const quantity = asNumber(variantInventory.inventory_quantity);
    const state = variantInventory.inventory_state || '';
    const inStockMessage = typeof variantInventory.inventory_message === 'string'
      ? variantInventory.inventory_message.trim()
      : '';
    const hasInventoryMarkup = inStockMessage.indexOf('inventory_number') !== -1;

    if (inStockMessage && !hasInventoryMarkup) {
      return {
        message: inStockMessage,
        state,
      };
    }

    const isPositiveQuantity = Number.isFinite(quantity) && quantity > 0;
    const isLowInventory = (Number.isFinite(quantity) && quantity > 0 && quantity < 5) || state === 'low';

    if (isLowInventory) {
      return {
        message: labels.lowStock,
        state: 'low',
      };
    }

    if (isPositiveQuantity || state === 'in_stock') {
      return {
        message: labels.inStock,
        state: 'in_stock',
      };
    }

    return {
      message: '',
      state,
    };
  };

  const sanitiseMessage = (message, state) => {
    if (!message) {
      return '';
    }
    const trimmed = message.trim();
    if (state === 'low') {
      return trimmed.replace(/\.+$/, '');
    }
    return trimmed;
  };

  const ensureInventoryIcon = (node) => {
    let icon = node.querySelector('[data-inventory-status-icon]');
    if (!icon) {
      icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('data-inventory-status-icon', 'true');
    }
    icon.classList.add(INVENTORY_ICON_CLASS);
    return icon;
  };

  const removeInventoryIcon = (node) => {
    const icon = node.querySelector('[data-inventory-status-icon]');
    if (icon) {
      icon.remove();
    }
    node.classList.remove(INVENTORY_ICON_WRAPPER_CLASS);
  };

  const hideInventoryNodes = () => {
    document.querySelectorAll(INVENTORY_SELECTOR).forEach((node) => {
      removeInventoryIcon(node);
      node.textContent = '';
      node.classList.remove(INVENTORY_CLASS);
      node.style.display = 'none';
      node.setAttribute('hidden', 'hidden');
    });
  };

  const applyInventoryMessage = (variantId, options = {}) => {
    if (!variantId) {
      return;
    }

    const nodes = document.querySelectorAll(INVENTORY_SELECTOR);
    const variantInventory = resolveVariantInventory(variantId);
    const allowReveal = Boolean(options.forceReveal || inventoryInteractionOccurred);
    const wrapperEl = document.querySelector('.custom-cart-wrapper');
    const preorderActiveGlobal = wrapperEl && wrapperEl.getAttribute('data-preorder-active') === 'true';
    const variantAvailable = variantId ? isVariantAvailableForPurchase(variantId) : true;
    if (wrapperEl) wrapperEl.dataset.stockUnavailable = String(!variantAvailable && !preorderActiveGlobal);
    if (!nodes.length) return;

    lastAppliedInventoryVariantId = variantId;

    nodes.forEach((node) => {
      const { message, state } = variantAvailable
        ? deriveMessage(node, variantInventory)
        : { message: node.dataset.outOfStockLabel || 'Out of stock', state: 'out_of_stock' };
      const sanitized = sanitiseMessage(message, state);
      const fallbackText = state === 'low'
        ? (node.dataset.lowStockLabel || FALLBACK_LOW_STOCK)
        : (node.dataset.inStockLabel || FALLBACK_IN_STOCK);
      const resolvedText = sanitized || fallbackText;
      const hasResolvedText = Boolean(resolvedText && resolvedText.trim().length);
      const nodeAlreadyVisible = node && node.style.display !== 'none' && !node.hasAttribute('hidden');
      const shouldReveal = Boolean((allowReveal && hasResolvedText) || (nodeAlreadyVisible && hasResolvedText));

      if (preorderActiveGlobal || !shouldReveal || !hasResolvedText) {
        removeInventoryIcon(node);
        node.textContent = '';
        node.classList.remove(INVENTORY_CLASS);
        node.style.display = 'none';
        node.setAttribute('hidden', 'hidden');
        return;
      }

      const icon = ensureInventoryIcon(node);
      const isLowInventory = state === 'low' || /almost/i.test(resolvedText);
      node.textContent = '';
      icon.classList.toggle(INVENTORY_ICON_LOW_CLASS, isLowInventory);
      node.append(icon, document.createTextNode(resolvedText));
      node.classList.add(INVENTORY_ICON_WRAPPER_CLASS);
      node.dataset.inventoryState = state;
      node.classList.toggle(INVENTORY_CLASS, state === 'in_stock' || state === 'low');
      node.style.removeProperty('display');
      node.removeAttribute('hidden');
    });
  };

  const getCurrentVariantId = () => {
    const variantField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantField && variantField.value) {
      return String(variantField.value);
    }
    const productJson = parseProductJson();
    if (productJson && productJson.selected_variant_id) {
      return String(productJson.selected_variant_id);
    }
    try {
      const urlVariant = new URL(window.location.href).searchParams.get('variant');
      if (urlVariant) {
        return String(urlVariant);
      }
    } catch (error) {
      // Ignore URL parsing issues and fall through to null
    }
    return null;
  };

  const handleVariantEvent = (event) => {
    if (!inventoryInteractionOccurred && event && event.isTrusted) {
      inventoryInteractionOccurred = true;
    }
    const variantId = resolveVariantId(event && event.detail);
    if (variantId) {
      applyInventoryMessage(variantId, { forceReveal: inventoryInteractionOccurred });
    }
  };

  const initializeInventoryMessaging = () => {
    const variantId = getCurrentVariantId();
    if (variantId) {
      applyInventoryMessage(variantId, { forceReveal: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeInventoryMessaging);
  } else {
    initializeInventoryMessaging();
  }

  ['variant:change', 'variant:changed', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, handleVariantEvent);
  });

  document.addEventListener('shopify:section:load', initializeInventoryMessaging);

  document.querySelectorAll('.SizeSwatch__Radio').forEach((radio) => {
    radio.addEventListener('change', (event) => {
      inventoryInteractionOccurred = true;
      const variantId = getCurrentVariantId();
      if (variantId) {
        applyInventoryMessage(variantId, { forceReveal: true });
      }
    });
  });

  const reapplyInventoryForPreorderState = (wrapper) => {
    if (!wrapper) {
      hideInventoryNodes();
      return;
    }

    const targetVariantId = getCurrentVariantId() || lastAppliedInventoryVariantId;
    if (targetVariantId) {
      const shouldForceReveal = inventoryInteractionOccurred || wrapper.getAttribute('data-variant-selected') === 'true';
      applyInventoryMessage(targetVariantId, { forceReveal: shouldForceReveal });
    } else if (wrapper.getAttribute('data-preorder-active') === 'true') {
      hideInventoryNodes();
    }
  };

  const ensurePreorderInventoryObserver = () => {
    const attachObserver = (wrapper) => {
      if (!wrapper || wrapper.dataset.inventoryPreorderObserver === 'true') {
        return;
      }

      const observer = new MutationObserver((mutationList) => {
        const currentValue = wrapper.getAttribute('data-preorder-active');
        const shouldSync = mutationList.some((mutation) => {
          if (mutation.attributeName !== 'data-preorder-active') {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(mutation, 'oldValue')) {
            return true;
          }
          return mutation.oldValue !== currentValue;
        });

        if (!shouldSync) {
          return;
        }

        reapplyInventoryForPreorderState(wrapper);
      });

      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['data-preorder-active'],
        attributeOldValue: true,
      });

      wrapper.dataset.inventoryPreorderObserver = 'true';
      reapplyInventoryForPreorderState(wrapper);
    };

    const wrapper = document.querySelector('.custom-cart-wrapper');
    if (wrapper) {
      attachObserver(wrapper);
      return;
    }

    if (typeof MutationObserver === 'function') {
      const waitObserver = new MutationObserver(() => {
        const nextWrapper = document.querySelector('.custom-cart-wrapper');
        if (nextWrapper) {
          attachObserver(nextWrapper);
          waitObserver.disconnect();
        }
      });

      waitObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  ensurePreorderInventoryObserver();
})();


// Hide ratings below the storefront threshold before customers can see them.
(function () {
  const REVIEW_BADGE_THRESHOLD = 4.5;
  const BADGE_SELECTOR = '.stamped-badge';

  function readBadgeRating(badge) {
    if (!badge) return null;

    const ratingSources = [
      badge.getAttribute('data-rating'),
      badge.getAttribute('data-rating-value'),
      badge.getAttribute('aria-label')
    ];

    const caption = badge.querySelector('.stamped-badge-caption');
    if (caption) {
      ratingSources.push(caption.getAttribute('data-rating'));
    }

    for (const value of ratingSources) {
      const rating = parseFloat(value);
      if (!Number.isNaN(rating)) {
        return rating;
      }
    }

    return null;
  }

  function hideBadge(badge) {
    const wrapper = badge.closest('.stamped-product-reviews-badge') || badge;
    wrapper.setAttribute('data-rating-hidden', 'true');
    wrapper.style.display = 'none';
  }

  function hideLowRatedStars(root) {
    const badges = [];
    const scope = root || document;

    if (scope.matches && scope.matches(BADGE_SELECTOR)) {
      badges.push(scope);
    }

    scope.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      badges.push(badge);
    });

    badges.forEach(function (badge) {
      const rating = readBadgeRating(badge);

      if (rating !== null && rating < REVIEW_BADGE_THRESHOLD) {
        hideBadge(badge);
      }
    });
  }

  hideLowRatedStars(document);

  if (typeof MutationObserver === 'function') {
    const starsObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target.matches && mutation.target.matches(BADGE_SELECTOR)) {
          hideLowRatedStars(mutation.target.parentElement || document);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            hideLowRatedStars(node);
          }
        });
      });
    });

    starsObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-rating', 'data-rating-value', 'aria-label'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hideLowRatedStars(document);
    });
  }
})();

// ENDS

(function () {
  var PREFETCH_FIRST_COUNT = 5;
  var PREFETCH_FLAG = '__pdpGalleryPrefetchInitialized';
  var REQUEST_IDLE = window.requestIdleCallback
    ? function (cb) {
        return window.requestIdleCallback(cb);
      }
    : function (cb) {
        return window.setTimeout(function () {
          cb({ didTimeout: false, timeRemaining: function () {
            return 0;
          } });
        }, 200);
      };
  var galleryState = {
    queue: [],
    idleHandle: null,
  };

  function isElementVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (!style) return true;
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getActiveGallery() {
    var galleries = Array.prototype.slice.call(document.querySelectorAll('[data-product-gallery]'));
    if (!galleries.length) return null;

    var preferMobile = false;
    try {
      preferMobile = window.matchMedia && window.matchMedia('(max-width: 1007px)').matches;
    } catch (e) {}

    if (preferMobile) {
      var mobile = galleries.find(function (el) {
        return el.getAttribute('data-product-gallery') === 'mobile';
      });
      if (mobile) return mobile;
    }

    var visible = galleries.find(isElementVisible);
    return visible || galleries[0];
  }

  function collectLazyImages(activeGallery) {
    var root = document.querySelector('.Product__Gallery') || activeGallery;
    if (!root) return [];

    var slides = [];
    if (activeGallery) {
      slides = slides.concat(Array.prototype.slice.call(activeGallery.querySelectorAll('.Product__SlideItem--image')));
    }
    slides = slides.concat(Array.prototype.slice.call(root.querySelectorAll('.Product__SlideItem--image')));

    var seen = Object.create(null);
    var lazyImages = [];

    slides.forEach(function (slide) {
      var mediaId = slide.getAttribute('data-media-id') || slide.getAttribute('data-media-position');
      if (mediaId && seen[mediaId]) return;
      var img = slide.querySelector('img');
      if (!img) return;
      if (!img.classList || !img.classList.contains('lazyload')) {
        img.setAttribute('data-prefetched', 'true');
        seen[mediaId] = true;
        return;
      }
      if (mediaId) seen[mediaId] = true;
      lazyImages.push(img);
    });

    return lazyImages;
  }

  function prefetchImage(img) {
    if (!img || img.getAttribute('data-prefetched') === 'true') {
      return Promise.resolve();
    }

    img.setAttribute('data-prefetched', 'true');

    if (!img.classList.contains('lazyload')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var completed = false;
      var cleanup = function () {
        if (completed) return;
        completed = true;
        resolve();
      };

      img.addEventListener('load', cleanup, { once: true });
      img.addEventListener('error', cleanup, { once: true });

      try {
        if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
          window.lazySizes.loader.unveil(img);
        } else if (img.dataset && img.dataset.src && !img.hasAttribute('src')) {
          img.setAttribute('src', img.dataset.src);
        } else {
          cleanup();
        }
      } catch (err) {
        cleanup();
      }

      window.setTimeout(cleanup, 3000);
    });
  }

  function prefetchVideo(video) {
    if (!video) return Promise.resolve();
    if (video.getAttribute('data-video-prefetched') === 'true') {
      return Promise.resolve();
    }

    if (video.readyState >= 2 || video.networkState === video.NETWORK_LOADING || video.networkState === video.NETWORK_IDLE) {
      video.setAttribute('data-video-prefetched', 'true');
      return Promise.resolve();
    }

    video.setAttribute('preload', 'auto');
    video.setAttribute('data-video-prefetched', 'true');

    return new Promise(function (resolve) {
      var done = false;
      var finalize = function () {
        if (done) return;
        done = true;
        resolve();
      };

      video.addEventListener('canplaythrough', finalize, { once: true });
      video.addEventListener('loadeddata', finalize, { once: true });
      video.addEventListener('error', finalize, { once: true });

      try {
        if (video.readyState < 2 && typeof video.load === 'function') {
          video.load();
        }
      } catch (err) {
        finalize();
      }

      window.setTimeout(finalize, 4000);
    });
  }

  function scheduleIdlePrefetch() {
    if (!galleryState.queue.length || galleryState.idleHandle) return;
    galleryState.idleHandle = REQUEST_IDLE(function () {
      galleryState.idleHandle = null;
      if (!galleryState.queue.length) return;
      var nextImg = galleryState.queue.shift();
      if (!nextImg) {
        scheduleIdlePrefetch();
        return;
      }
      prefetchImage(nextImg).finally(scheduleIdlePrefetch);
    });
  }

  function cancelIdlePrefetch() {
    if (!galleryState.idleHandle) return;
    if (typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(galleryState.idleHandle);
    } else {
      clearTimeout(galleryState.idleHandle);
    }
    galleryState.idleHandle = null;
  }

  function ensureLazySizes(callback) {
    if (window.lazySizes && window.lazySizes.loader) {
      callback();
      return;
    }

    var initialized = false;
    var handler = function () {
      if (initialized) return;
      initialized = true;
      document.removeEventListener('lazySizes:initialized', handler);
      callback();
    };

    document.addEventListener('lazySizes:initialized', handler, { once: true });
  }

  function bootstrapPrefetch() {
    if (!document.querySelector('[data-section-type="product"]')) return;
    if (window[PREFETCH_FLAG]) return;

    var activeGallery = getActiveGallery();
    var lazyImages = collectLazyImages(activeGallery);
    if (!lazyImages.length) return;

    window[PREFETCH_FLAG] = true;

    var initialBatch = lazyImages.slice(0, PREFETCH_FIRST_COUNT);
    var remaining = lazyImages.slice(PREFETCH_FIRST_COUNT);

    var galleryRoot = document.querySelector('.Product__Gallery');
    var videoElement = null;
    if (galleryRoot) {
      videoElement = (activeGallery || galleryRoot).querySelector('.Product__SlideItem--video video') || galleryRoot.querySelector('.Product__SlideItem--video video');
    }

    Promise.all(initialBatch.map(prefetchImage))
      .then(function () {
        return prefetchVideo(videoElement);
      })
      .finally(function () {
        if (!remaining.length) return;
        galleryState.queue = remaining.filter(function (img) {
          return img && img.getAttribute('data-prefetched') !== 'true';
        });
        scheduleIdlePrefetch();
      });
  }

  function prioritizeVideoOnSelection() {
    var galleryRoot = document.querySelector('.Product__Gallery');
    if (!galleryRoot) return;

    var videoSlides = Array.prototype.slice.call(galleryRoot.querySelectorAll('.Product__SlideItem--video'));
    if (!videoSlides.length) return;

    videoSlides.forEach(function (videoSlide) {
      var video = videoSlide.querySelector('video');
      var videoWrapper = videoSlide.querySelector('.VideoWrapper');
      if (!video || !videoWrapper) return;

      var aspectWrapper = videoSlide.querySelector('.AspectRatio');
      var lastSyncedAspect = null;
      var lastSyncedPadding = null;
      var lastSyncedHeight = null;

      var parseAspectRatio = function (value) {
        if (value == null) {
          return null;
        }

        var normalized = String(value).trim();
        if (!normalized) {
          return null;
        }

        var parsed = parseFloat(normalized);
        if (!parsed || !isFinite(parsed) || parsed <= 0) {
          return null;
        }

        return parsed;
      };

      var resolveReferenceAspect = function () {
        if (!galleryRoot) {
          return null;
        }

        var selectors = [
          '.Product__SlideItem--image.is-selected .AspectRatio',
          '.Product__SlideItem--image .AspectRatio'
        ];

        for (var i = 0; i < selectors.length; i++) {
          var candidate = galleryElement && galleryElement.querySelector(selectors[i]);
          if (candidate && candidate !== aspectWrapper) {
            return candidate;
          }
        }

        if (galleryRoot !== galleryElement) {
          for (var j = 0; j < selectors.length; j++) {
            var fallback = galleryRoot.querySelector(selectors[j]);
            if (fallback && fallback !== aspectWrapper) {
              return fallback;
            }
          }
        }

        return null;
      };

      var syncVideoAspectRatio = function () {
        if (!aspectWrapper) {
          return null;
        }

        var reference = resolveReferenceAspect();
        if (!reference) {
          return null;
        }

        var ratio = null;
        var paddingPercent = null;
        var referenceHeight = null;
        var referenceWidth = null;

        if (reference.style && reference.style.getPropertyValue) {
          ratio = parseAspectRatio(reference.style.getPropertyValue('--aspect-ratio'));
        }

        if (!ratio && window.getComputedStyle) {
          var computed = window.getComputedStyle(reference);
          if (computed) {
            ratio = parseAspectRatio(computed.getPropertyValue('--aspect-ratio'));
          }
        }

        if (window.getComputedStyle) {
          try {
            var beforeStyles = window.getComputedStyle(reference, '::before');
            if (beforeStyles) {
              var paddingBottom = beforeStyles.paddingBottom || '';
              var parsedPadding = parseFloat(paddingBottom);
              if (parsedPadding && isFinite(parsedPadding) && parsedPadding > 0) {
                var referenceRect = reference.getBoundingClientRect();
                referenceWidth = referenceRect && referenceRect.width ? referenceRect.width : reference.offsetWidth || 0;
                referenceHeight = referenceRect && referenceRect.height ? referenceRect.height : reference.offsetHeight || 0;
                if (referenceWidth > 0) {
                  paddingPercent = (parsedPadding / referenceWidth) * 100;
                }
              }
            }
          } catch (error) {
            /* noop */
          }
        }

        if (!referenceHeight && reference) {
          var fallbackRect = reference.getBoundingClientRect();
          if (fallbackRect) {
            referenceHeight = fallbackRect.height || reference.offsetHeight || null;
            referenceWidth = referenceWidth || fallbackRect.width || reference.offsetWidth || null;
          }
        }

        if (!paddingPercent && ratio) {
          paddingPercent = 100 / ratio;
        }

        var changed = false;

        if (ratio) {
          aspectWrapper.style.setProperty('--aspect-ratio', ratio);
          aspectWrapper.setAttribute('data-pdp-video-aspect', String(ratio));
          if (!lastSyncedAspect || Math.abs(lastSyncedAspect - ratio) > 0.001) {
            lastSyncedAspect = ratio;
            changed = true;
          }
        }

        if (referenceHeight && referenceHeight > 0) {
          var heightChanged = !lastSyncedHeight || Math.abs(lastSyncedHeight - referenceHeight) > 0.5;
          if (heightChanged) {
            aspectWrapper.style.removeProperty('padding-bottom');
            aspectWrapper.style.setProperty('height', referenceHeight + 'px', 'important');
            videoSlide.style.setProperty('height', referenceHeight + 'px', 'important');
            if (videoWrapper) {
              videoWrapper.style.removeProperty('height');
              videoWrapper.style.setProperty('height', '100%', 'important');
            }
            lastSyncedHeight = referenceHeight;
            lastSyncedPadding = null;
            aspectWrapper.removeAttribute('data-pdp-video-padding');
            changed = true;
          }
        } else if (paddingPercent && isFinite(paddingPercent) && paddingPercent > 0) {
          aspectWrapper.style.setProperty('padding-bottom', paddingPercent + '%', 'important');
          aspectWrapper.style.setProperty('height', 'auto', 'important');
          videoSlide.style.setProperty('height', 'auto', 'important');
          if (videoWrapper) {
            videoWrapper.style.setProperty('height', '100%', 'important');
          }
          aspectWrapper.setAttribute('data-pdp-video-padding', String(paddingPercent));
          if (!lastSyncedPadding || Math.abs(lastSyncedPadding - paddingPercent) > 0.1) {
            lastSyncedPadding = paddingPercent;
            lastSyncedHeight = null;
            changed = true;
          }
        }

        return changed ? (ratio || referenceHeight || paddingPercent || null) : null;
      };

      var prefersDesktop = window.matchMedia('(min-width: 1007px)').matches;
      var player = null;
      if (prefersDesktop) {
        var plyrHost = video.closest('.plyr');
        if (plyrHost && plyrHost.plyr) {
          player = plyrHost.plyr;
        }
      }

      var galleryElement = videoSlide.closest('[data-product-gallery]');
      if (!galleryElement) return;

      var poster = video.getAttribute('poster');
      if (poster) {
        videoWrapper.style.backgroundImage = 'url(' + poster + ')';
        videoWrapper.style.backgroundSize = 'cover';
        videoWrapper.style.backgroundPosition = 'center center';
      }

      syncVideoAspectRatio();

      var attach = function attach() {
        var flkty = (window.Flickity && window.Flickity.data && window.Flickity.data(galleryElement)) ||
          (window.jQuery && window.jQuery(galleryElement).data && window.jQuery(galleryElement).data('flickity'));

        if (!flkty || typeof flkty.on !== 'function') {
          setTimeout(attach, 150);
          return;
        }

        var applyViewportHeight = function (height) {
          if (!height || !flkty || !flkty.viewport) {
            return;
          }
          try {
            // Ensure Flickity viewport matches the computed slide height so the video fills the frame.
            flkty.viewport.style.height = height + 'px';
          } catch (error) {
            /* noop */
          }
        };

        syncVideoAspectRatio();
        if (lastSyncedHeight && flkty && flkty.viewport) {
          applyViewportHeight(lastSyncedHeight);
        }

        var ensureVideoReady = function () {
          cancelIdlePrefetch();
          var updatedAspect = syncVideoAspectRatio();
          if (lastSyncedHeight && flkty && flkty.viewport) {
            applyViewportHeight(lastSyncedHeight);
          }
          if (updatedAspect && flkty && typeof flkty.resize === 'function') {
            window.requestAnimationFrame(function () {
              try {
                flkty.resize();
                if (lastSyncedHeight && flkty.viewport) {
                  applyViewportHeight(lastSyncedHeight);
                }
              } catch (error) {
                /* noop */
              }
            });
          }
          if (player) {
            prefetchVideo(video);

            if (poster) {
              try {
                if (player.elements && player.elements.poster) {
                  player.elements.poster.style.backgroundImage = 'url(' + poster + ')';
                }
              } catch (error) {
                /* noop */
              }
            }

            var onPlyrPlaying = function () {
              player.off('playing', onPlyrPlaying);
              try {
                if (player.elements && player.elements.wrapper) {
                  player.elements.wrapper.classList.remove('plyr--loading');
                }
                if (player.elements && player.elements.poster) {
                  player.elements.poster.style.backgroundImage = 'none';
                }
              } catch (error) {
                /* noop */
              }
            };

            player.off && player.off('playing', onPlyrPlaying);
            player.on && player.on('playing', onPlyrPlaying);

            if (player.play) {
              try {
                player.play();
              } catch (error) {
                /* noop */
              }
            }
            return;
          }

          if (video && videoWrapper) {
            var posterSrc = video.getAttribute('poster');
            if (posterSrc) {
              videoWrapper.style.backgroundImage = 'url(' + posterSrc + ')';
              videoWrapper.style.backgroundSize = 'cover';
              videoWrapper.style.backgroundPosition = 'center center';
            }

            video.classList.remove('is-visible');

            var revealVideo = function () {
              video.classList.add('is-visible');
            };

            if (document.readyState === 'complete' || video.readyState >= 2) {
              window.requestAnimationFrame(revealVideo);
            } else {
              video.addEventListener('loadeddata', revealVideo, { once: true });
            }

            var onPlaying = function () {
              video.removeEventListener('playing', onPlaying);
              videoWrapper.style.backgroundImage = 'none';
            };
            video.addEventListener('playing', onPlaying, { once: true });
          }
          prefetchVideo(video);
        };

        if (flkty.selectedElement === videoSlide) {
          ensureVideoReady();
        }

        flkty.on('select', function () {
          // The alternate breakpoint gallery is hidden. Resizing it reselects
          // the zero-height slide and would queue another resize every frame.
          if (!galleryElement.getClientRects().length) return;
          if (flkty.selectedElement === videoSlide) {
            ensureVideoReady();
          } else if (flkty && flkty.viewport) {
            // Reset the inline height and immediately reapply the slide height so the viewport stays visible after swipes.
            flkty.viewport.style.height = '';
            var selectedElement = flkty.selectedElement;
            var targetHeight = 0;
            if (selectedElement) {
              var selectedRect = selectedElement.getBoundingClientRect && selectedElement.getBoundingClientRect();
              if (selectedRect && selectedRect.height) {
                targetHeight = selectedRect.height;
              } else if (selectedElement.offsetHeight) {
                targetHeight = selectedElement.offsetHeight;
              }
            }
            if (!targetHeight && flkty.selectedCell && flkty.selectedCell.size) {
              targetHeight = flkty.selectedCell.size.outerHeight || flkty.selectedCell.size.height || 0;
            }
            if (targetHeight > 0) {
              applyViewportHeight(targetHeight);
            } else if (typeof flkty.resize === 'function') {
              window.requestAnimationFrame(function () {
                try {
                  flkty.resize();
                } catch (error) {
                  /* noop */
                }
              });
            }
          }
        });
      };

      attach();
    });
  }

  function initPrefetching() {
    ensureLazySizes(function () {
      bootstrapPrefetch();
      prioritizeVideoOnSelection();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrefetching);
  } else {
    initPrefetching();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target && event.target.querySelector('[data-section-type="product"]')) {
      if (!window[PREFETCH_FLAG]) {
        initPrefetching();
      } else {
        prioritizeVideoOnSelection();
      }
    }
  });
})();

(function () {
  var ACTIVE_WEIGHT = '700';
  var INACTIVE_WEIGHT = '400';

  function syncViewOptionWeights(root) {
    var scope = root || document;
    scope.querySelectorAll('button.view-modal__option').forEach(function (button) {
      if (button.classList.contains('is-active')) {
        button.style.fontWeight = ACTIVE_WEIGHT;
      } else {
        button.style.fontWeight = INACTIVE_WEIGHT;
      }
    });
    scope.querySelectorAll('.model-image-switcher__option').forEach(function (label) {
      if (label.classList.contains('is-active')) {
        label.style.fontWeight = ACTIVE_WEIGHT;
      } else {
        label.style.fontWeight = INACTIVE_WEIGHT;
      }
    });
    scope.querySelectorAll('.view_popover .Popover__Value').forEach(function (button) {
      if (button.classList.contains('is-active') || button.classList.contains('is-selected')) {
        button.style.fontWeight = ACTIVE_WEIGHT;
      } else {
        button.style.fontWeight = INACTIVE_WEIGHT;
      }
    });
  }

  function scheduleSync() {
    requestAnimationFrame(function () {
      syncViewOptionWeights();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncViewOptionWeights();

    document.addEventListener('click', function (event) {
      if (
        event.target.closest('.view_modal_button') ||
        event.target.closest('.model-image-switcher') ||
        event.target.closest('.view_popover')
      ) {
        scheduleSync();
      }
    });

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        if (!(mutation.target instanceof HTMLElement)) {
          return false;
        }
        return (
          mutation.target.matches('button.view-modal__option') ||
          mutation.target.closest('.view_modal_button') ||
          mutation.target.matches('.model-image-switcher__option') ||
          mutation.target.matches('.view_popover .Popover__Value') ||
          mutation.target.closest('.view_popover')
        );
      });
      if (relevant) {
        scheduleSync();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event &&
      event.target &&
      (event.target.querySelector('.view_modal_button') ||
        event.target.querySelector('.model-image-switcher') ||
        event.target.querySelector('.view_popover'))
    ) {
      syncViewOptionWeights(event.target);
    }
  });
})();

(function () {
  function toSentenceCase(value) {
    var text = (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  }

  function normalizeBoostSearchTerms(root) {
    var scope = root || document;

    scope
      .querySelectorAll(
        '.boost-pfs-search-suggestion-group:not([data-group*="products"]) .boost-pfs-search-suggestion-item:not(.boost-pfs-search-suggestion-item-product) > a'
      )
      .forEach(function (link) {
        var nextText = toSentenceCase(link.textContent);

        if (nextText && link.textContent.trim() !== nextText) {
          link.textContent = nextText;
        }
      });
  }

  function scheduleBoostSearchTermNormalize(root) {
    requestAnimationFrame(function () {
      normalizeBoostSearchTerms(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    normalizeBoostSearchTerms();

    var observer = new MutationObserver(function (mutations) {
      var shouldNormalize = mutations.some(function (mutation) {
        if (!(mutation.target instanceof HTMLElement)) {
          return false;
        }

        return (
          mutation.target.matches('.boost-pfs-search-suggestion-wrapper') ||
          mutation.target.closest('.boost-pfs-search-suggestion-wrapper')
        );
      });

      if (shouldNormalize) {
        scheduleBoostSearchTermNormalize();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();

// document.addEventListener("DOMContentLoaded", function () {
//   const topSlider = document.querySelector(".Product__Slideshow.top");
//   const bottomSlider = document.querySelector(".Product__Slideshow.bottom");

//   function handleSliders() {
//     if (window.innerWidth > 768) {
//       // Desktop → remove bottom slider
//       if (bottomSlider && bottomSlider.parentNode) {
//         bottomSlider.parentNode.removeChild(bottomSlider);
//       }
//     } else {
//       // Mobile → remove top slider
//       if (topSlider && topSlider.parentNode) {
//         topSlider.parentNode.removeChild(topSlider);
//       }
//     }
//   }

//   // Run once on load
//   handleSliders();
// });

(function () {
  var SCROLL_RANGE = 420;
  var REDUCED_MOTION_THRESHOLD = 80;
  var logoLinks = [];
  var ticking = false;
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function collectLogoLinks() {
    logoLinks = Array.prototype.slice.call(document.querySelectorAll('[data-header-animated-logo]'));
  }

  function getProgress() {
    if (reduceMotionQuery.matches) {
      return window.scrollY >= REDUCED_MOTION_THRESHOLD ? 1 : 0;
    }

    return Math.max(0, Math.min(1, window.scrollY / SCROLL_RANGE));
  }

  function updateLogoProgress() {
    ticking = false;

    if (!logoLinks.length) {
      return;
    }

    var progress = getProgress().toFixed(4);
    logoLinks.forEach(function (logoLink) {
      logoLink.style.setProperty('--header-logo-progress', progress);
    });
  }

  function requestLogoProgressUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateLogoProgress);
  }

  function initAnimatedHeaderLogo() {
    collectLogoLinks();
    updateLogoProgress();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnimatedHeaderLogo();
    window.addEventListener('scroll', requestLogoProgressUpdate, { passive: true });
    window.addEventListener('resize', requestLogoProgressUpdate);
  });

  document.addEventListener('shopify:section:load', function () {
    initAnimatedHeaderLogo();
  });

  if (reduceMotionQuery.addEventListener) {
    reduceMotionQuery.addEventListener('change', requestLogoProgressUpdate);
  } else if (reduceMotionQuery.addListener) {
    reduceMotionQuery.addListener(requestLogoProgressUpdate);
  }
})();

(function () {
  function updateVisualViewportOffsets() {
    var viewport = window.visualViewport;
    var topOffset = 0;
    var bottomOffset = 0;
    var visibleHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    if (viewport) {
      topOffset = Math.max(Math.round(viewport.offsetTop || 0), 0);
      bottomOffset = Math.max(Math.round(window.innerHeight - viewport.height - (viewport.offsetTop || 0)), 0);
      visibleHeight = viewport.height || visibleHeight;
    }

    var style = document.documentElement.style;
    function setOffset(name, value) {
      if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
    }
    setOffset('--dsrcv-visual-viewport-top', topOffset + 'px');
    setOffset('--dsrcv-visual-viewport-bottom', bottomOffset + 'px');
    setOffset('--dsrcv-visual-viewport-height', Math.round(visibleHeight) + 'px');
  }

  var visualViewportUpdatePending = false;
  function scheduleVisualViewportUpdate() {
    if (visualViewportUpdatePending) return;
    visualViewportUpdatePending = true;
    window.requestAnimationFrame(function() {
      visualViewportUpdatePending = false;
      updateVisualViewportOffsets();
    });
  }

  document.addEventListener('DOMContentLoaded', updateVisualViewportOffsets);
  window.addEventListener('resize', scheduleVisualViewportUpdate);
  window.addEventListener('orientationchange', scheduleVisualViewportUpdate);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleVisualViewportUpdate);
    window.visualViewport.addEventListener('scroll', scheduleVisualViewportUpdate);
  }
})();

(function () {
  var nativeUcdPendingAdds = {};
  var nativeUcdRecentAdds = {};
  var nativeUcdDuplicateWindow = 4000;
  var nativeUcdCartIntentHandledAt = 0;
  var nativeUcdLastDeadlineMarkup = '';
  var nativeUcdDeadlineWatchTimer = null;
  var nativeUcdOriginalFetch = window.fetch && window.fetch.bind(window);
  var nativeUcdThemeSyncTimer = null;
  var nativeUcdLoadingCount = 0;
  var nativeUcdProductMediaCache = {};
  var nativeUcdShippingRateCache = {};
  var nativeUcdShippingRatePending = {};
  var nativeUcdCartShippingState = {
    hasPreOrder: false,
    hasNonPreOrder: false,
    isUkCustomer: false
  };

  function isNativeUcdDrawerFetch(input, init) {
    var method = (init && init.method) || (input && input.method) || 'GET';
    var url = typeof input === 'string' ? input : (input && input.url);

    return nativeUcdOriginalFetch &&
      (!method || String(method).toUpperCase() === 'GET') &&
      typeof url === 'string' &&
      url.indexOf('view=drawer') !== -1 &&
      url.indexOf('/cart') !== -1;
  }

  function getNativeUcdCurrentDrawerHtml() {
    var drawer = document.getElementById('sidebar-cart');
    return drawer ? drawer.outerHTML : '';
  }

  if (nativeUcdOriginalFetch && window.Response) {
    window.fetch = function (input, init) {
      if (!isNativeUcdDrawerFetch(input, init)) {
        return nativeUcdOriginalFetch(input, init);
      }

      return nativeUcdOriginalFetch(input, init).then(function (response) {
        return response.clone().text().then(function (html) {
          if (response.ok && html.indexOf('id="sidebar-cart"') !== -1) {
            return response;
          }

          var currentDrawerHtml = getNativeUcdCurrentDrawerHtml();

          if (!currentDrawerHtml) {
            return response;
          }

          return new Response(currentDrawerHtml, {
            status: 200,
            headers: {
              'Content-Type': 'text/html; charset=utf-8'
            }
          });
        }).catch(function () {
          return response;
        });
      });
    };
  }

  function updateNativeUcdHeaderCounts(itemCount) {
    if (!Number.isFinite(itemCount)) {
      return;
    }

    document.querySelectorAll('.Header__CartDot').forEach(function (dot) {
      dot.textContent = itemCount > 0 ? String(itemCount) : '';
      dot.classList.toggle('is-visible', itemCount > 0);
    });

    document.querySelectorAll('.Header__CartIcon .cart-icon').forEach(function (icon) {
      var showIcon = icon.classList.contains('fill') ? itemCount > 0 : itemCount === 0;
      icon.style.display = showIcon ? '' : 'none';
    });

    document.querySelectorAll('.Header__CartCount').forEach(function (count) {
      count.textContent = itemCount;
    });
  }

  function restoreNativeUcdDrawerScroll() {
    var scrollArea = document.querySelector('#sidebar-cart .Drawer__Main');

    if (!scrollArea) {
      return;
    }

    scrollArea.style.setProperty('overflow-x', 'hidden', 'important');
    scrollArea.style.setProperty('overflow-y', 'auto', 'important');
    scrollArea.style.setProperty('-webkit-overflow-scrolling', 'touch');
    scrollArea.style.setProperty('touch-action', 'auto');
    scrollArea.style.setProperty('overscroll-behavior-y', 'contain');

    if (scrollArea.getAttribute('data-native-ucd-scroll-guard') === 'true') {
      return;
    }

    var containDrawerScroll = function (event) {
      event.stopPropagation();
    };

    ['touchstart', 'touchmove', 'wheel'].forEach(function (eventName) {
      scrollArea.addEventListener(eventName, containDrawerScroll, { passive: true });
    });

    scrollArea.setAttribute('data-native-ucd-scroll-guard', 'true');
  }

  function scheduleNativeUcdThemeCartSync() {
    window.clearTimeout(nativeUcdThemeSyncTimer);
    nativeUcdThemeSyncTimer = window.setTimeout(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }, 120);
  }

  function replaceNativeCartDrawerContent(html) {
    var template = document.createElement('template');
    template.innerHTML = html || '';

    var currentDrawer = document.getElementById('sidebar-cart');
    var freshDrawer = template.content.querySelector('#sidebar-cart');
    var currentCart = currentDrawer && currentDrawer.querySelector('.Cart');
    var freshCart = freshDrawer && freshDrawer.querySelector('.Cart');

    if (!currentDrawer || !freshDrawer || !currentCart || !freshCart) {
      throw new Error('Native cart drawer refresh markup missing');
    }

    currentCart.parentNode.replaceChild(freshCart, currentCart);
    currentDrawer.setAttribute('data-section-settings', freshDrawer.getAttribute('data-section-settings') || currentDrawer.getAttribute('data-section-settings') || '{}');
    currentDrawer.setAttribute('data-native-ucd-has-pre-order', freshDrawer.getAttribute('data-native-ucd-has-pre-order') || 'false');
    currentDrawer.setAttribute('data-native-ucd-has-non-pre-order', freshDrawer.getAttribute('data-native-ucd-has-non-pre-order') || 'false');

    try {
      var settings = JSON.parse(freshDrawer.getAttribute('data-section-settings') || '{}');
      updateNativeUcdHeaderCounts(Number(settings.itemCount));
    } catch (error) {}

    if (typeof window.dsrcvInvalidateCartSnapshot === 'function') window.dsrcvInvalidateCartSnapshot();
    updateNativeUcdMessages();
    refreshNativeUcdShippingQuote();
    scheduleNativeUcdThemeCartSync();
    if (isNativeUcdDrawerVisible()) {
      loadNativeUcdShopifyRecommendations({ force: true });
      window.setTimeout(function () {
        loadNativeUcdShopifyRecommendations({ force: true });
      }, 180);
      scheduleNativeUcdCartMediaEnhancement(0);
      scheduleNativeUcdCartMediaEnhancement(220);
    }
    restoreNativeUcdDrawerScroll();
  }

  function fetchNativeCartDrawerHtml(attempt) {
    var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
    var fetcher = nativeUcdOriginalFetch || window.fetch;

    return fetcher(getNativeUcdMarketUrl(cartUrl + '?view=drawer&timestamp=' + Date.now()), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        if (attempt < 2) {
          return new Promise(function (resolve) {
            window.setTimeout(resolve, 500 * (attempt + 1));
          }).then(function () {
            return fetchNativeCartDrawerHtml(attempt + 1);
          });
        }

        throw new Error('Native cart drawer refresh failed');
      }

      return response.text().then(function (html) {
        if (html.indexOf('id="sidebar-cart"') === -1) {
          if (attempt < 2) {
            return new Promise(function (resolve) {
              window.setTimeout(resolve, 500 * (attempt + 1));
            }).then(function () {
              return fetchNativeCartDrawerHtml(attempt + 1);
            });
          }

          throw new Error('Native cart drawer refresh markup missing');
        }

        return html;
      });
    });
  }

  function refreshNativeCartDrawer() {
    return fetchNativeCartDrawerHtml(0).then(function (html) {
      replaceNativeCartDrawerContent(html);
    });
  }

  function setNativeUcdStatus(message) {
    document.querySelectorAll('#sidebar-cart [data-native-ucd-status]').forEach(function (status) {
      if (message) {
        status.textContent = message;
        status.hidden = false;
      } else {
        status.textContent = '';
        status.hidden = true;
      }
    });
  }

  function fetchNativeUcdCartJson() {
    var cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';

    return requestNativeUcdJson(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  }

  function getNativeUcdMarketUrl(url) {
    var country = String(getNativeUcdShippingCountry() || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(country)) return url;
    try {
      var marketUrl = new URL(url, window.location.href);
      if (marketUrl.origin !== window.location.origin) return url;
      // Country overrides are request-scoped. Ajax refreshes must retain the
      // selected market rather than fall back to the visitor's IP country.
      marketUrl.searchParams.set('country', country === 'UK' ? 'GB' : country);
      var previewTheme = window.Shopify && window.Shopify.theme;
      // Keep the admitted preview's Liquid controls during market-scoped refreshes.
      if (previewTheme && ['186911129978','186928333178','186964672890'].includes(String(previewTheme.id)) && previewTheme.role === 'unpublished' &&
          (marketUrl.searchParams.has('view') || marketUrl.searchParams.has('section_id'))) {
        marketUrl.searchParams.set('preview_theme_id', String(previewTheme.id));
      }
      return marketUrl.pathname + marketUrl.search + marketUrl.hash;
    } catch (error) {
      return url;
    }
  }

  function requestNativeUcdJson(url, options, parseText) {
    var fetcher = nativeUcdOriginalFetch || window.fetch;
    var timeoutDuration = 6500;
    url = getNativeUcdMarketUrl(url);

    if (fetcher) {
      var controller = window.AbortController ? new AbortController() : null;
      var fetchOptions = Object.assign({}, options || {});
      var timeout = null;

      if (controller) {
        fetchOptions.signal = controller.signal;
        timeout = window.setTimeout(function () {
          controller.abort();
        }, timeoutDuration);
      }

      return fetcher(url, fetchOptions).then(function (response) {
        if (!response.ok) {
          throw new Error('Native cart drawer JSON request failed');
        }

        return parseText ? response.text().then(parseText) : response.json();
      }).finally(function () {
        if (timeout) {
          window.clearTimeout(timeout);
        }
      });
    }

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var timeout = window.setTimeout(function () {
        xhr.abort();
        reject(new Error('Native cart drawer JSON request timed out'));
      }, timeoutDuration);

      xhr.open((options && options.method) || 'GET', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Accept', (options && options.headers && options.headers.Accept) || 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        window.clearTimeout(timeout);

        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error('Native cart drawer JSON request failed'));
          return;
        }

        try {
          resolve(parseText ? parseText(xhr.responseText) : JSON.parse(xhr.responseText));
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = function () {
        window.clearTimeout(timeout);
        reject(new Error('Native cart drawer JSON request failed'));
      };
      xhr.send();
    });
  }

  function recoverNativeUcdDrawerRefresh(error, message) {
    console.warn(message, error);
    setNativeUcdStatus('Bag updated. Please review your items before checkout.');

    scheduleNativeUcdThemeCartSync();
    openNativeCartDrawer();

    return fetchNativeUcdCartJson().then(function (cart) {
      updateNativeUcdHeaderCounts(Number(cart.item_count));
      window.setTimeout(updateNativeUcdMessages, 120);
    }).catch(function () {
      window.setTimeout(updateNativeUcdMessages, 120);
    });
  }

  function recoverNativeUcdMutationFailure(error, message) {
    console.warn(message, error);
    setNativeUcdStatus('We could not update your bag just now. Please try again.');
    openNativeCartDrawer();

    return fetchNativeUcdCartJson().then(function (cart) {
      updateNativeUcdHeaderCounts(Number(cart.item_count));
      scheduleNativeUcdThemeCartSync();
      window.setTimeout(updateNativeUcdMessages, 120);
    }).catch(function () {
      window.setTimeout(updateNativeUcdMessages, 120);
    });
  }

  function setNativeUcdControlsDisabled(drawer, isDisabled) {
    if (!drawer) {
      return;
    }

    drawer.querySelectorAll(
      '.NativeUcdDrawer__Checkout, ' +
      '.NativeUcdCartItem__Select, ' +
      '.NativeUcdCartItem__Remove, ' +
      '[data-native-ucd-add-variant], ' +
      '[data-native-ucd-variant-option]'
    ).forEach(function (control) {
      if (isDisabled) {
        if (!control.hasAttribute('data-native-ucd-disabled-by-loading')) {
          control.setAttribute('data-native-ucd-disabled-by-loading', 'true');
          if ('disabled' in control) control.setAttribute('data-native-ucd-original-disabled', control.disabled ? 'true' : 'false');

          if (control.hasAttribute('tabindex')) {
            control.setAttribute('data-native-ucd-original-tabindex', control.getAttribute('tabindex'));
          }
        }

        if ('disabled' in control) {
          control.disabled = true;
        } else {
          control.setAttribute('aria-disabled', 'true');
          control.setAttribute('tabindex', '-1');
        }
      } else if (control.hasAttribute('data-native-ucd-disabled-by-loading')) {
        control.removeAttribute('data-native-ucd-disabled-by-loading');

        if ('disabled' in control) {
          control.disabled = control.getAttribute('data-native-ucd-original-disabled') === 'true' || control.hasAttribute('data-native-ucd-needs-size');
          control.removeAttribute('data-native-ucd-original-disabled');
        } else {
          control.removeAttribute('aria-disabled');

          if (control.hasAttribute('data-native-ucd-original-tabindex')) {
            control.setAttribute('tabindex', control.getAttribute('data-native-ucd-original-tabindex'));
            control.removeAttribute('data-native-ucd-original-tabindex');
          } else {
            control.removeAttribute('tabindex');
          }
        }
      }
    });
  }

  function setNativeUcdLoading(isLoading) {
    var wasLoading = nativeUcdLoadingCount > 0;

    if (isLoading) {
      nativeUcdLoadingCount += 1;
    } else {
      nativeUcdLoadingCount = Math.max(0, nativeUcdLoadingCount - 1);
    }

    var isActive = nativeUcdLoadingCount > 0;
    var drawer = document.getElementById('sidebar-cart');

    if (drawer) {
      drawer.classList.toggle('is-updating', isActive);
      drawer.setAttribute('aria-busy', isActive ? 'true' : 'false');
      setNativeUcdControlsDisabled(drawer, isActive);
    }

    if (wasLoading !== isActive) {
      document.dispatchEvent(new CustomEvent(isActive ? 'theme:loading:start' : 'theme:loading:end'));
    }
  }

  function openNativeCartDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    var overlay = document.querySelector('.PageOverlay');

    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      document.documentElement.classList.add('no-scroll');
      restoreNativeUcdDrawerScroll();

      if (overlay) {
        overlay.classList.add('is-visible');
      }

      return;
    }

    var trigger = getNativeUcdCartTrigger();

    if (trigger && typeof trigger.click === 'function') {
      trigger.click();
      window.setTimeout(restoreNativeUcdDrawerScroll, 0);
      window.setTimeout(restoreNativeUcdDrawerScroll, 180);
      return;
    }

    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
    }

    if (overlay) {
      overlay.classList.add('is-visible');
    }

    restoreNativeUcdDrawerScroll();
  }

  function goToNativeUcdCartFallback() {
    window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
  }

  function changeNativeUcdLine(line, quantity) {
    return fetch(getNativeUcdMarketUrl(window.routes.cartChangeUrl + '.js'), {
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity)
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart change failed');
      }

      return response.json();
    });
  }

  function changeNativeUcdLineByKey(lineKey, quantity) {
    if (typeof lineKey !== 'string' || !lineKey || !Number.isSafeInteger(Number(quantity)) || Number(quantity) < 0) {
      return Promise.reject(new Error('This bag item is unavailable.'));
    }
    return fetch(getNativeUcdMarketUrl(window.routes.cartChangeUrl + '.js'), {
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity)
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart change failed');
      }

      return response.json();
    });
  }

  function handleNativeUcdCartRemove(event) {
    var removeItem = event.target && event.target.closest && event.target.closest('#sidebar-cart .NativeUcdCartItem__Remove');
    if (!removeItem) return;

    // Own the click before the legacy cart section's delegated handler. A
    // second positional removal could otherwise delete the next bag item.
    event.preventDefault();
    event.stopPropagation();

    if (nativeUcdLoadingCount > 0 || removeItem.getAttribute('aria-disabled') === 'true') return;
    var lineKey = (removeItem.getAttribute('data-line-id') || '').trim();
    if (!lineKey) {
      setNativeUcdStatus('Unable to update your bag. Please refresh and try again.');
      return;
    }

    setNativeUcdStatus('');
    setNativeUcdLoading(true);
    changeNativeUcdLineByKey(lineKey, 0)
      .then(function () {
        return refreshNativeCartDrawer().catch(function (error) {
          return recoverNativeUcdDrawerRefresh(error, 'Native cart drawer remove refresh failed');
        });
      })
      .catch(function (error) {
        return recoverNativeUcdMutationFailure(error, 'Native cart drawer remove failed');
      })
      .finally(function () {
        setNativeUcdLoading(false);
      });
  }

  function addNativeUcdVariant(variantId, quantity, properties, isUcdUpsell, sellingPlanId) {
    var body = {
      id: Number(variantId),
      quantity: Number(quantity) || 1
    };

    if (properties && typeof properties === 'object') {
      body.properties = properties;
    }

    if (sellingPlanId) {
      var sellingPlanNumber = Number(sellingPlanId);

      if (Number.isFinite(sellingPlanNumber) && sellingPlanNumber > 0) {
        body.selling_plan = sellingPlanNumber;
      }
    }

    var headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };

    if (isUcdUpsell) {
      headers['X-UCD-Upsell-Guard'] = '1';
    }

    return fetch(getNativeUcdMarketUrl(window.routes.cartAddUrl + '.js'), {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      method: 'POST',
      headers: headers
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      return response.json();
    });
  }

  function handleNativeProductCardSizeAdd(event) {
    var option = event.target && event.target.closest && event.target.closest('[data-product-card-add-variant]');
    if (!option || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button && event.button !== 0)) return false;
    if (!document.getElementById('sidebar-cart')) return false;
    event.preventDefault();
    event.stopPropagation();
    var variantId = option.getAttribute('data-product-card-add-variant');
    if (!/^\d+$/.test(variantId || '') || option.getAttribute('aria-disabled') === 'true' || isNativeUcdDuplicateAdd(variantId)) return true;

    var panel = option.closest('[data-product-card-sizes-panel]');
    var status = panel && panel.querySelector('[data-product-card-add-status]');
    if (!status && panel) {
      status = document.createElement('span');
      status.setAttribute('data-product-card-add-status', '');
      status.setAttribute('role', 'status');
      panel.appendChild(status);
    }
    if (status) status.textContent = '';
    nativeUcdPendingAdds[variantId] = Date.now();
    option.setAttribute('aria-busy', 'true');
    option.setAttribute('aria-disabled', 'true');
    addNativeUcdVariant(variantId, 1, getNativeUcdLineProperties(option), false)
      .then(function (cartItem) {
        markNativeUcdAddComplete(variantId);
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { item: cartItem, variantId: Number(variantId), quantity: 1 }
        }));
      })
      .catch(function () {
        if (status) status.textContent = 'Unable to add this size. Please try again.';
      })
      .finally(function () {
        delete nativeUcdPendingAdds[variantId];
        option.removeAttribute('aria-busy');
        option.removeAttribute('aria-disabled');
      });
    return true;
  }

  function getNativeUcdLineProperties(element) {
    if (!element) {
      return null;
    }

    var rawProperties = element.getAttribute('data-line-properties');

    if (!rawProperties) {
      return null;
    }

    try {
      var properties = JSON.parse(rawProperties);

      if (Array.isArray(properties)) {
        var mappedProperties = properties.reduce(function (memo, property) {
          if (Array.isArray(property) && property.length >= 2) {
            memo[property[0]] = property[1];
          } else if (property && typeof property === 'object') {
            var key = property.name || property.key || property.first;
            var value = typeof property.value !== 'undefined' ? property.value : property.last;

            if (key) {
              memo[key] = value;
            }
          }

          return memo;
        }, {});

        return Object.keys(mappedProperties).length ? mappedProperties : null;
      }

      return properties && typeof properties === 'object' && Object.keys(properties).length ? properties : null;
    } catch (error) {
      console.warn('Native cart drawer could not parse line properties', error);
      return null;
    }
  }

  function getNativeUcdReplacementProperties(properties, currentVariant, selectedVariant, sellingPlan) {
    // The hidden ordinary-checkout comparator has no native selling plan.
    // This is a presentation receipt check, never fulfilment authority.
    if (properties && properties._preorder_checkout === 'ordinary-full-payment-rehearsal') {
      var privateGroups = [
        { product: '16247074029946', variants: ['57448473362810', '57448473395578', '57448473428346', '57448473461114', '57448473493882'], from: '2027-01-06', by: '2027-01-13' },
        { product: '16247074128250', variants: ['57448473919866', '57448473952634', '57448473985402', '57448474018170', '57448474050938'], from: '2027-01-13', by: '2027-01-20' },
        { product: '16247074226554', variants: ['57448474116474', '57448474149242', '57448474182010', '57448474214778', '57448474247546'], from: '2027-01-20', by: '2027-01-27' },
        { product: '16247074292090', variants: ['57448474313082', '57448474345850', '57448474378618', '57448474411386'], from: '2027-01-06', by: '2027-01-13' }
      ];
      var group = privateGroups.filter(function (entry) { return entry.variants.indexOf(String(currentVariant)) !== -1; })[0];
      var privateVariants = group ? group.variants : [];
      if (!group || sellingPlan || properties._preorder_selling_plan ||
          privateVariants.indexOf(String(currentVariant)) === -1 ||
          privateVariants.indexOf(String(selectedVariant)) === -1 ||
          String(properties._preorder_variant) !== String(currentVariant) ||
          properties._preorder_batch !== 'private-test-20261022-' + group.product ||
          properties._preorder_despatch_start !== group.from ||
          properties._preorder_despatch_end !== group.by) {
        throw new Error('Private full-payment size receipt does not match the original line.');
      }
      return Object.assign({}, properties, {_preorder_variant: String(selectedVariant)});
    }
    if (!properties || !properties._preorder_variant && !properties._preorder_selling_plan) {
      return properties;
    }

    if (!/^\d+$/.test(String(selectedVariant || '')) ||
        String(properties._preorder_variant) !== String(currentVariant || '') ||
        !/^\d+$/.test(String(sellingPlan || '')) ||
        String(properties._preorder_selling_plan) !== String(sellingPlan)) {
      throw new Error('Pre-order size receipt does not match the original line.');
    }

    var replacement = Object.assign({}, properties);
    replacement._preorder_variant = String(selectedVariant);
    return replacement;
  }

  function nativeUcdSizeIdentity(item) {
    var props = item.properties || {};
    if (Array.isArray(props)) props = Object.fromEntries(props);
    return JSON.stringify([String(item.variant_id || item.id),
      Object.keys(props).sort().map(function (key) { return [key, props[key]]; }),
      String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || '')]);
  }

  async function replaceNativeUcdPrivateSize(select, currentVariant, selectedVariant, properties) {
    var theme = window.Shopify && window.Shopify.theme;
    if (!theme || theme.role !== 'unpublished' || ['186928333178', '186964672890'].indexOf(String(theme.id)) === -1 ||
        select.getAttribute('data-private-preorder-size-change') !== 'true' ||
        properties._preorder_checkout !== 'ordinary-full-payment-rehearsal') throw new Error('Size change is unavailable.');
    var before = await fetchNativeUcdCartJson();
    var original = before.items.filter(function (item) { return item.key === select.getAttribute('data-line-id'); });
    if (original.length !== 1 || String(original[0].variant_id) !== String(currentVariant)) throw new Error('Bag changed.');
    original = original[0];
    var supplied = getNativeUcdLineProperties(select);
    var sourceIdentity = nativeUcdSizeIdentity({variant_id:currentVariant,properties:supplied});
    if (nativeUcdSizeIdentity(original) !== sourceIdentity || !Number.isSafeInteger(original.quantity) || original.quantity < 1 || original.quantity > 10) throw new Error('Bag changed.');
    var targetIdentity = nativeUcdSizeIdentity({variant_id:selectedVariant,properties:properties});
    var quantities = function (cart) {
      var result = {};
      cart.items.forEach(function (item) {
        var id = nativeUcdSizeIdentity(item);
        if (Object.prototype.hasOwnProperty.call(result,id)) throw new Error('Ambiguous bag.');
        result[id] = item.quantity;
      });
      return result;
    };
    var same = function (a,b) { var keys=Object.keys(a).sort(); return JSON.stringify(keys)===JSON.stringify(Object.keys(b).sort()) && keys.every(function(k){return a[k]===b[k];}); };
    var expectedAdded = quantities(before);
    expectedAdded[targetIdentity] = (expectedAdded[targetIdentity] || 0) + original.quantity;
    var addError;
    try { await addNativeUcdVariant(selectedVariant, original.quantity, properties, false); } catch (error) { addError=error; }
    // Read after every add response, including a lost response. Never repeat an
    // ambiguous add or remove a line using a key captured before discount changes.
    var added = await fetchNativeUcdCartJson();
    if (!same(quantities(added),expectedAdded)) throw addError || new Error('Bag changed while choosing size.');
    var oldLine = added.items.filter(function(item){return nativeUcdSizeIdentity(item)===sourceIdentity;});
    if (oldLine.length!==1 || oldLine[0].quantity!==original.quantity) throw new Error('Bag changed.');
    var expectedFinal = Object.assign({},expectedAdded); delete expectedFinal[sourceIdentity];
    var removeError;
    try { await changeNativeUcdLineByKey(oldLine[0].key,0); } catch(error) { removeError=error; }
    var finalCart = await fetchNativeUcdCartJson();
    if (!same(quantities(finalCart),expectedFinal)) throw removeError || new Error('Please review your bag after changing size.');
    return finalCart;
  }

  function nativeUcdOrdinarySizeProperties(properties) {
    return !properties || (typeof properties === 'object' && !Array.isArray(properties) &&
      Object.keys(properties).every(function (key) { return key === '__Sale_Item' && properties[key] === 'Yes'; }));
  }

  function nativeUcdPurchasePropertiesSupported(properties) {
    return properties && typeof properties === 'object' && !Array.isArray(properties) &&
      Object.keys(properties).every(function (key) {
        return key === '__Sale_Item' && properties[key] === 'Yes' ||
          key === 'Notice' && typeof properties[key] === 'string' && properties[key].length < 160;
      });
  }

  function getNativeUcdPurchaseProperties(element) {
    var raw = element.getAttribute('data-line-properties');
    if (typeof raw !== 'string' || !raw.trim()) throw new Error('Missing bag properties.');
    var properties = JSON.parse(raw);
    if (properties === null) return {};
    if (Array.isArray(properties)) {
      var result = {};
      properties.forEach(function (entry) {
        if (!Array.isArray(entry) || entry.length !== 2 || typeof entry[0] !== 'string' ||
            Object.prototype.hasOwnProperty.call(result, entry[0])) throw new Error('Unsupported bag properties.');
        result[entry[0]] = entry[1];
      });
      properties = result;
    }
    if (!nativeUcdPurchasePropertiesSupported(properties)) throw new Error('Unsupported bag properties.');
    return properties;
  }

  function nativeUcdPurchaseOption(option) {
    if (!option || !/^\d+$/.test(option.value || '') || option.getAttribute('data-purchase-managed') !== 'shopify') throw new Error('This size is unavailable.');
    var preorder = option.getAttribute('data-purchase-preorder');
    var policy = option.getAttribute('data-purchase-policy');
    var stock = option.getAttribute('data-purchase-stock');
    var sale = option.getAttribute('data-purchase-sale');
    if (!['true', 'false'].includes(preorder) || !['deny', 'continue'].includes(policy) ||
        !/^-?\d+$/.test(stock || '') || !Number.isSafeInteger(Number(stock)) || !['true', 'false'].includes(sale)) throw new Error('This size is unavailable.');
    var properties = sale === 'true' ? {__Sale_Item:'Yes'} : {};
    if (preorder === 'true') {
      var iso = option.getAttribute('data-purchase-date') || '';
      var date = new Date(iso + 'T12:00:00Z');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0,10) !== iso) throw new Error('The pre-order date is unavailable.');
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      properties.Notice = 'Estimated shipping date is ' + months[date.getUTCMonth()] + ' ' + date.getUTCDate() + ', ' + date.getUTCFullYear();
    }
    return {id:option.value, preorder:preorder === 'true', policy:policy, stock:Number(stock), properties:properties};
  }

  async function replaceNativeUcdPurchaseSize(select, currentVariant, selectedVariant) {
    var theme = window.Shopify && window.Shopify.theme;
    var enabled = theme && (theme.role === 'main' || theme.role === 'unpublished' &&
      ['186911129978','186928333178','186964672890'].includes(String(theme.id)));
    if (!enabled || select.getAttribute('data-native-ucd-purchase-size-change') !== 'true' || select.getAttribute('data-selling-plan') ||
        !/^\d+$/.test(String(selectedVariant)) || String(selectedVariant) === String(currentVariant)) throw new Error('Size change is unavailable.');
    var country = window.Shopify.country;
    var before = await fetchNativeUcdCartJson();
    var originals = before.items.filter(function (item) { return item.key === select.getAttribute('data-line-id'); });
    if (originals.length !== 1) throw new Error('Bag changed.');
    var original = originals[0], supplied = getNativeUcdPurchaseProperties(select);
    var sourceIdentity = nativeUcdSizeIdentity(original);
    if (String(original.variant_id) !== String(currentVariant) || !nativeUcdPurchasePropertiesSupported(supplied) ||
        sourceIdentity !== nativeUcdSizeIdentity({variant_id:currentVariant,properties:supplied}) ||
        original.gift_card || original.selling_plan_allocation || original.parent_relationship ||
        !Number.isSafeInteger(original.quantity) || original.quantity < 1 ||
        String(original.quantity) !== select.getAttribute('data-current-quantity') ||
        String(original.product_id) !== select.getAttribute('data-product-id') || original.handle !== select.getAttribute('data-product-handle')) throw new Error('Bag changed.');
    function quantities(cart) {
      if (cart.currency !== before.currency || window.Shopify.country !== country) throw new Error('Bag market changed.');
      var result = {}, keys = new Set();
      cart.items.forEach(function (item) {
        if (!item.key || keys.has(item.key) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.parent_relationship ||
            item.item_components && (!Array.isArray(item.item_components) || item.item_components.length)) throw new Error('Unsupported bag.');
        keys.add(item.key);
        var identity = nativeUcdSizeIdentity(item);
        result[identity] = (result[identity] || 0) + item.quantity;
        if (!Number.isSafeInteger(result[identity])) throw new Error('Unsupported bag quantity.');
      });
      return result;
    }
    function same(a, b) { var keys = Object.keys(a).sort(); return JSON.stringify(keys) === JSON.stringify(Object.keys(b).sort()) && keys.every(function (key) { return a[key] === b[key]; }); }
    var expectedBefore = quantities(before);
    var fresh = new DOMParser().parseFromString(await fetchNativeCartDrawerHtml(0), 'text/html');
    var controls = Array.from(fresh.querySelectorAll('[data-native-ucd-purchase-size-change="true"]')).filter(function (control) {
      return control.getAttribute('data-line-id') === original.key && control.getAttribute('data-product-id') === String(original.product_id) &&
        control.getAttribute('data-product-handle') === original.handle && control.getAttribute('data-current-quantity') === String(original.quantity) && !control.getAttribute('data-selling-plan');
    });
    if (controls.length !== 1 || sourceIdentity !== nativeUcdSizeIdentity({variant_id:currentVariant,properties:getNativeUcdPurchaseProperties(controls[0])})) throw new Error('Bag changed.');
    var sourceOptions = Array.from(controls[0].options).filter(function (option) { return option.value === String(currentVariant); });
    var targetOptions = Array.from(controls[0].options).filter(function (option) { return option.value === String(selectedVariant); });
    if (sourceOptions.length !== 1 || targetOptions.length !== 1 || targetOptions[0].disabled) throw new Error('This size is unavailable.');
    // The original line keeps its recorded promise even after catalogue updates.
    // A deliberate new size records that target size's current native promise.
    if (supplied.Notice) {
      var promise = supplied.Notice.match(/^Estimated shipping date is (January|February|March|April|May|June|July|August|September|October|November|December) ([1-9]\d?), (\d{4})$/);
      var month = promise && ['January','February','March','April','May','June','July','August','September','October','November','December'].indexOf(promise[1]);
      var recordedDate = promise && new Date(Date.UTC(Number(promise[3]), month, Number(promise[2]), 12));
      if (!promise || recordedDate.getUTCFullYear() !== Number(promise[3]) || recordedDate.getUTCMonth() !== month || recordedDate.getUTCDate() !== Number(promise[2])) throw new Error('The original shipping promise cannot be changed here.');
    }
    var target = nativeUcdPurchaseOption(targetOptions[0]);
    var needed = before.items.reduce(function (count, item) { return count + (String(item.variant_id) === String(selectedVariant) ? item.quantity : 0); }, original.quantity);
    if (!Number.isSafeInteger(needed) || (!target.preorder || target.policy === 'deny') && target.stock < needed) throw new Error('Not enough stock for this size.');
    if (!same(quantities(await fetchNativeUcdCartJson()), expectedBefore)) throw new Error('Bag changed.');
    var targetIdentity = nativeUcdSizeIdentity({variant_id:selectedVariant,properties:target.properties});
    var expectedAdded = Object.assign({}, expectedBefore);
    expectedAdded[targetIdentity] = (expectedAdded[targetIdentity] || 0) + original.quantity;
    if (!Number.isSafeInteger(expectedAdded[targetIdentity])) throw new Error('Unsupported bag quantity.');
    // Only an acknowledged add may authorise removal. Never repeat a lost add.
    var acknowledgment = await addNativeUcdVariant(selectedVariant, original.quantity, target.properties, false);
    var addedLines = acknowledgment && Array.isArray(acknowledgment.items) ? acknowledgment.items : [acknowledgment];
    if (!addedLines.some(function (item) { return item && item.key && nativeUcdSizeIdentity(item) === targetIdentity && item.quantity >= original.quantity; })) throw new Error('Please review your bag after changing size.');
    if (!same(quantities(await fetchNativeUcdCartJson()), expectedAdded)) throw new Error('Bag changed while choosing size.');
    var preimage = await fetchNativeUcdCartJson();
    if (!same(quantities(preimage), expectedAdded)) throw new Error('Bag changed before choosing size.');
    var expectedFinal = Object.assign({}, expectedAdded), remaining = original.quantity, updates = {};
    expectedFinal[sourceIdentity] -= remaining;
    if (!expectedFinal[sourceIdentity]) delete expectedFinal[sourceIdentity];
    preimage.items.forEach(function (item) {
      if (remaining && nativeUcdSizeIdentity(item) === sourceIdentity) {
        var decrement = Math.min(item.quantity, remaining);
        updates[item.key] = item.quantity - decrement;
        remaining -= decrement;
      }
    });
    if (remaining) throw new Error('Bag changed.');
    var removeError;
    try {
      var cartUrl = window.routes && window.routes.cartUrl || '/cart';
      await requestNativeUcdJson(cartUrl.replace(/\/$/, '') + '/update.js', {method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({updates:updates})});
    } catch (error) { removeError = error; }
    var finalCart = await fetchNativeUcdCartJson();
    if (!same(quantities(finalCart), expectedFinal)) throw removeError || new Error('Please review your bag after changing size.');
    return finalCart;
  }

  async function recoverNativeUcdPurchaseSizeFailure(error) {
    console.warn('Native cart size change needs review', error);
    try { await refreshNativeCartDrawer(); }
    catch (refreshError) {
      // Keep checkout locked until Shopify has rendered the actual basket.
      // A badge-only recovery would leave stale line items after a partial add.
      setNativeUcdLoading(true);
      window.location.assign(getNativeUcdMarketUrl(window.routes && window.routes.cartUrl || '/cart'));
      return;
    }
    setNativeUcdStatus('Please review your bag. We could not safely complete the size change.');
    openNativeCartDrawer();
  }

  async function replaceNativeUcdOrdinarySize(select, currentVariant, selectedVariant, properties) {
    var theme = window.Shopify && window.Shopify.theme;
    var option = Array.from(select.options).filter(function (entry) { return entry.value === String(selectedVariant); });
    if (!theme || theme.role !== 'unpublished' || ['186928333178', '186964672890'].indexOf(String(theme.id)) === -1 ||
        select.getAttribute('data-native-ucd-ordinary-size-change') !== 'true' || select.getAttribute('data-selling-plan') ||
        !/^\d+$/.test(String(selectedVariant)) || String(selectedVariant) === String(currentVariant) ||
        option.length !== 1 || option[0].disabled || !nativeUcdOrdinarySizeProperties(properties)) throw new Error('Size change is unavailable.');
    var before = await fetchNativeUcdCartJson();
    var original = before.items.filter(function (item) { return item.key === select.getAttribute('data-line-id'); });
    if (original.length !== 1 || String(original[0].variant_id) !== String(currentVariant)) throw new Error('Bag changed.');
    original = original[0];
    var sourceIdentity = nativeUcdSizeIdentity({variant_id:currentVariant,properties:properties});
    if (original.gift_card || original.selling_plan_allocation || original.parent_relationship ||
        (original.item_components && (!Array.isArray(original.item_components) || original.item_components.length)) ||
        nativeUcdSizeIdentity(original) !== sourceIdentity || !Number.isSafeInteger(original.quantity) || original.quantity < 1 || original.quantity > 9 ||
        String(original.quantity) !== select.getAttribute('data-current-quantity') ||
        String(original.product_id) !== select.getAttribute('data-product-id') || original.handle !== select.getAttribute('data-product-handle')) throw new Error('Bag changed.');
    var quantities = function (cart) {
      if (cart.currency !== before.currency) throw new Error('Bag market changed.');
      var result = {};
      var keys = new Set();
      cart.items.forEach(function (item) {
        var id = nativeUcdSizeIdentity(item);
        if (!item.key || keys.has(item.key) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
            item.parent_relationship ||
            (item.item_components && (!Array.isArray(item.item_components) || item.item_components.length))) throw new Error('Unsupported bag.');
        if (id === sourceIdentity && (item.gift_card || item.selling_plan_allocation ||
            String(item.product_id) !== String(original.product_id) || item.handle !== original.handle ||
            !nativeUcdOrdinarySizeProperties(item.properties))) throw new Error('Unsupported source line.');
        keys.add(item.key);
        result[id] = (result[id] || 0) + item.quantity;
        if (!Number.isSafeInteger(result[id])) throw new Error('Unsupported bag quantity.');
      });
      return result;
    };
    var same = function (a,b) { var keys=Object.keys(a).sort(); return JSON.stringify(keys)===JSON.stringify(Object.keys(b).sort()) && keys.every(function(k){return a[k]===b[k];}); };
    var expectedBefore = quantities(before);
    // Fresh Liquid rechecks stock and deny/backorder policy, including changes
    // since the drawer opened. Product JSON availability alone is insufficient.
    var fresh = new DOMParser().parseFromString(await fetchNativeCartDrawerHtml(0), 'text/html');
    var controls = Array.from(fresh.querySelectorAll('[data-native-ucd-ordinary-size-change="true"]')).filter(function (control) {
      return control.getAttribute('data-line-id') === original.key &&
        control.getAttribute('data-product-id') === String(original.product_id) &&
        control.getAttribute('data-product-handle') === original.handle &&
        control.getAttribute('data-current-quantity') === String(original.quantity) && !control.getAttribute('data-selling-plan');
    });
    var target = controls.length === 1 && Array.from(controls[0].options).filter(function (entry) { return entry.value === String(selectedVariant); });
    if (!target || target.length !== 1 || target[0].disabled) throw new Error('This size is unavailable.');
    var stockText = target[0].getAttribute('data-native-ucd-stock-quantity');
    var needed = before.items.reduce(function (quantity, item) {
      return quantity + (String(item.variant_id) === String(selectedVariant) ? item.quantity : 0);
    }, original.quantity);
    if (!/^\d+$/.test(stockText || '') || !Number.isSafeInteger(Number(stockText)) || Number(stockText) < needed) throw new Error('Not enough stock for this size.');
    if (!same(quantities(await fetchNativeUcdCartJson()), expectedBefore)) throw new Error('Bag changed.');
    var targetIdentity = nativeUcdSizeIdentity({variant_id:selectedVariant,properties:properties});
    var expectedAdded = Object.assign({}, expectedBefore);
    expectedAdded[targetIdentity] = (expectedAdded[targetIdentity] || 0) + original.quantity;
    var addError;
    try { await addNativeUcdVariant(selectedVariant, original.quantity, properties, false); } catch (error) { addError=error; }
    // A lost response is resolved by reading the bag, never by repeating the add.
    var added = await fetchNativeUcdCartJson();
    if (!same(quantities(added),expectedAdded)) throw addError || new Error('Bag changed while choosing size.');
    // Automatic discounts can split identical units into paid/free rows and
    // replace their keys. Re-read the preimage and move only the selected row's
    // quantity, treating ordinary rows of the same identity as fungible.
    var preimage = await fetchNativeUcdCartJson();
    if (!same(quantities(preimage),expectedAdded)) throw new Error('Bag changed before choosing size.');
    var expectedFinal = Object.assign({},expectedAdded);
    expectedFinal[sourceIdentity] -= original.quantity;
    if (!expectedFinal[sourceIdentity]) delete expectedFinal[sourceIdentity];
    var remaining = original.quantity;
    var updates = {};
    preimage.items.forEach(function (item) {
      if (remaining && nativeUcdSizeIdentity(item) === sourceIdentity) {
        var decrement = Math.min(item.quantity, remaining);
        updates[item.key] = item.quantity - decrement;
        remaining -= decrement;
      }
    });
    if (remaining) throw new Error('Bag changed.');
    var removeError;
    try {
      // One keyed request also covers a decrement spanning multiple split rows.
      // Never retry an ambiguous response or update by variant ID/line position.
      var cartUrl = window.routes && window.routes.cartUrl || '/cart';
      await requestNativeUcdJson(cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({updates:updates})
      });
    } catch(error) { removeError=error; }
    var finalCart = await fetchNativeUcdCartJson();
    if (!same(quantities(finalCart),expectedFinal)) throw removeError || new Error('Please review your bag after changing size.');
    return finalCart;
  }

  function isNativeUcdDuplicateAdd(variantId) {
    if (!variantId) {
      return false;
    }

    if (nativeUcdPendingAdds[variantId]) {
      return true;
    }

    return nativeUcdRecentAdds[variantId] && Date.now() - nativeUcdRecentAdds[variantId] < nativeUcdDuplicateWindow;
  }

  function markNativeUcdAddComplete(variantId) {
    if (!variantId) {
      return;
    }

    nativeUcdRecentAdds[variantId] = Date.now();
    window.setTimeout(function () {
      if (nativeUcdRecentAdds[variantId] && Date.now() - nativeUcdRecentAdds[variantId] >= nativeUcdDuplicateWindow) {
        delete nativeUcdRecentAdds[variantId];
      }
    }, nativeUcdDuplicateWindow + 100);
  }

  function dispatchNativeUcdAddEvents(cartItem, variantId, quantity) {
    var detail = {
      item: cartItem || null,
      variantId: Number(variantId),
      quantity: Number(quantity) || 1,
      nativeUcdUpsell: true
    };
    var item = cartItem || {};
    var productId = item.product_id || item.productId || null;
    var productTitle = item.product_title || item.title || '';
    var variantTitle = item.variant_title || item.variantTitle || '';
    var itemUrl = item.url ? (window.location.origin + item.url) : window.location.href;

    if (typeof window.pintrk === 'function') {
      window.pintrk('track', 'addtocart');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      native_cart_drawer: true,
      ecommerce: {
        items: [
          {
            item_id: String(variantId),
            quantity: Number(quantity) || 1
          }
        ]
      }
    });

    window._learnq = window._learnq || [];
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['track', 'Added to Cart', {
        Name: productTitle || ('Variant ' + variantId),
        ProductID: productId || String(variantId),
        VariantID: String(variantId),
        Variant: variantTitle,
        URL: itemUrl,
        ImageURL: item.image || '',
        Price: item.price ? formatNativeUcdMoney(Number(item.price)) : '',
        Quantity: Number(quantity) || 1,
        Source: 'cart drawer recommendation'
      }]);
    }

    try {
      document.dispatchEvent(new CustomEvent('native-ucd:product-added', {
        bubbles: true,
        detail: detail
      }));
    } catch (error) {
      console.warn('Native cart drawer custom add event listener failed', error);
    }

    try {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: detail
      }));
    } catch (error) {
      console.warn('Native cart drawer product add event listener failed', error);
    }
  }

  function setNativeUcdRecommendationLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.disabled = !!isLoading || button.hasAttribute('data-native-ucd-needs-size') || button.hasAttribute('data-native-ucd-disabled-by-loading');
    button.classList.toggle('is-loading', !!isLoading);
  }

  function setNativeUcdCheckoutLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.classList.toggle('is-loading', !!isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (isLoading) {
      button.setAttribute('data-native-ucd-checkout-loading', 'true');
    } else {
      button.removeAttribute('data-native-ucd-checkout-loading');
    }
  }

  function scheduleNativeUcdCheckoutLoadingReset(button) {
    window.setTimeout(function () {
      setNativeUcdCheckoutLoading(button, false);
    }, 12000);
  }

  function resetNativeUcdCheckoutLoading() {
    document.querySelectorAll('#sidebar-cart .NativeUcdDrawer__Checkout').forEach(function (button) {
      setNativeUcdCheckoutLoading(button, false);
    });
  }

  function removeNativeUcdNestedShippingForms() {
    document.querySelectorAll('#sidebar-cart .cbb-shipping-rates-calculator').forEach(function (calculator) {
      calculator.remove();
    });
  }

  function closeNativeUcdKlaviyoForms() {
    try {
      var attemptedClick = false;
      var closeSelectors = [
        '.klaviyo-close-form',
        '.klaviyo-form button[aria-label*="close" i]',
        '.klaviyo-form [role="button"][aria-label*="close" i]',
        '.needsclick button[aria-label*="close" i]',
        '.needsclick [role="button"][aria-label*="close" i]',
        'button[class*="DismissButton" i]',
        '[class*="DismissButton" i][role="button"]'
      ];

      closeSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (button) {
          var rect = button.getBoundingClientRect && button.getBoundingClientRect();
          var visible = rect && rect.width > 0 && rect.height > 0;

          if (visible && typeof button.click === 'function') {
            button.click();
            attemptedClick = true;
          }
        });
      });

      if (!attemptedClick) {
        document.querySelectorAll('.klaviyo-form, .needsclick[role="dialog"], .needsclick [role="dialog"]').forEach(function (form) {
          var rect = form.getBoundingClientRect && form.getBoundingClientRect();
          var visible = rect && rect.width > 0 && rect.height > 0;

          if (visible && form.style) {
            form.style.setProperty('display', 'none', 'important');
            form.style.setProperty('pointer-events', 'none', 'important');
          }
        });
      }
    } catch (error) {
      console.warn('Native cart drawer failed to close Klaviyo form', error);
    }

    if (document.body) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }

    if (document.documentElement) {
      document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
    }
  }

  function isNativeUcdVisibleKlaviyoModal() {
    return Array.prototype.some.call(document.querySelectorAll('.klaviyo-form, .needsclick'), function (element) {
      var rect = element.getBoundingClientRect && element.getBoundingClientRect();
      var styles = window.getComputedStyle ? window.getComputedStyle(element) : null;

      if (!rect || !styles || styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) {
        return false;
      }

      return rect.width > Math.min(window.innerWidth * 0.5, 260) && rect.height > 120;
    });
  }

  function isNativeUcdVisibleElement(element) {
    if (!element || !element.getBoundingClientRect) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle ? window.getComputedStyle(element) : null;

    if (!styles || styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) {
      return false;
    }

    return rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.top < window.innerHeight;
  }

  function getNativeUcdPoint(event) {
    var point = event && event.touches && event.touches.length ? event.touches[0] : event;

    return {
      x: point && typeof point.clientX === 'number' ? point.clientX : null,
      y: point && typeof point.clientY === 'number' ? point.clientY : null
    };
  }

  function getNativeUcdElementBelowKlaviyoPoint(x, y) {
    if (x === null || y === null || typeof document.elementFromPoint !== 'function') {
      return null;
    }

    var overlays = Array.prototype.slice.call(document.querySelectorAll('.klaviyo-form, .needsclick'));
    var changedOverlays = [];
    var element = null;

    overlays.forEach(function (overlay) {
      if (!isNativeUcdVisibleElement(overlay) || !overlay.style) {
        return;
      }

      changedOverlays.push({
        element: overlay,
        pointerEvents: overlay.style.pointerEvents
      });
      overlay.style.pointerEvents = 'none';
    });

    try {
      element = document.elementFromPoint(x, y);
    } catch (error) {
      element = null;
    }

    changedOverlays.forEach(function (overlay) {
      overlay.element.style.pointerEvents = overlay.pointerEvents;
    });

    return element;
  }

  function getNativeUcdCartTrigger() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll(
      '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
    ));

    return triggers.find(isNativeUcdVisibleElement) || triggers[0] || null;
  }

  function getNativeUcdProductCartIntentTarget(event) {
    var selector = [
      '.ProductForm__AddToCart',
      '.MobileStickyCart__Primary',
      '.ProductForm label.SizeSwatch',
      '.ProductForm .SizeSwatch',
      '.ProductForm input.SizeSwatch__Radio',
      '.ProductForm select[name="id"]',
      '.ProductForm [data-action="add-to-cart"]',
      '.ProductFormBuyItWith [data-action="add-to-cart"]',
      '.MobileStickyCart [data-action="add-to-cart"]'
    ].join(', ');
    var directTarget = event.target && event.target.closest && event.target.closest(selector);

    if (directTarget) {
      return directTarget;
    }

    var point = getNativeUcdPoint(event);
    var underlyingTarget = getNativeUcdElementBelowKlaviyoPoint(point.x, point.y);

    return underlyingTarget && underlyingTarget.closest ? underlyingTarget.closest(selector) : null;
  }

  function getNativeUcdCartIntentTarget(event) {
    return event.target && event.target.closest && event.target.closest(
      '[data-action="open-drawer"][data-drawer-id="sidebar-cart"], ' +
      'a[aria-label*="open cart" i], button[aria-label*="open cart" i], ' +
      'a[href="/cart"], a[href$="/cart"]'
    );
  }

  function isNativeUcdPointOnCartTrigger(x, y) {
    if (x === null || y === null) {
      return false;
    }

    var trigger = getNativeUcdCartTrigger();

    if (!trigger || !trigger.getBoundingClientRect) {
      return false;
    }

    var rect = trigger.getBoundingClientRect();
    var hitSlop = window.innerWidth <= 640 ? 18 : 10;

    return x >= rect.left - hitSlop &&
      x <= rect.right + hitSlop &&
      y >= rect.top - hitSlop &&
      y <= rect.bottom + hitSlop;
  }

  function isNativeUcdCartIntent(event) {
    var target = getNativeUcdCartIntentTarget(event);

    if (target || getNativeUcdProductCartIntentTarget(event)) {
      return true;
    }

    var point = getNativeUcdPoint(event);

    return isNativeUcdPointOnCartTrigger(point.x, point.y) ||
      (window.innerWidth <= 640 && point.x !== null && point.y !== null && point.x >= window.innerWidth - 80 && point.y <= 120);
  }

  function handleNativeUcdCartIntent(event) {
    var closeControl = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-action="close-drawer"]');
    if (closeControl) return;

    if (!isNativeUcdVisibleKlaviyoModal() || !isNativeUcdCartIntent(event)) {
      return;
    }

    var now = Date.now();

    if (now - nativeUcdCartIntentHandledAt < 350) {
      event.preventDefault();

      if (typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }

      return;
    }

    nativeUcdCartIntentHandledAt = now;
    closeNativeUcdKlaviyoForms();
    event.preventDefault();

    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var trigger = getNativeUcdCartIntentTarget(event) || getNativeUcdProductCartIntentTarget(event) || getNativeUcdCartTrigger();

    if (trigger && typeof trigger.click === 'function') {
      window.setTimeout(function () {
        trigger.click();
      }, 180);
    }
  }

  function updateNativeUcdRecommendationCard(option) {
    var selectedOption = option && option.matches && option.matches('select') ? option.options[option.selectedIndex] : option;
    var card = option && option.closest && option.closest('.NativeUcdRecommendation, .NativeUcdEmptyRecommendation');
    var addButton = card && card.querySelector('[data-native-ucd-add-variant]');
    var price = card && card.querySelector('[data-native-ucd-recommendation-price]');

    if (!card || !addButton || !selectedOption) {
      return;
    }

    card.querySelectorAll('button[data-native-ucd-variant-option]').forEach(function (variantOption) {
      var selected = variantOption === selectedOption;
      variantOption.classList.toggle('is-selected', selected);
      variantOption.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var variantId = selectedOption.getAttribute('data-variant-id') || selectedOption.value || '';
    var needsSize = !variantId || selectedOption.disabled;
    addButton.setAttribute('data-native-ucd-add-variant', needsSize ? '' : variantId);
    addButton.toggleAttribute('data-native-ucd-needs-size', needsSize);
    addButton.disabled = needsSize || addButton.hasAttribute('data-native-ucd-disabled-by-loading');

    if (selectedOption.getAttribute('data-variant-title')) {
      var productTitle = card.querySelector('.NativeUcdRecommendation__Title, .NativeUcdEmptyRecommendation__Title');
      var titleText = productTitle ? productTitle.textContent.replace(/\s+/g, ' ').trim() : 'recommended item';
      addButton.setAttribute('aria-label', 'Add ' + titleText + ' size ' + selectedOption.getAttribute('data-variant-title') + ' to bag');
    }

    if (price && selectedOption.getAttribute('data-variant-price')) {
      price.textContent = textFromNativeUcdHtml(selectedOption.getAttribute('data-variant-price'));
    }
    if (card.getAttribute('data-bf-recommendation') === 'true' && !needsSize) {
      updateNativeUcdBlackFridayPrice(card, Number(selectedOption.getAttribute('data-bf-price')), Number(selectedOption.getAttribute('data-bf-compare-at')), false);
    }
  }

  function getNativeUcdVariantSize(variant, product) {
    var options = Array.isArray(product && product.options) ? product.options : [];
    var sizeIndex = options.findIndex(function (option) {
      var name = typeof option === 'string' ? option : option && option.name;
      return /size/i.test(name || '');
    });
    var sizeOption = sizeIndex >= 0 ? options[sizeIndex] : null;
    var configuredIndex = sizeOption && sizeOption.position ? Number(sizeOption.position) - 1 : sizeIndex;
    var optionValue = configuredIndex >= 0 && Array.isArray(variant && variant.options)
      ? variant.options[configuredIndex]
      : '';
    var value = optionValue || (variant && (variant.public_title || variant.title || (Array.isArray(variant.options) && variant.options[variant.options.length - 1]))) || '';
    return String(value).split(' / ').pop().trim();
  }

  function getNativeUcdCartItemSize(item) {
    var option = Array.isArray(item && item.options_with_values) && item.options_with_values.find(function (entry) {
      return entry && /size/i.test(entry.name || '');
    });

    return String((option && option.value) || (item && item.variant_title) || '').split(' / ').pop().trim();
  }

  function getNativeUcdSizeRank(size) {
    var ranks = {
      xxs: 0,
      xs: 1,
      s: 2,
      m: 3,
      l: 4,
      xl: 5,
      xxl: 6,
      xxxl: 7
    };
    var key = String(size || '').trim().toLowerCase();

    return Object.prototype.hasOwnProperty.call(ranks, key) ? ranks[key] : null;
  }

  function chooseNativeUcdRecommendedVariant(product, targetSize) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    var availableVariants = variants.filter(function (variant) {
      return variant && variant.available;
    });

    if ((product && product.available === false) || !availableVariants.length) {
      return null;
    }

    var target = String(targetSize || '').trim().toLowerCase();
    var exact = availableVariants.find(function (variant) {
      return getNativeUcdVariantSize(variant, product).toLowerCase() === target;
    });

    if (exact) {
      return exact;
    }

    var sizeOptionExists = Array.isArray(product && product.options) && product.options.some(function (option) {
      var name = typeof option === 'string' ? option : option && option.name;
      return /size/i.test(name || '');
    });
    var variantsAreSized = variants.some(function (variant) {
      var size = getNativeUcdVariantSize(variant, product).trim().toLowerCase();
      return getNativeUcdSizeRank(size) !== null || /^(?:uk|us|eu)\s*\d+(?:\.5)?$/.test(size) || /^\d{1,3}(?:\s*\/\s*\d{1,3})?$/.test(size);
    });

    // Keep recommendation cards purchasable in the likely cart size. Shopify
    // still reports valid continue-selling preorder variants as available.
    if (target && (sizeOptionExists || variantsAreSized)) {
      return null;
    }

    return availableVariants[0];
  }

  function getNativeUcdImageSrc(image) {
    var src = '';

    if (!image) {
      return '';
    }

    if (typeof image === 'string') {
      src = image;
    } else {
      src =
        image.src ||
        image.url ||
        image.originalSrc ||
        image.transformedSrc ||
        (image.preview_image && (image.preview_image.src || image.preview_image.url)) ||
        '';
    }

    if (!src) {
      return '';
    }

    if (src.indexOf('//') === 0) {
      return window.location.protocol + src;
    }

    if (src.indexOf('cdn.shopify.com') === 0) {
      return 'https://' + src;
    }

    return src;
  }

  function getNativeUcdProductImage(product) {
    var featuredImage = product && product.featured_image;
    var firstImage = product && Array.isArray(product.images) && product.images[0];

    return getNativeUcdImageSrc(featuredImage) || getNativeUcdImageSrc(firstImage);
  }

  function getNativeUcdProductHandleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match && match[1] ? match[1] : '';
  }

  function resizeNativeUcdShopifyImage(url, size, portrait) {
    var src = getNativeUcdImageSrc(url);
    var width = String(size || '').match(/^(\d+)x?$/);
    if (!src || !width) return src;

    try {
      var imageUrl = new URL(src, window.location.href);
      if (imageUrl.hostname !== 'cdn.shopify.com' &&
        !(imageUrl.origin === window.location.origin && imageUrl.pathname.indexOf('/cdn/shop/') === 0)) return src;
      imageUrl.searchParams.set('width', width[1]);
      if (portrait) {
        imageUrl.searchParams.set('height', String(Number(width[1]) * 1.25));
        imageUrl.searchParams.set('crop', 'center');
      }
      return imageUrl.href;
    } catch (error) {
      return src;
    }
  }

  function setNativeUcdResponsiveImage(image, src, container) {
    var isRecommendation = container && container.classList.contains('NativeUcdRecommendation__ImageLink');
    image.loading = 'lazy';
    image.decoding = 'async';
    image.sizes = isRecommendation
      ? '(max-width: 640px) calc((100vw - 36px) / 2), 228px'
      : '(max-width: 369px) 96px, (max-width: 476px) 26vw, 124px';
    var resized = resizeNativeUcdShopifyImage(src, '360x', isRecommendation);
    if (resized !== src) {
      image.srcset = (isRecommendation ? [180, 240, 360, 480, 720, 960] : [180, 240, 360, 480, 640, 720]).map(function (width) {
        return resizeNativeUcdShopifyImage(src, String(width), isRecommendation) + ' ' + width + 'w';
      }).join(', ');
    }
    image.src = resized;
    image.width = 360;
    image.height = 450;
  }

  function fetchNativeUcdProductMedia(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (!handle) {
      return Promise.resolve(null);
    }

    if (!nativeUcdProductMediaCache[handle]) {
      nativeUcdProductMediaCache[handle] = requestNativeUcdJson(root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).catch(function () {
        delete nativeUcdProductMediaCache[handle];
        return null;
      });
    }

    return nativeUcdProductMediaCache[handle];
  }

  function getNativeUcdMediaId(media) {
    return String((media && (
      media.id ||
      media.media_id ||
      media.src ||
      media.url ||
      (media.preview_image && (media.preview_image.src || media.preview_image.url))
    )) || '');
  }

  function getNativeUcdVideoSources(media) {
    var sources = Array.isArray(media && media.sources) ? media.sources : [];

    return sources.filter(function (source) {
      var url = source && (source.url || source.src);
      var type = String((source && (source.mime_type || source.mimeType || source.type)) || '').toLowerCase();
      return url && (type.indexOf('video/mp4') !== -1 || /\.mp4(?:\?|$)/i.test(url));
    }).sort(function (a, b) {
      return (a.height || 0) - (b.height || 0);
    });
  }

  function normaliseNativeUcdProductMedia(product, initialMediaId) {
    var media = Array.isArray(product && product.media) ? product.media.slice() : [];
    var seen = {};
    var slides = [];

    media.forEach(function (item) {
      var type = String((item && (item.media_type || item.type)) || 'image').toLowerCase();
      var id = getNativeUcdMediaId(item);

      if (!item || seen[id] || (type.indexOf('video') === -1 && type !== 'image')) {
        return;
      }

      if (type.indexOf('video') !== -1 && !getNativeUcdVideoSources(item).length) {
        return;
      }

      seen[id] = true;
      slides.push(item);
    });

    if (!slides.length && product && Array.isArray(product.images)) {
      product.images.forEach(function (image, index) {
        var src = getNativeUcdImageSrc(image);

        if (!src || seen[src]) {
          return;
        }

        seen[src] = true;
        slides.push({
          id: src,
          media_type: 'image',
          src: src,
          alt: product.title || '',
          position: index + 1
        });
      });
    }

    if (initialMediaId) {
      slides.sort(function (a, b) {
        var aMatch = getNativeUcdMediaId(a) === String(initialMediaId);
        var bMatch = getNativeUcdMediaId(b) === String(initialMediaId);

        if (aMatch === bMatch) {
          return 0;
        }

        return aMatch ? -1 : 1;
      });
    }

    return slides.slice(0, 12);
  }

  function buildNativeUcdMediaSlide(container, media, product, productUrl) {
    var type = String((media && (media.media_type || media.type)) || 'image').toLowerCase();
    var tagName = container && container.tagName === 'A' ? 'span' : 'a';
    var slide = document.createElement(tagName);
    var alt = (media && media.alt) || (product && product.title) || '';

    slide.className = 'NativeUcdMediaCarousel__Slide';
    slide.setAttribute('aria-hidden', 'true');
    slide.inert = true;
    if (tagName === 'a') {
      slide.href = productUrl || '#';
      slide.setAttribute('aria-label', (product && product.title) || alt);
      slide.tabIndex = -1;
    }

    if (type.indexOf('video') !== -1) {
      var sources = getNativeUcdVideoSources(media);
      var preview = media.preview_image || media.previewImage || {};
      var video = document.createElement('video');

      video.className = 'NativeUcdMediaCarousel__Video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'none');
      video.setAttribute('poster', resizeNativeUcdShopifyImage(preview.src || preview.url || '', '360x'));
      video.setAttribute('aria-label', alt);
      if (sources[0]) {
        video.setAttribute('data-video-src', sources[0].url || sources[0].src);
      }
      sources.forEach(function (source) {
        var sourceElement = document.createElement('source');
        sourceElement.setAttribute('data-src', source.url || source.src);
        sourceElement.type = source.mime_type || source.mimeType || source.type || 'video/mp4';
        video.appendChild(sourceElement);
      });
      slide.appendChild(video);
      return slide;
    }

    var image = document.createElement('img');
    var imageSrc = getNativeUcdImageSrc(media);

    image.className = 'NativeUcdMediaCarousel__Image';
    setNativeUcdResponsiveImage(image, imageSrc, container);
    image.alt = alt;
    slide.appendChild(image);
    return slide;
  }

  function attachNativeUcdMediaVideoSources(video) {
    if (!video || video.getAttribute('data-native-ucd-video-attached') === 'true') {
      return;
    }

    var primary = video.getAttribute('data-video-src');
    if (primary && !video.getAttribute('src')) {
      video.setAttribute('src', primary);
    }

    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      var sourceUrl = source.getAttribute('data-src');
      if (sourceUrl && !source.getAttribute('src')) {
        source.setAttribute('src', sourceUrl);
      }
    });

    video.setAttribute('data-native-ucd-video-attached', 'true');
  }

  function syncNativeUcdMediaVideos(track, index) {
    if (!track) {
      return;
    }

    Array.prototype.forEach.call(track.querySelectorAll('.NativeUcdMediaCarousel__Slide'), function (slide, slideIndex) {
      var active = slideIndex === index;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.inert = !active;
      if (slide.tagName === 'A') slide.tabIndex = active ? 0 : -1;
      Array.prototype.forEach.call(slide.querySelectorAll('video'), function (video) {
        if (slideIndex === index) {
          attachNativeUcdMediaVideoSources(video);
          if (video.getAttribute('data-native-ucd-video-active') !== 'true') {
            video.setAttribute('data-native-ucd-video-active', 'true');
            try {
              video.load();
            } catch (error) {}
          }
          var promise = video.play();
          if (promise && typeof promise.catch === 'function') {
            promise.catch(function () {});
          }
        } else {
          video.removeAttribute('data-native-ucd-video-active');
          try {
            video.pause();
            video.currentTime = 0;
          } catch (error) {}
        }
      });
    });
  }

  function updateNativeUcdMediaProgress(track, progress) {
    if (!track || !progress) {
      return;
    }

    var count = track.querySelectorAll('.NativeUcdMediaCarousel__Slide').length;
    var index = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;

    index = Math.min(Math.max(index, 0), Math.max(count - 1, 0));
    progress.hidden = count < 2;
    progress.style.setProperty('--native-ucd-media-count', Math.max(count, 1));
    progress.style.setProperty('--native-ucd-media-index', index);
    progress.setAttribute('data-native-ucd-media-count', String(count));
    progress.setAttribute('data-native-ucd-media-index', String(index));
    syncNativeUcdMediaVideos(track, index);
    if (track.getAttribute('data-native-ucd-media-warmed') === 'true') warmNativeUcdMediaImages(track);
  }

  function getNativeUcdMediaIndex(track) {
    if (!track) {
      return 0;
    }

    var count = track.querySelectorAll('.NativeUcdMediaCarousel__Slide').length;
    var index = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;

    return Math.min(Math.max(index, 0), Math.max(count - 1, 0));
  }

  function selectNativeUcdMediaIndex(track, index, instantWrap) {
    if (!track) {
      return;
    }

    var count = track.querySelectorAll('.NativeUcdMediaCarousel__Slide').length;
    if (count < 2 || !track.clientWidth) {
      return;
    }

    var boundedIndex = index;
    var isWrap = boundedIndex < 0 || boundedIndex >= count;
    if (boundedIndex < 0) {
      boundedIndex = count - 1;
    }
    if (boundedIndex >= count) {
      boundedIndex = 0;
    }

    track.scrollTo({
      left: boundedIndex * track.clientWidth,
      behavior: instantWrap && isWrap ? 'auto' : 'smooth'
    });
  }

  function warmNativeUcdMediaImages(track) {
    if (!track) return;
    track.setAttribute('data-native-ucd-media-warmed', 'true');
    if (window.DsrcvCardPhotos) {
      window.DsrcvCardPhotos.prepare(track, Array.prototype.slice.call(track.querySelectorAll('.NativeUcdMediaCarousel__Slide')), getNativeUcdMediaIndex(track), true, true);
    }
  }

  function getNativeUcdMediaPoint(event) {
    if (event && event.changedTouches && event.changedTouches.length) {
      return event.changedTouches[0];
    }

    if (event && event.touches && event.touches.length) {
      return event.touches[0];
    }

    return event;
  }

  function bindNativeUcdMediaSwipe(element, track, progress) {
    if (!element || !track || element.getAttribute('data-native-ucd-media-swipe-bound') === 'true') {
      return;
    }

    var startX = null;
    var startY = null;
    var startScrollLeft = 0;
    var startIndex = 0;
    var hasSwipeIntent = false;
    var blockClickUntil = 0;

    function resetSwipe() {
      startX = null;
      startY = null;
      startScrollLeft = 0;
      startIndex = 0;
      hasSwipeIntent = false;
    }

    function markManualIntent() {
      element.setAttribute('data-native-ucd-media-manual-intent', 'true');
    }

    function handleStart(event) {
      if (event && event.button && event.button !== 0) {
        return;
      }

      var point = getNativeUcdMediaPoint(event);
      if (!point) {
        return;
      }

      startX = point.clientX;
      startY = point.clientY;
      startScrollLeft = track.scrollLeft || 0;
      startIndex = getNativeUcdMediaIndex(track);
      hasSwipeIntent = false;
      markManualIntent();

      if (track.setPointerCapture && event && event.pointerId !== undefined) {
        try {
          track.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function handleMove(event) {
      if (startX === null || startY === null) {
        return;
      }

      var point = getNativeUcdMediaPoint(event);
      if (!point) {
        return;
      }

      var deltaX = point.clientX - startX;
      var deltaY = point.clientY - startY;

      // Once a gesture starts vertically, leave it with the drawer scroller.
      // Later sideways thumb movement must not capture that same gesture.
      if (!hasSwipeIntent && Math.abs(deltaY) >= 12 && Math.abs(deltaY) >= Math.abs(deltaX)) {
        resetSwipe();
        return;
      }

      if (!hasSwipeIntent && Math.abs(deltaX) >= 12 && Math.abs(deltaX) > Math.abs(deltaY) * 1.1) {
        hasSwipeIntent = true;
        warmNativeUcdMediaImages(track);
      }

      if (!hasSwipeIntent) {
        return;
      }

      if (event && event.cancelable) {
        event.preventDefault();
      }
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }

      track.scrollLeft = startScrollLeft - deltaX;
      updateNativeUcdMediaProgress(track, progress);
    }

    function handleEnd(event) {
      if (startX === null || startY === null) {
        return;
      }

      var point = getNativeUcdMediaPoint(event);
      var deltaX = point ? point.clientX - startX : 0;
      var deltaY = point ? point.clientY - startY : 0;
      var shouldSwipe = hasSwipeIntent && Math.abs(deltaX) >= 34 && Math.abs(deltaY) <= 62;
      var targetIndex = shouldSwipe ? (deltaX < 0 ? startIndex + 1 : startIndex - 1) : Math.round((track.scrollLeft || 0) / Math.max(track.clientWidth || 1, 1));

      if (hasSwipeIntent) {
        blockClickUntil = Date.now() + 500;
        if (event && event.cancelable) {
          event.preventDefault();
        }
        if (event && event.stopPropagation) {
          event.stopPropagation();
        }
      }

      resetSwipe();
      selectNativeUcdMediaIndex(track, targetIndex, false);
      window.setTimeout(function () {
        updateNativeUcdMediaProgress(track, progress);
      }, 220);
    }

    function handleClick(event) {
      if (Date.now() <= blockClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    track.addEventListener('pointerdown', handleStart, { passive: true, capture: true });
    track.addEventListener('pointermove', handleMove, { passive: false, capture: true });
    track.addEventListener('pointerup', handleEnd, { passive: false, capture: true });
    track.addEventListener('pointercancel', resetSwipe, { passive: true, capture: true });
    track.addEventListener('mousedown', handleStart, { passive: true, capture: true });
    track.addEventListener('mousemove', handleMove, { passive: false, capture: true });
    track.addEventListener('mouseup', handleEnd, { passive: false, capture: true });
    track.addEventListener('mouseleave', function (event) {
      // Captured child leaves can occur when pointer capture retargets an image.
      // Only leaving the track itself can end a mouse gesture.
      if (event.target === track) handleEnd(event);
    }, { passive: false, capture: true });
    track.addEventListener('touchstart', handleStart, { passive: true, capture: true });
    track.addEventListener('touchmove', handleMove, { passive: false, capture: true });
    track.addEventListener('touchend', handleEnd, { passive: false, capture: true });
    track.addEventListener('touchcancel', resetSwipe, { passive: true, capture: true });
    element.addEventListener('click', handleClick, true);
    element.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    element.setAttribute('data-native-ucd-media-swipe-bound', 'true');
  }

  function bindNativeUcdMediaHover(element, track) {
    if (!element || !track || element.getAttribute('data-native-ucd-media-hover-bound') === 'true') {
      return;
    }

    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) {
      return;
    }

    var hoverTimer = null;
    var isHovering = false;
    var hasManualMediaIntent = false;
    var hoverInitialDelay = 1200;
    var hoverInterval = 2000;
    var hoverScrollState = window.__dsrcvProductImageHoverScrollState || null;
    var unsubscribeHoverScroll = null;

    function prefersReducedMotion() {
      return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function stopHover(resetToStart) {
      isHovering = false;
      if (hoverTimer) {
        window.clearTimeout(hoverTimer);
        hoverTimer = null;
      }
      if (unsubscribeHoverScroll) {
        unsubscribeHoverScroll();
        unsubscribeHoverScroll = null;
      }
      if (resetToStart && !prefersReducedMotion()) {
        hasManualMediaIntent = false;
        element.removeAttribute('data-native-ucd-media-manual-intent');
        selectNativeUcdMediaIndex(track, 0, true);
      }
    }

    function markDirectManualMediaIntent(event) {
      if (event && event.pointerType === 'mouse') {
        return;
      }

      hasManualMediaIntent = true;
      element.setAttribute('data-native-ucd-media-manual-intent', 'true');
      stopHover(false);
    }

    function handleHoverScrollChange(isScrolling) {
      if (!isHovering) {
        return;
      }

      if (isScrolling) {
        if (hoverTimer) {
          window.clearTimeout(hoverTimer);
          hoverTimer = null;
        }
      } else if (element.matches && element.matches(':hover') && !hasManualMediaIntent) {
        scheduleHover(hoverInitialDelay);
      } else {
        stopHover(false);
      }
    }

    function markWheelManualMediaIntent(event) {
      var horizontalDelta = event && event.deltaX ? event.deltaX : 0;
      var verticalDelta = event && event.deltaY ? event.deltaY : 0;

      if (Math.abs(horizontalDelta) < 24 || Math.abs(horizontalDelta) < Math.abs(verticalDelta) * 1.2) {
        return;
      }

      markDirectManualMediaIntent();
    }

    function scheduleHover(delay) {
      if (prefersReducedMotion() || hoverScrollState && hoverScrollState.isScrolling) {
        return;
      }

      if (hoverTimer) {
        window.clearTimeout(hoverTimer);
      }

      hoverTimer = window.setTimeout(function () {
        if (prefersReducedMotion()) {
          stopHover(false);
          return;
        }
        if (!isHovering || (hoverScrollState && hoverScrollState.isScrolling) || hasManualMediaIntent) {
          return;
        }

        selectNativeUcdMediaIndex(track, getNativeUcdMediaIndex(track) + 1, true);
        if (isHovering && !hasManualMediaIntent) {
          scheduleHover(hoverInterval);
        }
      }, delay);
    }

    function startHover() {
      if (prefersReducedMotion() || hasManualMediaIntent || isHovering || (hoverScrollState && hoverScrollState.isScrolling)) {
        return;
      }

      isHovering = true;
      if (hoverScrollState) {
        unsubscribeHoverScroll = hoverScrollState.subscribe(handleHoverScrollChange);
      }
      warmNativeUcdMediaImages(track);
      scheduleHover(hoverInitialDelay);
    }

    track.addEventListener('wheel', markWheelManualMediaIntent, { passive: true });
    track.addEventListener('pointerdown', markDirectManualMediaIntent, { passive: true });
    track.addEventListener('touchstart', markDirectManualMediaIntent, { passive: true });
    track.addEventListener('keydown', markDirectManualMediaIntent);
    element.addEventListener('pointerenter', startHover);
    element.addEventListener('mouseenter', startHover);
    element.addEventListener('pointerleave', function () {
      stopHover(true);
    });
    element.addEventListener('mouseleave', function () {
      stopHover(true);
    });
    element.addEventListener('focusout', function () {
      stopHover(true);
    });
    element.setAttribute('data-native-ucd-media-hover-bound', 'true');
  }

  function prepareNativeUcdMediaTrack(track) {
    var firstSlide = track && track.firstElementChild;
    var image = firstSlide && firstSlide.querySelector('img');
    if (!image) {
      var video = firstSlide && firstSlide.querySelector('video[poster]');
      if (!video || !video.getAttribute('poster')) return Promise.reject(new Error('Gallery first frame unavailable'));
      image = document.createElement('img');
      image.src = video.getAttribute('poster');
    }
    if (!image.getAttribute('src') && !image.getAttribute('srcset')) return Promise.reject(new Error('Gallery image unavailable'));
    // Detached lazy images may not load. Keep the current hero visible until
    // the first gallery frame has pixels ready to paint.
    image.loading = 'eager';
    return new Promise(function (resolve, reject) {
      var settled = false;
      var finish = function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
        if (error) reject(error);
        else resolve();
      };
      var loaded = function () { finish(); };
      var failed = function () { finish(new Error('Gallery image unavailable')); };
      var timer = window.setTimeout(failed, 8000);
      if (typeof image.decode === 'function') {
        try { Promise.resolve(image.decode()).then(loaded, failed); }
        catch (error) { failed(); }
      } else if (image.complete) {
        if (image.naturalWidth > 0) loaded();
        else failed();
      } else {
        image.addEventListener('load', loaded);
        image.addEventListener('error', failed);
      }
    });
  }

  function enhanceNativeUcdMediaCarousel(element) {
    if (!element) {
      return Promise.resolve();
    }

    if (element.getAttribute('data-native-ucd-media-enhanced') === 'true' && element.querySelector('.NativeUcdMediaCarousel__Track')) {
      return Promise.resolve();
    }

    if (element.getAttribute('data-native-ucd-media-loading') === 'true') {
      return Promise.resolve();
    }

    var handle = element.getAttribute('data-product-handle') || getNativeUcdProductHandleFromUrl(element.getAttribute('href'));
    var initialMediaId = element.getAttribute('data-initial-media-id') || '';

    if (!handle) {
      return Promise.resolve();
    }

    element.removeAttribute('data-native-ucd-media-enhanced');
    element.setAttribute('data-native-ucd-media-loading', 'true');

    return fetchNativeUcdProductMedia(handle).then(function (product) {
      var slides = normaliseNativeUcdProductMedia(product, initialMediaId);

      if (!slides.length) {
        return;
      }

      var productUrl = (product && product.url) || element.getAttribute('href') || ('/products/' + handle);
      if (element.tagName === 'A' && product && product.title) {
        element.setAttribute('aria-label', product.title);
      }
      var track = document.createElement('div');
      var progress = document.createElement('div');

      track.className = 'NativeUcdMediaCarousel__Track';
      progress.className = 'NativeUcdMediaCarousel__Progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span></span>';

      slides.forEach(function (media) {
        track.appendChild(buildNativeUcdMediaSlide(element, media, product, productUrl));
      });

      return prepareNativeUcdMediaTrack(track).then(function () {
        if (!element.isConnected) return;
        var offerBadge = element.querySelector('.NativeUcdRecommendation__OfferBadge');
        element.textContent = '';
        element.appendChild(track);
        element.appendChild(progress);
        if (offerBadge) element.appendChild(offerBadge);

        var update = function () {
          window.requestAnimationFrame(function () {
            updateNativeUcdMediaProgress(track, progress);
          });
        };

        track.addEventListener('scroll', update, { passive: true });
        updateNativeUcdMediaProgress(track, progress);
        bindNativeUcdMediaSwipe(element, track, progress);
        bindNativeUcdMediaHover(element, track);
        element.setAttribute('data-native-ucd-media-enhanced', 'true');
      });
    }).catch(function () {
      element.removeAttribute('data-native-ucd-media-enhanced');
    }).finally(function () {
      element.removeAttribute('data-native-ucd-media-loading');
    });
  }

  function enhanceNativeUcdMediaCarousels(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var elements = root.querySelectorAll('[data-native-ucd-media-carousel]');

    Array.prototype.forEach.call(elements, function (element) {
      var drawer = element.closest('#sidebar-cart');
      var scroller = element.closest('.Drawer__Main');
      if (!drawer || !scroller) return;
      // The initial image remains usable. Build galleries near the viewport or
      // on deliberate interaction, rather than fetching every product at open.
      var enrich = function () {
        if (element.isConnected && drawer.getAttribute('aria-hidden') === 'false' && !element.closest('[hidden]')) {
          enhanceNativeUcdMediaCarousel(element);
        }
      };
      if (!element.hasAttribute('data-native-ucd-media-intent-bound')) {
        element.setAttribute('data-native-ucd-media-intent-bound', 'true');
        ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
          element.addEventListener(type, enrich, { passive: true });
        });
      }
      if (drawer.getAttribute('aria-hidden') !== 'false' || element.closest('[hidden]')) return;
      var state = drawer.__nativeUcdMediaObserver;
      if (!state || state.root !== scroller) {
        if (state && state.observer) state.observer.disconnect();
        state = { root: scroller, observer: null };
        if (window.IntersectionObserver) {
          state.observer = new window.IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && drawer.getAttribute('aria-hidden') === 'false' && !entry.target.closest('[hidden]')) {
                enhanceNativeUcdMediaCarousel(entry.target);
              }
            });
          }, { root: scroller, rootMargin: '120px 0px' });
        } else {
          scroller.addEventListener('scroll', function () { enhanceNativeUcdMediaCarousels(scroller); }, { passive: true });
        }
        drawer.__nativeUcdMediaObserver = state;
      }
      if (element.getAttribute('data-native-ucd-media-enhanced') === 'true') {
        if (state.observer) state.observer.unobserve(element);
        return;
      }
      if (state.observer) state.observer.observe(element);
      var rect = element.getBoundingClientRect();
      var viewport = scroller.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom >= viewport.top - 120 && rect.top <= viewport.bottom + 120) enrich();
    });
  }

  function isNativeUcdBlackFridayBasket() {
    var drawer = document.getElementById('sidebar-cart');
    return Boolean(drawer && drawer.getAttribute('data-bf-basket-recommendations') === 'true');
  }

  function updateNativeUcdBlackFridayPrice(card, price, compareAt, from) {
    var drawer = document.getElementById('sidebar-cart');
    var priceElement = card.querySelector('[data-native-ucd-recommendation-price]');
    var badge = card.querySelector('.NativeUcdRecommendation__OfferBadge');
    if (priceElement) {
      priceElement.textContent = from ? (drawer.getAttribute('data-copy-price-from') || 'From __price__').replace('__price__', formatNativeUcdMoney(price)) : formatNativeUcdMoney(price);
      if (!from && compareAt > price) {
        var reference = document.createElement('s');
        reference.textContent = formatNativeUcdMoney(compareAt);
        priceElement.appendChild(document.createTextNode(' '));
        priceElement.appendChild(reference);
      }
    }
    if (badge) {
      var reduction = compareAt > price && compareAt > 0 ? Math.round((compareAt - price) * 20 / compareAt) * 5 : 0;
      badge.hidden = from || compareAt <= price;
      badge.textContent = reduction > 0 ? reduction + '% off' : 'Reduced';
    }
  }

  function createNativeUcdRecommendationCard(product, targetSize) {
    var blackFriday = typeof isNativeUcdBlackFridayBasket === 'function' && isNativeUcdBlackFridayBasket();
    if (blackFriday) {
      if (!Array.isArray(product && product.bfQuickAddVariantIds)) return null;
      var optionNames = (product.options || []).map(function (option) { return String(option.name || option).toLowerCase(); });
      if ((product.variants || []).length > 1 && !optionNames.some(function (name) { return /size/i.test(name); })) return null;
      var eligibleIds = product.bfQuickAddVariantIds.map(String);
      product = Object.assign({}, product, {variants: (product.variants || []).map(function (item) {
        return Object.assign({}, item, {available: item.available && eligibleIds.indexOf(String(item.id)) !== -1});
      })});
      product.available = product.variants.some(function (item) { return item.available; });
      targetSize = '';
    }
    var variant = chooseNativeUcdRecommendedVariant(product, targetSize);

    if (!product || !variant) {
      return null;
    }

    var productUrl = product.url || (product.handle ? ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + product.handle : '#');
    var card = document.createElement('div');
    var imageLink = document.createElement('a');
    var imageSrc = getNativeUcdProductImage(product);
    var info = document.createElement('div');
    var title = document.createElement('a');
    var price = document.createElement('span');
    var addButton = document.createElement('button');

    card.className = 'NativeUcdRecommendation';
    card.setAttribute('data-product-id', product.id);
    card.setAttribute('data-product-type', product.type || '');
    card.setAttribute('data-native-ucd-target-size', targetSize || '');
    card.setAttribute('data-native-ucd-shopify-recommendation', 'true');

    imageLink.className = 'NativeUcdRecommendation__ImageLink';
    imageLink.href = productUrl;
    imageLink.setAttribute('aria-label', product.title || '');
    imageLink.setAttribute('data-native-ucd-media-carousel', '');
    imageLink.setAttribute('data-product-handle', product.handle || getNativeUcdProductHandleFromUrl(productUrl));
    if (product.featured_image && product.featured_image.id) {
      imageLink.setAttribute('data-initial-media-id', product.featured_image.id);
    }

    if (imageSrc) {
      var image = document.createElement('img');
      image.className = 'NativeUcdRecommendation__Image';
      setNativeUcdResponsiveImage(image, imageSrc, imageLink);
      image.alt = product.title || '';
      imageLink.appendChild(image);
    }

    var recommendationLabel = '';
    var recommendationPrice = Number(product.price);
    var recommendationCompareAt = Number(product.compare_at_price);
    if (product.available === false) {
      recommendationLabel = 'Sold out';
    } else if (recommendationCompareAt > recommendationPrice && recommendationCompareAt > 0) {
      var recommendationReduction = Math.round((recommendationCompareAt - recommendationPrice) * 20 / recommendationCompareAt) * 5;
      recommendationLabel = recommendationReduction > 0 ? recommendationReduction + '% off' : 'Reduced';
    } else if (product.nativeThreeForTwoEligible === true) {
      recommendationLabel = '3 for 2';
    }
    if (recommendationLabel || blackFriday) {
      var badge = document.createElement('span');
      badge.className = 'NativeUcdRecommendation__OfferBadge';
      badge.textContent = recommendationLabel;
      imageLink.appendChild(badge);
    }

    info.className = 'NativeUcdRecommendation__Info';
    title.className = 'NativeUcdRecommendation__Title';
    title.href = productUrl;
    title.textContent = product.title || '';
    price.className = 'NativeUcdRecommendation__Price';
    price.setAttribute('data-native-ucd-recommendation-price', '');
    price.textContent = formatNativeUcdMoney(Number(variant.price)) || '';

    info.appendChild(title);
    info.appendChild(price);

    var needsSize = !targetSize && Array.isArray(product.variants) && product.variants.some(function (itemVariant) {
      return getNativeUcdVariantSize(itemVariant, product) !== 'Default Title';
    });
    var drawer = document.getElementById('sidebar-cart');
    if (Array.isArray(product.variants) && (product.variants.length > 1 || needsSize)) {
      var variants = document.createElement('div');
      var label = document.createElement('label');
      var wrap = document.createElement('div');
      var select = document.createElement('select');
      var selectId = 'native-ucd-recommendation-api-' + product.id;

      variants.className = 'NativeUcdRecommendation__Variants';
      label.className = 'NativeUcdRecommendation__SelectLabel';
      label.htmlFor = selectId;
      label.textContent = 'Size';
      wrap.className = 'NativeUcdCartItem__SelectWrap NativeUcdRecommendation__SelectWrap';
      select.id = selectId;
      select.className = 'NativeUcdCartItem__Select NativeUcdRecommendation__Select';
      select.setAttribute('data-native-ucd-variant-option', '');
      select.setAttribute('aria-label', 'Choose size for ' + (product.title || 'recommended item'));
      if (needsSize) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = (drawer && drawer.getAttribute('data-copy-choose-size')) || 'Choose size';
        select.appendChild(placeholder);
        wrap.style.width = '124px';
        wrap.style.maxWidth = '100%';
      }

      product.variants.forEach(function (itemVariant) {
        var option = document.createElement('option');
        var size = getNativeUcdVariantSize(itemVariant, product);
        option.value = itemVariant.id;
        option.textContent = size || itemVariant.title || '';
        option.setAttribute('data-variant-id', itemVariant.id);
        option.setAttribute('data-variant-title', size);
        option.setAttribute('data-variant-price', formatNativeUcdMoney(Number(itemVariant.price)) || '');
        if (blackFriday) {
          option.setAttribute('data-bf-price', Number(itemVariant.price));
          option.setAttribute('data-bf-compare-at', Number(itemVariant.compare_at_price) || 0);
        }
        option.selected = !needsSize && String(itemVariant.id) === String(variant.id);
        option.disabled = !itemVariant.available;
        select.appendChild(option);
      });

      wrap.appendChild(select);
      variants.appendChild(label);
      variants.appendChild(wrap);
      info.appendChild(variants);
    }

    addButton.type = 'button';
    addButton.className = 'NativeUcdRecommendation__Button';
    addButton.setAttribute('data-native-ucd-add-variant', needsSize ? '' : variant.id);
    if (needsSize) {
      addButton.setAttribute('data-native-ucd-needs-size', '');
      addButton.disabled = true;
    }
    addButton.setAttribute('aria-label', 'Add ' + (product.title || 'recommended item') + ' size ' + getNativeUcdVariantSize(variant, product) + ' to bag');
    addButton.textContent = (drawer && drawer.getAttribute('data-copy-add-to-bag')) || 'Add to bag';
    info.appendChild(addButton);

    card.appendChild(imageLink);
    card.appendChild(info);
    if (blackFriday) {
      card.setAttribute('data-bf-recommendation', 'true');
      var eligiblePrices = product.variants.filter(function (item) { return item.available; }).map(function (item) { return Number(item.price); });
      updateNativeUcdBlackFridayPrice(card, Math.min.apply(Math, eligiblePrices), Number(variant.compare_at_price) || 0, needsSize);
    }
    return card;
  }

  function fetchNativeUcdShopifyRecommendationsForItem(item, intent) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var productId = item && item.product_id;

    if (!productId) {
      return Promise.resolve([]);
    }

    var recommendationIntent = intent === 'complementary' ? 'complementary' : 'related';
    return requestNativeUcdJson(root.replace(/\/$/, '') + '/recommendations/products?section_id=native-cart-recommendations&intent=' + recommendationIntent + '&product_id=' + encodeURIComponent(productId) + '&limit=10', {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }, function (html) {
      var template = document.createElement('template');
      template.innerHTML = html;
      var payload = template.content.querySelector('[data-native-cart-recommendation-data]');
      if (!payload) throw new Error('Shopify recommendation data missing');
      return JSON.parse(payload.textContent);
    }).then(function (payload) {
      return Array.isArray(payload && payload.products) ? payload.products : [];
    });
  }

  function fetchNativeUcdOfferProductsPage(page) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return requestNativeUcdJson(root.replace(/\/$/, '') + '/collections/3-for-2?section_id=native-cart-offer-products&page=' + encodeURIComponent(page), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    }, function (html) {
      var template = document.createElement('template');
      template.innerHTML = html;
      var data = template.content.querySelector('[data-native-cart-offer-data]');
      if (!data) throw new Error('Shopify offer collection data missing');
      var payload = JSON.parse(data.textContent);
      if (payload.collection !== '3-for-2' || !Array.isArray(payload.products) || payload.page !== page ||
          (payload.nextPage !== null && (!Number.isInteger(payload.nextPage) || payload.nextPage !== page + 1))) {
        throw new Error('Shopify offer collection pagination invalid');
      }
      return payload;
    });
  }

  function isNativeUcdDrawerVisible() {
    var drawer = document.getElementById('sidebar-cart');
    return Boolean(drawer && drawer.getAttribute('aria-hidden') === 'false');
  }

  function scheduleNativeUcdCartMediaEnhancement(delay) {
    window.setTimeout(function () {
      var drawer = document.getElementById('sidebar-cart');

      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        enhanceNativeUcdMediaCarousels(drawer);
      }
    }, typeof delay === 'number' ? delay : 0);
  }

  function scheduleNativeUcdShopifyRecommendations(delay, options) {
    window.setTimeout(function () {
      loadNativeUcdShopifyRecommendations(options || {});
    }, typeof delay === 'number' ? delay : 0);
  }

  var nativeUcdOfferRecommendations = false;
  var nativeUcdRecommendationPrompt = null;
  var nativeUcdRecommendationPromptState = '';
  var nativeUcdRecommendationCache = {};
  var nativeUcdRecommendationCacheContext = '';

  function getNativeUcdRecommendationContext(cart) {
    return JSON.stringify([
      typeof getNativeUcdShippingCountry === 'function' ? getNativeUcdShippingCountry() : '',
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (cart && cart.currency) || '',
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
      document.documentElement.lang,
      cart && cart.total_price,
      (cart && cart.items || []).map(function (item) {
        return [item.key, item.product_id, item.variant_id || item.id, item.quantity, getNativeUcdCartItemSize(item), item.selling_plan_allocation, item.final_line_price];
      })
    ]);
  }

  function getNativeUcdCachedRecommendationData(key, context, fetchData) {
    // A fresh cart read on every batch keeps quantity, size and market in scope.
    if (nativeUcdRecommendationCacheContext !== context) {
      nativeUcdRecommendationCache = {};
      nativeUcdRecommendationCacheContext = context;
    }
    var entry = nativeUcdRecommendationCache[key];
    if (entry && (entry.pending || Date.now() - entry.at < 45000)) return entry.promise;
    entry = { at: Date.now(), pending: true, promise: null };
    entry.promise = fetchData().then(function (data) {
      entry.at = Date.now();
      entry.pending = false;
      return data;
    }).catch(function (error) {
      if (nativeUcdRecommendationCacheContext === context && nativeUcdRecommendationCache[key] === entry) delete nativeUcdRecommendationCache[key];
      throw error;
    });
    nativeUcdRecommendationCache[key] = entry;
    return entry.promise;
  }

  function getNativeUcdCachedRecommendations(item, context, intent) {
    var key = intent ? intent + ':' + item.product_id : String(item.product_id);
    return getNativeUcdCachedRecommendationData(key, context, function () {
      return fetchNativeUcdShopifyRecommendationsForItem(item, intent);
    });
  }

  function getNativeUcdCachedOfferPage(page, context) {
    return getNativeUcdCachedRecommendationData('offer:' + page, context, function () {
      return fetchNativeUcdOfferProductsPage(page);
    });
  }

  function syncNativeUcdRecommendationMode() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    var blackFriday = typeof isNativeUcdBlackFridayBasket === 'function' && isNativeUcdBlackFridayBasket();
    if (blackFriday || !drawer.querySelector('[data-native-ucd-find-eligible]:not([hidden])')) nativeUcdOfferRecommendations = false;
    var section = drawer.querySelector('.NativeUcdDrawer__Recommendations:not(.NativeUcdDrawer__Recommendations--empty)');
    if (!section) return;
    var prompt = drawer.querySelector('[data-native-ucd-offer-prompt]');
    var promptState = prompt && prompt.getAttribute('data-native-ucd-eligible-quantity') + ':' + prompt.getAttribute('data-native-ucd-three-for-two-applied');
    if (!blackFriday && prompt && (prompt !== nativeUcdRecommendationPrompt || promptState !== nativeUcdRecommendationPromptState)) {
      nativeUcdRecommendationPrompt = prompt;
      nativeUcdRecommendationPromptState = promptState;
      nativeUcdOfferRecommendations = prompt.getAttribute('data-native-ucd-eligible-quantity') === '2' && prompt.getAttribute('data-native-ucd-three-for-two-applied') !== 'true';
      if (nativeUcdOfferRecommendations) section.open = true;
    }
    var title = section.querySelector('#native-ucd-recommendations-title');
    if (title) {
      if (!title.hasAttribute('data-copy-title')) title.setAttribute('data-copy-title', title.textContent);
      title.textContent = nativeUcdOfferRecommendations
        ? (section.getAttribute('data-copy-offer-title') || 'Complete your 3 for 2')
        : title.getAttribute('data-copy-title');
    }
  }

  function handleNativeUcdRecommendationMode(event) {
    if (typeof isNativeUcdBlackFridayBasket === 'function' && isNativeUcdBlackFridayBasket()) return false;
    var link = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-find-eligible]');
    var section = document.querySelector('#sidebar-cart .NativeUcdDrawer__Recommendations:not(.NativeUcdDrawer__Recommendations--empty)');
    var grid = section && section.querySelector('[data-native-ucd-recommendation-grid]');
    if (!link || !section || !grid) return false;
    event.preventDefault();
    var scroller = section.closest('.Drawer__Main');
    var offerOnly = true;
    if (nativeUcdOfferRecommendations !== offerOnly) {
      nativeUcdOfferRecommendations = offerOnly;
      var fallback = section.querySelector('[data-native-ucd-recommendation-fallback]');
      if (fallback) fallback.hidden = true;
      // Invalidate a response for the previous mode without replacing the cart.
      var freshGrid = document.createElement('div');
      freshGrid.id = grid.id;
      freshGrid.className = grid.className;
      freshGrid.setAttribute('data-native-ucd-recommendation-grid', '');
      // Keep enough scroll room while the filtered grid is empty. Otherwise
      // the browser clamps the offer scroll before its products arrive.
      var pendingHeight = Math.max(grid.getBoundingClientRect().height, scroller ? scroller.clientHeight : 0);
      if (pendingHeight > 0) {
        freshGrid.style.minHeight = pendingHeight + 'px';
        freshGrid.setAttribute('data-native-ucd-pending-height', '');
      }
      grid.parentNode.replaceChild(freshGrid, grid);
    }
    syncNativeUcdRecommendationMode();
    section.hidden = false;
    section.open = true;
    var heading = section.querySelector('summary') || section.querySelector('#native-ucd-recommendations-title');
    if (heading) {
      if (heading.tagName !== 'SUMMARY') heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
    if (scroller) scroller.scrollTo({
      top: scroller.scrollTop + section.getBoundingClientRect().top - scroller.getBoundingClientRect().top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    loadNativeUcdShopifyRecommendations({ force: true });
    return true;
  }

  function loadNativeUcdShopifyRecommendations(options) {
    var loadOptions = options || {};
    syncNativeUcdRecommendationMode();
    var blackFriday = typeof isNativeUcdBlackFridayBasket === 'function' && isNativeUcdBlackFridayBasket();
    var offerOnly = !blackFriday && nativeUcdOfferRecommendations;

    if (!loadOptions.force && !isNativeUcdDrawerVisible()) {
      return Promise.resolve();
    }

    var grid = document.querySelector('#sidebar-cart [data-native-ucd-recommendation-grid]');
    var section = grid && grid.closest('.NativeUcdDrawer__Recommendations');
    var moreButton = section && section.querySelector('[data-native-ucd-recommendations-more]');
    var status = section && section.querySelector('[data-native-ucd-recommendations-status]');
    var copyContainer = section && section.querySelector('.NativeUcdDrawer__RecommendationMore');
    var recommendationCopy = function (key, fallback, count) {
      var copy = copyContainer && copyContainer.getAttribute('data-copy-' + key);
      if (!copy) copy = fallback;
      return typeof count === 'number' ? copy.replace('__count__', String(count)) : copy;
    };

    if (!grid ||
        (section && section.classList.contains('NativeUcdDrawer__Recommendations--empty')) ||
        grid.getAttribute('data-native-ucd-shopify-loading') === 'true') {
      return Promise.resolve();
    }

    if (grid.getAttribute('data-native-ucd-recommendations-exhausted') === 'true' ||
        (!loadOptions.more && grid.getAttribute('data-native-ucd-recommendations-initialised') === 'true')) {
      return Promise.resolve();
    }

    var existingIds = Array.prototype.reduce.call(grid.querySelectorAll('.NativeUcdRecommendation'), function (ids, card) {
      var productId = card.getAttribute('data-product-id');
      if (productId) ids[String(productId)] = true;
      return ids;
    }, {});
    var failed = false;
    var stale = false;
    var targetBatchSize = offerOnly ? 6 : 4;
    var restoreMoreFocus = loadOptions.more && document.activeElement === moreButton;

    if (!loadOptions.more && grid.getAttribute('data-native-ucd-shopify-recommendations') !== 'true') {
      grid.textContent = '';
      existingIds = {};
    }

    grid.setAttribute('data-native-ucd-shopify-loading', 'true');
    var fallback = section && section.querySelector('[data-native-ucd-recommendation-fallback]');
    if (fallback) fallback.hidden = true;
    if (section) section.hidden = false;
    if (status) status.textContent = loadOptions.more ? '' : recommendationCopy('finding', 'Finding recommendations…');
    if (moreButton) {
      moreButton.hidden = false;
      moreButton.disabled = true;
      moreButton.textContent = recommendationCopy('loading', 'Loading…');
      moreButton.setAttribute('aria-busy', 'true');
    }

    return fetchNativeUcdCartJson().then(function (cart) {
      if (grid.isConnected === false || offerOnly !== nativeUcdOfferRecommendations) { stale = true; return; }
      var context = getNativeUcdRecommendationContext(cart);
      if (grid.__nativeUcdRecommendationContext && grid.__nativeUcdRecommendationContext !== context) {
        grid.textContent = '';
        existingIds = {};
      }
      grid.__nativeUcdRecommendationContext = context;
      var items = Array.isArray(cart && cart.items) ? cart.items : [];
      var cartProductIds = items.reduce(function (ids, item) {
        if (item && item.product_id) ids[String(item.product_id)] = true;
        return ids;
      }, {});

      var seenProductIds = Object.assign({}, cartProductIds, existingIds);

      var requests = blackFriday ? ['complementary', 'related'].reduce(function (all, intent) {
        var seeded = {};
        return all.concat(items.filter(function (item) {
          if (!item.product_id || seeded[item.product_id]) return false;
          seeded[item.product_id] = true;
          return true;
        }).slice(0, 3).map(function (item) { return {item: item, intent: intent}; }));
      }, []) : items.map(function (item) { return {item: item}; });
      return Promise.all(requests.map(function (request) {
        return getNativeUcdCachedRecommendations(request.item, context, request.intent).then(function (products) {
          return { item: request.item, products: products };
        }).catch(function () {
          return { item: request.item, products: [], failed: true };
        });
      })).then(function (recommendationSets) {
        if (!offerOnly && recommendationSets.length && recommendationSets.every(function (set) { return set.failed; })) {
          throw new Error('Shopify recommendations unavailable');
        }
        failed = recommendationSets.some(function (set) { return set.failed; });
        var candidateById = {};
        var candidates = [];
        var addCandidates = function (products, targetSizes) {
          products.forEach(function (product) {
            var productId = String(product && product.id || '');
            if (!product || !productId || product.available === false || seenProductIds[productId]) return;
            if (offerOnly && product.nativeThreeForTwoEligible !== true) return;
            var entry = candidateById[productId];
            if (!entry) {
              entry = { product: product, targetSizes: [] };
              candidateById[productId] = entry;
              candidates.push(entry);
            }
            targetSizes.forEach(function (size) {
              if (size && entry.targetSizes.indexOf(size) === -1) entry.targetSizes.push(size);
            });
          });
        };
        var makeCards = function () {
          return candidates.map(function (entry) {
            var card = null;
            (entry.targetSizes.length ? entry.targetSizes : ['']).some(function (size) {
              card = createNativeUcdRecommendationCard(entry.product, size);
              return Boolean(card);
            });
            return card;
          }).filter(Boolean);
        };
        recommendationSets.forEach(function (set) {
          addCandidates(set.products, blackFriday ? [] : [getNativeUcdCartItemSize(set.item)]);
        });
        var targetSizes = items.map(getNativeUcdCartItemSize).filter(function (size, index, sizes) {
          return size && sizes.indexOf(size) === index;
        });
        var findOfferCards = function (page) {
          if (!offerOnly || !items.length) return Promise.resolve({ makeCards: makeCards });
          var cards = makeCards();
          if (cards.length > targetBatchSize) return Promise.resolve({ cards: cards });
          return getNativeUcdCachedOfferPage(page, context).then(function (payload) {
            if (grid.isConnected === false || offerOnly !== nativeUcdOfferRecommendations || context !== nativeUcdRecommendationCacheContext) {
              stale = true;
              return { cards: [], hasMore: false };
            }
            addCandidates(payload.products, targetSizes);
            cards = makeCards();
            // Scan past sold-out, wrong-size and duplicate pages, including one
            // lookahead option so Show more is not a false promise at six cards.
            if (cards.length <= targetBatchSize && payload.nextPage) return findOfferCards(payload.nextPage);
            failed = false; // The collection covers the offer even if related failed.
            return { cards: cards, hasMore: cards.length > targetBatchSize };
          }).catch(function () {
            failed = true;
            return { cards: makeCards(), hasMore: false };
          });
        };
        return findOfferCards(1).then(function (result) {
          return fetchNativeUcdCartJson().then(function (currentCart) {
            return { cards: result.cards, makeCards: result.makeCards, cart: currentCart };
          });
        });
      }).then(function (currentResults) {
        if (stale || grid.isConnected === false || offerOnly !== nativeUcdOfferRecommendations || context !== getNativeUcdRecommendationContext(currentResults.cart) || (items.length && context !== nativeUcdRecommendationCacheContext)) { stale = true; return; }
        var eligibleCards = currentResults.cards || currentResults.makeCards();
        var cardsToAdd = eligibleCards.slice(0, targetBatchSize);
        var hasMore = eligibleCards.length > targetBatchSize;

        cardsToAdd.forEach(function (card) {
          var productId = card.getAttribute('data-product-id');
          if (!productId || seenProductIds[productId]) return;
          seenProductIds[productId] = true;
          grid.appendChild(card);
        });

        grid.setAttribute('data-native-ucd-shopify-recommendations', 'true');
        if (hasMore || failed) grid.removeAttribute('data-native-ucd-recommendations-exhausted');
        else grid.setAttribute('data-native-ucd-recommendations-exhausted', 'true');
        // Empty related results still need the status and collection fallback.
        if (section) section.hidden = false;
        if (status) {
          var completionCopy = recommendationCopy('all-relevant-shown', 'All relevant recommendations shown.');
          if (failed) {
            status.textContent = recommendationCopy('load-failed', 'Couldn’t load recommendations. Try again.');
          } else if (loadOptions.more) {
            var batchCopy = cardsToAdd.length ? recommendationCopy(cardsToAdd.length === 1 ? 'more-shown-one' : 'more-shown-other', '__count__ more recommendations shown.', cardsToAdd.length) : '';
            status.textContent = [batchCopy, hasMore ? '' : completionCopy].filter(Boolean).join(' ');
          } else {
            status.textContent = cardsToAdd.length ? (hasMore ? '' : completionCopy) : recommendationCopy('no-related', 'No related recommendations available right now.');
          }
        }

        if (restoreMoreFocus && cardsToAdd.length && (document.activeElement === moreButton || document.activeElement === document.body)) {
          var nextLink = cardsToAdd[0].querySelector('a');
          if (nextLink) nextLink.focus({ preventScroll: true });
        }

        enhanceNativeUcdMediaCarousels(grid);
        window.setTimeout(function () { enhanceNativeUcdMediaCarousels(grid); }, 350);
        window.setTimeout(function () { enhanceNativeUcdMediaCarousels(grid); }, 1200);
      });
    }).catch(function () {
      failed = true;
      if (grid.isConnected !== false && section) section.hidden = false;
      if (status && grid.isConnected !== false) status.textContent = recommendationCopy('load-failed', 'Couldn’t load recommendations. Try again.');
    }).finally(function () {
      grid.removeAttribute('data-native-ucd-shopify-loading');
      if (grid.isConnected === false) return;
      if (grid.hasAttribute('data-native-ucd-pending-height')) {
        grid.style.removeProperty('min-height');
        grid.removeAttribute('data-native-ucd-pending-height');
      }
      if (!failed && !stale) grid.setAttribute('data-native-ucd-recommendations-initialised', 'true');
      if (stale && status) status.textContent = '';
      if (moreButton) {
        var exhausted = grid.getAttribute('data-native-ucd-recommendations-exhausted') === 'true';
        moreButton.hidden = exhausted && !failed;
        moreButton.disabled = false;
        moreButton.textContent = failed
          ? recommendationCopy('try-again', 'Try again')
          : recommendationCopy('show-more', 'Load more');
        moreButton.removeAttribute('aria-busy');
        if (moreButton.hidden && restoreMoreFocus && (document.activeElement === moreButton || document.activeElement === document.body) && status) {
          status.focus({ preventScroll: true });
        }
      }
      var fallback = section && section.querySelector('[data-native-ucd-recommendation-fallback]');
      if (fallback && offerOnly === nativeUcdOfferRecommendations) {
        fallback.hidden = grid.querySelector('.NativeUcdRecommendation') !== null;
        var fallbackMode = offerOnly ? 'eligible' : 'favourites';
        fallback.href = fallback.getAttribute('data-' + fallbackMode + '-url');
        fallback.textContent = fallback.getAttribute('data-copy-' + fallbackMode);
      }
    });
  }

  function handleNativeUcdReviewMore(event) {
    var button = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-reviews-more]');
    if (!button) return false;
    event.preventDefault();
    if (button.disabled) return true;

    var section = button.closest('.NativeUcdDrawer__Reviews');
    var reviews = section ? Array.prototype.slice.call(section.querySelectorAll('[data-native-ucd-review]')) : [];
    var nextReviews = reviews.filter(function (review) { return review.hidden; }).slice(0, 3);
    nextReviews.forEach(function (review) { review.hidden = false; });

    var shown = reviews.filter(function (review) { return !review.hidden; }).length;
    var status = section && section.querySelector('[data-native-ucd-reviews-status]');
    if (status) status.textContent = 'Showing ' + shown + ' of ' + reviews.length + ' selected reviews.';
    if (shown === reviews.length) {
      button.disabled = true;
      button.textContent = 'All reviews loaded';
    }
    // Keep the viewport anchored to the review the shopper was reading.
    if (nextReviews.length) {
      var firstLink = nextReviews[0].querySelector('a');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }
    return true;
  }

  function handleNativeUcdRecommendationMore(event) {
    var button = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-recommendations-more]');

    if (!button) {
      return false;
    }

    event.preventDefault();
    loadNativeUcdShopifyRecommendations({ force: true, more: true });
    return true;
  }

  function handleNativeUcdEmptyRecommendationMore(event) {
    var button = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-empty-more]');
    if (!button) return false;
    event.preventDefault();
    var section = button.closest('.NativeUcdDrawer__Recommendations--empty');
    var cards = section ? Array.prototype.slice.call(section.querySelectorAll('.NativeUcdRecommendation[hidden]'), 0, 4) : [];
    cards.forEach(function (card) { card.hidden = false; });
    var status = section && section.querySelector('[data-native-ucd-empty-status]');
    var copy = button.parentNode.getAttribute('data-copy-more-shown-' + (cards.length === 1 ? 'one' : 'other')) || '__count__ more recommendations shown.';
    if (status) status.textContent = copy.replace('__count__', String(cards.length));
    button.hidden = !section || !section.querySelector('.NativeUcdRecommendation[hidden]');
    if (cards.length) {
      var firstLink = cards[0].querySelector('a');
      if (firstLink) firstLink.focus({ preventScroll: true });
      enhanceNativeUcdMediaCarousels(section);
    }
    return true;
  }

  function handleNativeUcdRecommendationAdd(event) {
    var button = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-add-variant]');

    if (!button) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var variantId = button.getAttribute('data-native-ucd-add-variant');
    if (!variantId || button.disabled || button.hasAttribute('data-native-ucd-needs-size')) {
      var card = button.closest('.NativeUcdRecommendation');
      var sizeControl = card && card.querySelector('.BrandSelect__Trigger, select[data-native-ucd-variant-option]');
      if (sizeControl) sizeControl.focus();
      return true;
    }

    if (isNativeUcdDuplicateAdd(variantId)) {
      return true;
    }

    setNativeUcdStatus('');
    nativeUcdPendingAdds[variantId] = Date.now();
    setNativeUcdLoading(true);
    setNativeUcdRecommendationLoading(button, true);

    addNativeUcdVariant(variantId, 1, { __ucd: 'true' }, true).then(function (cartItem) {
      markNativeUcdAddComplete(variantId);
      return refreshNativeCartDrawer().catch(function (error) {
        return recoverNativeUcdDrawerRefresh(error, 'Native cart drawer quick add refresh failed');
      }).then(function () {
        openNativeCartDrawer();
        dispatchNativeUcdAddEvents(cartItem, variantId, 1);
      });
    }).catch(function (error) {
      return recoverNativeUcdMutationFailure(error, 'Native cart drawer quick add failed');
    }).finally(function () {
      delete nativeUcdPendingAdds[variantId];
      setNativeUcdRecommendationLoading(button, false);
      setNativeUcdLoading(false);
    });

    return true;
  }

  function getNativeUcdDialogFocusTargets(dialog) {
    return Array.prototype.filter.call(dialog.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'), function (element) {
      return element.tabIndex >= 0 && !element.disabled && element.getAttribute('aria-disabled') !== 'true' && !element.closest('[hidden], [aria-hidden="true"], [inert]') && element.getClientRects().length > 0;
    });
  }

  function setNativeUcdDialogBackgroundInert(dialog, boundary, state, enabled) {
    if (!enabled) {
      (state.elements || []).forEach(function (element) { element.removeAttribute('inert'); });
      state.elements = [];
      return;
    }
    if (state.elements && state.elements.length) return;
    state.elements = [];
    var branch = dialog;
    while (branch && branch !== boundary && branch.parentElement) {
      Array.prototype.forEach.call(branch.parentElement.children, function (element) {
        if (element === branch || element.matches('script, style, link, .PageOverlay') || element.hasAttribute('inert')) return;
        element.setAttribute('inert', '');
        state.elements.push(element);
      });
      branch = branch.parentElement;
    }
  }

  function bindNativeUcdCartDialog(drawer) {
    if (!drawer || drawer.__nativeUcdDialogBound) return;
    drawer.__nativeUcdDialogBound = true;
    drawer.__nativeUcdBackground = {};
    document.addEventListener('focusin', function (event) {
      if (drawer.getAttribute('aria-hidden') !== 'false' && !drawer.contains(event.target)) drawer.__nativeUcdReturnFocus = event.target;
    });
    document.addEventListener('click', function (event) {
      var opener = getNativeUcdCartIntentTarget(event);
      if (!opener || drawer.contains(opener)) return;
      // Safari pointer clicks need not focus links. Keep the actual opener for
      // this activation rather than whichever field was previously focused.
      drawer.__nativeUcdPendingReturnFocus = opener;
      window.setTimeout(function () {
        if (drawer.__nativeUcdPendingReturnFocus === opener) drawer.__nativeUcdPendingReturnFocus = null;
      }, 0);
    }, true);
    drawer.addEventListener('keydown', function (event) {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      var popup = drawer.querySelector('[data-native-ucd-preorder-popup]:not([hidden])');
      var dialog = popup ? popup.querySelector('[role="dialog"]') : drawer;
      if (popup && event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        drawer.__nativeUcdPopupEscape = true;
        toggleNativeUcdPreOrderPopup(false);
        return;
      }
      if (event.key !== 'Tab') return;
      var targets = getNativeUcdDialogFocusTargets(dialog);
      var active = document.activeElement;
      var destination = !targets.length ? dialog : event.shiftKey
        ? (active === targets[0] || targets.indexOf(active) === -1 ? targets[targets.length - 1] : null)
        : (active === targets[targets.length - 1] ? targets[0] : null);
      if (destination) {
        event.preventDefault();
        destination.focus({ preventScroll: true });
      }
    });
    drawer.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && drawer.__nativeUcdPopupEscape) {
        event.stopImmediatePropagation();
        drawer.__nativeUcdPopupEscape = false;
      }
    }, true);
  }

  function syncNativeUcdCartDialog(drawer, justOpened) {
    if (!drawer) return;
    bindNativeUcdCartDialog(drawer);
    var open = drawer.getAttribute('aria-hidden') === 'false';
    if (open && justOpened) {
      var opener = drawer.__nativeUcdPendingReturnFocus;
      drawer.__nativeUcdPendingReturnFocus = null;
      if (opener && opener.isConnected && !drawer.contains(opener)) drawer.__nativeUcdReturnFocus = opener;
      else if (!drawer.contains(document.activeElement) && document.activeElement !== document.body) drawer.__nativeUcdReturnFocus = document.activeElement;
      var title = drawer.querySelector('#native-ucd-cart-title');
      if (title) title.focus({ preventScroll: true });
    }
    setNativeUcdDialogBackgroundInert(drawer, document.body, drawer.__nativeUcdBackground, open);
    if (!open) {
      var popup = drawer.querySelector('[data-native-ucd-preorder-popup]');
      if (popup && popup.__nativeUcdBackground) setNativeUcdDialogBackgroundInert(popup, drawer, popup.__nativeUcdBackground, false);
      if (popup) popup.hidden = true;
      drawer.classList.remove('no-scroll');
      var target = drawer.__nativeUcdReturnFocus;
      var otherDialog = Array.prototype.some.call(document.querySelectorAll('.Drawer[aria-hidden="false"], [role="dialog"][aria-modal="true"]'), function (element) {
        return element !== drawer && !element.closest('[hidden], [aria-hidden="true"]') && element.getClientRects().length > 0;
      });
      if (target && target.isConnected && !target.closest('[hidden], [aria-hidden="true"], [inert]') && !otherDialog && (drawer.contains(document.activeElement) || document.activeElement === document.body)) target.focus({ preventScroll: true });
    }
  }

  function toggleNativeUcdPreOrderPopup(show) {
    var popup = document.querySelector('#sidebar-cart [data-native-ucd-preorder-popup]');
    var drawer = document.getElementById('sidebar-cart');

    if (!popup || !drawer) {
      return;
    }

    if (show && popup.hidden) popup.__nativeUcdReturnFocus = document.activeElement;
    var wasOpen = !popup.hidden;
    popup.hidden = !show;
    drawer.classList.toggle('no-scroll', !!show);
    popup.__nativeUcdBackground = popup.__nativeUcdBackground || {};
    setNativeUcdDialogBackgroundInert(popup, drawer, popup.__nativeUcdBackground, !!show);
    if (show) {
      var dialog = popup.querySelector('[role="dialog"]');
      var close = popup.querySelector('button');
      if (dialog) dialog.setAttribute('tabindex', '-1');
      if (close) close.focus({ preventScroll: true });
    } else if (wasOpen && drawer.getAttribute('aria-hidden') === 'false' && popup.__nativeUcdReturnFocus && popup.__nativeUcdReturnFocus.isConnected) {
      popup.__nativeUcdReturnFocus.focus({ preventScroll: true });
    }
  }

  function normalizeNativeUcdDeadlineMarkup(value) {
    return (value || '').replace(/\b(monday|tuesday|wednesday|thursday|friday|saturday|sunday)\b/gi, function (match) {
      return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
    });
  }

  function buildNativeUcdDeadlineResult(markup) {
    var container = document.createElement('div');
    container.innerHTML = markup || '';
    var message = container.querySelector('.trustblox-message');

    if (message) {
      message.querySelectorAll('.trustblox-1-timer-locations-toggle, .trustblox-timer').forEach(function (element) {
        element.remove();
      });
    }

    var text = ((message || container).textContent || '').replace(/\s+/g, ' ').trim();

    return {
      html: '',
      text: normalizeNativeUcdDeadlineMarkup(text)
    };
  }

  function refineNativeUcdShippingMessage(message) {
    var text = String(message || '').replace(/\s+/g, ' ').trim();

    if (!text) {
      return '';
    }

    return normalizeNativeUcdDeadlineMarkup(text.toLowerCase().replace(/(^|[.!?]\s+)([a-z])/g, function (match, prefix, char) {
      return prefix + char.toUpperCase();
    }));
  }

  function getNativeUcdPreOrderShippingCopy(state) {
    var hasPreOrder = !!(state && state.hasPreOrder);
    var hasNonPreOrder = !!(state && state.hasNonPreOrder);
    var isUkCustomer = !!(state && state.isUkCustomer);
    var preOrderDates = state && Array.isArray(state.preOrderDates) ? state.preOrderDates.filter(Boolean) : [];
    var uniquePreOrderDates = preOrderDates.filter(function (date, index) {
      return preOrderDates.indexOf(date) === index;
    });
    var singlePreOrderDate = uniquePreOrderDates.length === 1 ? uniquePreOrderDates[0] : '';

    if (!hasPreOrder) {
      return null;
    }

    if (isUkCustomer) {
      if (hasNonPreOrder) {
        return {
          deadline: singlePreOrderDate
            ? 'Order now. In-stock items ship first; pre-order item estimated shipping date: ' + singlePreOrderDate + '.'
            : 'Order now. In-stock items ship first; pre-order items ship separately once available.',
          benefit: 'In-stock items ship first. Pre-order items ship separately once available.',
          item: 'Your in-stock items ship first. This pre-order item ships separately once it arrives.',
          footer: 'In-stock items ship next day once dispatched. Pre-order items ship separately once available.'
        };
      }

      return {
        deadline: singlePreOrderDate
          ? 'Pre-order now. Estimated shipping date: ' + singlePreOrderDate + '. Delivered next day once dispatched.'
          : 'Pre-order now. Ships once available, then delivered next day once dispatched.',
        benefit: 'Ships once available, then delivered next day once dispatched.',
        item: "This item ships once it arrives. We'll email you if the estimated date changes.",
        footer: 'Your order ships once the pre-order item is available, then it is delivered next day once dispatched.'
      };
    }

    if (hasNonPreOrder) {
      return {
        deadline: singlePreOrderDate
          ? 'Order now. Your order ships together after the pre-order item is available: ' + singlePreOrderDate + '.'
          : 'Order now. Your order ships together once every item is available.',
        benefit: 'Your order ships together once every item is available.',
        item: 'Your order ships together once every item is available. Delivery estimates update for your destination.',
        footer: 'International orders with pre-order items ship together once every item is available. Delivery estimates update for your destination.'
      };
    }

    return {
      deadline: singlePreOrderDate
        ? 'Pre-order now. Estimated shipping date: ' + singlePreOrderDate + '. Delivery estimates update for your destination.'
        : 'Pre-order now. Ships once available. Delivery estimates update for your destination.',
      benefit: 'Ships once the pre-order item is available.',
      item: 'Your order ships once this pre-order item is available. Delivery estimates update for your destination.',
      footer: 'This pre-order ships once available. Delivery estimates update for your destination.'
    };
  }

  function normalizeNativeUcdPreOrderDate(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/^estimated\s+(shipping|ship)\s+date\s*:?\s*/i, '')
      .trim();
  }

  function updateNativeUcdPreOrderShippingCopy(state) {
    var copy = getNativeUcdPreOrderShippingCopy(state);

    if (!copy) {
      return;
    }

    document.querySelectorAll('[data-native-ucd-shipping-message], [data-native-ucd-shipping-detail]').forEach(function (element) {
      element.textContent = copy.benefit;
    });

    document.querySelectorAll('#sidebar-cart [data-native-ucd-preorder-shipping-copy]').forEach(function (element) {
      element.textContent = copy.item;
    });
  }

  function textFromNativeUcdHtml(html) {
    var template = document.createElement('template');
    template.innerHTML = html || '';
    return (template.content.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function formatNativeUcdMoney(cents) {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) {
      return '';
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return textFromNativeUcdHtml(window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat));
      } catch (error) {}
    }

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (error) {
      return '£' + Math.round(cents / 100);
    }
  }

  // cart.js is in the selected Shopify market's currency. Only validated
  // delivery amounts can be added. Shopify.formatMoney may be wrapped
  // by a conversion app, so never pass presentment cents through it.
  function formatNativeUcdPresentmentMoney(cents, currency) {
    if (!Number.isSafeInteger(cents) || cents < 0 || !/^[A-Z]{3}$/.test(currency || '')) return '';
    var fractionDigits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(cents / 100);
    } catch (error) {
      return currency + ' ' + (cents / 100).toFixed(fractionDigits);
    }
  }

  function normaliseNativeUcdRatePrice(rate) {
    return rate && Number.isSafeInteger(rate.priceCents) && rate.priceCents >= 0 ? rate.priceCents : null;
  }

  function getNativeUcdShippingRate() {
    var rates = Array.isArray(window._shipping_rates) ? window._shipping_rates : [];

    if (!rates.length) {
      return null;
    }

    return rates.find(function (rate) {
      var text = String((rate.code || '') + ' ' + (rate.name || '') + ' ' + (rate.description || '')).toLowerCase();
      return text.includes('delivered next day') || text.includes('next day') || text.includes('express');
    }) || rates[0];
  }

  function getNativeUcdShippingCountry() {
    var config = getNativeUcdStorefrontConfig() || {};
    return String((window.Shopify && window.Shopify.country) || config.countryCode || document.body.getAttribute('data-country') || 'GB').toUpperCase();
  }

  function getNativeUcdShippingOptionText(rate) {
    var raw = rate && (rate.presentment_name || rate.description || rate.code || rate.name);

    return raw ? String(raw).split(' (')[0].replace(/\s+/g, ' ').trim() : '';
  }

  function renderNativeUcdShippingSummary(rate, cartSubtotalCents, isLoading, country, quoteState) {
    cartSubtotalCents = getNativeUcdCurrentMerchandiseTotal(cartSubtotalCents);
    var shippingCents = normaliseNativeUcdRatePrice(rate);
    var isFree = shippingCents === 0;
    var preOrderCopy = getNativeUcdPreOrderShippingCopy(nativeUcdCartShippingState);
    var rateCurrency = rate && rate.currency;
    var estimate = country !== 'GB' && !preOrderCopy && rate && typeof window.dsrcvGetCartDeliveryMessage === 'function'
      ? String(window.dsrcvGetCartDeliveryMessage(country, cartSubtotalCents) || '') : '';
    if (!/^Ships /.test(estimate)) estimate = '';

    document.querySelectorAll('[data-native-ucd-shipping-price]').forEach(function (element) {
      element.classList.toggle('is-free', isFree);
      setNativeUcdText(element, isFree ? 'Free' : (Number.isSafeInteger(shippingCents) && shippingCents >= 0
        ? formatNativeUcdPresentmentMoney(shippingCents, rateCurrency) : (isLoading ? 'Checking delivery…' : quoteState && quoteState.status === 'selection_required' ? 'Choose service' : quoteState && quoteState.status === 'checkout_required' ? 'Calculated at checkout' : 'Unavailable')));
    });

    document.querySelectorAll('[data-native-ucd-shipping-row]').forEach(function (element) {
      element.setAttribute('aria-busy', isLoading && shippingCents === null ? 'true' : 'false');
    });

    document.querySelectorAll('[data-native-ucd-shipping-status]').forEach(function (element) {
      var unavailable = shippingCents === null && !isLoading;
      var failed = unavailable && quoteState && ['error', 'no_rates'].indexOf(quoteState.status) !== -1;
      var text = element.querySelector('[data-native-ucd-shipping-status-text]') || element;
      setNativeUcdText(text, unavailable ? (quoteState && quoteState.status === 'checkout_required' ? 'Delivery and your final total will be calculated at checkout.' : quoteState && quoteState.status === 'currency_unavailable' ? 'Continue to secure checkout to review delivery options in ' + String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || (getNativeUcdStorefrontConfig() || {}).currencyCode || 'your currency') + '.' : failed ? (quoteState.status === 'no_rates' ? 'No delivery services found for this country.' : 'Unable to retrieve delivery rates. Please try again.') : quoteState && quoteState.status === 'selection_required' ? 'Choose a delivery service below.' : 'Delivery estimate unavailable. Continue to secure checkout to review delivery options.') : '');
      var retry = element.querySelector('[data-native-ucd-shipping-retry]');
      if (retry) retry.hidden = !failed;
      element.hidden = !unavailable;
      element.classList.toggle('is-hidden', !unavailable);
    });

    // Keep the checkout method separate from pre-order notes, which can be
    // rewritten by the shared pre-order presentation controller.
    document.querySelectorAll('[data-native-ucd-shipping-method]').forEach(function (element) {
      var methodLabel = rate && typeof rate.methodLabel === 'string' ? rate.methodLabel.trim() : '';
      // Calendar copy does not depend on the separate shipping-price request.
      if ((country || (rate && rate.countryCode)) === 'GB') {
        var calendarLabel = typeof window.dsrcvGetCartDeliveryMessage === 'function'
          ? window.dsrcvGetCartDeliveryMessage('GB', cartSubtotalCents) : '';
        if (calendarLabel && !/^(?:delivery (?:confirmed|will be confirmed) at checkout|checking delivery)[.\u2026]*$/i.test(String(calendarLabel).trim())) {
          methodLabel = calendarLabel;
        }
      }
      setNativeUcdText(element, methodLabel);
      element.classList.toggle('is-hidden', !methodLabel);
      element.hidden = !methodLabel;
    });

    document.querySelectorAll('[data-native-ucd-shipping-estimate]').forEach(function (element) {
      setNativeUcdText(element, estimate);
      element.hidden = !estimate;
      element.classList.toggle('is-hidden', !estimate);
    });

    document.querySelectorAll('[data-native-ucd-shipping-label]').forEach(function (element) {
      setNativeUcdText(element, 'Delivery');
    });

    document.querySelectorAll('[data-native-ucd-total-label]').forEach(function (element) {
      setNativeUcdText(element, 'Total');
    });

    if (isFree && !preOrderCopy) {
      document.querySelectorAll('[data-native-ucd-shipping-message], [data-native-ucd-shipping-detail]').forEach(function (element) {
        setNativeUcdText(element, 'Free delivery unlocked');
        element.hidden = false;
        element.classList.remove('is-hidden');
      });
    }

    document.querySelectorAll('[data-native-ucd-shipping-option], [data-native-ucd-shipping-detail-option]').forEach(function (element) {
      var summaryText = preOrderCopy ? preOrderCopy.footer : '';
      setNativeUcdText(element, summaryText);
      element.classList.toggle('is-hidden', !summaryText);
      element.hidden = !summaryText;
    });

    document.querySelectorAll('[data-native-ucd-total]').forEach(function (element) {
      if (!Number.isSafeInteger(cartSubtotalCents) || cartSubtotalCents < 0) {
        return;
      }
      // cart.total_price already includes all line/order discounts. Add only
      // the current delivery quote; never subtract the displayed savings twice.
      // "Total" includes delivery. Keep it blank until a current delivery rate
      // is available instead of presenting the merchandise amount as final.
      if (shippingCents === null) {
        element.removeAttribute('data-money-convertible');
        setNativeUcdText(element, '—');
        return;
      }
      var config = getNativeUcdStorefrontConfig() || {};
      var totalCurrency = rateCurrency ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || config.currencyCode;
      var totalCents = cartSubtotalCents + shippingCents;
      var totalText = formatNativeUcdPresentmentMoney(totalCents, totalCurrency);
      if (!totalText) return;
      element.toggleAttribute('data-money-convertible', true);
      setNativeUcdText(element, totalText);
    });
    if (window.dsrcvCartDutiesPreview) window.dsrcvCartDutiesPreview.render();
  }

  function getNativeUcdCurrentMerchandiseTotal(fallbackCents) {
    var totals = document.querySelector('#sidebar-cart .NativeUcdDrawer__Totals');
    var currentCents = totals ? Number(totals.getAttribute('data-native-ucd-merchandise-total')) : NaN;

    return Number.isFinite(currentCents) && currentCents >= 0 ? currentCents : fallbackCents;
  }


  function setNativeUcdText(element, value) {
    var text = String(value == null ? '' : value);
    if (element.textContent !== text) element.textContent = text;
  }


  function getNativeUcdCanonicalShippingRate(quote, country, currency, subtotalCents) {
    var config = getNativeUcdStorefrontConfig() || {};
    if (currency !== String(config.shopCurrencyCode || 'GBP').toUpperCase() ||
      !/^[A-Z]{2}$/.test(country) || !/^[A-Z]{3}$/.test(currency) || !Number.isSafeInteger(subtotalCents) || subtotalCents < 0 ||
      !quote || quote.available !== true || quote.countryCode !== country || quote.currency !== currency ||
      quote.subtotalCents !== subtotalCents || !Number.isSafeInteger(quote.priceCents) || quote.priceCents < 0 ||
      quote.isFree !== (quote.priceCents === 0)) {
      return null;
    }
    return {
      priceCents: quote.priceCents,
      countryCode: quote.countryCode,
      currency: quote.currency,
      methodLabel: typeof quote.methodLabel === 'string' ? quote.methodLabel.trim()
        .replace(/\s*[\u2013\u2014]\s*/g, ', ')
        .replace(/delivered next day once dispatched/gi, 'Next day delivery once dispatched')
        .replace(/no import charges on delivery/gi, 'No import charges on delivery') : ''
    };
  }


  function refreshNativeUcdShippingQuote() {
    var api = window.__FreeShippingBarAPI;
    if (!api || typeof api.refresh !== 'function' || typeof api.getQuote !== 'function' ||
      (typeof api.isLoading === 'function' && api.isLoading())) return;
    var config = getNativeUcdStorefrontConfig() || {};
    var country = getNativeUcdShippingCountry();
    var currency = String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active ||
      config.currencyCode || '').toUpperCase();
    var subtotal = getNativeUcdCurrentMerchandiseTotal(NaN);
    if (!getNativeUcdCanonicalShippingRate(api.getQuote(), country, currency, subtotal)) api.refresh();
  }


  function setNativeUcdDeliveryBenefit(element, benefit, fallbackText) {
    if (!benefit || !benefit.subtitle) {
      setNativeUcdText(element, benefit && benefit.title || fallbackText);
      return;
    }
    var currentTitle = element.querySelector('.NativeUcdDrawer__DeliveryTitle');
    var currentCutoff = element.querySelector('.NativeUcdDrawer__DeliveryCutoff');
    if (currentTitle && currentCutoff && currentTitle.textContent === benefit.title && currentCutoff.textContent === benefit.subtitle) return;
    var title = document.createElement('span');
    title.className = 'NativeUcdDrawer__DeliveryTitle';
    title.textContent = benefit.title;
    var cutoff = document.createElement('span');
    cutoff.className = 'NativeUcdDrawer__DeliveryCutoff';
    cutoff.textContent = benefit.subtitle;
    element.replaceChildren(title, cutoff);
  }


  function updateNativeUcdShippingSummary(cartSubtotalCents) {
    cartSubtotalCents = getNativeUcdCurrentMerchandiseTotal(cartSubtotalCents);
    var country = getNativeUcdShippingCountry();
    var currency = String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || (getNativeUcdStorefrontConfig() || {}).currencyCode || '').toUpperCase();
    var api = window.dsrcvCartShipping;
    var state = api ? api.getState() : { status: 'address_required' };
    var rate = state.rate;
    if (!rate || rate.countryCode !== country || rate.currency !== currency || rate.subtotalCents !== cartSubtotalCents) rate = null;
    renderNativeUcdShippingSummary(rate, cartSubtotalCents, state.status === 'pending', country, state);
    if (api) api.render();
    return Promise.resolve();
  }

  function getNativeUcdStorefrontConfig() {
    var script = document.querySelector('#sidebar-cart [data-native-ucd-storefront-config]');

    if (!script || !script.textContent) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateNativeUcdDutyUi(amountText, noteText, isLoading) {
    document.querySelectorAll('[data-native-ucd-duty-amount]').forEach(function (element) {
      element.textContent = amountText;
    });

    document.querySelectorAll('[data-native-ucd-duty-note]').forEach(function (element) {
      element.textContent = noteText;
    });

    document.querySelectorAll('[data-native-ucd-duty-detail]').forEach(function (element) {
      element.textContent = amountText === 'Included' ? 'Duties are included for your region.' : amountText;
    });

    document.querySelectorAll('[data-native-ucd-duty-detail-note]').forEach(function (element) {
      element.textContent = noteText;
    });

    document.querySelectorAll('[data-native-ucd-duties-row]').forEach(function (element) {
      element.classList.toggle('is-loading', !!isLoading);
    });
  }

  function ensureNativeUcdDutyRow(config) {
    var totals = document.querySelector('#sidebar-cart .NativeUcdDrawer__Totals');
    if (!totals) return null;

    // Only show confirmed inclusion, never a speculative checkout charge.
    if (!config || config.dutiesIncluded !== true) {
      totals.querySelectorAll('[data-native-ucd-duties-row], [data-native-ucd-duty-note]').forEach(function (element) {
        element.remove();
      });
      return null;
    }

    var existingRow = totals.querySelector('[data-native-ucd-duties-row]');
    if (existingRow) {
      existingRow.firstElementChild.textContent = 'Duties';
      return existingRow;
    }

    var totalRow = totals.querySelector('.NativeUcdDrawer__TotalRow--strong');
    var dutyRow = document.createElement('div');
    var dutyLabel = document.createElement('span');
    var dutyAmount = document.createElement('span');
    var dutyNote = document.createElement('p');

    dutyRow.className = 'NativeUcdDrawer__TotalRow NativeUcdDrawer__TotalRow--duties';
    dutyRow.setAttribute('data-native-ucd-duties-row', '');
    dutyLabel.textContent = 'Duties';
    dutyAmount.setAttribute('data-native-ucd-duty-amount', '');
    dutyAmount.textContent = 'Included';
    dutyRow.appendChild(dutyLabel);
    dutyRow.appendChild(dutyAmount);

    dutyNote.className = 'NativeUcdDrawer__DutiesNote';
    dutyNote.setAttribute('data-native-ucd-duty-note', '');
    dutyNote.textContent = 'Duties are included in product prices.';

    totals.insertBefore(dutyRow, totalRow || null);
    totals.insertBefore(dutyNote, totalRow || null);

    return dutyRow;
  }

  function updateNativeUcdDutyEstimate() {
    var config = getNativeUcdStorefrontConfig();
    if (!ensureNativeUcdDutyRow(config)) return;
    // Shopify deprecated tax/duty estimates in Storefront Cart API in 2025-01.
    // Never create a second basket or treat an unavailable amount as zero.
    updateNativeUcdDutyUi(
      'Included',
      'Duties are included in product prices.',
      false
    );
  }

  function getNativeUcdDeadlineMarkup(country, subtotalCents) {
    if (typeof window.dsrcvGetCartDeliveryMessage === 'function') {
      return { html: '', text: window.dsrcvGetCartDeliveryMessage(country, subtotalCents) };
    }
    // Core mode has no Order Deadline fallback. A missing current Core node is
    // an unavailable promise, not permission to replay cached/app markup.
    nativeUcdLastDeadlineMarkup = '';
    var source = null;
    Array.prototype.some.call(document.querySelectorAll('[data-dsrcv-delivery-promise="cart"]'), function (candidate) {
      if (candidate.closest('#sidebar-cart') || candidate.closest('#upside-ucd-cart-drawer')) return false;
      source = candidate;
      return true;
    });

    if (source && source.textContent && source.textContent.replace(/\s+/g, '').length) {
      nativeUcdLastDeadlineMarkup = source.outerHTML || source.innerHTML || '';
      return buildNativeUcdDeadlineResult(nativeUcdLastDeadlineMarkup);
    }

    return { html: '', text: '' };
  }

  function formatNativeUcdCompactDelivery(text, isUkCustomer) {
    var copy = String(text || '').replace(/\s+/g, ' ').trim();
    if (isUkCustomer) copy = copy.replace(/^Delivered (?:tomorrow, )?/i, '');
    return copy.replace(/\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|January|February|March|April|June|July|August|September|October|November|December)\b/g, function (word) {
      return word.slice(0, 3);
    });
  }

  function updateNativeUcdMessages(event) {
    removeNativeUcdNestedShippingForms();

    var shippingText = '';
    var cartSubtotalCents = null;

    try {
      var freeShippingApi = window.__FreeShippingBarAPI;
      var totalsElement = document.querySelector('#sidebar-cart .NativeUcdDrawer__Totals');
      var merchandiseTotal = totalsElement ? Number(totalsElement.getAttribute('data-native-ucd-merchandise-total')) : NaN;
      var subtotalElement = document.querySelector('#sidebar-cart .NativeUcdDrawer__Totals .NativeUcdDrawer__TotalRow:first-child [data-money-convertible]');
      var subtotalText = subtotalElement ? subtotalElement.textContent : '';
      var subtotalNumber = Number(String(subtotalText).replace(/[^0-9.]/g, ''));
      cartSubtotalCents = Number.isFinite(merchandiseTotal) && merchandiseTotal >= 0
        ? Math.round(merchandiseTotal)
        : (Number.isFinite(subtotalNumber) ? Math.round(subtotalNumber * 100) : null);

      if (freeShippingApi && typeof freeShippingApi.getMessageForCart === 'function') {
        shippingText = freeShippingApi.getMessageForCart({
          totalPriceCents: Number.isFinite(cartSubtotalCents) ? cartSubtotalCents : 0,
          countryCode: (window.Shopify && window.Shopify.country) || (typeof freeShippingApi.getActiveCountry === 'function' ? freeShippingApi.getActiveCountry() : '')
        }) || '';
      }
    } catch (error) {
      shippingText = '';
    }

    if (shippingText) {
      document.querySelectorAll('[data-native-ucd-shipping-message], [data-native-ucd-shipping-detail]').forEach(function (element) {
        setNativeUcdText(element, refineNativeUcdShippingMessage(shippingText));
      });
    } else {
      var freeShippingElement = document.querySelector('.FreeShippingBar__Message[data-role="dynamic-message"]');
      var freeShippingText = freeShippingElement && freeShippingElement.textContent;

      if (freeShippingText && freeShippingText.replace(/\s+/g, '').length) {
        document.querySelectorAll('[data-native-ucd-shipping-message], [data-native-ucd-shipping-detail]').forEach(function (element) {
          setNativeUcdText(element, refineNativeUcdShippingMessage(freeShippingText));
        });
      }
    }

    var storefrontConfig = getNativeUcdStorefrontConfig() || {};
    var returnsConfig = storefrontConfig.returns || {};
    var exchangeCountries = [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
      'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
      'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'LI', 'NO'
    ];
    var country = getNativeUcdShippingCountry();
    var returnText = returnsConfig.internationalMessage || 'Easy international returns';
    var returnMeta = returnsConfig.internationalMeta || 'Start your return through the DSRCV returns portal. Available options vary by region.';

    if (country === 'GB' || country === 'UK') {
      returnText = returnsConfig.ukMessage || 'Free returns on all orders';
      returnMeta = returnsConfig.ukMeta || 'Book a return through the DSRCV returns portal with simple tracked options.';
    } else if (country === 'US') {
      returnText = returnsConfig.usMessage || 'Free exchange options';
      if (['Eligible exchanges and gift-card returns are free', 'Eligible exchanges and refunds to a gift card are free'].indexOf(returnText) !== -1) {
        returnText = 'Free exchange options';
      }
      returnMeta = returnsConfig.usMeta || 'Standard refund return labels are charged. See the fee in our returns portal before submitting.';
    } else if (exchangeCountries.indexOf(country) !== -1) {
      returnText = returnsConfig.exchangeMessage || 'Free exchanges on all orders';
      returnMeta = returnsConfig.exchangeMeta || 'Free exchanges are available through the DSRCV returns portal. Refund return labels may vary by region.';
    }

    document.querySelectorAll('[data-native-ucd-return-message], [data-native-ucd-return-detail]').forEach(function (element) {
      if (returnText) {
        setNativeUcdText(element, element.hasAttribute('data-native-ucd-compact-returns') && returnText === 'Free returns on all orders' ? 'Free on all orders' : returnText);
      }
    });

    document.querySelectorAll('[data-native-ucd-return-detail-meta]').forEach(function (element) {
      if (returnMeta) {
        setNativeUcdText(element, returnMeta);
      }
    });

    var deadline = getNativeUcdDeadlineMarkup(country, cartSubtotalCents);
    var drawer = document.getElementById('sidebar-cart');
    var lineItems = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('.NativeUcdCartItem')) : [];
    var hasPreOrder = !!drawer && (
      drawer.getAttribute('data-native-ucd-has-pre-order') === 'true' ||
      lineItems.some(function (lineItem) {
        return lineItem.classList.contains('NativeUcdCartItem--preOrder');
      })
    );
    var hasNonPreOrder = !drawer ||
      drawer.getAttribute('data-native-ucd-has-non-pre-order') === 'true' ||
      lineItems.some(function (lineItem) {
        return !lineItem.classList.contains('NativeUcdCartItem--preOrder');
      });
    var isUkCustomer = country === 'UK' || country === 'GB';
    var preOrderDates = lineItems.map(function (lineItem) {
      var dateEl = lineItem.querySelector('.NativeUcdCartItem__PreOrderDate[data-native-ucd-preorder-date="true"]');
      return dateEl ? normalizeNativeUcdPreOrderDate(dateEl.textContent) : '';
    }).filter(Boolean);

    nativeUcdCartShippingState = {
      hasPreOrder: hasPreOrder,
      hasNonPreOrder: hasNonPreOrder,
      isUkCustomer: isUkCustomer,
      preOrderDates: preOrderDates
    };
    updateNativeUcdPreOrderShippingCopy(nativeUcdCartShippingState);

    // The service column shares space with returns. Hide only an unavailable
    // delivery/progress line after resolving preorder fulfilment copy; price
    // failures and their retry stay in the totals.
    document.querySelectorAll('[data-native-ucd-shipping-message], [data-native-ucd-shipping-detail]').forEach(function (element) {
      var resolvedShippingText = String(element.textContent || '').replace(/\s+/g, ' ').trim();
      var unavailableShippingText = !resolvedShippingText || /^(?:delivery (?:confirmed|will be confirmed) at checkout|checking delivery)[.\u2026]*$/i.test(resolvedShippingText);
      element.hidden = unavailableShippingText;
      element.classList.toggle('is-hidden', unavailableShippingText);
    });

    var deadlineText = deadline.text || '';
    var benefit = (hasPreOrder || hasNonPreOrder) && typeof window.dsrcvGetCartDeliveryBenefit === 'function'
      ? window.dsrcvGetCartDeliveryBenefit(country, cartSubtotalCents) : null;
    var shippingMessage = drawer && drawer.querySelector('[data-native-ucd-shipping-message]');
    var resolvedBenefitText = benefit && benefit.title || deadlineText;
    if (!hasPreOrder && /^(?:delivery (?:confirmed|will be confirmed) at checkout|checking delivery)[.\u2026]*$/i.test(String(resolvedBenefitText).trim())) {
      var quoteApi = window.__FreeShippingBarAPI;
      var quoteCurrency = String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || storefrontConfig.currencyCode || '').toUpperCase();
      var currentRate = quoteApi && typeof quoteApi.getQuote === 'function'
        ? getNativeUcdCanonicalShippingRate(quoteApi.getQuote(), country, quoteCurrency, cartSubtotalCents) : null;
      deadlineText = currentRate && currentRate.methodLabel || '';
      benefit = deadlineText ? { title: deadlineText, subtitle: '' } : null;
      resolvedBenefitText = deadlineText;
    }
    var allowDeadline = (hasPreOrder || hasNonPreOrder) && !!resolvedBenefitText;
    var normaliseBenefitText = function (text) {
      return String(text || '').replace(/\s+/g, ' ').trim().replace(/\.$/, '').toLowerCase();
    };
    // Keep preorder information and real deadlines. A missing promise should
    // contribute one fallback, not repeat the shipping row beside it.
    if (!hasPreOrder && !(benefit && benefit.subtitle) && shippingMessage &&
      normaliseBenefitText(resolvedBenefitText) === normaliseBenefitText(shippingMessage.textContent)) {
      allowDeadline = false;
    }

    window.__nativeUcdDeadlineDebug = {
      isUKCustomer: isUkCustomer,
      order_deadline_has_text: !!deadline.text,
      order_deadline_text: deadline.text,
      resolved_deadline_text: deadlineText,
      has_pre_order_items: hasPreOrder,
      has_non_pre_order_items: hasNonPreOrder,
      pre_order_dates: preOrderDates,
      allow_order_deadline: allowDeadline,
      source_has_markup: !!deadline.html,
      cached_markup: !!nativeUcdLastDeadlineMarkup
    };

    document.querySelectorAll('[data-native-ucd-deadline-row]').forEach(function (row) {
      row.hidden = !allowDeadline;
      row.classList.toggle('is-hidden', !allowDeadline);
    });

    document.querySelectorAll('[data-native-ucd-deadline-detail]').forEach(function (row) {
      row.classList.toggle('is-hidden', !allowDeadline);
    });

    if (allowDeadline) {
      document.querySelectorAll('[data-native-ucd-deadline-message], [data-native-ucd-deadline-detail-message]').forEach(function (element) {
        if (element.hasAttribute('data-native-ucd-deadline-message')) {
          if (element.hasAttribute('data-native-ucd-compact-delivery')) {
            setNativeUcdText(element, formatNativeUcdCompactDelivery(deadlineText, isUkCustomer));
          } else {
            setNativeUcdDeliveryBenefit(element, benefit, deadlineText);
          }
        } else if (!hasPreOrder && deadline.html) {
          if (element.innerHTML !== deadline.html) {
            element.innerHTML = deadline.html;
          }
        } else if (element.textContent !== deadlineText) {
          setNativeUcdText(element, deadlineText);
        }
      });

      var immediateFooterCopy = hasPreOrder
        ? (getNativeUcdPreOrderShippingCopy(nativeUcdCartShippingState) || {}).footer
        : '';

      document.querySelectorAll('[data-native-ucd-shipping-option], [data-native-ucd-shipping-detail-option]').forEach(function (element) {
        element.classList.toggle('is-hidden', !immediateFooterCopy);
        element.hidden = !immediateFooterCopy;
        if (immediateFooterCopy) setNativeUcdText(element, immediateFooterCopy);
      });
    }

    var shippingUpdate = updateNativeUcdShippingSummary(cartSubtotalCents);
    // Quote and clock events redraw copy only. Duty estimation is refreshed
    // by actual basket changes, not by each informational minute tick.
    if (!event || !/^dsrcv:/.test(event.type || '')) updateNativeUcdDutyEstimate();

    return Promise.resolve(shippingUpdate);
  }

  document.addEventListener('dsrcv:shipping-quote-updated', updateNativeUcdMessages);
  document.addEventListener('dsrcv:cart-shipping-updated', updateNativeUcdMessages);
  document.addEventListener('dsrcv:delivery-promise:rendered', updateNativeUcdMessages);

  document.addEventListener('codeblackbelt:shipping-rates-calculator-plus:rates-rendered', function (event) {
    if (event.detail && Array.isArray(event.detail.shippingRates)) {
      window._shipping_rates = event.detail.shippingRates;
    }
    updateNativeUcdMessages();
  });

  document.addEventListener('product:added', function (event) {
    if (!document.getElementById('sidebar-cart')) {
      return;
    }

    // Claim the drawer refresh before the legacy bubbling listener runs.
    // Upsells already refreshed the drawer before emitting this analytics event.
    event.nativeUcdDrawerHandled = true;
    if (event.detail && event.detail.nativeUcdUpsell) {
      return;
    }

    setNativeUcdLoading(true);
    refreshNativeCartDrawer()
      .then(openNativeCartDrawer)
      .catch(function (error) {
        return recoverNativeUcdDrawerRefresh(error, 'Native cart drawer product add refresh failed');
      })
      .finally(function () {
        setNativeUcdLoading(false);
      });
  }, true);

  document.addEventListener('click', function (event) {
    if (handleNativeProductCardSizeAdd(event)) return;
    var shippingRetry = event.target && event.target.closest && event.target.closest('#sidebar-cart [data-native-ucd-shipping-retry]');
    if (shippingRetry) {
      event.preventDefault();
      // The Shopify rate controller owns this retry; never call Core for a price.
      return;
    }
    if (handleNativeUcdRecommendationMode(event)) {
      return;
    }

    if (handleNativeUcdReviewMore(event)) {
      return;
    }
    if (handleNativeUcdRecommendationMore(event)) {
      return;
    }
    if (handleNativeUcdEmptyRecommendationMore(event)) {
      return;
    }

    if (handleNativeUcdRecommendationAdd(event)) {
      return;
    }
  }, true);

  document.addEventListener('click', handleNativeUcdCartRemove, true);

  document.addEventListener('click', function (event) {
    handleNativeUcdCartIntent(event);

    if (event.target && event.target.closest && event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')) {
      window.setTimeout(restoreNativeUcdDrawerScroll, 0);
      window.setTimeout(restoreNativeUcdDrawerScroll, 180);
      scheduleNativeUcdCartMediaEnhancement(180);
      scheduleNativeUcdCartMediaEnhancement(650);
      scheduleNativeUcdCartMediaEnhancement(1400);
    }

    var checkoutButton = event.target && event.target.closest && event.target.closest('#sidebar-cart .NativeUcdDrawer__Checkout');

    if (checkoutButton) {
      if (checkoutButton.getAttribute('data-native-ucd-checkout-loading') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // The submit listener owns loading; allow this click's native submission.
      // Setting it here would make that first submit look like a duplicate.
      return;
    }

    if (event.target && event.target.closest && event.target.closest('#sidebar-cart .NativeUcdCartItem__Remove, #sidebar-cart button[data-native-ucd-variant-option]')) {
      setNativeUcdStatus('');
    }

    var openPreOrder = event.target && event.target.closest && event.target.closest('[data-native-ucd-open-preorder]');

    if (openPreOrder) {
      event.preventDefault();
      toggleNativeUcdPreOrderPopup(true);
      return;
    }

    var closePreOrder = event.target && event.target.closest && event.target.closest('[data-native-ucd-close-preorder]');
    var preOrderBackdrop = event.target && event.target.matches && event.target.matches('[data-native-ucd-preorder-popup]');

    if (closePreOrder || preOrderBackdrop) {
      event.preventDefault();
      toggleNativeUcdPreOrderPopup(false);
      return;
    }

    var variantOption = event.target && event.target.closest && event.target.closest('button[data-native-ucd-variant-option]');

    if (variantOption) {
      event.preventDefault();
      updateNativeUcdRecommendationCard(variantOption);
      return;
    }

  });
  document.addEventListener('touchstart', handleNativeUcdCartIntent, { capture: true, passive: false });
  document.addEventListener('pointerdown', handleNativeUcdCartIntent, true);

  document.addEventListener('change', function (event) {
    var recommendationSelect = event.target && event.target.closest && event.target.closest('#sidebar-cart select[data-native-ucd-variant-option]');
    var quantitySelect = event.target && event.target.closest && event.target.closest('[data-native-ucd-line-quantity]');
    var variantSelect = event.target && event.target.closest && event.target.closest('[data-native-ucd-line-variant]');

    if (recommendationSelect) {
      updateNativeUcdRecommendationCard(recommendationSelect);
      return;
    }

    if (!quantitySelect && !variantSelect) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var requestedVariant = variantSelect && variantSelect.value;
    if (variantSelect) {
      var savedVariant = variantSelect.querySelector('option[selected]');
      if (savedVariant) variantSelect.value = savedVariant.value;
    }
    if (nativeUcdLoadingCount > 0) return;
    setNativeUcdStatus('');
    setNativeUcdLoading(true);

    if (quantitySelect) {
      changeNativeUcdLineByKey(quantitySelect.getAttribute('data-line-id'), quantitySelect.value)
        .then(function () {
          return refreshNativeCartDrawer().catch(function (error) {
            return recoverNativeUcdDrawerRefresh(error, 'Native cart drawer quantity refresh failed');
          });
        })
        .catch(function (error) {
          return recoverNativeUcdMutationFailure(error, 'Native cart drawer quantity update failed');
        })
        .finally(function () {
          setNativeUcdLoading(false);
        });
      return;
    }

    var selectedVariant = requestedVariant;
    var currentVariant = variantSelect.querySelector('option[selected]') && variantSelect.querySelector('option[selected]').value;

    if (!selectedVariant || selectedVariant === currentVariant) {
      setNativeUcdLoading(false);
      return;
    }

    var replacementProperties;
    if (variantSelect.getAttribute('data-native-ucd-purchase-size-change') === 'true') {
      replaceNativeUcdPurchaseSize(variantSelect, currentVariant, selectedVariant)
        .then(function () { return refreshNativeCartDrawer(); })
        .catch(recoverNativeUcdPurchaseSizeFailure)
        .finally(function () { setNativeUcdLoading(false); });
      return;
    }
    try {
      replacementProperties = getNativeUcdReplacementProperties(
        getNativeUcdLineProperties(variantSelect),
        currentVariant,
        selectedVariant,
        variantSelect.getAttribute('data-selling-plan')
      );
    } catch (error) {
      variantSelect.value = currentVariant;
      setNativeUcdStatus('To change size, remove this item, then choose the new size on its product page.');
      setNativeUcdLoading(false);
      return;
    }

    if (variantSelect.getAttribute('data-private-preorder-size-change') === 'true') {
      replaceNativeUcdPrivateSize(variantSelect,currentVariant,selectedVariant,replacementProperties)
        .then(function () { return refreshNativeCartDrawer(); })
        .catch(function (error) { return recoverNativeUcdMutationFailure(error, 'Please review your bag after changing size.'); })
        .finally(function () { setNativeUcdLoading(false); });
      return;
    }
    if (variantSelect.getAttribute('data-native-ucd-ordinary-size-change') === 'true') {
      replaceNativeUcdOrdinarySize(variantSelect, currentVariant, selectedVariant, replacementProperties)
        .then(function () { return refreshNativeCartDrawer(); })
        .catch(function (error) { return recoverNativeUcdMutationFailure(error, 'Please review your bag after changing size.'); })
        .finally(function () { setNativeUcdLoading(false); });
      return;
    }
    variantSelect.value = currentVariant;
    setNativeUcdStatus('To change size, remove this item, then choose the new size on its product page.');
    setNativeUcdLoading(false);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('#sidebar-cart form.Cart');

    if (!form) {
      return;
    }

    if (nativeUcdLoadingCount > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setNativeUcdStatus('Updating your bag…');
      return;
    }

    var checkoutButton = form.querySelector('.NativeUcdDrawer__Checkout');

    if (checkoutButton) {
      if (checkoutButton.getAttribute('data-native-ucd-checkout-loading') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      setNativeUcdCheckoutLoading(checkoutButton, true);
      scheduleNativeUcdCheckoutLoadingReset(checkoutButton);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      toggleNativeUcdPreOrderPopup(false);
    }
  });

  window.addEventListener('pageshow', resetNativeUcdCheckoutLoading);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      resetNativeUcdCheckoutLoading();
    }
  });

  document.addEventListener('DOMContentLoaded', updateNativeUcdMessages);
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('sidebar-cart');
    syncNativeUcdCartDialog(drawer, isNativeUcdDrawerVisible());
    if (isNativeUcdDrawerVisible()) {
      enhanceNativeUcdMediaCarousels(drawer || document);
      loadNativeUcdShopifyRecommendations({ force: true });
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.MutationObserver) {
      return;
    }

    var drawer = document.getElementById('sidebar-cart');

    if (!drawer) {
      return;
    }

    if (drawer.getAttribute('aria-hidden') === 'false') {
      closeNativeUcdKlaviyoForms();
    }

    var updateTimer = null;
    var recommendationTimer = null;
    var lastDrawerVisibility = drawer.getAttribute('aria-hidden');
    var observer = new MutationObserver(function (mutations) {
      var formReplaced = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.target === drawer &&
          Array.prototype.some.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1 && node.matches('.Cart');
          });
      });
      var calculatorAdded = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (node.matches('.cbb-shipping-rates-calculator') ||
            node.querySelector('.cbb-shipping-rates-calculator'));
        });
      });
      if (calculatorAdded) removeNativeUcdNestedShippingForms();

      // Legacy refreshes also replace the form, then update the text count.
      // Keep the mobile icon in sync when that fallback owns the refresh.
      if (formReplaced) {
        var headerCount = document.querySelector('.Header__CartCount');
        if (headerCount) updateNativeUcdHeaderCounts(Number(headerCount.textContent));
      }

      var drawerVisibility = drawer.getAttribute('aria-hidden');
      var justOpened = lastDrawerVisibility !== drawerVisibility && drawerVisibility === 'false';
      if (lastDrawerVisibility !== drawerVisibility || formReplaced) syncNativeUcdCartDialog(drawer, justOpened);
      lastDrawerVisibility = drawerVisibility;

      // Descendant text/media updates must not restart the timers: messages
      // update their own text nodes and previously starved recommendations.
      if (!formReplaced && !justOpened) return;
      if (justOpened) closeNativeUcdKlaviyoForms();
      if (drawerVisibility === 'false') {
        scheduleNativeUcdCartMediaEnhancement(0);
        scheduleNativeUcdCartMediaEnhancement(300);
        loadNativeUcdShopifyRecommendations({ force: true });
      }

      if (updateTimer) {
        window.clearTimeout(updateTimer);
      }

      updateTimer = window.setTimeout(updateNativeUcdMessages, 80);

      if (drawer.getAttribute('aria-hidden') === 'false') {
        if (recommendationTimer) {
          window.clearTimeout(recommendationTimer);
        }

        recommendationTimer = window.setTimeout(function () {
          loadNativeUcdShopifyRecommendations({ force: true });
        }, 180);
      }
    });
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.MutationObserver || !document.body) {
      return;
    }

    var trustBloxObserver = new MutationObserver(function (mutations) {
      var sawDeadlineChange = mutations.some(function (mutation) {
        var target = mutation.target;

        if (target && target.nodeType === 1 && target.matches && target.matches('.trustblox-1-viewcart-wrap, .trustblox-1-viewcart-wrap *')) {
          return true;
        }

        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.trustblox-1-viewcart-wrap')) ||
            (node.querySelector && node.querySelector('.trustblox-1-viewcart-wrap'))
          );
        });
      });

      if (!sawDeadlineChange) {
        return;
      }

      if (nativeUcdDeadlineWatchTimer) {
        window.clearTimeout(nativeUcdDeadlineWatchTimer);
      }

      nativeUcdDeadlineWatchTimer = window.setTimeout(updateNativeUcdMessages, 120);
    });

    trustBloxObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(removeNativeUcdNestedShippingForms, 50);
    window.setTimeout(updateNativeUcdMessages, 300);
    window.setTimeout(updateNativeUcdMessages, 1200);
    scheduleNativeUcdCartMediaEnhancement(250);
    scheduleNativeUcdShopifyRecommendations(350);
  });
  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(removeNativeUcdNestedShippingForms, 50);
    window.setTimeout(updateNativeUcdMessages, 300);
    window.setTimeout(updateNativeUcdMessages, 1200);
    scheduleNativeUcdCartMediaEnhancement(250);
    scheduleNativeUcdShopifyRecommendations(350);
  });
})();
/* Product add-to-cart fallback for PDP buttons missed by the theme delegate. */
(function nativeUcdProductAddFallback() {
  var FALLBACK_FLAG = 'data-native-ucd-product-add-fallback';
  var BUTTON_SELECTOR = '.ProductForm__AddToCart[data-action="add-to-cart"]';

  function getVisibleProductButton(target) {
    var button = target && target.closest ? target.closest(BUTTON_SELECTOR) : null;
    var form = button && button.closest ? button.closest('form[action*="/cart/add"]') : null;
    var rect = button && button.getBoundingClientRect ? button.getBoundingClientRect() : null;

    if (!button || !form || !rect || rect.width <= 0 || rect.height <= 0) {
      return null;
    }

    return button;
  }

  function serializeProductForm(form) {
    var formData = new FormData(form);
    var properties = {};
    var payload = {};

    formData.forEach(function collectFormValue(value, key) {
      var propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (propertyMatch) {
        if (value !== '') {
          properties[propertyMatch[1]] = value;
        }
        return;
      }

      if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
        payload[key] = value;
      }
    });

    payload.id = Number(payload.id);
    payload.quantity = Number(payload.quantity) || 1;

    if (payload.selling_plan) {
      payload.selling_plan = Number(payload.selling_plan);
    }

    if (Object.keys(properties).length) {
      payload.properties = properties;
    }

    return payload;
  }

  function needsProductSizeSelection(button) {
    var wrapper = button.closest('.custom-cart-wrapper');
    return button.classList.contains('select-your-size') || Boolean(wrapper &&
      wrapper.getAttribute('data-requires-selection') === 'true' &&
      wrapper.getAttribute('data-variant-selected') !== 'true');
  }

  function focusProductSizeSelection(button) {
    var form = button.closest('form[action*="/cart/add"]');
    var sizes = form.querySelector('[id^="ProductFormSize-"]') || form.querySelector('.ProductForm__Option');
    var firstSize = sizes && sizes.querySelector('.SizeSwatch__Radio:not([disabled]), select, button');
    if (sizes) {
      sizes.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (firstSize) {
      firstSize.focus({ preventScroll: true });
    }
  }

  // Stop the theme delegate and fallback from adding the hidden default variant.
  document.addEventListener('click', function guardProductSizeSelection(event) {
    var button = getVisibleProductButton(event.target);
    if (button && needsProductSizeSelection(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      focusProductSizeSelection(button);
    }
  }, true);

  document.addEventListener('submit', function guardProductFormSelection(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) {
      return;
    }
    var button = form.querySelector(BUTTON_SELECTOR);
    if (button && needsProductSizeSelection(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      focusProductSizeSelection(button);
    }
  }, true);

  function setButtonLoading(button, isLoading) {
    button.toggleAttribute('disabled', isLoading);
    button.classList.toggle('is-adding', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showProductFallbackError(button, message) {
    var error = document.createElement('span');
    error.className = 'ProductForm__Error Alert Alert--error';
    error.textContent = message || 'Unable to add this item. Please try again.';
    button.insertAdjacentElement('afterend', error);
    window.setTimeout(function removeError() {
      error.remove();
    }, 3000);
  }

  function cartDrawerIsOpen() {
    var drawer = document.getElementById('sidebar-cart');
    return Boolean(drawer && drawer.getAttribute('aria-hidden') === 'false');
  }

  function runFallbackAdd(button, options) {
    var form = button.closest('form[action*="/cart/add"]');
    var payload = serializeProductForm(form);
    var force = Boolean(options && options.force);

    if (!payload.id || needsProductSizeSelection(button) || !force && button.disabled || button.getAttribute(FALLBACK_FLAG) === 'true') {
      return;
    }

    button.setAttribute(FALLBACK_FLAG, 'true');
    setButtonLoading(button, true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function handleResponse(response) {
      if (!response.ok) {
        return response.json().then(function raiseCartError(error) {
          throw new Error(error && error.description ? error.description : 'Cart add failed');
        });
      }

      return response.json();
    }).then(function dispatchProductAdded(cartItem) {
      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          item: cartItem,
          variant: { id: payload.id },
          quantity: payload.quantity
        }
      }));
    }).catch(function handleFallbackError(error) {
      showProductFallbackError(button, error && error.message);
    }).finally(function resetFallbackState() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      setButtonLoading(button, false);
      button.removeAttribute(FALLBACK_FLAG);
    });
  }

  document.addEventListener('click', function handleProductAddFallback(event) {
    var button = getVisibleProductButton(event.target);

    if (!button) {
      return;
    }

    if (event.defaultPrevented) {
      window.setTimeout(function rescueThemeAddIfNeeded() {
        if (button.disabled && !cartDrawerIsOpen() && button.getAttribute(FALLBACK_FLAG) !== 'true') {
          runFallbackAdd(button, { force: true });
        }
      }, 3500);
      return;
    }

    window.setTimeout(function runIfThemeDidNotHandleClick() {
      if (event.defaultPrevented) {
        return;
      }

      event.preventDefault();
      runFallbackAdd(button);
    }, 0);
  });
})();
/* Profit preorder line item properties patch. */
/*
 * Profit preorder line item properties.
 *
 * Adds customer-visible preorder properties to Shopify cart-add requests so
 * checkout, Admin order detail, and notification templates can render the same
 * preorder promise.
 */
(function profitPreorderLineItemProperties() {
  var MANAGED_THEME_IDS = ['184067195258', '184107565434'];
  var MANAGED_THEME_NAMES = ['A Still Summer', 'A Still Summer Dev - 2026-04-21'];
  var MANAGED_THEME_ASSET_PATHS = ['/t/198/assets/custom.js', '/t/199/assets/custom.js'];
  var PROPERTY_NAMES = ['_preorder', '_Pre-order', '_preorder_ship_date', 'Notice', 'Pre-order', 'Estimated shipping date'];
  var FORM_SELECTOR = 'form[action*="/cart/add"]';
  var WRAPPER_SELECTOR = '.custom-cart-wrapper';
  var CART_ROOT_SELECTOR = '#sidebar-cart, [data-section-type="cart"], form.Cart, .Cart';
  var CART_PROPERTY_ROW_SELECTOR = [
    'li',
    'dd',
    '[class*="Property"]',
    '[class*="property"]',
    '[data-cart-item-property]',
    '[data-line-item-property]',
  ].join(',');
  var NATIVE_UCD_PREORDER_CART_COPY_SELECTORS = [
    '[data-native-ucd-shipping-message]',
    '[data-native-ucd-shipping-detail]',
    '[data-native-ucd-preorder-shipping-copy]',
    '[data-native-ucd-shipping-option]',
    '[data-native-ucd-shipping-detail-option]',
  ].join(',');
  var CART_TEXT_NODE_SELECTOR = 'li, p, span, div';
  var ESTIMATE_SELECTORS = [
    '.pre-order-estimated-ship-date',
    '.timesact-preorder-description .pre_order',
    '.pre_order',
  ];

  function normalize(value) {
    return value == null ? '' : String(value).trim();
  }

  function themeMatches() {
    var params = null;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (error) {
      params = null;
    }

    if (params && MANAGED_THEME_IDS.indexOf(params.get('preview_theme_id')) !== -1) {
      return true;
    }

    if (documentHasManagedThemeAsset()) {
      return true;
    }

    var theme = window.Shopify && window.Shopify.theme ? window.Shopify.theme : null;
    if (!theme) {
      return false;
    }

    var themeId = String(theme.id || '');
    var themeName = String(theme.name || '');
    return MANAGED_THEME_IDS.indexOf(themeId) !== -1 || MANAGED_THEME_NAMES.indexOf(themeName) !== -1;
  }

  function documentHasManagedThemeAsset() {
    var currentScriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
    if (managedThemeAssetPathMatches(currentScriptSrc)) {
      return true;
    }
    var scripts = document.querySelectorAll ? document.querySelectorAll('script[src]') : [];
    for (var index = 0; index < scripts.length; index += 1) {
      if (managedThemeAssetPathMatches(scripts[index].src || '')) {
        return true;
      }
    }
    return false;
  }

  function managedThemeAssetPathMatches(src) {
    return Boolean(src && MANAGED_THEME_ASSET_PATHS.some(function matchesAssetPath(path) {
      return src.indexOf(path) !== -1;
    }));
  }

  if (!themeMatches()) {
    return;
  }

  function findProductRoot(form) {
    return (
      (form && form.closest && form.closest('[data-section-type="product"]')) ||
      document.querySelector('[data-section-type="product"]') ||
      document
    );
  }

  function getActiveForm() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (wrapper) {
      var wrapperForm = wrapper.querySelector(FORM_SELECTOR);
      if (wrapperForm) {
        return wrapperForm;
      }
    }
    return document.querySelector(FORM_SELECTOR);
  }

  function getWrapper(form) {
    if (form && form.closest) {
      var formWrapper = form.closest(WRAPPER_SELECTOR);
      if (formWrapper) {
        return formWrapper;
      }
    }
    return document.querySelector(WRAPPER_SELECTOR);
  }

  function getVariantId(form) {
    if (!form) {
      return '';
    }
    var idInput = form.querySelector('[name="id"]');
    return idInput ? normalize(idInput.value) : '';
  }

  function readProductJsonFromScript(script) {
    if (!script) {
      return null;
    }
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function readProductJson(root) {
    var script = root && root.querySelector ? root.querySelector('[data-product-json]') : null;
    if (!script) {
      script = document.querySelector('[data-product-json]');
    }
    return readProductJsonFromScript(script);
  }

  function getPreorderVariantIds(productJson) {
    return productJson && Array.isArray(productJson.preorder_variant_ids)
      ? productJson.preorder_variant_ids.map(function mapId(id) { return String(id); })
      : [];
  }

  function productJsonContainsVariant(productJson, variantId) {
    if (!productJson || !variantId) {
      return false;
    }
    if (String(productJson.selected_variant_id || '') === String(variantId)) {
      return true;
    }
    var variants = Array.isArray(productJson.variants) ? productJson.variants : [];
    return variants.some(function matchesVariant(variant) {
      return String((variant && variant.id) || '') === String(variantId);
    });
  }

  function variantIsPreorderInProductJson(productJson, variantId) {
    var preorderIds = getPreorderVariantIds(productJson);
    return Boolean(variantId && preorderIds.length > 0 && preorderIds.indexOf(String(variantId)) !== -1);
  }

  function findProductJsonForVariant(variantId) {
    if (!variantId) {
      return null;
    }
    var scripts = document.querySelectorAll('[data-product-json]');
    for (var index = 0; index < scripts.length; index += 1) {
      var productJson = readProductJsonFromScript(scripts[index]);
      if (productJsonContainsVariant(productJson, variantId)) {
        return productJson;
      }
    }
    return null;
  }

  function variantIsPreorder(form, explicitVariantId) {
    var root = findProductRoot(form);
    var productJson = readProductJson(root);
    var variantId = explicitVariantId ? String(explicitVariantId) : getVariantId(form);

    if (variantIsPreorderInProductJson(productJson, variantId)) {
      return true;
    }
    if (variantId && productJsonContainsVariant(productJson, variantId) && getPreorderVariantIds(productJson).length > 0) {
      return false;
    }

    var globalProductJson = findProductJsonForVariant(variantId);
    if (globalProductJson) {
      return variantIsPreorderInProductJson(globalProductJson, variantId);
    }

    if (explicitVariantId && (!form || getVariantId(form) !== String(explicitVariantId))) {
      return false;
    }

    var wrapper = getWrapper(form);
    if (wrapper) {
      var active = wrapper.getAttribute('data-preorder-active');
      if (active === 'true') {
        return true;
      }
      if (active === 'false') {
        return false;
      }
    }

    return Boolean(wrapper && wrapper.classList && wrapper.classList.contains('has-preorder'));
  }

  function findFormForVariant(variantId) {
    if (!variantId) {
      return null;
    }
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var index = 0; index < forms.length; index += 1) {
      if (String(getVariantId(forms[index])) === String(variantId)) {
        return forms[index];
      }
    }
    return null;
  }

  function findContextElementForVariant(variantId) {
    var form = findFormForVariant(variantId);
    if (form) {
      return form;
    }
    if (!variantId || !document.querySelector) {
      return document;
    }
    var selectors = [
      '[data-native-ucd-add-variant="' + variantId + '"]',
      '[data-variant-id="' + variantId + '"]',
      'option[value="' + variantId + '"]',
      'input[name="id"][value="' + variantId + '"]',
    ];
    for (var index = 0; index < selectors.length; index += 1) {
      var node = document.querySelector(selectors[index]);
      if (node) {
        return (
          (node.closest && node.closest(FORM_SELECTOR)) ||
          (node.closest && node.closest('[data-section-type="product"]')) ||
          (node.closest && node.closest('.custom-cart-wrapper')) ||
          (node.closest && node.closest('.NativeUcdRecommendation, .NativeUcdEmptyRecommendation')) ||
          node
        );
      }
    }
    return document;
  }

  function findEstimateNode(form) {
    var root = findProductRoot(form);
    for (var index = 0; index < ESTIMATE_SELECTORS.length; index += 1) {
      var selector = ESTIMATE_SELECTORS[index];
      var node = root && root.querySelector ? root.querySelector(selector) : null;
      if (!node) {
        node = document.querySelector(selector);
      }
      if (node && normalize(node.textContent)) {
        return node;
      }
    }
    return null;
  }

  function cleanEstimateText(value) {
    return normalize(value)
      .replace(/\s+/g, ' ')
      .replace(/^estimated shipping date:\s*/i, '')
      .replace(/^estimated ship date:\s*/i, '')
      .replace(/^the estimated shipping date is\s*/i, '')
      .replace(/\.$/, '');
  }

  function dateToIso(label) {
    var cleaned = cleanEstimateText(label);
    if (!cleaned) {
      return '';
    }
    var parsed = Date.parse(cleaned);
    if (Number.isNaN(parsed)) {
      return '';
    }
    var date = new Date(parsed);
    var year = String(date.getFullYear());
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function formatEstimatedDateLabel(label) {
    var cleaned = cleanEstimateText(label);
    var isoMatch = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!isoMatch) {
      return cleaned;
    }
    var date = new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
    if (Number.isNaN(date.getTime())) {
      return cleaned;
    }
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  function cartCopyDateLabel(label) {
    var formatted = formatEstimatedDateLabel(label);
    return formatted || cleanEstimateText(label);
  }

  function readExistingEstimatedDate(existingProperties) {
    if (!existingProperties || typeof existingProperties !== 'object') {
      return '';
    }
    return cleanEstimateText(existingProperties['Estimated shipping date'] || '');
  }

  function readVariantPreorderMetafieldEstimate(form, explicitVariantId) {
    var variantId = explicitVariantId ? String(explicitVariantId) : getVariantId(form);
    var metafields = window.variantPreOrderMetafields || null;
    var variantMetafields = variantId && metafields ? metafields[variantId] : null;
    if (!variantMetafields || typeof variantMetafields !== 'object') {
      return '';
    }
    return cleanEstimateText(variantMetafields.estimated_ship_date || '');
  }

  function buildProperties(form, existingProperties, explicitVariantId) {
    var estimateNode = findEstimateNode(form);
    var estimatedDateLabel = estimateNode
      ? cleanEstimateText(estimateNode.textContent)
      : readVariantPreorderMetafieldEstimate(form, explicitVariantId) || readExistingEstimatedDate(existingProperties);
    if (!estimatedDateLabel) {
      return {
        '_preorder': 'true',
        '_Pre-order': 'Yes',
        'Notice': 'Pre-order shipping notice.',
        'Pre-order': 'Pre-order item ships once available.',
      };
    }
    var customerDateLabel = formatEstimatedDateLabel(estimatedDateLabel);
    var noticeText = 'Estimated shipping date is ' + customerDateLabel + '.';
    var estimateSentence = 'The estimated shipping date is ' + customerDateLabel + '.';

    return {
      '_preorder': 'true',
      '_Pre-order': 'Yes',
      '_preorder_ship_date': dateToIso(estimatedDateLabel),
      'Notice': noticeText,
      'Pre-order': estimateSentence,
      'Estimated shipping date': customerDateLabel,
    };
  }

  function removeExistingPropertyInputs(form) {
    if (!form || !form.querySelectorAll) {
      return;
    }
    form.querySelectorAll('[data-profit-preorder-property]').forEach(function removeInput(input) {
      input.remove();
    });
  }

  function findManagedPropertyInput(form, name) {
    var inputs = form.querySelectorAll('[data-profit-preorder-property]');
    for (var index = 0; index < inputs.length; index += 1) {
      if (inputs[index].getAttribute('data-profit-preorder-property') === name) {
        return inputs[index];
      }
    }
    return null;
  }

  function ensurePropertyInput(form, name, value) {
    var input = findManagedPropertyInput(form, name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.setAttribute('data-profit-preorder-property', name);
      form.appendChild(input);
    }
    input.value = value;
    input.disabled = false;
  }

  function syncFormProperties(form) {
    if (!form) {
      return false;
    }

    if (!variantIsPreorder(form)) {
      removeExistingPropertyInputs(form);
      return false;
    }

    var properties = buildProperties(form);
    if (!properties) {
      removeExistingPropertyInputs(form);
      return false;
    }
    Object.keys(properties).forEach(function syncProperty(name) {
      ensurePropertyInput(form, name, properties[name]);
    });
    return true;
  }

  function propertiesForVariant(variantId, existingProperties) {
    var context = findContextElementForVariant(variantId);
    var form = context && context.matches && context.matches(FORM_SELECTOR) ? context : null;
    if (!form && context && context.querySelector) {
      form = context.querySelector(FORM_SELECTOR);
    }
    if (!variantIsPreorder(form || context, variantId)) {
      return null;
    }
    return buildProperties(form || context, existingProperties, variantId);
  }

  function propertiesForCurrentForm() {
    var form = getActiveForm();
    if (!form || !variantIsPreorder(form)) {
      return null;
    }
    return buildProperties(form);
  }

  function readPropertiesFromFormData(formData) {
    var properties = {};
    PROPERTY_NAMES.forEach(function readProperty(name) {
      var value = formData.get('properties[' + name + ']');
      if (value != null && value !== '') {
        properties[name] = value;
      }
    });
    return properties;
  }

  function readPropertiesFromSearchParams(params) {
    var properties = {};
    PROPERTY_NAMES.forEach(function readProperty(name) {
      var value = params.get('properties[' + name + ']');
      if (value != null && value !== '') {
        properties[name] = value;
      }
    });
    return properties;
  }

  function removePropertiesFromFormData(formData) {
    PROPERTY_NAMES.forEach(function removeProperty(name) {
      formData.delete('properties[' + name + ']');
    });
  }

  function removePropertiesFromSearchParams(params) {
    PROPERTY_NAMES.forEach(function removeProperty(name) {
      params.delete('properties[' + name + ']');
    });
  }

  function removePropertiesFromJson(value) {
    if (!value || typeof value !== 'object' || !value.properties || typeof value.properties !== 'object') {
      return value;
    }
    PROPERTY_NAMES.forEach(function removeProperty(name) {
      delete value.properties[name];
    });
    return value;
  }

  function addPropertiesToFormData(formData, properties) {
    if (!formData || typeof formData.set !== 'function') {
      return formData;
    }
    removePropertiesFromFormData(formData);
    if (!properties) {
      return formData;
    }
    Object.keys(properties).forEach(function setProperty(name) {
      formData.set('properties[' + name + ']', properties[name]);
    });
    return formData;
  }

  function addPropertiesToSearchParams(params, properties) {
    if (!params || typeof params.set !== 'function') {
      return params;
    }
    removePropertiesFromSearchParams(params);
    if (!properties) {
      return params;
    }
    Object.keys(properties).forEach(function setProperty(name) {
      params.set('properties[' + name + ']', properties[name]);
    });
    return params;
  }

  function addPropertiesToJson(value, properties) {
    if (!value || typeof value !== 'object') {
      return value;
    }
    removePropertiesFromJson(value);
    if (!properties) {
      return value;
    }
    value.properties = value.properties && typeof value.properties === 'object' ? value.properties : {};
    Object.keys(properties).forEach(function setProperty(name) {
      value.properties[name] = properties[name];
    });
    return value;
  }

  function extractVariantIdFromJson(value) {
    if (!value || typeof value !== 'object') {
      return '';
    }
    if (value.id) {
      return normalize(value.id);
    }
    if (Array.isArray(value.items) && value.items[0] && value.items[0].id) {
      return normalize(value.items[0].id);
    }
    return '';
  }

  function quantityIsZero(value) {
    return normalize(value) === '0';
  }

  function formDataQuantityIsZero(formData) {
    return formData && typeof formData.get === 'function' && quantityIsZero(formData.get('quantity'));
  }

  function searchParamsQuantityIsZero(params) {
    return params && typeof params.get === 'function' && quantityIsZero(params.get('quantity'));
  }

  function jsonQuantityIsZero(value) {
    if (!value || typeof value !== 'object') {
      return false;
    }
    if (quantityIsZero(value.quantity)) {
      return true;
    }
    return Boolean(Array.isArray(value.items) && value.items[0] && quantityIsZero(value.items[0].quantity));
  }

  function applyPropertiesToFormDataBody(formData, requireVariantId) {
    var variantId = normalize(formData.get('id'));
    if (formDataQuantityIsZero(formData) || !variantId && requireVariantId) {
      return addPropertiesToFormData(formData, null);
    }
    var properties = variantId
      ? propertiesForVariant(variantId, readPropertiesFromFormData(formData))
      : propertiesForCurrentForm();
    return addPropertiesToFormData(formData, properties);
  }

  function applyPropertiesToSearchParamsBody(params, requireVariantId) {
    var variantId = normalize(params.get('id'));
    if (searchParamsQuantityIsZero(params) || !variantId && requireVariantId) {
      return addPropertiesToSearchParams(params, null);
    }
    var properties = variantId
      ? propertiesForVariant(variantId, readPropertiesFromSearchParams(params))
      : propertiesForCurrentForm();
    return addPropertiesToSearchParams(params, properties);
  }

  function applyPropertiesToJsonBody(value, requireVariantId) {
    var variantId = extractVariantIdFromJson(value);
    var existingProperties = value && value.properties && typeof value.properties === 'object' ? value.properties : {};
    if (jsonQuantityIsZero(value) || !variantId && requireVariantId) {
      return addPropertiesToJson(value, null);
    }
    var properties = variantId ? propertiesForVariant(variantId, existingProperties) : propertiesForCurrentForm();
    return addPropertiesToJson(value, properties);
  }

  function applyPropertiesToBody(body, options) {
    var requireVariantId = Boolean(options && options.requireVariantId);
    if (body instanceof FormData) {
      return applyPropertiesToFormDataBody(body, requireVariantId);
    }
    if (body instanceof URLSearchParams) {
      return applyPropertiesToSearchParamsBody(body, requireVariantId);
    }
    if (typeof body === 'string') {
      try {
        return JSON.stringify(applyPropertiesToJsonBody(JSON.parse(body), requireVariantId));
      } catch (error) {
        var params = new URLSearchParams(body);
        applyPropertiesToSearchParamsBody(params, requireVariantId);
        return params.toString();
      }
    }
    return body;
  }

  function getManagedCartPropertiesRequest(input) {
    var url = '';
    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
    }
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
      return 'add';
    }
    if (/\/cart\/change(?:\.js)?(?:\?|$)/.test(url)) {
      return 'change';
    }
    return '';
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function' || window.fetch.__profitPreorderPatched) {
      return;
    }
    var originalFetch = window.fetch;
    window.fetch = function profitPreorderFetch(input, init) {
      var requestKind = getManagedCartPropertiesRequest(input);
      if (requestKind && init && init.body) {
        init.body = applyPropertiesToBody(init.body, {
          requireVariantId: requestKind === 'change',
        });
      }
      return originalFetch.call(this, input, init);
    };
    window.fetch.__profitPreorderPatched = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__profitPreorderPatched) {
      return;
    }
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function profitPreorderXhrOpen(method, url) {
      this.__profitPreorderCartRequestKind = getManagedCartPropertiesRequest(url);
      return originalOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function profitPreorderXhrSend(body) {
      if (this.__profitPreorderCartRequestKind && body) {
        body = applyPropertiesToBody(body, {
          requireVariantId: this.__profitPreorderCartRequestKind === 'change',
        });
      }
      return originalSend.call(this, body);
    };
    window.XMLHttpRequest.__profitPreorderPatched = true;
  }

  function getCartRoots() {
    var roots = document.querySelectorAll(CART_ROOT_SELECTOR);
    return roots.length ? roots : [];
  }

  function normalizedCartText(element) {
    return normalize(element && element.textContent).replace(/\s+/g, ' ');
  }

  function managedPreorderCartPropertyIsVisible(text) {
    return /^(Notice|Pre-order|Estimated shipping date)\s*:/i.test(text);
  }

  function hideDuplicateCartPreorderProperties(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    root.querySelectorAll(CART_PROPERTY_ROW_SELECTOR).forEach(function hidePropertyRow(row) {
      var text = normalizedCartText(row);
      if (!managedPreorderCartPropertyIsVisible(text)) {
        return;
      }
      row.hidden = true;
      row.setAttribute('data-profit-preorder-cart-duplicate', 'true');
      row.style.display = 'none';
    });
  }

  function addUniqueCartDate(dates, label) {
    var date = cartCopyDateLabel(label);
    if (date && dates.indexOf(date) === -1) {
      dates.push(date);
    }
  }

  function findPreorderDatesInCart(root) {
    var dates = [];
    var text = normalizedCartText(root);
    var labelMatch = null;
    var labelRegex = /(?:Estimated shipping date(?: is|:)?|Pre-order[:\s]+(?:estimated shipping\s+)?)\s*(\d{1,2}\s+[A-Za-z]+\s+\d{4})/gi;
    while ((labelMatch = labelRegex.exec(text)) !== null) {
      addUniqueCartDate(dates, labelMatch[1]);
    }
    var sentenceMatch = null;
    var sentenceRegex = /the estimated shipping date is\s*(\d{1,2}\s+[A-Za-z]+\s+\d{4})/gi;
    while ((sentenceMatch = sentenceRegex.exec(text)) !== null) {
      addUniqueCartDate(dates, sentenceMatch[1]);
    }
    var isoMatch = null;
    var isoRegex = /(?:_preorder_ship_date|Estimated shipping date(?: is|:)?)\s*[:=]?\s*(\d{4}-\d{2}-\d{2})/gi;
    while ((isoMatch = isoRegex.exec(text)) !== null) {
      addUniqueCartDate(dates, isoMatch[1]);
    }
    findPreorderDatesFromCartVariants(root).forEach(function addVariantDate(date) {
      addUniqueCartDate(dates, date);
    });
    return dates;
  }

  function readVariantPreorderCartEstimate(variantId) {
    var metafields = window.variantPreOrderMetafields || null;
    var variantMetafields = variantId && metafields && typeof metafields === 'object' ? metafields[variantId] : null;
    return variantMetafields && typeof variantMetafields === 'object'
      ? cleanEstimateText(variantMetafields.estimated_ship_date || '')
      : '';
  }

  function getCartVariantIds(root) {
    if (!root || !root.querySelectorAll) {
      return [];
    }
    var variantIds = [];
    function addVariantId(variantId) {
      var normalizedVariantId = normalize(variantId);
      if (normalizedVariantId && variantIds.indexOf(normalizedVariantId) === -1) {
        variantIds.push(normalizedVariantId);
      }
    }
    var links = root.querySelectorAll('a[href*="/cart/change"][href*="id="]');
    for (var linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
      var href = links[linkIndex].getAttribute('href') || '';
      var match = href.match(/[?&]id=(\d+)(?::|&|$)/);
      if (match) {
        addVariantId(match[1]);
      }
    }
    return variantIds;
  }

  function findPreorderDatesFromCartVariants(root) {
    if (!root || !root.querySelectorAll) {
      return [];
    }
    var dates = [];
    getCartVariantIds(root).forEach(function addVariantDate(variantId) {
      var estimate = readVariantPreorderCartEstimate(variantId);
      if (estimate) {
        addUniqueCartDate(dates, estimate);
      }
    });
    return dates;
  }

  function closestCartLineElement(node, root) {
    if (!node || !node.closest) {
      return null;
    }
    var line = node.closest('.CartItem, .NativeUcdCartItem, .CartItemWrapper, [data-cart-item], [data-line-item], [class*="cart-item"]');
    if (line && line !== root) {
      return line;
    }
    var current = node.parentElement;
    var depth = 0;
    while (current && current !== root && depth < 6) {
      line = current;
      current = current.parentElement;
      depth += 1;
    }
    return line && line !== root ? line : null;
  }

  function cartLineElementHasPreorder(line) {
    var text = normalizedCartText(line);
    return Boolean(text.match(/(?:^|\s)(?:_preorder=true|Pre-order|Estimated shipping date)/i));
  }

  function cartHasNonPreorderItems(root) {
    if (!root || !root.querySelectorAll) {
      return false;
    }
    var checkedLines = [];
    var variantIds = getCartVariantIds(root);
    if (variantIds.length) {
      for (var idIndex = 0; idIndex < variantIds.length; idIndex += 1) {
        var variantId = variantIds[idIndex];
        if (readVariantPreorderCartEstimate(variantId)) {
          continue;
        }
        var variantLink = root.querySelector('a[href*="/cart/change"][href*="id=' + variantId + '"]');
        var line = closestCartLineElement(variantLink, root);
        if (!line || checkedLines.indexOf(line) === -1 && !cartLineElementHasPreorder(line)) {
          return true;
        }
        if (line) {
          checkedLines.push(line);
        }
      }
    }
    return false;
  }

  function buildPreorderCartCopy(root) {
    var dates = findPreorderDatesInCart(root);
    var hasNonPreorderItems = cartHasNonPreorderItems(root);
    if (dates.length > 1) {
      return {
        dates: dates,
        itemCopy: "We'll email you if this changes.",
        summary: hasNonPreorderItems
          ? 'In-stock items ship first. Pre-order dates are shown beside each item.'
          : 'Items ship as they become available. Dates are shown beside each item.',
      };
    }
    if (dates.length === 1) {
      return {
        dates: dates,
        itemCopy: "We'll email you if this changes.",
        summary: hasNonPreorderItems
          ? 'In-stock items ship first. Pre-order ships from ' + dates[0] + '.'
          : "Ships from " + dates[0] + ". We'll email you if this changes.",
      };
    }
    return {
      dates: [],
      itemCopy: 'Ships once available.',
      summary: 'Pre-order item ships once available.',
    };
  }

  function replaceFastDeliveryPromise(root, preorderSummary) {
    if (!root || !root.querySelectorAll || !preorderSummary) {
      return;
    }
    root.querySelectorAll(CART_TEXT_NODE_SELECTOR).forEach(function replacePromise(element) {
      if (element.closest && element.closest('#sidebar-cart .NativeUcdDrawer__Messages')) {
        return;
      }
      var text = normalizedCartText(element);
      if (
        !/^Order now and receive by [A-Za-z]+$/i.test(text) &&
        !/^Pre-order now\.\s*Estimated shipping date:/i.test(text) &&
        !/^Pre-order:\s*estimated shipping/i.test(text) &&
        !/^Your order ships once the pre-order item is available/i.test(text)
      ) {
        return;
      }
      if (element.textContent !== preorderSummary) {
        element.textContent = preorderSummary;
      }
    });
  }

  function hideDuplicatePreorderSummaries(root, preorderSummary) {
    if (!root || !root.querySelectorAll || !preorderSummary) {
      return;
    }
    var hasVisibleSummary = false;
    root.querySelectorAll(CART_TEXT_NODE_SELECTOR).forEach(function hideDuplicateSummary(element) {
      if (normalizedCartText(element) !== preorderSummary) {
        return;
      }
      if (element.closest && element.closest('#sidebar-cart .NativeUcdDrawer__Messages')) {
        return;
      }
      if (!hasVisibleSummary) {
        hasVisibleSummary = true;
        return;
      }
      element.hidden = true;
      element.setAttribute('data-profit-preorder-cart-duplicate-summary', 'true');
      element.style.display = 'none';
    });
  }

  function compactNativeUcdPreorderCartCopy(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    var cartCopy = buildPreorderCartCopy(root);
    replaceFastDeliveryPromise(root, cartCopy.summary);
    root.querySelectorAll(NATIVE_UCD_PREORDER_CART_COPY_SELECTORS).forEach(function compactElement(element) {
      var text = normalizedCartText(element);
      if (!text || text.indexOf('pre-order') === -1 && text.indexOf('Pre-order') === -1 && text.indexOf('Ships once') === -1 && text.indexOf('ships once') === -1) {
        return;
      }
      if (element.matches && element.matches('.NativeUcdCartItem__PreOrderDate')) {
        return;
      }
      if (element.matches && element.matches('[data-native-ucd-preorder-shipping-copy]')) {
        if (element.textContent !== cartCopy.itemCopy) {
          element.textContent = cartCopy.itemCopy;
        }
        return;
      }
      if (element.matches && element.matches('[data-native-ucd-shipping-option], [data-native-ucd-shipping-detail-option]')) {
        if (element.textContent !== cartCopy.summary) {
          element.textContent = cartCopy.summary;
        }
        return;
      }
      if (element.textContent !== cartCopy.summary) {
        element.textContent = cartCopy.summary;
      }
    });
    hideDuplicatePreorderSummaries(root, cartCopy.summary);
  }

  function cleanupCartPreorderPresentation() {
    getCartRoots().forEach(function cleanupRoot(root) {
      hideDuplicateCartPreorderProperties(root);
      compactNativeUcdPreorderCartCopy(root);
    });
  }

  function scheduleCartPreorderPresentationCleanup() {
    window.setTimeout(cleanupCartPreorderPresentation, 0);
    window.setTimeout(cleanupCartPreorderPresentation, 150);
  }

  function syncAllForms() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function syncForm(form) {
      syncFormProperties(form);
    });
    cleanupCartPreorderPresentation();
  }

  document.addEventListener('submit', function handleSubmit(event) {
    var form = event.target && event.target.matches && event.target.matches(FORM_SELECTOR)
      ? event.target
      : null;
    if (form) {
      syncFormProperties(form);
    }
  }, true);

  document.addEventListener('change', function handleChange(event) {
    if (event.target && event.target.matches && event.target.matches('[name="id"], .SizeSwatch__Radio')) {
      window.setTimeout(syncAllForms, 0);
    }
  }, true);

  ['variant:change', 'variant:changed', 'product:variant-change'].forEach(function listen(eventName) {
    document.addEventListener(eventName, function scheduleSync() {
      window.setTimeout(syncAllForms, 0);
    });
  });

  ['cart:refresh', 'cart:updated', 'cart:request:success', 'cart:change', 'native-ucd:product-added'].forEach(function listenCart(eventName) {
    document.addEventListener(eventName, scheduleCartPreorderPresentationCleanup);
    if (document.documentElement && document.documentElement.addEventListener) {
      document.documentElement.addEventListener(eventName, scheduleCartPreorderPresentationCleanup);
    }
  });

  var observer = new MutationObserver(syncAllForms);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-preorder-active'],
  });

  patchFetch();
  patchXhr();
  syncAllForms();

  window.ProfitPreorderLineItemProperties = {
    themeIds: MANAGED_THEME_IDS.slice(),
    propertyNames: PROPERTY_NAMES.slice(),
    collectState: function collectState() {
      var form = getActiveForm();
      var properties = form ? buildProperties(form) : null;
      return {
        enabled: true,
        themeIds: MANAGED_THEME_IDS.slice(),
        formFound: Boolean(form),
        preorderActive: form ? variantIsPreorder(form) : false,
        properties: properties,
      };
    },
    cleanupCartPreorderPresentation: cleanupCartPreorderPresentation,
    sync: syncAllForms,
  };
})();

// Return keyboard focus when the native size guide closes.
(function sizeGuideReturnFocus() {
  var modal = document.getElementById('modal-size-guide');
  if (!modal || typeof MutationObserver !== 'function') return;

  var opener = null;
  var wasOpen = modal.getAttribute('aria-hidden') === 'false';
  var connected = false;
  var triggerSelector = '[data-action="open-modal"][aria-controls="modal-size-guide"]';

  function rememberOpener(event) {
    var trigger = event.target && typeof event.target.closest === 'function'
      ? event.target.closest(triggerSelector) : null;
    if (trigger) opener = trigger;
  }

  var observer = new MutationObserver(function() {
    var isOpen = modal.getAttribute('aria-hidden') === 'false';
    if (wasOpen && !isOpen && opener) {
      var active = document.activeElement;
      var canRestore = active === document.body || active === document.documentElement || modal.contains(active);
      var otherDialog = document.querySelector('[aria-modal="true"][aria-hidden="false"]');
      var target = opener.isConnected ? opener : null;
      if (!target && opener.id) {
        var replacement = document.getElementById(opener.id);
        if (replacement && replacement.matches(triggerSelector)) target = replacement;
      }
      if (!target && !opener.id) {
        var triggers = document.querySelectorAll(triggerSelector);
        if (triggers.length === 1) target = triggers[0];
      }
      if (canRestore && !otherDialog && target && !target.disabled && target.getClientRects().length) {
        target.focus({ preventScroll: true });
      }
      opener = null;
    }
    wasOpen = isOpen;
  });

  function connect() {
    if (connected || !modal.isConnected) return;
    connected = true;
    wasOpen = modal.getAttribute('aria-hidden') === 'false';
    document.addEventListener('click', rememberOpener, true);
    observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  window.addEventListener('pagehide', function(event) {
    connected = false;
    document.removeEventListener('click', rememberOpener, true);
    observer.disconnect();
    if (!event.persisted) opener = null;
  });
  window.addEventListener('pageshow', connect);
  connect();
})();
